// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ffb595%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23662b11%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fea67f%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 1rem 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.7;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #d0c8c8;
  --bs-backdrop-opacity: 0.8;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
/*!
 * Bootstrap  v5.3.3 (https://getbootstrap.com/)
 * Copyright 2011-2024 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #fe6b2a;
  --bs-secondary: #35353a;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #000;
  --bs-primary-rgb: 254, 107, 42;
  --bs-secondary-rgb: 53, 53, 58;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 0, 0, 0;
  --bs-primary-text-emphasis: #662b11;
  --bs-secondary-text-emphasis: #151517;
  --bs-success-text-emphasis: #0a3622;
  --bs-info-text-emphasis: #055160;
  --bs-warning-text-emphasis: #664d03;
  --bs-danger-text-emphasis: #58151c;
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: #ffe1d4;
  --bs-secondary-bg-subtle: #d7d7d8;
  --bs-success-bg-subtle: #d1e7dd;
  --bs-info-bg-subtle: #cff4fc;
  --bs-warning-bg-subtle: #fff3cd;
  --bs-danger-bg-subtle: #f8d7da;
  --bs-light-bg-subtle: #fcfcfd;
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: #ffc4aa;
  --bs-secondary-border-subtle: #aeaeb0;
  --bs-success-border-subtle: #a3cfbb;
  --bs-info-border-subtle: #9eeaf9;
  --bs-warning-border-subtle: #ffe69c;
  --bs-danger-border-subtle: #f1aeb5;
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: "Poppins", sans-serif;
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1.15rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.7;
  --bs-body-color: #fff;
  --bs-body-color-rgb: 255, 255, 255;
  --bs-body-bg: #0c0c0e;
  --bs-body-bg-rgb: 12, 12, 14;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(255, 255, 255, 0.75);
  --bs-secondary-color-rgb: 255, 255, 255;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(255, 255, 255, 0.5);
  --bs-tertiary-color-rgb: 255, 255, 255;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #fe6b2a;
  --bs-link-color-rgb: 254, 107, 42;
  --bs-link-decoration: underline;
  --bs-link-hover-color: #fe6b2a;
  --bs-link-hover-color-rgb: 254, 107, 42;
  --bs-code-color: #d63384;
  --bs-highlight-color: #fff;
  --bs-highlight-bg: #fff3cd;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.8);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.8);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(254, 107, 42, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: #2b3035;
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: #fea67f;
  --bs-secondary-text-emphasis: #868689;
  --bs-success-text-emphasis: #75b798;
  --bs-info-text-emphasis: #6edff6;
  --bs-warning-text-emphasis: #ffda6a;
  --bs-danger-text-emphasis: #ea868f;
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: #331508;
  --bs-secondary-bg-subtle: #0b0b0c;
  --bs-success-bg-subtle: #051b11;
  --bs-info-bg-subtle: #032830;
  --bs-warning-bg-subtle: #332701;
  --bs-danger-bg-subtle: #2c0b0e;
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: #984019;
  --bs-secondary-border-subtle: #202023;
  --bs-success-border-subtle: #0f5132;
  --bs-info-border-subtle: #087990;
  --bs-warning-border-subtle: #997404;
  --bs-danger-border-subtle: #842029;
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: #fea67f;
  --bs-link-hover-color: #feb899;
  --bs-link-color-rgb: 254, 166, 127;
  --bs-link-hover-color-rgb: 254, 184, 153;
  --bs-code-color: #e685b5;
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: #664d03;
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #75b798;
  --bs-form-valid-border-color: #75b798;
  --bs-form-invalid-color: #ea868f;
  --bs-form-invalid-border-color: #ea868f;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: #fe6b2a;
  border: 0;
  border-top: 3px solid;
  opacity: 1;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 1rem;
  font-weight: bold;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.4125rem + 1.95vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.875rem;
  }
}

h2, .h2 {
  font-size: calc(1.355rem + 1.26vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2.3rem;
  }
}

h3, .h3 {
  font-size: calc(1.32625rem + 0.915vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 2.0125rem;
  }
}

h4, .h4 {
  font-size: calc(1.2975rem + 0.57vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.725rem;
  }
}

h5, .h5 {
  font-size: calc(1.26875rem + 0.225vw);
}
@media (min-width: 1200px) {
  h5, .h5 {
    font-size: 1.4375rem;
  }
}

h6, .h6 {
  font-size: 1.15rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: calc(1.26875rem + 0.225vw);
  font-weight: 300;
}
@media (min-width: 1200px) {
  .lead {
    font-size: 1.4375rem;
  }
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: calc(1.26875rem + 0.225vw);
}
@media (min-width: 1200px) {
  .blockquote {
    font-size: 1.4375rem;
  }
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-mlg,
.container-md,
.container-mmd,
.container-sm,
.container-xxs {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 438px) {
  .container-xxs, .container {
    max-width: 401px;
  }
}
@media (min-width: 576px) {
  .container-sm, .container-xxs, .container {
    max-width: 540px;
  }
}
@media (min-width: 664px) {
  .container-mmd, .container-sm, .container-xxs, .container {
    max-width: 622px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-mmd, .container-sm, .container-xxs, .container {
    max-width: 720px;
  }
}
@media (min-width: 880px) {
  .container-mlg, .container-md, .container-mmd, .container-sm, .container-xxs, .container {
    max-width: 840px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-mlg, .container-md, .container-mmd, .container-sm, .container-xxs, .container {
    max-width: 960px;
  }
}
@media (min-width: 1199px) {
  .container-xl, .container-lg, .container-mlg, .container-md, .container-mmd, .container-sm, .container-xxs, .container {
    max-width: 1050px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-mlg, .container-md, .container-mmd, .container-sm, .container-xxs, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-xxs: 438px;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-mmd: 664px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-mlg: 880px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1199px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0 0%;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

.g-6,
.gx-6 {
  --bs-gutter-x: 4.5rem;
}

.g-6,
.gy-6 {
  --bs-gutter-y: 4.5rem;
}

.g-7,
.gx-7 {
  --bs-gutter-x: 6rem;
}

.g-7,
.gy-7 {
  --bs-gutter-y: 6rem;
}

.g-8,
.gx-8 {
  --bs-gutter-x: 8rem;
}

.g-8,
.gy-8 {
  --bs-gutter-y: 8rem;
}

.g-9,
.gx-9 {
  --bs-gutter-x: 12rem;
}

.g-9,
.gy-9 {
  --bs-gutter-y: 12rem;
}

@media (min-width: 438px) {
  .col-xxs {
    flex: 1 0 0%;
  }
  .row-cols-xxs-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxs-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxs-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxs-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxs-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxs-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxs-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxs-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxs-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxs-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxs-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxs-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxs-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxs-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxs-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxs-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxs-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxs-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxs-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxs-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxs-0 {
    margin-left: 0;
  }
  .offset-xxs-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxs-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxs-3 {
    margin-left: 25%;
  }
  .offset-xxs-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxs-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxs-6 {
    margin-left: 50%;
  }
  .offset-xxs-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxs-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxs-9 {
    margin-left: 75%;
  }
  .offset-xxs-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxs-11 {
    margin-left: 91.66666667%;
  }
  .g-xxs-0,
  .gx-xxs-0 {
    --bs-gutter-x: 0;
  }
  .g-xxs-0,
  .gy-xxs-0 {
    --bs-gutter-y: 0;
  }
  .g-xxs-1,
  .gx-xxs-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxs-1,
  .gy-xxs-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxs-2,
  .gx-xxs-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxs-2,
  .gy-xxs-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxs-3,
  .gx-xxs-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxs-3,
  .gy-xxs-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxs-4,
  .gx-xxs-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxs-4,
  .gy-xxs-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxs-5,
  .gx-xxs-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxs-5,
  .gy-xxs-5 {
    --bs-gutter-y: 3rem;
  }
  .g-xxs-6,
  .gx-xxs-6 {
    --bs-gutter-x: 4.5rem;
  }
  .g-xxs-6,
  .gy-xxs-6 {
    --bs-gutter-y: 4.5rem;
  }
  .g-xxs-7,
  .gx-xxs-7 {
    --bs-gutter-x: 6rem;
  }
  .g-xxs-7,
  .gy-xxs-7 {
    --bs-gutter-y: 6rem;
  }
  .g-xxs-8,
  .gx-xxs-8 {
    --bs-gutter-x: 8rem;
  }
  .g-xxs-8,
  .gy-xxs-8 {
    --bs-gutter-y: 8rem;
  }
  .g-xxs-9,
  .gx-xxs-9 {
    --bs-gutter-x: 12rem;
  }
  .g-xxs-9,
  .gy-xxs-9 {
    --bs-gutter-y: 12rem;
  }
}
@media (min-width: 576px) {
  .col-sm {
    flex: 1 0 0%;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
  .g-sm-6,
  .gx-sm-6 {
    --bs-gutter-x: 4.5rem;
  }
  .g-sm-6,
  .gy-sm-6 {
    --bs-gutter-y: 4.5rem;
  }
  .g-sm-7,
  .gx-sm-7 {
    --bs-gutter-x: 6rem;
  }
  .g-sm-7,
  .gy-sm-7 {
    --bs-gutter-y: 6rem;
  }
  .g-sm-8,
  .gx-sm-8 {
    --bs-gutter-x: 8rem;
  }
  .g-sm-8,
  .gy-sm-8 {
    --bs-gutter-y: 8rem;
  }
  .g-sm-9,
  .gx-sm-9 {
    --bs-gutter-x: 12rem;
  }
  .g-sm-9,
  .gy-sm-9 {
    --bs-gutter-y: 12rem;
  }
}
@media (min-width: 664px) {
  .col-mmd {
    flex: 1 0 0%;
  }
  .row-cols-mmd-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-mmd-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-mmd-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-mmd-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-mmd-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-mmd-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-mmd-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-mmd-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-mmd-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-mmd-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-mmd-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-mmd-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-mmd-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-mmd-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-mmd-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-mmd-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-mmd-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-mmd-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-mmd-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-mmd-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-mmd-0 {
    margin-left: 0;
  }
  .offset-mmd-1 {
    margin-left: 8.33333333%;
  }
  .offset-mmd-2 {
    margin-left: 16.66666667%;
  }
  .offset-mmd-3 {
    margin-left: 25%;
  }
  .offset-mmd-4 {
    margin-left: 33.33333333%;
  }
  .offset-mmd-5 {
    margin-left: 41.66666667%;
  }
  .offset-mmd-6 {
    margin-left: 50%;
  }
  .offset-mmd-7 {
    margin-left: 58.33333333%;
  }
  .offset-mmd-8 {
    margin-left: 66.66666667%;
  }
  .offset-mmd-9 {
    margin-left: 75%;
  }
  .offset-mmd-10 {
    margin-left: 83.33333333%;
  }
  .offset-mmd-11 {
    margin-left: 91.66666667%;
  }
  .g-mmd-0,
  .gx-mmd-0 {
    --bs-gutter-x: 0;
  }
  .g-mmd-0,
  .gy-mmd-0 {
    --bs-gutter-y: 0;
  }
  .g-mmd-1,
  .gx-mmd-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-mmd-1,
  .gy-mmd-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-mmd-2,
  .gx-mmd-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-mmd-2,
  .gy-mmd-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-mmd-3,
  .gx-mmd-3 {
    --bs-gutter-x: 1rem;
  }
  .g-mmd-3,
  .gy-mmd-3 {
    --bs-gutter-y: 1rem;
  }
  .g-mmd-4,
  .gx-mmd-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-mmd-4,
  .gy-mmd-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-mmd-5,
  .gx-mmd-5 {
    --bs-gutter-x: 3rem;
  }
  .g-mmd-5,
  .gy-mmd-5 {
    --bs-gutter-y: 3rem;
  }
  .g-mmd-6,
  .gx-mmd-6 {
    --bs-gutter-x: 4.5rem;
  }
  .g-mmd-6,
  .gy-mmd-6 {
    --bs-gutter-y: 4.5rem;
  }
  .g-mmd-7,
  .gx-mmd-7 {
    --bs-gutter-x: 6rem;
  }
  .g-mmd-7,
  .gy-mmd-7 {
    --bs-gutter-y: 6rem;
  }
  .g-mmd-8,
  .gx-mmd-8 {
    --bs-gutter-x: 8rem;
  }
  .g-mmd-8,
  .gy-mmd-8 {
    --bs-gutter-y: 8rem;
  }
  .g-mmd-9,
  .gx-mmd-9 {
    --bs-gutter-x: 12rem;
  }
  .g-mmd-9,
  .gy-mmd-9 {
    --bs-gutter-y: 12rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0 0%;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
  .g-md-6,
  .gx-md-6 {
    --bs-gutter-x: 4.5rem;
  }
  .g-md-6,
  .gy-md-6 {
    --bs-gutter-y: 4.5rem;
  }
  .g-md-7,
  .gx-md-7 {
    --bs-gutter-x: 6rem;
  }
  .g-md-7,
  .gy-md-7 {
    --bs-gutter-y: 6rem;
  }
  .g-md-8,
  .gx-md-8 {
    --bs-gutter-x: 8rem;
  }
  .g-md-8,
  .gy-md-8 {
    --bs-gutter-y: 8rem;
  }
  .g-md-9,
  .gx-md-9 {
    --bs-gutter-x: 12rem;
  }
  .g-md-9,
  .gy-md-9 {
    --bs-gutter-y: 12rem;
  }
}
@media (min-width: 880px) {
  .col-mlg {
    flex: 1 0 0%;
  }
  .row-cols-mlg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-mlg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-mlg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-mlg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-mlg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-mlg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-mlg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-mlg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-mlg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-mlg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-mlg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-mlg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-mlg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-mlg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-mlg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-mlg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-mlg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-mlg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-mlg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-mlg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-mlg-0 {
    margin-left: 0;
  }
  .offset-mlg-1 {
    margin-left: 8.33333333%;
  }
  .offset-mlg-2 {
    margin-left: 16.66666667%;
  }
  .offset-mlg-3 {
    margin-left: 25%;
  }
  .offset-mlg-4 {
    margin-left: 33.33333333%;
  }
  .offset-mlg-5 {
    margin-left: 41.66666667%;
  }
  .offset-mlg-6 {
    margin-left: 50%;
  }
  .offset-mlg-7 {
    margin-left: 58.33333333%;
  }
  .offset-mlg-8 {
    margin-left: 66.66666667%;
  }
  .offset-mlg-9 {
    margin-left: 75%;
  }
  .offset-mlg-10 {
    margin-left: 83.33333333%;
  }
  .offset-mlg-11 {
    margin-left: 91.66666667%;
  }
  .g-mlg-0,
  .gx-mlg-0 {
    --bs-gutter-x: 0;
  }
  .g-mlg-0,
  .gy-mlg-0 {
    --bs-gutter-y: 0;
  }
  .g-mlg-1,
  .gx-mlg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-mlg-1,
  .gy-mlg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-mlg-2,
  .gx-mlg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-mlg-2,
  .gy-mlg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-mlg-3,
  .gx-mlg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-mlg-3,
  .gy-mlg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-mlg-4,
  .gx-mlg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-mlg-4,
  .gy-mlg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-mlg-5,
  .gx-mlg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-mlg-5,
  .gy-mlg-5 {
    --bs-gutter-y: 3rem;
  }
  .g-mlg-6,
  .gx-mlg-6 {
    --bs-gutter-x: 4.5rem;
  }
  .g-mlg-6,
  .gy-mlg-6 {
    --bs-gutter-y: 4.5rem;
  }
  .g-mlg-7,
  .gx-mlg-7 {
    --bs-gutter-x: 6rem;
  }
  .g-mlg-7,
  .gy-mlg-7 {
    --bs-gutter-y: 6rem;
  }
  .g-mlg-8,
  .gx-mlg-8 {
    --bs-gutter-x: 8rem;
  }
  .g-mlg-8,
  .gy-mlg-8 {
    --bs-gutter-y: 8rem;
  }
  .g-mlg-9,
  .gx-mlg-9 {
    --bs-gutter-x: 12rem;
  }
  .g-mlg-9,
  .gy-mlg-9 {
    --bs-gutter-y: 12rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0 0%;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
  .g-lg-6,
  .gx-lg-6 {
    --bs-gutter-x: 4.5rem;
  }
  .g-lg-6,
  .gy-lg-6 {
    --bs-gutter-y: 4.5rem;
  }
  .g-lg-7,
  .gx-lg-7 {
    --bs-gutter-x: 6rem;
  }
  .g-lg-7,
  .gy-lg-7 {
    --bs-gutter-y: 6rem;
  }
  .g-lg-8,
  .gx-lg-8 {
    --bs-gutter-x: 8rem;
  }
  .g-lg-8,
  .gy-lg-8 {
    --bs-gutter-y: 8rem;
  }
  .g-lg-9,
  .gx-lg-9 {
    --bs-gutter-x: 12rem;
  }
  .g-lg-9,
  .gy-lg-9 {
    --bs-gutter-y: 12rem;
  }
}
@media (min-width: 1199px) {
  .col-xl {
    flex: 1 0 0%;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
  .g-xl-6,
  .gx-xl-6 {
    --bs-gutter-x: 4.5rem;
  }
  .g-xl-6,
  .gy-xl-6 {
    --bs-gutter-y: 4.5rem;
  }
  .g-xl-7,
  .gx-xl-7 {
    --bs-gutter-x: 6rem;
  }
  .g-xl-7,
  .gy-xl-7 {
    --bs-gutter-y: 6rem;
  }
  .g-xl-8,
  .gx-xl-8 {
    --bs-gutter-x: 8rem;
  }
  .g-xl-8,
  .gy-xl-8 {
    --bs-gutter-y: 8rem;
  }
  .g-xl-9,
  .gx-xl-9 {
    --bs-gutter-x: 12rem;
  }
  .g-xl-9,
  .gy-xl-9 {
    --bs-gutter-y: 12rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0 0%;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
  .g-xxl-6,
  .gx-xxl-6 {
    --bs-gutter-x: 4.5rem;
  }
  .g-xxl-6,
  .gy-xxl-6 {
    --bs-gutter-y: 4.5rem;
  }
  .g-xxl-7,
  .gx-xxl-7 {
    --bs-gutter-x: 6rem;
  }
  .g-xxl-7,
  .gy-xxl-7 {
    --bs-gutter-y: 6rem;
  }
  .g-xxl-8,
  .gx-xxl-8 {
    --bs-gutter-x: 8rem;
  }
  .g-xxl-8,
  .gy-xxl-8 {
    --bs-gutter-y: 8rem;
  }
  .g-xxl-9,
  .gx-xxl-9 {
    --bs-gutter-x: 12rem;
  }
  .g-xxl-9,
  .gy-xxl-9 {
    --bs-gutter-y: 12rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #ffe1d4;
  --bs-table-border-color: #ccb4aa;
  --bs-table-striped-bg: #f2d6c9;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6cbbf;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ecd0c4;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: #d7d7d8;
  --bs-table-border-color: #acacad;
  --bs-table-striped-bg: #cccccd;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #c2c2c2;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c7c7c8;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: #d1e7dd;
  --bs-table-border-color: #a7b9b1;
  --bs-table-striped-bg: #c7dbd2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bcd0c7;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c1d6cc;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: #cff4fc;
  --bs-table-border-color: #a6c3ca;
  --bs-table-striped-bg: #c5e8ef;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #badce3;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfe2e9;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: #fff3cd;
  --bs-table-border-color: #ccc2a4;
  --bs-table-striped-bg: #f2e7c3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6dbb9;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ece1be;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: #f8d7da;
  --bs-table-border-color: #c6acae;
  --bs-table-striped-bg: #eccccf;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfc2c4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5c7ca;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: #c6c7c8;
  --bs-table-striped-bg: #ecedee;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfe0e1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5e6e7;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #000;
  --bs-table-border-color: #333333;
  --bs-table-striped-bg: #0d0d0d;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #1a1a1a;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #131313;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 437.98px) {
  .table-responsive-xxs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 663.98px) {
  .table-responsive-mmd {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 879.98px) {
  .table-responsive-mlg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1198.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(1rem + var(--bs-border-width));
  padding-bottom: calc(1rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.7;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: calc(1.26875rem + 0.225vw);
}
@media (min-width: 1200px) {
  .col-form-label-lg {
    font-size: 1.4375rem;
  }
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 1.00625rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 1rem 1rem;
  font-size: 1.15rem;
  font-weight: 400;
  line-height: 1.7;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid #666;
  border-radius: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: #ffb595;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(254, 107, 42, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.7em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-gray-700);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 1rem 1rem;
  margin: -1rem -1rem;
  margin-inline-end: 1rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 1rem 0;
  margin-bottom: 0;
  line-height: 1.7;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.7em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 1.00625rem;
  border-radius: 0;
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.7em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: calc(1.26875rem + 0.225vw);
  border-radius: 0;
}
@media (min-width: 1200px) {
  .form-control-lg {
    font-size: 1.4375rem;
  }
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.7em + 2rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.7em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.7em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.7em + 2rem + calc(var(--bs-border-width) * 2));
  padding: 1rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0;
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 0;
}
.form-control-color.form-control-sm {
  height: calc(1.7em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.7em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 1rem 3rem 1rem 1rem;
  font-size: 1.15rem;
  font-weight: 400;
  line-height: 1.7;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid #666;
  border-radius: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: #ffb595;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(254, 107, 42, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 1rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 1.00625rem;
  border-radius: 0;
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: calc(1.26875rem + 0.225vw);
  border-radius: 0;
}
@media (min-width: 1200px) {
  .form-select-lg {
    font-size: 1.4375rem;
  }
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.955rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.35em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: #ffb595;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(254, 107, 42, 0.25);
}
.form-check-input:checked {
  background-color: #fe6b2a;
  border-color: #fe6b2a;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #fe6b2a;
  border-color: #fe6b2a;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #0c0c0e, 0 0 0 0.25rem rgba(254, 107, 42, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #0c0c0e, 0 0 0 0.25rem rgba(254, 107, 42, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #fe6b2a;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #ffd3bf;
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #fe6b2a;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #ffd3bf;
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 1rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 1rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.5rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: 0;
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 1rem 1rem;
  font-size: 1.15rem;
  font-weight: 400;
  line-height: 1.7;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid #666;
  border-radius: 0;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: calc(1.26875rem + 0.225vw);
  border-radius: 0;
}
@media (min-width: 1200px) {
  .input-group-lg > .form-control,
  .input-group-lg > .form-select,
  .input-group-lg > .input-group-text,
  .input-group-lg > .btn {
    font-size: 1.4375rem;
  }
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 1.00625rem;
  border-radius: 0;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 4rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 1.00625rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.7em + 2rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.425em + 0.5rem) center;
  background-size: calc(0.85em + 1rem) calc(0.85em + 1rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.7em + 2rem);
  background-position: top calc(0.425em + 0.5rem) right calc(0.425em + 0.5rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 5.5rem;
  background-position: right 1rem center, center right 3rem;
  background-size: 16px 12px, calc(0.85em + 1rem) calc(0.85em + 1rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.7em + 2rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 1.00625rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.7em + 2rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.425em + 0.5rem) center;
  background-size: calc(0.85em + 1rem) calc(0.85em + 1rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.7em + 2rem);
  background-position: top calc(0.425em + 0.5rem) right calc(0.425em + 0.5rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 5.5rem;
  background-position: right 1rem center, center right 3rem;
  background-size: 16px 12px, calc(0.85em + 1rem) calc(0.85em + 1rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.7em + 2rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 30px;
  --bs-btn-padding-y: 10px;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1.15rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.7;
  --bs-btn-color: #fff !important;
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 50px;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #000;
  --bs-btn-bg: #fe6b2a;
  --bs-btn-border-color: #fe6b2a;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #fe814a;
  --bs-btn-hover-border-color: #fe7a3f;
  --bs-btn-focus-shadow-rgb: 216, 91, 36;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #fe8955;
  --bs-btn-active-border-color: #fe7a3f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #fe6b2a;
  --bs-btn-disabled-border-color: #fe6b2a;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #35353a;
  --bs-btn-border-color: #35353a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #2d2d31;
  --bs-btn-hover-border-color: #2a2a2e;
  --bs-btn-focus-shadow-rgb: 83, 83, 88;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #2a2a2e;
  --bs-btn-active-border-color: #28282c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #35353a;
  --bs-btn-disabled-border-color: #35353a;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #157347;
  --bs-btn-hover-border-color: #146c43;
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #146c43;
  --bs-btn-active-border-color: #13653f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #31d2f2;
  --bs-btn-hover-border-color: #25cff2;
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3dd5f3;
  --bs-btn-active-border-color: #25cff2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffca2c;
  --bs-btn-hover-border-color: #ffc720;
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffcd39;
  --bs-btn-active-border-color: #ffc720;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #bb2d3b;
  --bs-btn-hover-border-color: #b02a37;
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #b02a37;
  --bs-btn-active-border-color: #a52834;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d3d4d5;
  --bs-btn-hover-border-color: #c6c7c8;
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #c6c7c8;
  --bs-btn-active-border-color: #babbbc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #000;
  --bs-btn-border-color: #000;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #262626;
  --bs-btn-hover-border-color: #1a1a1a;
  --bs-btn-focus-shadow-rgb: 38, 38, 38;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #333333;
  --bs-btn-active-border-color: #1a1a1a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #000;
  --bs-btn-disabled-border-color: #000;
}

.btn-outline-primary {
  --bs-btn-color: #fe6b2a;
  --bs-btn-border-color: #fe6b2a;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #fe6b2a;
  --bs-btn-hover-border-color: #fe6b2a;
  --bs-btn-focus-shadow-rgb: 254, 107, 42;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #fe6b2a;
  --bs-btn-active-border-color: #fe6b2a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fe6b2a;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #fe6b2a;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #35353a;
  --bs-btn-border-color: #35353a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #35353a;
  --bs-btn-hover-border-color: #35353a;
  --bs-btn-focus-shadow-rgb: 53, 53, 58;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #35353a;
  --bs-btn-active-border-color: #35353a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #35353a;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #35353a;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #000;
  --bs-btn-border-color: #000;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #000;
  --bs-btn-hover-border-color: #000;
  --bs-btn-focus-shadow-rgb: 0, 0, 0;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #000;
  --bs-btn-active-border-color: #000;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #000;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 216, 91, 36;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 10px;
  --bs-btn-padding-x: 30px;
  --bs-btn-font-size: 1.15rem;
  --bs-btn-border-radius: 50px;
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 10px;
  --bs-btn-padding-x: 30px;
  --bs-btn-font-size: 1.15rem;
  --bs-btn-border-radius: 50px;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1.15rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #fe6b2a;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 438px) {
  .dropdown-menu-xxs-start {
    --bs-position: start;
  }
  .dropdown-menu-xxs-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxs-end {
    --bs-position: end;
  }
  .dropdown-menu-xxs-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 664px) {
  .dropdown-menu-mmd-start {
    --bs-position: start;
  }
  .dropdown-menu-mmd-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-mmd-end {
    --bs-position: end;
  }
  .dropdown-menu-mmd-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 880px) {
  .dropdown-menu-mlg-start {
    --bs-position: start;
  }
  .dropdown-menu-mlg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-mlg-end {
    --bs-position: end;
  }
  .dropdown-menu-mlg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1199px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 1.00625rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #fe6b2a;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 50px;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--bs-border-width) * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 22.5px;
  padding-left: 22.5px;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 22.5px;
  padding-left: 22.5px;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 22.5px;
  padding-left: 22.5px;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--bs-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-size: 1.05rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(254, 107, 42, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #fe6b2a;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 1rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.255625rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.4375rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.4375rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: 5px;
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-xxs,
.navbar > .container-sm,
.navbar > .container-mmd,
.navbar > .container-md,
.navbar > .container-mlg,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-size: 1.05rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 438px) {
  .navbar-expand-xxs {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxs .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxs .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxs .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxs .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxs .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxs .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxs .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxs .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxs .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 664px) {
  .navbar-expand-mmd {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-mmd .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-mmd .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-mmd .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-mmd .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-mmd .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-mmd .navbar-toggler {
    display: none;
  }
  .navbar-expand-mmd .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-mmd .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-mmd .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 880px) {
  .navbar-expand-mlg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-mlg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-mlg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-mlg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-mlg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-mlg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-mlg .navbar-toggler {
    display: none;
  }
  .navbar-expand-mlg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-mlg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-mlg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1199px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: #fff;
  --bs-navbar-hover-color: #fe6b2a;
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: #35353a;
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(254, 107, 42, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1.15rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1.15rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(254, 107, 42, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #fe6b2a;
  --bs-pagination-active-border-color: #fe6b2a;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: calc(1.26875rem + 0.225vw);
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}
@media (min-width: 1200px) {
  .pagination-lg {
    --bs-pagination-font-size: 1.4375rem;
  }
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 1.00625rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.6rem;
  --bs-badge-padding-y: 0.4rem;
  --bs-badge-font-size: 0.9rem;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.8625rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #fe6b2a;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: #2a2a30;
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: #2a2a30;
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #fe6b2a;
  --bs-list-group-active-border-color: #fe6b2a;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 438px) {
  .list-group-horizontal-xxs {
    flex-direction: row;
  }
  .list-group-horizontal-xxs > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxs > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxs > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxs > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxs > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 664px) {
  .list-group-horizontal-mmd {
    flex-direction: row;
  }
  .list-group-horizontal-mmd > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-mmd > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-mmd > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-mmd > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-mmd > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 880px) {
  .list-group-horizontal-mlg {
    flex-direction: row;
  }
  .list-group-horizontal-mlg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-mlg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-mlg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-mlg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-mlg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1199px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(254, 107, 42, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 1rem 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.7;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #d0c8c8;
  --bs-backdrop-opacity: 0.8;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1199px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 437.98px) {
  .modal-fullscreen-xxs-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxs-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxs-down .modal-header,
  .modal-fullscreen-xxs-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxs-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 663.98px) {
  .modal-fullscreen-mmd-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-mmd-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-mmd-down .modal-header,
  .modal-fullscreen-mmd-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-mmd-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 879.98px) {
  .modal-fullscreen-mlg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-mlg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-mlg-down .modal-header,
  .modal-fullscreen-mlg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-mlg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1198.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 1.00625rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.7;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 1.00625rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1.15rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.7;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-mlg, .offcanvas-md, .offcanvas-mmd, .offcanvas-sm, .offcanvas-xxs {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.7;
}

@media (max-width: 437.98px) {
  .offcanvas-xxs {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 437.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxs {
    transition: none;
  }
}
@media (max-width: 437.98px) {
  .offcanvas-xxs.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxs.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxs.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxs.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxs.showing, .offcanvas-xxs.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxs.showing, .offcanvas-xxs.hiding, .offcanvas-xxs.show {
    visibility: visible;
  }
}
@media (min-width: 438px) {
  .offcanvas-xxs {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxs .offcanvas-header {
    display: none;
  }
  .offcanvas-xxs .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 663.98px) {
  .offcanvas-mmd {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 663.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-mmd {
    transition: none;
  }
}
@media (max-width: 663.98px) {
  .offcanvas-mmd.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-mmd.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-mmd.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-mmd.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-mmd.showing, .offcanvas-mmd.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-mmd.showing, .offcanvas-mmd.hiding, .offcanvas-mmd.show {
    visibility: visible;
  }
}
@media (min-width: 664px) {
  .offcanvas-mmd {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-mmd .offcanvas-header {
    display: none;
  }
  .offcanvas-mmd .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 879.98px) {
  .offcanvas-mlg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 879.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-mlg {
    transition: none;
  }
}
@media (max-width: 879.98px) {
  .offcanvas-mlg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-mlg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-mlg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-mlg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-mlg.showing, .offcanvas-mlg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-mlg.showing, .offcanvas-mlg.hiding, .offcanvas-mlg.show {
    visibility: visible;
  }
}
@media (min-width: 880px) {
  .offcanvas-mlg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-mlg .offcanvas-header {
    display: none;
  }
  .offcanvas-mlg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1198.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1198.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1198.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1199px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #d0c8c8;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.8;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #000 !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(254, 137, 85, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(254, 137, 85, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(42, 42, 46, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(42, 42, 46, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(0, 0, 0, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(0, 0, 0, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 438px) {
  .sticky-xxs-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxs-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 664px) {
  .sticky-mmd-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-mmd-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 880px) {
  .sticky-mlg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-mlg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1199px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 1;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.opacity-5 {
  opacity: 0.5 !important;
}

.opacity-10 {
  opacity: 0.1 !important;
}

.opacity-15 {
  opacity: 0.15 !important;
}

.opacity-20 {
  opacity: 0.2 !important;
}

.opacity-30 {
  opacity: 0.3 !important;
}

.opacity-35 {
  opacity: 0.35 !important;
}

.opacity-40 {
  opacity: 0.4 !important;
}

.opacity-45 {
  opacity: 0.45 !important;
}

.opacity-60 {
  opacity: 0.6 !important;
}

.opacity-65 {
  opacity: 0.65 !important;
}

.opacity-70 {
  opacity: 0.7 !important;
}

.opacity-80 {
  opacity: 0.8 !important;
}

.opacity-85 {
  opacity: 0.85 !important;
}

.opacity-90 {
  opacity: 0.9 !important;
}

.opacity-95 {
  opacity: 0.95 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.top-1 {
  top: 1% !important;
}

.top-2 {
  top: 2% !important;
}

.top-3 {
  top: 3% !important;
}

.top-4 {
  top: 4% !important;
}

.top-5 {
  top: 5% !important;
}

.top-10 {
  top: 10% !important;
}

.top-15 {
  top: 15% !important;
}

.top-20 {
  top: 20% !important;
}

.top-25 {
  top: 25% !important;
}

.top-30 {
  top: 30% !important;
}

.top-35 {
  top: 35% !important;
}

.top-40 {
  top: 40% !important;
}

.top-45 {
  top: 45% !important;
}

.top-55 {
  top: 55% !important;
}

.top-60 {
  top: 60% !important;
}

.top-65 {
  top: 65% !important;
}

.top-70 {
  top: 70% !important;
}

.top-75 {
  top: 75% !important;
}

.top-80 {
  top: 80% !important;
}

.top-85 {
  top: 85% !important;
}

.top-90 {
  top: 90% !important;
}

.top-95 {
  top: 95% !important;
}

.top-n50 {
  top: -50% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.bottom-1 {
  bottom: 1% !important;
}

.bottom-2 {
  bottom: 2% !important;
}

.bottom-3 {
  bottom: 3% !important;
}

.bottom-4 {
  bottom: 4% !important;
}

.bottom-5 {
  bottom: 5% !important;
}

.bottom-10 {
  bottom: 10% !important;
}

.bottom-15 {
  bottom: 15% !important;
}

.bottom-20 {
  bottom: 20% !important;
}

.bottom-25 {
  bottom: 25% !important;
}

.bottom-30 {
  bottom: 30% !important;
}

.bottom-35 {
  bottom: 35% !important;
}

.bottom-40 {
  bottom: 40% !important;
}

.bottom-45 {
  bottom: 45% !important;
}

.bottom-55 {
  bottom: 55% !important;
}

.bottom-60 {
  bottom: 60% !important;
}

.bottom-65 {
  bottom: 65% !important;
}

.bottom-70 {
  bottom: 70% !important;
}

.bottom-75 {
  bottom: 75% !important;
}

.bottom-80 {
  bottom: 80% !important;
}

.bottom-85 {
  bottom: 85% !important;
}

.bottom-90 {
  bottom: 90% !important;
}

.bottom-95 {
  bottom: 95% !important;
}

.bottom-n50 {
  bottom: -50% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.start-1 {
  left: 1% !important;
}

.start-2 {
  left: 2% !important;
}

.start-3 {
  left: 3% !important;
}

.start-4 {
  left: 4% !important;
}

.start-5 {
  left: 5% !important;
}

.start-10 {
  left: 10% !important;
}

.start-15 {
  left: 15% !important;
}

.start-20 {
  left: 20% !important;
}

.start-25 {
  left: 25% !important;
}

.start-30 {
  left: 30% !important;
}

.start-35 {
  left: 35% !important;
}

.start-40 {
  left: 40% !important;
}

.start-45 {
  left: 45% !important;
}

.start-55 {
  left: 55% !important;
}

.start-60 {
  left: 60% !important;
}

.start-65 {
  left: 65% !important;
}

.start-70 {
  left: 70% !important;
}

.start-75 {
  left: 75% !important;
}

.start-80 {
  left: 80% !important;
}

.start-85 {
  left: 85% !important;
}

.start-90 {
  left: 90% !important;
}

.start-95 {
  left: 95% !important;
}

.start-n50 {
  left: -50% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.end-1 {
  right: 1% !important;
}

.end-2 {
  right: 2% !important;
}

.end-3 {
  right: 3% !important;
}

.end-4 {
  right: 4% !important;
}

.end-5 {
  right: 5% !important;
}

.end-10 {
  right: 10% !important;
}

.end-15 {
  right: 15% !important;
}

.end-20 {
  right: 20% !important;
}

.end-25 {
  right: 25% !important;
}

.end-30 {
  right: 30% !important;
}

.end-35 {
  right: 35% !important;
}

.end-40 {
  right: 40% !important;
}

.end-45 {
  right: 45% !important;
}

.end-55 {
  right: 55% !important;
}

.end-60 {
  right: 60% !important;
}

.end-65 {
  right: 65% !important;
}

.end-70 {
  right: 70% !important;
}

.end-75 {
  right: 75% !important;
}

.end-80 {
  right: 80% !important;
}

.end-85 {
  right: 85% !important;
}

.end-90 {
  right: 90% !important;
}

.end-95 {
  right: 95% !important;
}

.end-n50 {
  right: -50% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.w-5 {
  width: 5% !important;
}

.w-10 {
  width: 10% !important;
}

.w-15 {
  width: 15% !important;
}

.w-20 {
  width: 20% !important;
}

.w-30 {
  width: 30% !important;
}

.w-35 {
  width: 35% !important;
}

.w-40 {
  width: 40% !important;
}

.w-45 {
  width: 45% !important;
}

.w-55 {
  width: 55% !important;
}

.w-60 {
  width: 60% !important;
}

.w-65 {
  width: 65% !important;
}

.w-70 {
  width: 70% !important;
}

.w-80 {
  width: 80% !important;
}

.w-85 {
  width: 85% !important;
}

.w-90 {
  width: 90% !important;
}

.w-95 {
  width: 95% !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.h-5 {
  height: 5% !important;
}

.h-10 {
  height: 10% !important;
}

.h-15 {
  height: 15% !important;
}

.h-20 {
  height: 20% !important;
}

.h-30 {
  height: 30% !important;
}

.h-35 {
  height: 35% !important;
}

.h-40 {
  height: 40% !important;
}

.h-45 {
  height: 45% !important;
}

.h-55 {
  height: 55% !important;
}

.h-60 {
  height: 60% !important;
}

.h-65 {
  height: 65% !important;
}

.h-70 {
  height: 70% !important;
}

.h-80 {
  height: 80% !important;
}

.h-85 {
  height: 85% !important;
}

.h-90 {
  height: 90% !important;
}

.h-95 {
  height: 95% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-6 {
  margin: 4.5rem !important;
}

.m-7 {
  margin: 6rem !important;
}

.m-8 {
  margin: 8rem !important;
}

.m-9 {
  margin: 12rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-6 {
  margin-right: 4.5rem !important;
  margin-left: 4.5rem !important;
}

.mx-7 {
  margin-right: 6rem !important;
  margin-left: 6rem !important;
}

.mx-8 {
  margin-right: 8rem !important;
  margin-left: 8rem !important;
}

.mx-9 {
  margin-right: 12rem !important;
  margin-left: 12rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-6 {
  margin-top: 4.5rem !important;
  margin-bottom: 4.5rem !important;
}

.my-7 {
  margin-top: 6rem !important;
  margin-bottom: 6rem !important;
}

.my-8 {
  margin-top: 8rem !important;
  margin-bottom: 8rem !important;
}

.my-9 {
  margin-top: 12rem !important;
  margin-bottom: 12rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-6 {
  margin-top: 4.5rem !important;
}

.mt-7 {
  margin-top: 6rem !important;
}

.mt-8 {
  margin-top: 8rem !important;
}

.mt-9 {
  margin-top: 12rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-6 {
  margin-right: 4.5rem !important;
}

.me-7 {
  margin-right: 6rem !important;
}

.me-8 {
  margin-right: 8rem !important;
}

.me-9 {
  margin-right: 12rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-6 {
  margin-bottom: 4.5rem !important;
}

.mb-7 {
  margin-bottom: 6rem !important;
}

.mb-8 {
  margin-bottom: 8rem !important;
}

.mb-9 {
  margin-bottom: 12rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-6 {
  margin-left: 4.5rem !important;
}

.ms-7 {
  margin-left: 6rem !important;
}

.ms-8 {
  margin-left: 8rem !important;
}

.ms-9 {
  margin-left: 12rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.m-n6 {
  margin: -4.5rem !important;
}

.m-n7 {
  margin: -6rem !important;
}

.m-n8 {
  margin: -8rem !important;
}

.m-n9 {
  margin: -12rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.mx-n6 {
  margin-right: -4.5rem !important;
  margin-left: -4.5rem !important;
}

.mx-n7 {
  margin-right: -6rem !important;
  margin-left: -6rem !important;
}

.mx-n8 {
  margin-right: -8rem !important;
  margin-left: -8rem !important;
}

.mx-n9 {
  margin-right: -12rem !important;
  margin-left: -12rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.my-n6 {
  margin-top: -4.5rem !important;
  margin-bottom: -4.5rem !important;
}

.my-n7 {
  margin-top: -6rem !important;
  margin-bottom: -6rem !important;
}

.my-n8 {
  margin-top: -8rem !important;
  margin-bottom: -8rem !important;
}

.my-n9 {
  margin-top: -12rem !important;
  margin-bottom: -12rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -1rem !important;
}

.mt-n4 {
  margin-top: -1.5rem !important;
}

.mt-n5 {
  margin-top: -3rem !important;
}

.mt-n6 {
  margin-top: -4.5rem !important;
}

.mt-n7 {
  margin-top: -6rem !important;
}

.mt-n8 {
  margin-top: -8rem !important;
}

.mt-n9 {
  margin-top: -12rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -1rem !important;
}

.me-n4 {
  margin-right: -1.5rem !important;
}

.me-n5 {
  margin-right: -3rem !important;
}

.me-n6 {
  margin-right: -4.5rem !important;
}

.me-n7 {
  margin-right: -6rem !important;
}

.me-n8 {
  margin-right: -8rem !important;
}

.me-n9 {
  margin-right: -12rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -1rem !important;
}

.mb-n4 {
  margin-bottom: -1.5rem !important;
}

.mb-n5 {
  margin-bottom: -3rem !important;
}

.mb-n6 {
  margin-bottom: -4.5rem !important;
}

.mb-n7 {
  margin-bottom: -6rem !important;
}

.mb-n8 {
  margin-bottom: -8rem !important;
}

.mb-n9 {
  margin-bottom: -12rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -1rem !important;
}

.ms-n4 {
  margin-left: -1.5rem !important;
}

.ms-n5 {
  margin-left: -3rem !important;
}

.ms-n6 {
  margin-left: -4.5rem !important;
}

.ms-n7 {
  margin-left: -6rem !important;
}

.ms-n8 {
  margin-left: -8rem !important;
}

.ms-n9 {
  margin-left: -12rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.p-6 {
  padding: 4.5rem !important;
}

.p-7 {
  padding: 6rem !important;
}

.p-8 {
  padding: 8rem !important;
}

.p-9 {
  padding: 12rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.px-6 {
  padding-right: 4.5rem !important;
  padding-left: 4.5rem !important;
}

.px-7 {
  padding-right: 6rem !important;
  padding-left: 6rem !important;
}

.px-8 {
  padding-right: 8rem !important;
  padding-left: 8rem !important;
}

.px-9 {
  padding-right: 12rem !important;
  padding-left: 12rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.py-6 {
  padding-top: 4.5rem !important;
  padding-bottom: 4.5rem !important;
}

.py-7 {
  padding-top: 6rem !important;
  padding-bottom: 6rem !important;
}

.py-8 {
  padding-top: 8rem !important;
  padding-bottom: 8rem !important;
}

.py-9 {
  padding-top: 12rem !important;
  padding-bottom: 12rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pt-6 {
  padding-top: 4.5rem !important;
}

.pt-7 {
  padding-top: 6rem !important;
}

.pt-8 {
  padding-top: 8rem !important;
}

.pt-9 {
  padding-top: 12rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pe-6 {
  padding-right: 4.5rem !important;
}

.pe-7 {
  padding-right: 6rem !important;
}

.pe-8 {
  padding-right: 8rem !important;
}

.pe-9 {
  padding-right: 12rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.pb-6 {
  padding-bottom: 4.5rem !important;
}

.pb-7 {
  padding-bottom: 6rem !important;
}

.pb-8 {
  padding-bottom: 8rem !important;
}

.pb-9 {
  padding-bottom: 12rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.ps-6 {
  padding-left: 4.5rem !important;
}

.ps-7 {
  padding-left: 6rem !important;
}

.ps-8 {
  padding-left: 8rem !important;
}

.ps-9 {
  padding-left: 12rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.gap-6 {
  gap: 4.5rem !important;
}

.gap-7 {
  gap: 6rem !important;
}

.gap-8 {
  gap: 8rem !important;
}

.gap-9 {
  gap: 12rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.row-gap-6 {
  row-gap: 4.5rem !important;
}

.row-gap-7 {
  row-gap: 6rem !important;
}

.row-gap-8 {
  row-gap: 8rem !important;
}

.row-gap-9 {
  row-gap: 12rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.column-gap-6 {
  column-gap: 4.5rem !important;
}

.column-gap-7 {
  column-gap: 6rem !important;
}

.column-gap-8 {
  column-gap: 8rem !important;
}

.column-gap-9 {
  column-gap: 12rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.4125rem + 1.95vw) !important;
}

.fs-2 {
  font-size: calc(1.355rem + 1.26vw) !important;
}

.fs-3 {
  font-size: calc(1.32625rem + 0.915vw) !important;
}

.fs-4 {
  font-size: calc(1.2975rem + 0.57vw) !important;
}

.fs-5 {
  font-size: calc(1.26875rem + 0.225vw) !important;
}

.fs-6 {
  font-size: 1.15rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.7 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  user-select: all !important;
}

.user-select-auto {
  user-select: auto !important;
}

.user-select-none {
  user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-6 {
  border-radius: 3rem !important;
}

.rounded-7 {
  border-radius: 4rem !important;
}

.rounded-8 {
  border-radius: 5rem !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 438px) {
  .float-xxs-start {
    float: left !important;
  }
  .float-xxs-end {
    float: right !important;
  }
  .float-xxs-none {
    float: none !important;
  }
  .object-fit-xxs-contain {
    object-fit: contain !important;
  }
  .object-fit-xxs-cover {
    object-fit: cover !important;
  }
  .object-fit-xxs-fill {
    object-fit: fill !important;
  }
  .object-fit-xxs-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxs-none {
    object-fit: none !important;
  }
  .opacity-xxs-0 {
    opacity: 0 !important;
  }
  .opacity-xxs-25 {
    opacity: 0.25 !important;
  }
  .opacity-xxs-50 {
    opacity: 0.5 !important;
  }
  .opacity-xxs-75 {
    opacity: 0.75 !important;
  }
  .opacity-xxs-100 {
    opacity: 1 !important;
  }
  .opacity-xxs-5 {
    opacity: 0.5 !important;
  }
  .opacity-xxs-10 {
    opacity: 0.1 !important;
  }
  .opacity-xxs-15 {
    opacity: 0.15 !important;
  }
  .opacity-xxs-20 {
    opacity: 0.2 !important;
  }
  .opacity-xxs-30 {
    opacity: 0.3 !important;
  }
  .opacity-xxs-35 {
    opacity: 0.35 !important;
  }
  .opacity-xxs-40 {
    opacity: 0.4 !important;
  }
  .opacity-xxs-45 {
    opacity: 0.45 !important;
  }
  .opacity-xxs-60 {
    opacity: 0.6 !important;
  }
  .opacity-xxs-65 {
    opacity: 0.65 !important;
  }
  .opacity-xxs-70 {
    opacity: 0.7 !important;
  }
  .opacity-xxs-80 {
    opacity: 0.8 !important;
  }
  .opacity-xxs-85 {
    opacity: 0.85 !important;
  }
  .opacity-xxs-90 {
    opacity: 0.9 !important;
  }
  .opacity-xxs-95 {
    opacity: 0.95 !important;
  }
  .d-xxs-inline {
    display: inline !important;
  }
  .d-xxs-inline-block {
    display: inline-block !important;
  }
  .d-xxs-block {
    display: block !important;
  }
  .d-xxs-grid {
    display: grid !important;
  }
  .d-xxs-inline-grid {
    display: inline-grid !important;
  }
  .d-xxs-table {
    display: table !important;
  }
  .d-xxs-table-row {
    display: table-row !important;
  }
  .d-xxs-table-cell {
    display: table-cell !important;
  }
  .d-xxs-flex {
    display: flex !important;
  }
  .d-xxs-inline-flex {
    display: inline-flex !important;
  }
  .d-xxs-none {
    display: none !important;
  }
  .top-xxs-0 {
    top: 0 !important;
  }
  .top-xxs-50 {
    top: 50% !important;
  }
  .top-xxs-100 {
    top: 100% !important;
  }
  .top-xxs-1 {
    top: 1% !important;
  }
  .top-xxs-2 {
    top: 2% !important;
  }
  .top-xxs-3 {
    top: 3% !important;
  }
  .top-xxs-4 {
    top: 4% !important;
  }
  .top-xxs-5 {
    top: 5% !important;
  }
  .top-xxs-10 {
    top: 10% !important;
  }
  .top-xxs-15 {
    top: 15% !important;
  }
  .top-xxs-20 {
    top: 20% !important;
  }
  .top-xxs-25 {
    top: 25% !important;
  }
  .top-xxs-30 {
    top: 30% !important;
  }
  .top-xxs-35 {
    top: 35% !important;
  }
  .top-xxs-40 {
    top: 40% !important;
  }
  .top-xxs-45 {
    top: 45% !important;
  }
  .top-xxs-55 {
    top: 55% !important;
  }
  .top-xxs-60 {
    top: 60% !important;
  }
  .top-xxs-65 {
    top: 65% !important;
  }
  .top-xxs-70 {
    top: 70% !important;
  }
  .top-xxs-75 {
    top: 75% !important;
  }
  .top-xxs-80 {
    top: 80% !important;
  }
  .top-xxs-85 {
    top: 85% !important;
  }
  .top-xxs-90 {
    top: 90% !important;
  }
  .top-xxs-95 {
    top: 95% !important;
  }
  .top-xxs-n50 {
    top: -50% !important;
  }
  .bottom-xxs-0 {
    bottom: 0 !important;
  }
  .bottom-xxs-50 {
    bottom: 50% !important;
  }
  .bottom-xxs-100 {
    bottom: 100% !important;
  }
  .bottom-xxs-1 {
    bottom: 1% !important;
  }
  .bottom-xxs-2 {
    bottom: 2% !important;
  }
  .bottom-xxs-3 {
    bottom: 3% !important;
  }
  .bottom-xxs-4 {
    bottom: 4% !important;
  }
  .bottom-xxs-5 {
    bottom: 5% !important;
  }
  .bottom-xxs-10 {
    bottom: 10% !important;
  }
  .bottom-xxs-15 {
    bottom: 15% !important;
  }
  .bottom-xxs-20 {
    bottom: 20% !important;
  }
  .bottom-xxs-25 {
    bottom: 25% !important;
  }
  .bottom-xxs-30 {
    bottom: 30% !important;
  }
  .bottom-xxs-35 {
    bottom: 35% !important;
  }
  .bottom-xxs-40 {
    bottom: 40% !important;
  }
  .bottom-xxs-45 {
    bottom: 45% !important;
  }
  .bottom-xxs-55 {
    bottom: 55% !important;
  }
  .bottom-xxs-60 {
    bottom: 60% !important;
  }
  .bottom-xxs-65 {
    bottom: 65% !important;
  }
  .bottom-xxs-70 {
    bottom: 70% !important;
  }
  .bottom-xxs-75 {
    bottom: 75% !important;
  }
  .bottom-xxs-80 {
    bottom: 80% !important;
  }
  .bottom-xxs-85 {
    bottom: 85% !important;
  }
  .bottom-xxs-90 {
    bottom: 90% !important;
  }
  .bottom-xxs-95 {
    bottom: 95% !important;
  }
  .bottom-xxs-n50 {
    bottom: -50% !important;
  }
  .start-xxs-0 {
    left: 0 !important;
  }
  .start-xxs-50 {
    left: 50% !important;
  }
  .start-xxs-100 {
    left: 100% !important;
  }
  .start-xxs-1 {
    left: 1% !important;
  }
  .start-xxs-2 {
    left: 2% !important;
  }
  .start-xxs-3 {
    left: 3% !important;
  }
  .start-xxs-4 {
    left: 4% !important;
  }
  .start-xxs-5 {
    left: 5% !important;
  }
  .start-xxs-10 {
    left: 10% !important;
  }
  .start-xxs-15 {
    left: 15% !important;
  }
  .start-xxs-20 {
    left: 20% !important;
  }
  .start-xxs-25 {
    left: 25% !important;
  }
  .start-xxs-30 {
    left: 30% !important;
  }
  .start-xxs-35 {
    left: 35% !important;
  }
  .start-xxs-40 {
    left: 40% !important;
  }
  .start-xxs-45 {
    left: 45% !important;
  }
  .start-xxs-55 {
    left: 55% !important;
  }
  .start-xxs-60 {
    left: 60% !important;
  }
  .start-xxs-65 {
    left: 65% !important;
  }
  .start-xxs-70 {
    left: 70% !important;
  }
  .start-xxs-75 {
    left: 75% !important;
  }
  .start-xxs-80 {
    left: 80% !important;
  }
  .start-xxs-85 {
    left: 85% !important;
  }
  .start-xxs-90 {
    left: 90% !important;
  }
  .start-xxs-95 {
    left: 95% !important;
  }
  .start-xxs-n50 {
    left: -50% !important;
  }
  .end-xxs-0 {
    right: 0 !important;
  }
  .end-xxs-50 {
    right: 50% !important;
  }
  .end-xxs-100 {
    right: 100% !important;
  }
  .end-xxs-1 {
    right: 1% !important;
  }
  .end-xxs-2 {
    right: 2% !important;
  }
  .end-xxs-3 {
    right: 3% !important;
  }
  .end-xxs-4 {
    right: 4% !important;
  }
  .end-xxs-5 {
    right: 5% !important;
  }
  .end-xxs-10 {
    right: 10% !important;
  }
  .end-xxs-15 {
    right: 15% !important;
  }
  .end-xxs-20 {
    right: 20% !important;
  }
  .end-xxs-25 {
    right: 25% !important;
  }
  .end-xxs-30 {
    right: 30% !important;
  }
  .end-xxs-35 {
    right: 35% !important;
  }
  .end-xxs-40 {
    right: 40% !important;
  }
  .end-xxs-45 {
    right: 45% !important;
  }
  .end-xxs-55 {
    right: 55% !important;
  }
  .end-xxs-60 {
    right: 60% !important;
  }
  .end-xxs-65 {
    right: 65% !important;
  }
  .end-xxs-70 {
    right: 70% !important;
  }
  .end-xxs-75 {
    right: 75% !important;
  }
  .end-xxs-80 {
    right: 80% !important;
  }
  .end-xxs-85 {
    right: 85% !important;
  }
  .end-xxs-90 {
    right: 90% !important;
  }
  .end-xxs-95 {
    right: 95% !important;
  }
  .end-xxs-n50 {
    right: -50% !important;
  }
  .w-xxs-25 {
    width: 25% !important;
  }
  .w-xxs-50 {
    width: 50% !important;
  }
  .w-xxs-75 {
    width: 75% !important;
  }
  .w-xxs-100 {
    width: 100% !important;
  }
  .w-xxs-auto {
    width: auto !important;
  }
  .w-xxs-5 {
    width: 5% !important;
  }
  .w-xxs-10 {
    width: 10% !important;
  }
  .w-xxs-15 {
    width: 15% !important;
  }
  .w-xxs-20 {
    width: 20% !important;
  }
  .w-xxs-30 {
    width: 30% !important;
  }
  .w-xxs-35 {
    width: 35% !important;
  }
  .w-xxs-40 {
    width: 40% !important;
  }
  .w-xxs-45 {
    width: 45% !important;
  }
  .w-xxs-55 {
    width: 55% !important;
  }
  .w-xxs-60 {
    width: 60% !important;
  }
  .w-xxs-65 {
    width: 65% !important;
  }
  .w-xxs-70 {
    width: 70% !important;
  }
  .w-xxs-80 {
    width: 80% !important;
  }
  .w-xxs-85 {
    width: 85% !important;
  }
  .w-xxs-90 {
    width: 90% !important;
  }
  .w-xxs-95 {
    width: 95% !important;
  }
  .h-xxs-25 {
    height: 25% !important;
  }
  .h-xxs-50 {
    height: 50% !important;
  }
  .h-xxs-75 {
    height: 75% !important;
  }
  .h-xxs-100 {
    height: 100% !important;
  }
  .h-xxs-auto {
    height: auto !important;
  }
  .h-xxs-5 {
    height: 5% !important;
  }
  .h-xxs-10 {
    height: 10% !important;
  }
  .h-xxs-15 {
    height: 15% !important;
  }
  .h-xxs-20 {
    height: 20% !important;
  }
  .h-xxs-30 {
    height: 30% !important;
  }
  .h-xxs-35 {
    height: 35% !important;
  }
  .h-xxs-40 {
    height: 40% !important;
  }
  .h-xxs-45 {
    height: 45% !important;
  }
  .h-xxs-55 {
    height: 55% !important;
  }
  .h-xxs-60 {
    height: 60% !important;
  }
  .h-xxs-65 {
    height: 65% !important;
  }
  .h-xxs-70 {
    height: 70% !important;
  }
  .h-xxs-80 {
    height: 80% !important;
  }
  .h-xxs-85 {
    height: 85% !important;
  }
  .h-xxs-90 {
    height: 90% !important;
  }
  .h-xxs-95 {
    height: 95% !important;
  }
  .flex-xxs-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxs-row {
    flex-direction: row !important;
  }
  .flex-xxs-column {
    flex-direction: column !important;
  }
  .flex-xxs-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxs-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxs-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxs-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxs-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxs-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxs-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxs-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxs-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxs-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxs-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxs-center {
    justify-content: center !important;
  }
  .justify-content-xxs-between {
    justify-content: space-between !important;
  }
  .justify-content-xxs-around {
    justify-content: space-around !important;
  }
  .justify-content-xxs-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxs-start {
    align-items: flex-start !important;
  }
  .align-items-xxs-end {
    align-items: flex-end !important;
  }
  .align-items-xxs-center {
    align-items: center !important;
  }
  .align-items-xxs-baseline {
    align-items: baseline !important;
  }
  .align-items-xxs-stretch {
    align-items: stretch !important;
  }
  .align-content-xxs-start {
    align-content: flex-start !important;
  }
  .align-content-xxs-end {
    align-content: flex-end !important;
  }
  .align-content-xxs-center {
    align-content: center !important;
  }
  .align-content-xxs-between {
    align-content: space-between !important;
  }
  .align-content-xxs-around {
    align-content: space-around !important;
  }
  .align-content-xxs-stretch {
    align-content: stretch !important;
  }
  .align-self-xxs-auto {
    align-self: auto !important;
  }
  .align-self-xxs-start {
    align-self: flex-start !important;
  }
  .align-self-xxs-end {
    align-self: flex-end !important;
  }
  .align-self-xxs-center {
    align-self: center !important;
  }
  .align-self-xxs-baseline {
    align-self: baseline !important;
  }
  .align-self-xxs-stretch {
    align-self: stretch !important;
  }
  .order-xxs-first {
    order: -1 !important;
  }
  .order-xxs-0 {
    order: 0 !important;
  }
  .order-xxs-1 {
    order: 1 !important;
  }
  .order-xxs-2 {
    order: 2 !important;
  }
  .order-xxs-3 {
    order: 3 !important;
  }
  .order-xxs-4 {
    order: 4 !important;
  }
  .order-xxs-5 {
    order: 5 !important;
  }
  .order-xxs-last {
    order: 6 !important;
  }
  .m-xxs-0 {
    margin: 0 !important;
  }
  .m-xxs-1 {
    margin: 0.25rem !important;
  }
  .m-xxs-2 {
    margin: 0.5rem !important;
  }
  .m-xxs-3 {
    margin: 1rem !important;
  }
  .m-xxs-4 {
    margin: 1.5rem !important;
  }
  .m-xxs-5 {
    margin: 3rem !important;
  }
  .m-xxs-6 {
    margin: 4.5rem !important;
  }
  .m-xxs-7 {
    margin: 6rem !important;
  }
  .m-xxs-8 {
    margin: 8rem !important;
  }
  .m-xxs-9 {
    margin: 12rem !important;
  }
  .m-xxs-auto {
    margin: auto !important;
  }
  .mx-xxs-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxs-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxs-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxs-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxs-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxs-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxs-6 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-xxs-7 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-xxs-8 {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-xxs-9 {
    margin-right: 12rem !important;
    margin-left: 12rem !important;
  }
  .mx-xxs-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxs-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxs-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxs-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxs-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxs-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxs-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxs-6 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-xxs-7 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-xxs-8 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-xxs-9 {
    margin-top: 12rem !important;
    margin-bottom: 12rem !important;
  }
  .my-xxs-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxs-0 {
    margin-top: 0 !important;
  }
  .mt-xxs-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxs-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxs-3 {
    margin-top: 1rem !important;
  }
  .mt-xxs-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxs-5 {
    margin-top: 3rem !important;
  }
  .mt-xxs-6 {
    margin-top: 4.5rem !important;
  }
  .mt-xxs-7 {
    margin-top: 6rem !important;
  }
  .mt-xxs-8 {
    margin-top: 8rem !important;
  }
  .mt-xxs-9 {
    margin-top: 12rem !important;
  }
  .mt-xxs-auto {
    margin-top: auto !important;
  }
  .me-xxs-0 {
    margin-right: 0 !important;
  }
  .me-xxs-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxs-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxs-3 {
    margin-right: 1rem !important;
  }
  .me-xxs-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxs-5 {
    margin-right: 3rem !important;
  }
  .me-xxs-6 {
    margin-right: 4.5rem !important;
  }
  .me-xxs-7 {
    margin-right: 6rem !important;
  }
  .me-xxs-8 {
    margin-right: 8rem !important;
  }
  .me-xxs-9 {
    margin-right: 12rem !important;
  }
  .me-xxs-auto {
    margin-right: auto !important;
  }
  .mb-xxs-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxs-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxs-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxs-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxs-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxs-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxs-6 {
    margin-bottom: 4.5rem !important;
  }
  .mb-xxs-7 {
    margin-bottom: 6rem !important;
  }
  .mb-xxs-8 {
    margin-bottom: 8rem !important;
  }
  .mb-xxs-9 {
    margin-bottom: 12rem !important;
  }
  .mb-xxs-auto {
    margin-bottom: auto !important;
  }
  .ms-xxs-0 {
    margin-left: 0 !important;
  }
  .ms-xxs-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxs-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxs-3 {
    margin-left: 1rem !important;
  }
  .ms-xxs-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxs-5 {
    margin-left: 3rem !important;
  }
  .ms-xxs-6 {
    margin-left: 4.5rem !important;
  }
  .ms-xxs-7 {
    margin-left: 6rem !important;
  }
  .ms-xxs-8 {
    margin-left: 8rem !important;
  }
  .ms-xxs-9 {
    margin-left: 12rem !important;
  }
  .ms-xxs-auto {
    margin-left: auto !important;
  }
  .m-xxs-n1 {
    margin: -0.25rem !important;
  }
  .m-xxs-n2 {
    margin: -0.5rem !important;
  }
  .m-xxs-n3 {
    margin: -1rem !important;
  }
  .m-xxs-n4 {
    margin: -1.5rem !important;
  }
  .m-xxs-n5 {
    margin: -3rem !important;
  }
  .m-xxs-n6 {
    margin: -4.5rem !important;
  }
  .m-xxs-n7 {
    margin: -6rem !important;
  }
  .m-xxs-n8 {
    margin: -8rem !important;
  }
  .m-xxs-n9 {
    margin: -12rem !important;
  }
  .mx-xxs-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xxs-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xxs-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xxs-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxs-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-xxs-n6 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-xxs-n7 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-xxs-n8 {
    margin-right: -8rem !important;
    margin-left: -8rem !important;
  }
  .mx-xxs-n9 {
    margin-right: -12rem !important;
    margin-left: -12rem !important;
  }
  .my-xxs-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xxs-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xxs-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xxs-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxs-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-xxs-n6 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-xxs-n7 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-xxs-n8 {
    margin-top: -8rem !important;
    margin-bottom: -8rem !important;
  }
  .my-xxs-n9 {
    margin-top: -12rem !important;
    margin-bottom: -12rem !important;
  }
  .mt-xxs-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xxs-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xxs-n3 {
    margin-top: -1rem !important;
  }
  .mt-xxs-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xxs-n5 {
    margin-top: -3rem !important;
  }
  .mt-xxs-n6 {
    margin-top: -4.5rem !important;
  }
  .mt-xxs-n7 {
    margin-top: -6rem !important;
  }
  .mt-xxs-n8 {
    margin-top: -8rem !important;
  }
  .mt-xxs-n9 {
    margin-top: -12rem !important;
  }
  .me-xxs-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xxs-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xxs-n3 {
    margin-right: -1rem !important;
  }
  .me-xxs-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xxs-n5 {
    margin-right: -3rem !important;
  }
  .me-xxs-n6 {
    margin-right: -4.5rem !important;
  }
  .me-xxs-n7 {
    margin-right: -6rem !important;
  }
  .me-xxs-n8 {
    margin-right: -8rem !important;
  }
  .me-xxs-n9 {
    margin-right: -12rem !important;
  }
  .mb-xxs-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xxs-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xxs-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xxs-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxs-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-xxs-n6 {
    margin-bottom: -4.5rem !important;
  }
  .mb-xxs-n7 {
    margin-bottom: -6rem !important;
  }
  .mb-xxs-n8 {
    margin-bottom: -8rem !important;
  }
  .mb-xxs-n9 {
    margin-bottom: -12rem !important;
  }
  .ms-xxs-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xxs-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xxs-n3 {
    margin-left: -1rem !important;
  }
  .ms-xxs-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xxs-n5 {
    margin-left: -3rem !important;
  }
  .ms-xxs-n6 {
    margin-left: -4.5rem !important;
  }
  .ms-xxs-n7 {
    margin-left: -6rem !important;
  }
  .ms-xxs-n8 {
    margin-left: -8rem !important;
  }
  .ms-xxs-n9 {
    margin-left: -12rem !important;
  }
  .p-xxs-0 {
    padding: 0 !important;
  }
  .p-xxs-1 {
    padding: 0.25rem !important;
  }
  .p-xxs-2 {
    padding: 0.5rem !important;
  }
  .p-xxs-3 {
    padding: 1rem !important;
  }
  .p-xxs-4 {
    padding: 1.5rem !important;
  }
  .p-xxs-5 {
    padding: 3rem !important;
  }
  .p-xxs-6 {
    padding: 4.5rem !important;
  }
  .p-xxs-7 {
    padding: 6rem !important;
  }
  .p-xxs-8 {
    padding: 8rem !important;
  }
  .p-xxs-9 {
    padding: 12rem !important;
  }
  .px-xxs-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxs-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxs-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxs-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxs-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxs-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-xxs-6 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-xxs-7 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-xxs-8 {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .px-xxs-9 {
    padding-right: 12rem !important;
    padding-left: 12rem !important;
  }
  .py-xxs-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxs-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxs-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxs-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxs-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxs-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-xxs-6 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-xxs-7 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-xxs-8 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .py-xxs-9 {
    padding-top: 12rem !important;
    padding-bottom: 12rem !important;
  }
  .pt-xxs-0 {
    padding-top: 0 !important;
  }
  .pt-xxs-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxs-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxs-3 {
    padding-top: 1rem !important;
  }
  .pt-xxs-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxs-5 {
    padding-top: 3rem !important;
  }
  .pt-xxs-6 {
    padding-top: 4.5rem !important;
  }
  .pt-xxs-7 {
    padding-top: 6rem !important;
  }
  .pt-xxs-8 {
    padding-top: 8rem !important;
  }
  .pt-xxs-9 {
    padding-top: 12rem !important;
  }
  .pe-xxs-0 {
    padding-right: 0 !important;
  }
  .pe-xxs-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxs-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxs-3 {
    padding-right: 1rem !important;
  }
  .pe-xxs-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxs-5 {
    padding-right: 3rem !important;
  }
  .pe-xxs-6 {
    padding-right: 4.5rem !important;
  }
  .pe-xxs-7 {
    padding-right: 6rem !important;
  }
  .pe-xxs-8 {
    padding-right: 8rem !important;
  }
  .pe-xxs-9 {
    padding-right: 12rem !important;
  }
  .pb-xxs-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxs-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxs-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxs-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxs-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxs-5 {
    padding-bottom: 3rem !important;
  }
  .pb-xxs-6 {
    padding-bottom: 4.5rem !important;
  }
  .pb-xxs-7 {
    padding-bottom: 6rem !important;
  }
  .pb-xxs-8 {
    padding-bottom: 8rem !important;
  }
  .pb-xxs-9 {
    padding-bottom: 12rem !important;
  }
  .ps-xxs-0 {
    padding-left: 0 !important;
  }
  .ps-xxs-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxs-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxs-3 {
    padding-left: 1rem !important;
  }
  .ps-xxs-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxs-5 {
    padding-left: 3rem !important;
  }
  .ps-xxs-6 {
    padding-left: 4.5rem !important;
  }
  .ps-xxs-7 {
    padding-left: 6rem !important;
  }
  .ps-xxs-8 {
    padding-left: 8rem !important;
  }
  .ps-xxs-9 {
    padding-left: 12rem !important;
  }
  .gap-xxs-0 {
    gap: 0 !important;
  }
  .gap-xxs-1 {
    gap: 0.25rem !important;
  }
  .gap-xxs-2 {
    gap: 0.5rem !important;
  }
  .gap-xxs-3 {
    gap: 1rem !important;
  }
  .gap-xxs-4 {
    gap: 1.5rem !important;
  }
  .gap-xxs-5 {
    gap: 3rem !important;
  }
  .gap-xxs-6 {
    gap: 4.5rem !important;
  }
  .gap-xxs-7 {
    gap: 6rem !important;
  }
  .gap-xxs-8 {
    gap: 8rem !important;
  }
  .gap-xxs-9 {
    gap: 12rem !important;
  }
  .row-gap-xxs-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxs-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxs-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxs-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxs-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxs-5 {
    row-gap: 3rem !important;
  }
  .row-gap-xxs-6 {
    row-gap: 4.5rem !important;
  }
  .row-gap-xxs-7 {
    row-gap: 6rem !important;
  }
  .row-gap-xxs-8 {
    row-gap: 8rem !important;
  }
  .row-gap-xxs-9 {
    row-gap: 12rem !important;
  }
  .column-gap-xxs-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxs-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxs-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxs-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxs-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxs-5 {
    column-gap: 3rem !important;
  }
  .column-gap-xxs-6 {
    column-gap: 4.5rem !important;
  }
  .column-gap-xxs-7 {
    column-gap: 6rem !important;
  }
  .column-gap-xxs-8 {
    column-gap: 8rem !important;
  }
  .column-gap-xxs-9 {
    column-gap: 12rem !important;
  }
  .fs-xxs-1 {
    font-size: calc(1.4125rem + 1.95vw) !important;
  }
  .fs-xxs-2 {
    font-size: calc(1.355rem + 1.26vw) !important;
  }
  .fs-xxs-3 {
    font-size: calc(1.32625rem + 0.915vw) !important;
  }
  .fs-xxs-4 {
    font-size: calc(1.2975rem + 0.57vw) !important;
  }
  .fs-xxs-5 {
    font-size: calc(1.26875rem + 0.225vw) !important;
  }
  .fs-xxs-6 {
    font-size: 1.15rem !important;
  }
  .text-xxs-start {
    text-align: left !important;
  }
  .text-xxs-end {
    text-align: right !important;
  }
  .text-xxs-center {
    text-align: center !important;
  }
  .text-xxs-primary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxs-secondary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxs-success {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxs-info {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxs-warning {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxs-danger {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxs-light {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxs-dark {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxs-black {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxs-white {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxs-body {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxs-muted {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important;
  }
  .text-xxs-black-50 {
    --bs-text-opacity: 1;
    color: rgba(0, 0, 0, 0.5) !important;
  }
  .text-xxs-white-50 {
    --bs-text-opacity: 1;
    color: rgba(255, 255, 255, 0.5) !important;
  }
  .text-xxs-body-secondary {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important;
  }
  .text-xxs-body-tertiary {
    --bs-text-opacity: 1;
    color: var(--bs-tertiary-color) !important;
  }
  .text-xxs-body-emphasis {
    --bs-text-opacity: 1;
    color: var(--bs-emphasis-color) !important;
  }
  .text-xxs-reset {
    --bs-text-opacity: 1;
    color: inherit !important;
  }
}
@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .opacity-sm-0 {
    opacity: 0 !important;
  }
  .opacity-sm-25 {
    opacity: 0.25 !important;
  }
  .opacity-sm-50 {
    opacity: 0.5 !important;
  }
  .opacity-sm-75 {
    opacity: 0.75 !important;
  }
  .opacity-sm-100 {
    opacity: 1 !important;
  }
  .opacity-sm-5 {
    opacity: 0.5 !important;
  }
  .opacity-sm-10 {
    opacity: 0.1 !important;
  }
  .opacity-sm-15 {
    opacity: 0.15 !important;
  }
  .opacity-sm-20 {
    opacity: 0.2 !important;
  }
  .opacity-sm-30 {
    opacity: 0.3 !important;
  }
  .opacity-sm-35 {
    opacity: 0.35 !important;
  }
  .opacity-sm-40 {
    opacity: 0.4 !important;
  }
  .opacity-sm-45 {
    opacity: 0.45 !important;
  }
  .opacity-sm-60 {
    opacity: 0.6 !important;
  }
  .opacity-sm-65 {
    opacity: 0.65 !important;
  }
  .opacity-sm-70 {
    opacity: 0.7 !important;
  }
  .opacity-sm-80 {
    opacity: 0.8 !important;
  }
  .opacity-sm-85 {
    opacity: 0.85 !important;
  }
  .opacity-sm-90 {
    opacity: 0.9 !important;
  }
  .opacity-sm-95 {
    opacity: 0.95 !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .top-sm-0 {
    top: 0 !important;
  }
  .top-sm-50 {
    top: 50% !important;
  }
  .top-sm-100 {
    top: 100% !important;
  }
  .top-sm-1 {
    top: 1% !important;
  }
  .top-sm-2 {
    top: 2% !important;
  }
  .top-sm-3 {
    top: 3% !important;
  }
  .top-sm-4 {
    top: 4% !important;
  }
  .top-sm-5 {
    top: 5% !important;
  }
  .top-sm-10 {
    top: 10% !important;
  }
  .top-sm-15 {
    top: 15% !important;
  }
  .top-sm-20 {
    top: 20% !important;
  }
  .top-sm-25 {
    top: 25% !important;
  }
  .top-sm-30 {
    top: 30% !important;
  }
  .top-sm-35 {
    top: 35% !important;
  }
  .top-sm-40 {
    top: 40% !important;
  }
  .top-sm-45 {
    top: 45% !important;
  }
  .top-sm-55 {
    top: 55% !important;
  }
  .top-sm-60 {
    top: 60% !important;
  }
  .top-sm-65 {
    top: 65% !important;
  }
  .top-sm-70 {
    top: 70% !important;
  }
  .top-sm-75 {
    top: 75% !important;
  }
  .top-sm-80 {
    top: 80% !important;
  }
  .top-sm-85 {
    top: 85% !important;
  }
  .top-sm-90 {
    top: 90% !important;
  }
  .top-sm-95 {
    top: 95% !important;
  }
  .top-sm-n50 {
    top: -50% !important;
  }
  .bottom-sm-0 {
    bottom: 0 !important;
  }
  .bottom-sm-50 {
    bottom: 50% !important;
  }
  .bottom-sm-100 {
    bottom: 100% !important;
  }
  .bottom-sm-1 {
    bottom: 1% !important;
  }
  .bottom-sm-2 {
    bottom: 2% !important;
  }
  .bottom-sm-3 {
    bottom: 3% !important;
  }
  .bottom-sm-4 {
    bottom: 4% !important;
  }
  .bottom-sm-5 {
    bottom: 5% !important;
  }
  .bottom-sm-10 {
    bottom: 10% !important;
  }
  .bottom-sm-15 {
    bottom: 15% !important;
  }
  .bottom-sm-20 {
    bottom: 20% !important;
  }
  .bottom-sm-25 {
    bottom: 25% !important;
  }
  .bottom-sm-30 {
    bottom: 30% !important;
  }
  .bottom-sm-35 {
    bottom: 35% !important;
  }
  .bottom-sm-40 {
    bottom: 40% !important;
  }
  .bottom-sm-45 {
    bottom: 45% !important;
  }
  .bottom-sm-55 {
    bottom: 55% !important;
  }
  .bottom-sm-60 {
    bottom: 60% !important;
  }
  .bottom-sm-65 {
    bottom: 65% !important;
  }
  .bottom-sm-70 {
    bottom: 70% !important;
  }
  .bottom-sm-75 {
    bottom: 75% !important;
  }
  .bottom-sm-80 {
    bottom: 80% !important;
  }
  .bottom-sm-85 {
    bottom: 85% !important;
  }
  .bottom-sm-90 {
    bottom: 90% !important;
  }
  .bottom-sm-95 {
    bottom: 95% !important;
  }
  .bottom-sm-n50 {
    bottom: -50% !important;
  }
  .start-sm-0 {
    left: 0 !important;
  }
  .start-sm-50 {
    left: 50% !important;
  }
  .start-sm-100 {
    left: 100% !important;
  }
  .start-sm-1 {
    left: 1% !important;
  }
  .start-sm-2 {
    left: 2% !important;
  }
  .start-sm-3 {
    left: 3% !important;
  }
  .start-sm-4 {
    left: 4% !important;
  }
  .start-sm-5 {
    left: 5% !important;
  }
  .start-sm-10 {
    left: 10% !important;
  }
  .start-sm-15 {
    left: 15% !important;
  }
  .start-sm-20 {
    left: 20% !important;
  }
  .start-sm-25 {
    left: 25% !important;
  }
  .start-sm-30 {
    left: 30% !important;
  }
  .start-sm-35 {
    left: 35% !important;
  }
  .start-sm-40 {
    left: 40% !important;
  }
  .start-sm-45 {
    left: 45% !important;
  }
  .start-sm-55 {
    left: 55% !important;
  }
  .start-sm-60 {
    left: 60% !important;
  }
  .start-sm-65 {
    left: 65% !important;
  }
  .start-sm-70 {
    left: 70% !important;
  }
  .start-sm-75 {
    left: 75% !important;
  }
  .start-sm-80 {
    left: 80% !important;
  }
  .start-sm-85 {
    left: 85% !important;
  }
  .start-sm-90 {
    left: 90% !important;
  }
  .start-sm-95 {
    left: 95% !important;
  }
  .start-sm-n50 {
    left: -50% !important;
  }
  .end-sm-0 {
    right: 0 !important;
  }
  .end-sm-50 {
    right: 50% !important;
  }
  .end-sm-100 {
    right: 100% !important;
  }
  .end-sm-1 {
    right: 1% !important;
  }
  .end-sm-2 {
    right: 2% !important;
  }
  .end-sm-3 {
    right: 3% !important;
  }
  .end-sm-4 {
    right: 4% !important;
  }
  .end-sm-5 {
    right: 5% !important;
  }
  .end-sm-10 {
    right: 10% !important;
  }
  .end-sm-15 {
    right: 15% !important;
  }
  .end-sm-20 {
    right: 20% !important;
  }
  .end-sm-25 {
    right: 25% !important;
  }
  .end-sm-30 {
    right: 30% !important;
  }
  .end-sm-35 {
    right: 35% !important;
  }
  .end-sm-40 {
    right: 40% !important;
  }
  .end-sm-45 {
    right: 45% !important;
  }
  .end-sm-55 {
    right: 55% !important;
  }
  .end-sm-60 {
    right: 60% !important;
  }
  .end-sm-65 {
    right: 65% !important;
  }
  .end-sm-70 {
    right: 70% !important;
  }
  .end-sm-75 {
    right: 75% !important;
  }
  .end-sm-80 {
    right: 80% !important;
  }
  .end-sm-85 {
    right: 85% !important;
  }
  .end-sm-90 {
    right: 90% !important;
  }
  .end-sm-95 {
    right: 95% !important;
  }
  .end-sm-n50 {
    right: -50% !important;
  }
  .w-sm-25 {
    width: 25% !important;
  }
  .w-sm-50 {
    width: 50% !important;
  }
  .w-sm-75 {
    width: 75% !important;
  }
  .w-sm-100 {
    width: 100% !important;
  }
  .w-sm-auto {
    width: auto !important;
  }
  .w-sm-5 {
    width: 5% !important;
  }
  .w-sm-10 {
    width: 10% !important;
  }
  .w-sm-15 {
    width: 15% !important;
  }
  .w-sm-20 {
    width: 20% !important;
  }
  .w-sm-30 {
    width: 30% !important;
  }
  .w-sm-35 {
    width: 35% !important;
  }
  .w-sm-40 {
    width: 40% !important;
  }
  .w-sm-45 {
    width: 45% !important;
  }
  .w-sm-55 {
    width: 55% !important;
  }
  .w-sm-60 {
    width: 60% !important;
  }
  .w-sm-65 {
    width: 65% !important;
  }
  .w-sm-70 {
    width: 70% !important;
  }
  .w-sm-80 {
    width: 80% !important;
  }
  .w-sm-85 {
    width: 85% !important;
  }
  .w-sm-90 {
    width: 90% !important;
  }
  .w-sm-95 {
    width: 95% !important;
  }
  .h-sm-25 {
    height: 25% !important;
  }
  .h-sm-50 {
    height: 50% !important;
  }
  .h-sm-75 {
    height: 75% !important;
  }
  .h-sm-100 {
    height: 100% !important;
  }
  .h-sm-auto {
    height: auto !important;
  }
  .h-sm-5 {
    height: 5% !important;
  }
  .h-sm-10 {
    height: 10% !important;
  }
  .h-sm-15 {
    height: 15% !important;
  }
  .h-sm-20 {
    height: 20% !important;
  }
  .h-sm-30 {
    height: 30% !important;
  }
  .h-sm-35 {
    height: 35% !important;
  }
  .h-sm-40 {
    height: 40% !important;
  }
  .h-sm-45 {
    height: 45% !important;
  }
  .h-sm-55 {
    height: 55% !important;
  }
  .h-sm-60 {
    height: 60% !important;
  }
  .h-sm-65 {
    height: 65% !important;
  }
  .h-sm-70 {
    height: 70% !important;
  }
  .h-sm-80 {
    height: 80% !important;
  }
  .h-sm-85 {
    height: 85% !important;
  }
  .h-sm-90 {
    height: 90% !important;
  }
  .h-sm-95 {
    height: 95% !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-6 {
    margin: 4.5rem !important;
  }
  .m-sm-7 {
    margin: 6rem !important;
  }
  .m-sm-8 {
    margin: 8rem !important;
  }
  .m-sm-9 {
    margin: 12rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-6 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-sm-7 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-sm-8 {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-sm-9 {
    margin-right: 12rem !important;
    margin-left: 12rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-6 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-sm-7 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-sm-8 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-sm-9 {
    margin-top: 12rem !important;
    margin-bottom: 12rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-6 {
    margin-top: 4.5rem !important;
  }
  .mt-sm-7 {
    margin-top: 6rem !important;
  }
  .mt-sm-8 {
    margin-top: 8rem !important;
  }
  .mt-sm-9 {
    margin-top: 12rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-6 {
    margin-right: 4.5rem !important;
  }
  .me-sm-7 {
    margin-right: 6rem !important;
  }
  .me-sm-8 {
    margin-right: 8rem !important;
  }
  .me-sm-9 {
    margin-right: 12rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-6 {
    margin-bottom: 4.5rem !important;
  }
  .mb-sm-7 {
    margin-bottom: 6rem !important;
  }
  .mb-sm-8 {
    margin-bottom: 8rem !important;
  }
  .mb-sm-9 {
    margin-bottom: 12rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-6 {
    margin-left: 4.5rem !important;
  }
  .ms-sm-7 {
    margin-left: 6rem !important;
  }
  .ms-sm-8 {
    margin-left: 8rem !important;
  }
  .ms-sm-9 {
    margin-left: 12rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .m-sm-n6 {
    margin: -4.5rem !important;
  }
  .m-sm-n7 {
    margin: -6rem !important;
  }
  .m-sm-n8 {
    margin: -8rem !important;
  }
  .m-sm-n9 {
    margin: -12rem !important;
  }
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-sm-n6 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-sm-n7 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-sm-n8 {
    margin-right: -8rem !important;
    margin-left: -8rem !important;
  }
  .mx-sm-n9 {
    margin-right: -12rem !important;
    margin-left: -12rem !important;
  }
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-sm-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-sm-n6 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-sm-n7 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-sm-n8 {
    margin-top: -8rem !important;
    margin-bottom: -8rem !important;
  }
  .my-sm-n9 {
    margin-top: -12rem !important;
    margin-bottom: -12rem !important;
  }
  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-sm-n3 {
    margin-top: -1rem !important;
  }
  .mt-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-sm-n5 {
    margin-top: -3rem !important;
  }
  .mt-sm-n6 {
    margin-top: -4.5rem !important;
  }
  .mt-sm-n7 {
    margin-top: -6rem !important;
  }
  .mt-sm-n8 {
    margin-top: -8rem !important;
  }
  .mt-sm-n9 {
    margin-top: -12rem !important;
  }
  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .me-sm-n3 {
    margin-right: -1rem !important;
  }
  .me-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .me-sm-n5 {
    margin-right: -3rem !important;
  }
  .me-sm-n6 {
    margin-right: -4.5rem !important;
  }
  .me-sm-n7 {
    margin-right: -6rem !important;
  }
  .me-sm-n8 {
    margin-right: -8rem !important;
  }
  .me-sm-n9 {
    margin-right: -12rem !important;
  }
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-sm-n6 {
    margin-bottom: -4.5rem !important;
  }
  .mb-sm-n7 {
    margin-bottom: -6rem !important;
  }
  .mb-sm-n8 {
    margin-bottom: -8rem !important;
  }
  .mb-sm-n9 {
    margin-bottom: -12rem !important;
  }
  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-sm-n3 {
    margin-left: -1rem !important;
  }
  .ms-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-sm-n5 {
    margin-left: -3rem !important;
  }
  .ms-sm-n6 {
    margin-left: -4.5rem !important;
  }
  .ms-sm-n7 {
    margin-left: -6rem !important;
  }
  .ms-sm-n8 {
    margin-left: -8rem !important;
  }
  .ms-sm-n9 {
    margin-left: -12rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .p-sm-6 {
    padding: 4.5rem !important;
  }
  .p-sm-7 {
    padding: 6rem !important;
  }
  .p-sm-8 {
    padding: 8rem !important;
  }
  .p-sm-9 {
    padding: 12rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-sm-6 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-sm-7 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-sm-8 {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .px-sm-9 {
    padding-right: 12rem !important;
    padding-left: 12rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-sm-6 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-sm-7 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-sm-8 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .py-sm-9 {
    padding-top: 12rem !important;
    padding-bottom: 12rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pt-sm-6 {
    padding-top: 4.5rem !important;
  }
  .pt-sm-7 {
    padding-top: 6rem !important;
  }
  .pt-sm-8 {
    padding-top: 8rem !important;
  }
  .pt-sm-9 {
    padding-top: 12rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pe-sm-6 {
    padding-right: 4.5rem !important;
  }
  .pe-sm-7 {
    padding-right: 6rem !important;
  }
  .pe-sm-8 {
    padding-right: 8rem !important;
  }
  .pe-sm-9 {
    padding-right: 12rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pb-sm-6 {
    padding-bottom: 4.5rem !important;
  }
  .pb-sm-7 {
    padding-bottom: 6rem !important;
  }
  .pb-sm-8 {
    padding-bottom: 8rem !important;
  }
  .pb-sm-9 {
    padding-bottom: 12rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .ps-sm-6 {
    padding-left: 4.5rem !important;
  }
  .ps-sm-7 {
    padding-left: 6rem !important;
  }
  .ps-sm-8 {
    padding-left: 8rem !important;
  }
  .ps-sm-9 {
    padding-left: 12rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .gap-sm-6 {
    gap: 4.5rem !important;
  }
  .gap-sm-7 {
    gap: 6rem !important;
  }
  .gap-sm-8 {
    gap: 8rem !important;
  }
  .gap-sm-9 {
    gap: 12rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .row-gap-sm-6 {
    row-gap: 4.5rem !important;
  }
  .row-gap-sm-7 {
    row-gap: 6rem !important;
  }
  .row-gap-sm-8 {
    row-gap: 8rem !important;
  }
  .row-gap-sm-9 {
    row-gap: 12rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .column-gap-sm-6 {
    column-gap: 4.5rem !important;
  }
  .column-gap-sm-7 {
    column-gap: 6rem !important;
  }
  .column-gap-sm-8 {
    column-gap: 8rem !important;
  }
  .column-gap-sm-9 {
    column-gap: 12rem !important;
  }
  .fs-sm-1 {
    font-size: calc(1.4125rem + 1.95vw) !important;
  }
  .fs-sm-2 {
    font-size: calc(1.355rem + 1.26vw) !important;
  }
  .fs-sm-3 {
    font-size: calc(1.32625rem + 0.915vw) !important;
  }
  .fs-sm-4 {
    font-size: calc(1.2975rem + 0.57vw) !important;
  }
  .fs-sm-5 {
    font-size: calc(1.26875rem + 0.225vw) !important;
  }
  .fs-sm-6 {
    font-size: 1.15rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
  .text-sm-primary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
  }
  .text-sm-secondary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
  }
  .text-sm-success {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
  }
  .text-sm-info {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
  }
  .text-sm-warning {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
  }
  .text-sm-danger {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
  }
  .text-sm-light {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
  }
  .text-sm-dark {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
  }
  .text-sm-black {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
  }
  .text-sm-white {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
  }
  .text-sm-body {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
  }
  .text-sm-muted {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important;
  }
  .text-sm-black-50 {
    --bs-text-opacity: 1;
    color: rgba(0, 0, 0, 0.5) !important;
  }
  .text-sm-white-50 {
    --bs-text-opacity: 1;
    color: rgba(255, 255, 255, 0.5) !important;
  }
  .text-sm-body-secondary {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important;
  }
  .text-sm-body-tertiary {
    --bs-text-opacity: 1;
    color: var(--bs-tertiary-color) !important;
  }
  .text-sm-body-emphasis {
    --bs-text-opacity: 1;
    color: var(--bs-emphasis-color) !important;
  }
  .text-sm-reset {
    --bs-text-opacity: 1;
    color: inherit !important;
  }
}
@media (min-width: 664px) {
  .float-mmd-start {
    float: left !important;
  }
  .float-mmd-end {
    float: right !important;
  }
  .float-mmd-none {
    float: none !important;
  }
  .object-fit-mmd-contain {
    object-fit: contain !important;
  }
  .object-fit-mmd-cover {
    object-fit: cover !important;
  }
  .object-fit-mmd-fill {
    object-fit: fill !important;
  }
  .object-fit-mmd-scale {
    object-fit: scale-down !important;
  }
  .object-fit-mmd-none {
    object-fit: none !important;
  }
  .opacity-mmd-0 {
    opacity: 0 !important;
  }
  .opacity-mmd-25 {
    opacity: 0.25 !important;
  }
  .opacity-mmd-50 {
    opacity: 0.5 !important;
  }
  .opacity-mmd-75 {
    opacity: 0.75 !important;
  }
  .opacity-mmd-100 {
    opacity: 1 !important;
  }
  .opacity-mmd-5 {
    opacity: 0.5 !important;
  }
  .opacity-mmd-10 {
    opacity: 0.1 !important;
  }
  .opacity-mmd-15 {
    opacity: 0.15 !important;
  }
  .opacity-mmd-20 {
    opacity: 0.2 !important;
  }
  .opacity-mmd-30 {
    opacity: 0.3 !important;
  }
  .opacity-mmd-35 {
    opacity: 0.35 !important;
  }
  .opacity-mmd-40 {
    opacity: 0.4 !important;
  }
  .opacity-mmd-45 {
    opacity: 0.45 !important;
  }
  .opacity-mmd-60 {
    opacity: 0.6 !important;
  }
  .opacity-mmd-65 {
    opacity: 0.65 !important;
  }
  .opacity-mmd-70 {
    opacity: 0.7 !important;
  }
  .opacity-mmd-80 {
    opacity: 0.8 !important;
  }
  .opacity-mmd-85 {
    opacity: 0.85 !important;
  }
  .opacity-mmd-90 {
    opacity: 0.9 !important;
  }
  .opacity-mmd-95 {
    opacity: 0.95 !important;
  }
  .d-mmd-inline {
    display: inline !important;
  }
  .d-mmd-inline-block {
    display: inline-block !important;
  }
  .d-mmd-block {
    display: block !important;
  }
  .d-mmd-grid {
    display: grid !important;
  }
  .d-mmd-inline-grid {
    display: inline-grid !important;
  }
  .d-mmd-table {
    display: table !important;
  }
  .d-mmd-table-row {
    display: table-row !important;
  }
  .d-mmd-table-cell {
    display: table-cell !important;
  }
  .d-mmd-flex {
    display: flex !important;
  }
  .d-mmd-inline-flex {
    display: inline-flex !important;
  }
  .d-mmd-none {
    display: none !important;
  }
  .top-mmd-0 {
    top: 0 !important;
  }
  .top-mmd-50 {
    top: 50% !important;
  }
  .top-mmd-100 {
    top: 100% !important;
  }
  .top-mmd-1 {
    top: 1% !important;
  }
  .top-mmd-2 {
    top: 2% !important;
  }
  .top-mmd-3 {
    top: 3% !important;
  }
  .top-mmd-4 {
    top: 4% !important;
  }
  .top-mmd-5 {
    top: 5% !important;
  }
  .top-mmd-10 {
    top: 10% !important;
  }
  .top-mmd-15 {
    top: 15% !important;
  }
  .top-mmd-20 {
    top: 20% !important;
  }
  .top-mmd-25 {
    top: 25% !important;
  }
  .top-mmd-30 {
    top: 30% !important;
  }
  .top-mmd-35 {
    top: 35% !important;
  }
  .top-mmd-40 {
    top: 40% !important;
  }
  .top-mmd-45 {
    top: 45% !important;
  }
  .top-mmd-55 {
    top: 55% !important;
  }
  .top-mmd-60 {
    top: 60% !important;
  }
  .top-mmd-65 {
    top: 65% !important;
  }
  .top-mmd-70 {
    top: 70% !important;
  }
  .top-mmd-75 {
    top: 75% !important;
  }
  .top-mmd-80 {
    top: 80% !important;
  }
  .top-mmd-85 {
    top: 85% !important;
  }
  .top-mmd-90 {
    top: 90% !important;
  }
  .top-mmd-95 {
    top: 95% !important;
  }
  .top-mmd-n50 {
    top: -50% !important;
  }
  .bottom-mmd-0 {
    bottom: 0 !important;
  }
  .bottom-mmd-50 {
    bottom: 50% !important;
  }
  .bottom-mmd-100 {
    bottom: 100% !important;
  }
  .bottom-mmd-1 {
    bottom: 1% !important;
  }
  .bottom-mmd-2 {
    bottom: 2% !important;
  }
  .bottom-mmd-3 {
    bottom: 3% !important;
  }
  .bottom-mmd-4 {
    bottom: 4% !important;
  }
  .bottom-mmd-5 {
    bottom: 5% !important;
  }
  .bottom-mmd-10 {
    bottom: 10% !important;
  }
  .bottom-mmd-15 {
    bottom: 15% !important;
  }
  .bottom-mmd-20 {
    bottom: 20% !important;
  }
  .bottom-mmd-25 {
    bottom: 25% !important;
  }
  .bottom-mmd-30 {
    bottom: 30% !important;
  }
  .bottom-mmd-35 {
    bottom: 35% !important;
  }
  .bottom-mmd-40 {
    bottom: 40% !important;
  }
  .bottom-mmd-45 {
    bottom: 45% !important;
  }
  .bottom-mmd-55 {
    bottom: 55% !important;
  }
  .bottom-mmd-60 {
    bottom: 60% !important;
  }
  .bottom-mmd-65 {
    bottom: 65% !important;
  }
  .bottom-mmd-70 {
    bottom: 70% !important;
  }
  .bottom-mmd-75 {
    bottom: 75% !important;
  }
  .bottom-mmd-80 {
    bottom: 80% !important;
  }
  .bottom-mmd-85 {
    bottom: 85% !important;
  }
  .bottom-mmd-90 {
    bottom: 90% !important;
  }
  .bottom-mmd-95 {
    bottom: 95% !important;
  }
  .bottom-mmd-n50 {
    bottom: -50% !important;
  }
  .start-mmd-0 {
    left: 0 !important;
  }
  .start-mmd-50 {
    left: 50% !important;
  }
  .start-mmd-100 {
    left: 100% !important;
  }
  .start-mmd-1 {
    left: 1% !important;
  }
  .start-mmd-2 {
    left: 2% !important;
  }
  .start-mmd-3 {
    left: 3% !important;
  }
  .start-mmd-4 {
    left: 4% !important;
  }
  .start-mmd-5 {
    left: 5% !important;
  }
  .start-mmd-10 {
    left: 10% !important;
  }
  .start-mmd-15 {
    left: 15% !important;
  }
  .start-mmd-20 {
    left: 20% !important;
  }
  .start-mmd-25 {
    left: 25% !important;
  }
  .start-mmd-30 {
    left: 30% !important;
  }
  .start-mmd-35 {
    left: 35% !important;
  }
  .start-mmd-40 {
    left: 40% !important;
  }
  .start-mmd-45 {
    left: 45% !important;
  }
  .start-mmd-55 {
    left: 55% !important;
  }
  .start-mmd-60 {
    left: 60% !important;
  }
  .start-mmd-65 {
    left: 65% !important;
  }
  .start-mmd-70 {
    left: 70% !important;
  }
  .start-mmd-75 {
    left: 75% !important;
  }
  .start-mmd-80 {
    left: 80% !important;
  }
  .start-mmd-85 {
    left: 85% !important;
  }
  .start-mmd-90 {
    left: 90% !important;
  }
  .start-mmd-95 {
    left: 95% !important;
  }
  .start-mmd-n50 {
    left: -50% !important;
  }
  .end-mmd-0 {
    right: 0 !important;
  }
  .end-mmd-50 {
    right: 50% !important;
  }
  .end-mmd-100 {
    right: 100% !important;
  }
  .end-mmd-1 {
    right: 1% !important;
  }
  .end-mmd-2 {
    right: 2% !important;
  }
  .end-mmd-3 {
    right: 3% !important;
  }
  .end-mmd-4 {
    right: 4% !important;
  }
  .end-mmd-5 {
    right: 5% !important;
  }
  .end-mmd-10 {
    right: 10% !important;
  }
  .end-mmd-15 {
    right: 15% !important;
  }
  .end-mmd-20 {
    right: 20% !important;
  }
  .end-mmd-25 {
    right: 25% !important;
  }
  .end-mmd-30 {
    right: 30% !important;
  }
  .end-mmd-35 {
    right: 35% !important;
  }
  .end-mmd-40 {
    right: 40% !important;
  }
  .end-mmd-45 {
    right: 45% !important;
  }
  .end-mmd-55 {
    right: 55% !important;
  }
  .end-mmd-60 {
    right: 60% !important;
  }
  .end-mmd-65 {
    right: 65% !important;
  }
  .end-mmd-70 {
    right: 70% !important;
  }
  .end-mmd-75 {
    right: 75% !important;
  }
  .end-mmd-80 {
    right: 80% !important;
  }
  .end-mmd-85 {
    right: 85% !important;
  }
  .end-mmd-90 {
    right: 90% !important;
  }
  .end-mmd-95 {
    right: 95% !important;
  }
  .end-mmd-n50 {
    right: -50% !important;
  }
  .w-mmd-25 {
    width: 25% !important;
  }
  .w-mmd-50 {
    width: 50% !important;
  }
  .w-mmd-75 {
    width: 75% !important;
  }
  .w-mmd-100 {
    width: 100% !important;
  }
  .w-mmd-auto {
    width: auto !important;
  }
  .w-mmd-5 {
    width: 5% !important;
  }
  .w-mmd-10 {
    width: 10% !important;
  }
  .w-mmd-15 {
    width: 15% !important;
  }
  .w-mmd-20 {
    width: 20% !important;
  }
  .w-mmd-30 {
    width: 30% !important;
  }
  .w-mmd-35 {
    width: 35% !important;
  }
  .w-mmd-40 {
    width: 40% !important;
  }
  .w-mmd-45 {
    width: 45% !important;
  }
  .w-mmd-55 {
    width: 55% !important;
  }
  .w-mmd-60 {
    width: 60% !important;
  }
  .w-mmd-65 {
    width: 65% !important;
  }
  .w-mmd-70 {
    width: 70% !important;
  }
  .w-mmd-80 {
    width: 80% !important;
  }
  .w-mmd-85 {
    width: 85% !important;
  }
  .w-mmd-90 {
    width: 90% !important;
  }
  .w-mmd-95 {
    width: 95% !important;
  }
  .h-mmd-25 {
    height: 25% !important;
  }
  .h-mmd-50 {
    height: 50% !important;
  }
  .h-mmd-75 {
    height: 75% !important;
  }
  .h-mmd-100 {
    height: 100% !important;
  }
  .h-mmd-auto {
    height: auto !important;
  }
  .h-mmd-5 {
    height: 5% !important;
  }
  .h-mmd-10 {
    height: 10% !important;
  }
  .h-mmd-15 {
    height: 15% !important;
  }
  .h-mmd-20 {
    height: 20% !important;
  }
  .h-mmd-30 {
    height: 30% !important;
  }
  .h-mmd-35 {
    height: 35% !important;
  }
  .h-mmd-40 {
    height: 40% !important;
  }
  .h-mmd-45 {
    height: 45% !important;
  }
  .h-mmd-55 {
    height: 55% !important;
  }
  .h-mmd-60 {
    height: 60% !important;
  }
  .h-mmd-65 {
    height: 65% !important;
  }
  .h-mmd-70 {
    height: 70% !important;
  }
  .h-mmd-80 {
    height: 80% !important;
  }
  .h-mmd-85 {
    height: 85% !important;
  }
  .h-mmd-90 {
    height: 90% !important;
  }
  .h-mmd-95 {
    height: 95% !important;
  }
  .flex-mmd-fill {
    flex: 1 1 auto !important;
  }
  .flex-mmd-row {
    flex-direction: row !important;
  }
  .flex-mmd-column {
    flex-direction: column !important;
  }
  .flex-mmd-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-mmd-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-mmd-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-mmd-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-mmd-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-mmd-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-mmd-wrap {
    flex-wrap: wrap !important;
  }
  .flex-mmd-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-mmd-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-mmd-start {
    justify-content: flex-start !important;
  }
  .justify-content-mmd-end {
    justify-content: flex-end !important;
  }
  .justify-content-mmd-center {
    justify-content: center !important;
  }
  .justify-content-mmd-between {
    justify-content: space-between !important;
  }
  .justify-content-mmd-around {
    justify-content: space-around !important;
  }
  .justify-content-mmd-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-mmd-start {
    align-items: flex-start !important;
  }
  .align-items-mmd-end {
    align-items: flex-end !important;
  }
  .align-items-mmd-center {
    align-items: center !important;
  }
  .align-items-mmd-baseline {
    align-items: baseline !important;
  }
  .align-items-mmd-stretch {
    align-items: stretch !important;
  }
  .align-content-mmd-start {
    align-content: flex-start !important;
  }
  .align-content-mmd-end {
    align-content: flex-end !important;
  }
  .align-content-mmd-center {
    align-content: center !important;
  }
  .align-content-mmd-between {
    align-content: space-between !important;
  }
  .align-content-mmd-around {
    align-content: space-around !important;
  }
  .align-content-mmd-stretch {
    align-content: stretch !important;
  }
  .align-self-mmd-auto {
    align-self: auto !important;
  }
  .align-self-mmd-start {
    align-self: flex-start !important;
  }
  .align-self-mmd-end {
    align-self: flex-end !important;
  }
  .align-self-mmd-center {
    align-self: center !important;
  }
  .align-self-mmd-baseline {
    align-self: baseline !important;
  }
  .align-self-mmd-stretch {
    align-self: stretch !important;
  }
  .order-mmd-first {
    order: -1 !important;
  }
  .order-mmd-0 {
    order: 0 !important;
  }
  .order-mmd-1 {
    order: 1 !important;
  }
  .order-mmd-2 {
    order: 2 !important;
  }
  .order-mmd-3 {
    order: 3 !important;
  }
  .order-mmd-4 {
    order: 4 !important;
  }
  .order-mmd-5 {
    order: 5 !important;
  }
  .order-mmd-last {
    order: 6 !important;
  }
  .m-mmd-0 {
    margin: 0 !important;
  }
  .m-mmd-1 {
    margin: 0.25rem !important;
  }
  .m-mmd-2 {
    margin: 0.5rem !important;
  }
  .m-mmd-3 {
    margin: 1rem !important;
  }
  .m-mmd-4 {
    margin: 1.5rem !important;
  }
  .m-mmd-5 {
    margin: 3rem !important;
  }
  .m-mmd-6 {
    margin: 4.5rem !important;
  }
  .m-mmd-7 {
    margin: 6rem !important;
  }
  .m-mmd-8 {
    margin: 8rem !important;
  }
  .m-mmd-9 {
    margin: 12rem !important;
  }
  .m-mmd-auto {
    margin: auto !important;
  }
  .mx-mmd-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-mmd-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-mmd-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-mmd-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-mmd-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-mmd-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-mmd-6 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-mmd-7 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-mmd-8 {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-mmd-9 {
    margin-right: 12rem !important;
    margin-left: 12rem !important;
  }
  .mx-mmd-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-mmd-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-mmd-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-mmd-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-mmd-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-mmd-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-mmd-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-mmd-6 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-mmd-7 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-mmd-8 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-mmd-9 {
    margin-top: 12rem !important;
    margin-bottom: 12rem !important;
  }
  .my-mmd-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-mmd-0 {
    margin-top: 0 !important;
  }
  .mt-mmd-1 {
    margin-top: 0.25rem !important;
  }
  .mt-mmd-2 {
    margin-top: 0.5rem !important;
  }
  .mt-mmd-3 {
    margin-top: 1rem !important;
  }
  .mt-mmd-4 {
    margin-top: 1.5rem !important;
  }
  .mt-mmd-5 {
    margin-top: 3rem !important;
  }
  .mt-mmd-6 {
    margin-top: 4.5rem !important;
  }
  .mt-mmd-7 {
    margin-top: 6rem !important;
  }
  .mt-mmd-8 {
    margin-top: 8rem !important;
  }
  .mt-mmd-9 {
    margin-top: 12rem !important;
  }
  .mt-mmd-auto {
    margin-top: auto !important;
  }
  .me-mmd-0 {
    margin-right: 0 !important;
  }
  .me-mmd-1 {
    margin-right: 0.25rem !important;
  }
  .me-mmd-2 {
    margin-right: 0.5rem !important;
  }
  .me-mmd-3 {
    margin-right: 1rem !important;
  }
  .me-mmd-4 {
    margin-right: 1.5rem !important;
  }
  .me-mmd-5 {
    margin-right: 3rem !important;
  }
  .me-mmd-6 {
    margin-right: 4.5rem !important;
  }
  .me-mmd-7 {
    margin-right: 6rem !important;
  }
  .me-mmd-8 {
    margin-right: 8rem !important;
  }
  .me-mmd-9 {
    margin-right: 12rem !important;
  }
  .me-mmd-auto {
    margin-right: auto !important;
  }
  .mb-mmd-0 {
    margin-bottom: 0 !important;
  }
  .mb-mmd-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-mmd-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-mmd-3 {
    margin-bottom: 1rem !important;
  }
  .mb-mmd-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-mmd-5 {
    margin-bottom: 3rem !important;
  }
  .mb-mmd-6 {
    margin-bottom: 4.5rem !important;
  }
  .mb-mmd-7 {
    margin-bottom: 6rem !important;
  }
  .mb-mmd-8 {
    margin-bottom: 8rem !important;
  }
  .mb-mmd-9 {
    margin-bottom: 12rem !important;
  }
  .mb-mmd-auto {
    margin-bottom: auto !important;
  }
  .ms-mmd-0 {
    margin-left: 0 !important;
  }
  .ms-mmd-1 {
    margin-left: 0.25rem !important;
  }
  .ms-mmd-2 {
    margin-left: 0.5rem !important;
  }
  .ms-mmd-3 {
    margin-left: 1rem !important;
  }
  .ms-mmd-4 {
    margin-left: 1.5rem !important;
  }
  .ms-mmd-5 {
    margin-left: 3rem !important;
  }
  .ms-mmd-6 {
    margin-left: 4.5rem !important;
  }
  .ms-mmd-7 {
    margin-left: 6rem !important;
  }
  .ms-mmd-8 {
    margin-left: 8rem !important;
  }
  .ms-mmd-9 {
    margin-left: 12rem !important;
  }
  .ms-mmd-auto {
    margin-left: auto !important;
  }
  .m-mmd-n1 {
    margin: -0.25rem !important;
  }
  .m-mmd-n2 {
    margin: -0.5rem !important;
  }
  .m-mmd-n3 {
    margin: -1rem !important;
  }
  .m-mmd-n4 {
    margin: -1.5rem !important;
  }
  .m-mmd-n5 {
    margin: -3rem !important;
  }
  .m-mmd-n6 {
    margin: -4.5rem !important;
  }
  .m-mmd-n7 {
    margin: -6rem !important;
  }
  .m-mmd-n8 {
    margin: -8rem !important;
  }
  .m-mmd-n9 {
    margin: -12rem !important;
  }
  .mx-mmd-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-mmd-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-mmd-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-mmd-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-mmd-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-mmd-n6 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-mmd-n7 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-mmd-n8 {
    margin-right: -8rem !important;
    margin-left: -8rem !important;
  }
  .mx-mmd-n9 {
    margin-right: -12rem !important;
    margin-left: -12rem !important;
  }
  .my-mmd-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-mmd-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-mmd-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-mmd-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-mmd-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-mmd-n6 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-mmd-n7 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-mmd-n8 {
    margin-top: -8rem !important;
    margin-bottom: -8rem !important;
  }
  .my-mmd-n9 {
    margin-top: -12rem !important;
    margin-bottom: -12rem !important;
  }
  .mt-mmd-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-mmd-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-mmd-n3 {
    margin-top: -1rem !important;
  }
  .mt-mmd-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-mmd-n5 {
    margin-top: -3rem !important;
  }
  .mt-mmd-n6 {
    margin-top: -4.5rem !important;
  }
  .mt-mmd-n7 {
    margin-top: -6rem !important;
  }
  .mt-mmd-n8 {
    margin-top: -8rem !important;
  }
  .mt-mmd-n9 {
    margin-top: -12rem !important;
  }
  .me-mmd-n1 {
    margin-right: -0.25rem !important;
  }
  .me-mmd-n2 {
    margin-right: -0.5rem !important;
  }
  .me-mmd-n3 {
    margin-right: -1rem !important;
  }
  .me-mmd-n4 {
    margin-right: -1.5rem !important;
  }
  .me-mmd-n5 {
    margin-right: -3rem !important;
  }
  .me-mmd-n6 {
    margin-right: -4.5rem !important;
  }
  .me-mmd-n7 {
    margin-right: -6rem !important;
  }
  .me-mmd-n8 {
    margin-right: -8rem !important;
  }
  .me-mmd-n9 {
    margin-right: -12rem !important;
  }
  .mb-mmd-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-mmd-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-mmd-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-mmd-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-mmd-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-mmd-n6 {
    margin-bottom: -4.5rem !important;
  }
  .mb-mmd-n7 {
    margin-bottom: -6rem !important;
  }
  .mb-mmd-n8 {
    margin-bottom: -8rem !important;
  }
  .mb-mmd-n9 {
    margin-bottom: -12rem !important;
  }
  .ms-mmd-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-mmd-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-mmd-n3 {
    margin-left: -1rem !important;
  }
  .ms-mmd-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-mmd-n5 {
    margin-left: -3rem !important;
  }
  .ms-mmd-n6 {
    margin-left: -4.5rem !important;
  }
  .ms-mmd-n7 {
    margin-left: -6rem !important;
  }
  .ms-mmd-n8 {
    margin-left: -8rem !important;
  }
  .ms-mmd-n9 {
    margin-left: -12rem !important;
  }
  .p-mmd-0 {
    padding: 0 !important;
  }
  .p-mmd-1 {
    padding: 0.25rem !important;
  }
  .p-mmd-2 {
    padding: 0.5rem !important;
  }
  .p-mmd-3 {
    padding: 1rem !important;
  }
  .p-mmd-4 {
    padding: 1.5rem !important;
  }
  .p-mmd-5 {
    padding: 3rem !important;
  }
  .p-mmd-6 {
    padding: 4.5rem !important;
  }
  .p-mmd-7 {
    padding: 6rem !important;
  }
  .p-mmd-8 {
    padding: 8rem !important;
  }
  .p-mmd-9 {
    padding: 12rem !important;
  }
  .px-mmd-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-mmd-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-mmd-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-mmd-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-mmd-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-mmd-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-mmd-6 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-mmd-7 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-mmd-8 {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .px-mmd-9 {
    padding-right: 12rem !important;
    padding-left: 12rem !important;
  }
  .py-mmd-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-mmd-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-mmd-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-mmd-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-mmd-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-mmd-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-mmd-6 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-mmd-7 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-mmd-8 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .py-mmd-9 {
    padding-top: 12rem !important;
    padding-bottom: 12rem !important;
  }
  .pt-mmd-0 {
    padding-top: 0 !important;
  }
  .pt-mmd-1 {
    padding-top: 0.25rem !important;
  }
  .pt-mmd-2 {
    padding-top: 0.5rem !important;
  }
  .pt-mmd-3 {
    padding-top: 1rem !important;
  }
  .pt-mmd-4 {
    padding-top: 1.5rem !important;
  }
  .pt-mmd-5 {
    padding-top: 3rem !important;
  }
  .pt-mmd-6 {
    padding-top: 4.5rem !important;
  }
  .pt-mmd-7 {
    padding-top: 6rem !important;
  }
  .pt-mmd-8 {
    padding-top: 8rem !important;
  }
  .pt-mmd-9 {
    padding-top: 12rem !important;
  }
  .pe-mmd-0 {
    padding-right: 0 !important;
  }
  .pe-mmd-1 {
    padding-right: 0.25rem !important;
  }
  .pe-mmd-2 {
    padding-right: 0.5rem !important;
  }
  .pe-mmd-3 {
    padding-right: 1rem !important;
  }
  .pe-mmd-4 {
    padding-right: 1.5rem !important;
  }
  .pe-mmd-5 {
    padding-right: 3rem !important;
  }
  .pe-mmd-6 {
    padding-right: 4.5rem !important;
  }
  .pe-mmd-7 {
    padding-right: 6rem !important;
  }
  .pe-mmd-8 {
    padding-right: 8rem !important;
  }
  .pe-mmd-9 {
    padding-right: 12rem !important;
  }
  .pb-mmd-0 {
    padding-bottom: 0 !important;
  }
  .pb-mmd-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-mmd-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-mmd-3 {
    padding-bottom: 1rem !important;
  }
  .pb-mmd-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-mmd-5 {
    padding-bottom: 3rem !important;
  }
  .pb-mmd-6 {
    padding-bottom: 4.5rem !important;
  }
  .pb-mmd-7 {
    padding-bottom: 6rem !important;
  }
  .pb-mmd-8 {
    padding-bottom: 8rem !important;
  }
  .pb-mmd-9 {
    padding-bottom: 12rem !important;
  }
  .ps-mmd-0 {
    padding-left: 0 !important;
  }
  .ps-mmd-1 {
    padding-left: 0.25rem !important;
  }
  .ps-mmd-2 {
    padding-left: 0.5rem !important;
  }
  .ps-mmd-3 {
    padding-left: 1rem !important;
  }
  .ps-mmd-4 {
    padding-left: 1.5rem !important;
  }
  .ps-mmd-5 {
    padding-left: 3rem !important;
  }
  .ps-mmd-6 {
    padding-left: 4.5rem !important;
  }
  .ps-mmd-7 {
    padding-left: 6rem !important;
  }
  .ps-mmd-8 {
    padding-left: 8rem !important;
  }
  .ps-mmd-9 {
    padding-left: 12rem !important;
  }
  .gap-mmd-0 {
    gap: 0 !important;
  }
  .gap-mmd-1 {
    gap: 0.25rem !important;
  }
  .gap-mmd-2 {
    gap: 0.5rem !important;
  }
  .gap-mmd-3 {
    gap: 1rem !important;
  }
  .gap-mmd-4 {
    gap: 1.5rem !important;
  }
  .gap-mmd-5 {
    gap: 3rem !important;
  }
  .gap-mmd-6 {
    gap: 4.5rem !important;
  }
  .gap-mmd-7 {
    gap: 6rem !important;
  }
  .gap-mmd-8 {
    gap: 8rem !important;
  }
  .gap-mmd-9 {
    gap: 12rem !important;
  }
  .row-gap-mmd-0 {
    row-gap: 0 !important;
  }
  .row-gap-mmd-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-mmd-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-mmd-3 {
    row-gap: 1rem !important;
  }
  .row-gap-mmd-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-mmd-5 {
    row-gap: 3rem !important;
  }
  .row-gap-mmd-6 {
    row-gap: 4.5rem !important;
  }
  .row-gap-mmd-7 {
    row-gap: 6rem !important;
  }
  .row-gap-mmd-8 {
    row-gap: 8rem !important;
  }
  .row-gap-mmd-9 {
    row-gap: 12rem !important;
  }
  .column-gap-mmd-0 {
    column-gap: 0 !important;
  }
  .column-gap-mmd-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-mmd-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-mmd-3 {
    column-gap: 1rem !important;
  }
  .column-gap-mmd-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-mmd-5 {
    column-gap: 3rem !important;
  }
  .column-gap-mmd-6 {
    column-gap: 4.5rem !important;
  }
  .column-gap-mmd-7 {
    column-gap: 6rem !important;
  }
  .column-gap-mmd-8 {
    column-gap: 8rem !important;
  }
  .column-gap-mmd-9 {
    column-gap: 12rem !important;
  }
  .fs-mmd-1 {
    font-size: calc(1.4125rem + 1.95vw) !important;
  }
  .fs-mmd-2 {
    font-size: calc(1.355rem + 1.26vw) !important;
  }
  .fs-mmd-3 {
    font-size: calc(1.32625rem + 0.915vw) !important;
  }
  .fs-mmd-4 {
    font-size: calc(1.2975rem + 0.57vw) !important;
  }
  .fs-mmd-5 {
    font-size: calc(1.26875rem + 0.225vw) !important;
  }
  .fs-mmd-6 {
    font-size: 1.15rem !important;
  }
  .text-mmd-start {
    text-align: left !important;
  }
  .text-mmd-end {
    text-align: right !important;
  }
  .text-mmd-center {
    text-align: center !important;
  }
  .text-mmd-primary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mmd-secondary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mmd-success {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mmd-info {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mmd-warning {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mmd-danger {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mmd-light {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mmd-dark {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mmd-black {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mmd-white {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mmd-body {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mmd-muted {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important;
  }
  .text-mmd-black-50 {
    --bs-text-opacity: 1;
    color: rgba(0, 0, 0, 0.5) !important;
  }
  .text-mmd-white-50 {
    --bs-text-opacity: 1;
    color: rgba(255, 255, 255, 0.5) !important;
  }
  .text-mmd-body-secondary {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important;
  }
  .text-mmd-body-tertiary {
    --bs-text-opacity: 1;
    color: var(--bs-tertiary-color) !important;
  }
  .text-mmd-body-emphasis {
    --bs-text-opacity: 1;
    color: var(--bs-emphasis-color) !important;
  }
  .text-mmd-reset {
    --bs-text-opacity: 1;
    color: inherit !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .opacity-md-0 {
    opacity: 0 !important;
  }
  .opacity-md-25 {
    opacity: 0.25 !important;
  }
  .opacity-md-50 {
    opacity: 0.5 !important;
  }
  .opacity-md-75 {
    opacity: 0.75 !important;
  }
  .opacity-md-100 {
    opacity: 1 !important;
  }
  .opacity-md-5 {
    opacity: 0.5 !important;
  }
  .opacity-md-10 {
    opacity: 0.1 !important;
  }
  .opacity-md-15 {
    opacity: 0.15 !important;
  }
  .opacity-md-20 {
    opacity: 0.2 !important;
  }
  .opacity-md-30 {
    opacity: 0.3 !important;
  }
  .opacity-md-35 {
    opacity: 0.35 !important;
  }
  .opacity-md-40 {
    opacity: 0.4 !important;
  }
  .opacity-md-45 {
    opacity: 0.45 !important;
  }
  .opacity-md-60 {
    opacity: 0.6 !important;
  }
  .opacity-md-65 {
    opacity: 0.65 !important;
  }
  .opacity-md-70 {
    opacity: 0.7 !important;
  }
  .opacity-md-80 {
    opacity: 0.8 !important;
  }
  .opacity-md-85 {
    opacity: 0.85 !important;
  }
  .opacity-md-90 {
    opacity: 0.9 !important;
  }
  .opacity-md-95 {
    opacity: 0.95 !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .top-md-0 {
    top: 0 !important;
  }
  .top-md-50 {
    top: 50% !important;
  }
  .top-md-100 {
    top: 100% !important;
  }
  .top-md-1 {
    top: 1% !important;
  }
  .top-md-2 {
    top: 2% !important;
  }
  .top-md-3 {
    top: 3% !important;
  }
  .top-md-4 {
    top: 4% !important;
  }
  .top-md-5 {
    top: 5% !important;
  }
  .top-md-10 {
    top: 10% !important;
  }
  .top-md-15 {
    top: 15% !important;
  }
  .top-md-20 {
    top: 20% !important;
  }
  .top-md-25 {
    top: 25% !important;
  }
  .top-md-30 {
    top: 30% !important;
  }
  .top-md-35 {
    top: 35% !important;
  }
  .top-md-40 {
    top: 40% !important;
  }
  .top-md-45 {
    top: 45% !important;
  }
  .top-md-55 {
    top: 55% !important;
  }
  .top-md-60 {
    top: 60% !important;
  }
  .top-md-65 {
    top: 65% !important;
  }
  .top-md-70 {
    top: 70% !important;
  }
  .top-md-75 {
    top: 75% !important;
  }
  .top-md-80 {
    top: 80% !important;
  }
  .top-md-85 {
    top: 85% !important;
  }
  .top-md-90 {
    top: 90% !important;
  }
  .top-md-95 {
    top: 95% !important;
  }
  .top-md-n50 {
    top: -50% !important;
  }
  .bottom-md-0 {
    bottom: 0 !important;
  }
  .bottom-md-50 {
    bottom: 50% !important;
  }
  .bottom-md-100 {
    bottom: 100% !important;
  }
  .bottom-md-1 {
    bottom: 1% !important;
  }
  .bottom-md-2 {
    bottom: 2% !important;
  }
  .bottom-md-3 {
    bottom: 3% !important;
  }
  .bottom-md-4 {
    bottom: 4% !important;
  }
  .bottom-md-5 {
    bottom: 5% !important;
  }
  .bottom-md-10 {
    bottom: 10% !important;
  }
  .bottom-md-15 {
    bottom: 15% !important;
  }
  .bottom-md-20 {
    bottom: 20% !important;
  }
  .bottom-md-25 {
    bottom: 25% !important;
  }
  .bottom-md-30 {
    bottom: 30% !important;
  }
  .bottom-md-35 {
    bottom: 35% !important;
  }
  .bottom-md-40 {
    bottom: 40% !important;
  }
  .bottom-md-45 {
    bottom: 45% !important;
  }
  .bottom-md-55 {
    bottom: 55% !important;
  }
  .bottom-md-60 {
    bottom: 60% !important;
  }
  .bottom-md-65 {
    bottom: 65% !important;
  }
  .bottom-md-70 {
    bottom: 70% !important;
  }
  .bottom-md-75 {
    bottom: 75% !important;
  }
  .bottom-md-80 {
    bottom: 80% !important;
  }
  .bottom-md-85 {
    bottom: 85% !important;
  }
  .bottom-md-90 {
    bottom: 90% !important;
  }
  .bottom-md-95 {
    bottom: 95% !important;
  }
  .bottom-md-n50 {
    bottom: -50% !important;
  }
  .start-md-0 {
    left: 0 !important;
  }
  .start-md-50 {
    left: 50% !important;
  }
  .start-md-100 {
    left: 100% !important;
  }
  .start-md-1 {
    left: 1% !important;
  }
  .start-md-2 {
    left: 2% !important;
  }
  .start-md-3 {
    left: 3% !important;
  }
  .start-md-4 {
    left: 4% !important;
  }
  .start-md-5 {
    left: 5% !important;
  }
  .start-md-10 {
    left: 10% !important;
  }
  .start-md-15 {
    left: 15% !important;
  }
  .start-md-20 {
    left: 20% !important;
  }
  .start-md-25 {
    left: 25% !important;
  }
  .start-md-30 {
    left: 30% !important;
  }
  .start-md-35 {
    left: 35% !important;
  }
  .start-md-40 {
    left: 40% !important;
  }
  .start-md-45 {
    left: 45% !important;
  }
  .start-md-55 {
    left: 55% !important;
  }
  .start-md-60 {
    left: 60% !important;
  }
  .start-md-65 {
    left: 65% !important;
  }
  .start-md-70 {
    left: 70% !important;
  }
  .start-md-75 {
    left: 75% !important;
  }
  .start-md-80 {
    left: 80% !important;
  }
  .start-md-85 {
    left: 85% !important;
  }
  .start-md-90 {
    left: 90% !important;
  }
  .start-md-95 {
    left: 95% !important;
  }
  .start-md-n50 {
    left: -50% !important;
  }
  .end-md-0 {
    right: 0 !important;
  }
  .end-md-50 {
    right: 50% !important;
  }
  .end-md-100 {
    right: 100% !important;
  }
  .end-md-1 {
    right: 1% !important;
  }
  .end-md-2 {
    right: 2% !important;
  }
  .end-md-3 {
    right: 3% !important;
  }
  .end-md-4 {
    right: 4% !important;
  }
  .end-md-5 {
    right: 5% !important;
  }
  .end-md-10 {
    right: 10% !important;
  }
  .end-md-15 {
    right: 15% !important;
  }
  .end-md-20 {
    right: 20% !important;
  }
  .end-md-25 {
    right: 25% !important;
  }
  .end-md-30 {
    right: 30% !important;
  }
  .end-md-35 {
    right: 35% !important;
  }
  .end-md-40 {
    right: 40% !important;
  }
  .end-md-45 {
    right: 45% !important;
  }
  .end-md-55 {
    right: 55% !important;
  }
  .end-md-60 {
    right: 60% !important;
  }
  .end-md-65 {
    right: 65% !important;
  }
  .end-md-70 {
    right: 70% !important;
  }
  .end-md-75 {
    right: 75% !important;
  }
  .end-md-80 {
    right: 80% !important;
  }
  .end-md-85 {
    right: 85% !important;
  }
  .end-md-90 {
    right: 90% !important;
  }
  .end-md-95 {
    right: 95% !important;
  }
  .end-md-n50 {
    right: -50% !important;
  }
  .w-md-25 {
    width: 25% !important;
  }
  .w-md-50 {
    width: 50% !important;
  }
  .w-md-75 {
    width: 75% !important;
  }
  .w-md-100 {
    width: 100% !important;
  }
  .w-md-auto {
    width: auto !important;
  }
  .w-md-5 {
    width: 5% !important;
  }
  .w-md-10 {
    width: 10% !important;
  }
  .w-md-15 {
    width: 15% !important;
  }
  .w-md-20 {
    width: 20% !important;
  }
  .w-md-30 {
    width: 30% !important;
  }
  .w-md-35 {
    width: 35% !important;
  }
  .w-md-40 {
    width: 40% !important;
  }
  .w-md-45 {
    width: 45% !important;
  }
  .w-md-55 {
    width: 55% !important;
  }
  .w-md-60 {
    width: 60% !important;
  }
  .w-md-65 {
    width: 65% !important;
  }
  .w-md-70 {
    width: 70% !important;
  }
  .w-md-80 {
    width: 80% !important;
  }
  .w-md-85 {
    width: 85% !important;
  }
  .w-md-90 {
    width: 90% !important;
  }
  .w-md-95 {
    width: 95% !important;
  }
  .h-md-25 {
    height: 25% !important;
  }
  .h-md-50 {
    height: 50% !important;
  }
  .h-md-75 {
    height: 75% !important;
  }
  .h-md-100 {
    height: 100% !important;
  }
  .h-md-auto {
    height: auto !important;
  }
  .h-md-5 {
    height: 5% !important;
  }
  .h-md-10 {
    height: 10% !important;
  }
  .h-md-15 {
    height: 15% !important;
  }
  .h-md-20 {
    height: 20% !important;
  }
  .h-md-30 {
    height: 30% !important;
  }
  .h-md-35 {
    height: 35% !important;
  }
  .h-md-40 {
    height: 40% !important;
  }
  .h-md-45 {
    height: 45% !important;
  }
  .h-md-55 {
    height: 55% !important;
  }
  .h-md-60 {
    height: 60% !important;
  }
  .h-md-65 {
    height: 65% !important;
  }
  .h-md-70 {
    height: 70% !important;
  }
  .h-md-80 {
    height: 80% !important;
  }
  .h-md-85 {
    height: 85% !important;
  }
  .h-md-90 {
    height: 90% !important;
  }
  .h-md-95 {
    height: 95% !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-6 {
    margin: 4.5rem !important;
  }
  .m-md-7 {
    margin: 6rem !important;
  }
  .m-md-8 {
    margin: 8rem !important;
  }
  .m-md-9 {
    margin: 12rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-6 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-md-7 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-md-8 {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-md-9 {
    margin-right: 12rem !important;
    margin-left: 12rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-6 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-md-7 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-md-8 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-md-9 {
    margin-top: 12rem !important;
    margin-bottom: 12rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-6 {
    margin-top: 4.5rem !important;
  }
  .mt-md-7 {
    margin-top: 6rem !important;
  }
  .mt-md-8 {
    margin-top: 8rem !important;
  }
  .mt-md-9 {
    margin-top: 12rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-6 {
    margin-right: 4.5rem !important;
  }
  .me-md-7 {
    margin-right: 6rem !important;
  }
  .me-md-8 {
    margin-right: 8rem !important;
  }
  .me-md-9 {
    margin-right: 12rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-6 {
    margin-bottom: 4.5rem !important;
  }
  .mb-md-7 {
    margin-bottom: 6rem !important;
  }
  .mb-md-8 {
    margin-bottom: 8rem !important;
  }
  .mb-md-9 {
    margin-bottom: 12rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-6 {
    margin-left: 4.5rem !important;
  }
  .ms-md-7 {
    margin-left: 6rem !important;
  }
  .ms-md-8 {
    margin-left: 8rem !important;
  }
  .ms-md-9 {
    margin-left: 12rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .m-md-n6 {
    margin: -4.5rem !important;
  }
  .m-md-n7 {
    margin: -6rem !important;
  }
  .m-md-n8 {
    margin: -8rem !important;
  }
  .m-md-n9 {
    margin: -12rem !important;
  }
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-md-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-md-n6 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-md-n7 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-md-n8 {
    margin-right: -8rem !important;
    margin-left: -8rem !important;
  }
  .mx-md-n9 {
    margin-right: -12rem !important;
    margin-left: -12rem !important;
  }
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-md-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-md-n6 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-md-n7 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-md-n8 {
    margin-top: -8rem !important;
    margin-bottom: -8rem !important;
  }
  .my-md-n9 {
    margin-top: -12rem !important;
    margin-bottom: -12rem !important;
  }
  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-md-n3 {
    margin-top: -1rem !important;
  }
  .mt-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-md-n5 {
    margin-top: -3rem !important;
  }
  .mt-md-n6 {
    margin-top: -4.5rem !important;
  }
  .mt-md-n7 {
    margin-top: -6rem !important;
  }
  .mt-md-n8 {
    margin-top: -8rem !important;
  }
  .mt-md-n9 {
    margin-top: -12rem !important;
  }
  .me-md-n1 {
    margin-right: -0.25rem !important;
  }
  .me-md-n2 {
    margin-right: -0.5rem !important;
  }
  .me-md-n3 {
    margin-right: -1rem !important;
  }
  .me-md-n4 {
    margin-right: -1.5rem !important;
  }
  .me-md-n5 {
    margin-right: -3rem !important;
  }
  .me-md-n6 {
    margin-right: -4.5rem !important;
  }
  .me-md-n7 {
    margin-right: -6rem !important;
  }
  .me-md-n8 {
    margin-right: -8rem !important;
  }
  .me-md-n9 {
    margin-right: -12rem !important;
  }
  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-md-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-md-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-md-n6 {
    margin-bottom: -4.5rem !important;
  }
  .mb-md-n7 {
    margin-bottom: -6rem !important;
  }
  .mb-md-n8 {
    margin-bottom: -8rem !important;
  }
  .mb-md-n9 {
    margin-bottom: -12rem !important;
  }
  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-md-n3 {
    margin-left: -1rem !important;
  }
  .ms-md-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-md-n5 {
    margin-left: -3rem !important;
  }
  .ms-md-n6 {
    margin-left: -4.5rem !important;
  }
  .ms-md-n7 {
    margin-left: -6rem !important;
  }
  .ms-md-n8 {
    margin-left: -8rem !important;
  }
  .ms-md-n9 {
    margin-left: -12rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .p-md-6 {
    padding: 4.5rem !important;
  }
  .p-md-7 {
    padding: 6rem !important;
  }
  .p-md-8 {
    padding: 8rem !important;
  }
  .p-md-9 {
    padding: 12rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-md-6 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-md-7 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-md-8 {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .px-md-9 {
    padding-right: 12rem !important;
    padding-left: 12rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-md-6 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-md-7 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-md-8 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .py-md-9 {
    padding-top: 12rem !important;
    padding-bottom: 12rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pt-md-6 {
    padding-top: 4.5rem !important;
  }
  .pt-md-7 {
    padding-top: 6rem !important;
  }
  .pt-md-8 {
    padding-top: 8rem !important;
  }
  .pt-md-9 {
    padding-top: 12rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pe-md-6 {
    padding-right: 4.5rem !important;
  }
  .pe-md-7 {
    padding-right: 6rem !important;
  }
  .pe-md-8 {
    padding-right: 8rem !important;
  }
  .pe-md-9 {
    padding-right: 12rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .pb-md-6 {
    padding-bottom: 4.5rem !important;
  }
  .pb-md-7 {
    padding-bottom: 6rem !important;
  }
  .pb-md-8 {
    padding-bottom: 8rem !important;
  }
  .pb-md-9 {
    padding-bottom: 12rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .ps-md-6 {
    padding-left: 4.5rem !important;
  }
  .ps-md-7 {
    padding-left: 6rem !important;
  }
  .ps-md-8 {
    padding-left: 8rem !important;
  }
  .ps-md-9 {
    padding-left: 12rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .gap-md-6 {
    gap: 4.5rem !important;
  }
  .gap-md-7 {
    gap: 6rem !important;
  }
  .gap-md-8 {
    gap: 8rem !important;
  }
  .gap-md-9 {
    gap: 12rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .row-gap-md-6 {
    row-gap: 4.5rem !important;
  }
  .row-gap-md-7 {
    row-gap: 6rem !important;
  }
  .row-gap-md-8 {
    row-gap: 8rem !important;
  }
  .row-gap-md-9 {
    row-gap: 12rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .column-gap-md-6 {
    column-gap: 4.5rem !important;
  }
  .column-gap-md-7 {
    column-gap: 6rem !important;
  }
  .column-gap-md-8 {
    column-gap: 8rem !important;
  }
  .column-gap-md-9 {
    column-gap: 12rem !important;
  }
  .fs-md-1 {
    font-size: calc(1.4125rem + 1.95vw) !important;
  }
  .fs-md-2 {
    font-size: calc(1.355rem + 1.26vw) !important;
  }
  .fs-md-3 {
    font-size: calc(1.32625rem + 0.915vw) !important;
  }
  .fs-md-4 {
    font-size: calc(1.2975rem + 0.57vw) !important;
  }
  .fs-md-5 {
    font-size: calc(1.26875rem + 0.225vw) !important;
  }
  .fs-md-6 {
    font-size: 1.15rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
  .text-md-primary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
  }
  .text-md-secondary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
  }
  .text-md-success {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
  }
  .text-md-info {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
  }
  .text-md-warning {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
  }
  .text-md-danger {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
  }
  .text-md-light {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
  }
  .text-md-dark {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
  }
  .text-md-black {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
  }
  .text-md-white {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
  }
  .text-md-body {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
  }
  .text-md-muted {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important;
  }
  .text-md-black-50 {
    --bs-text-opacity: 1;
    color: rgba(0, 0, 0, 0.5) !important;
  }
  .text-md-white-50 {
    --bs-text-opacity: 1;
    color: rgba(255, 255, 255, 0.5) !important;
  }
  .text-md-body-secondary {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important;
  }
  .text-md-body-tertiary {
    --bs-text-opacity: 1;
    color: var(--bs-tertiary-color) !important;
  }
  .text-md-body-emphasis {
    --bs-text-opacity: 1;
    color: var(--bs-emphasis-color) !important;
  }
  .text-md-reset {
    --bs-text-opacity: 1;
    color: inherit !important;
  }
}
@media (min-width: 880px) {
  .float-mlg-start {
    float: left !important;
  }
  .float-mlg-end {
    float: right !important;
  }
  .float-mlg-none {
    float: none !important;
  }
  .object-fit-mlg-contain {
    object-fit: contain !important;
  }
  .object-fit-mlg-cover {
    object-fit: cover !important;
  }
  .object-fit-mlg-fill {
    object-fit: fill !important;
  }
  .object-fit-mlg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-mlg-none {
    object-fit: none !important;
  }
  .opacity-mlg-0 {
    opacity: 0 !important;
  }
  .opacity-mlg-25 {
    opacity: 0.25 !important;
  }
  .opacity-mlg-50 {
    opacity: 0.5 !important;
  }
  .opacity-mlg-75 {
    opacity: 0.75 !important;
  }
  .opacity-mlg-100 {
    opacity: 1 !important;
  }
  .opacity-mlg-5 {
    opacity: 0.5 !important;
  }
  .opacity-mlg-10 {
    opacity: 0.1 !important;
  }
  .opacity-mlg-15 {
    opacity: 0.15 !important;
  }
  .opacity-mlg-20 {
    opacity: 0.2 !important;
  }
  .opacity-mlg-30 {
    opacity: 0.3 !important;
  }
  .opacity-mlg-35 {
    opacity: 0.35 !important;
  }
  .opacity-mlg-40 {
    opacity: 0.4 !important;
  }
  .opacity-mlg-45 {
    opacity: 0.45 !important;
  }
  .opacity-mlg-60 {
    opacity: 0.6 !important;
  }
  .opacity-mlg-65 {
    opacity: 0.65 !important;
  }
  .opacity-mlg-70 {
    opacity: 0.7 !important;
  }
  .opacity-mlg-80 {
    opacity: 0.8 !important;
  }
  .opacity-mlg-85 {
    opacity: 0.85 !important;
  }
  .opacity-mlg-90 {
    opacity: 0.9 !important;
  }
  .opacity-mlg-95 {
    opacity: 0.95 !important;
  }
  .d-mlg-inline {
    display: inline !important;
  }
  .d-mlg-inline-block {
    display: inline-block !important;
  }
  .d-mlg-block {
    display: block !important;
  }
  .d-mlg-grid {
    display: grid !important;
  }
  .d-mlg-inline-grid {
    display: inline-grid !important;
  }
  .d-mlg-table {
    display: table !important;
  }
  .d-mlg-table-row {
    display: table-row !important;
  }
  .d-mlg-table-cell {
    display: table-cell !important;
  }
  .d-mlg-flex {
    display: flex !important;
  }
  .d-mlg-inline-flex {
    display: inline-flex !important;
  }
  .d-mlg-none {
    display: none !important;
  }
  .top-mlg-0 {
    top: 0 !important;
  }
  .top-mlg-50 {
    top: 50% !important;
  }
  .top-mlg-100 {
    top: 100% !important;
  }
  .top-mlg-1 {
    top: 1% !important;
  }
  .top-mlg-2 {
    top: 2% !important;
  }
  .top-mlg-3 {
    top: 3% !important;
  }
  .top-mlg-4 {
    top: 4% !important;
  }
  .top-mlg-5 {
    top: 5% !important;
  }
  .top-mlg-10 {
    top: 10% !important;
  }
  .top-mlg-15 {
    top: 15% !important;
  }
  .top-mlg-20 {
    top: 20% !important;
  }
  .top-mlg-25 {
    top: 25% !important;
  }
  .top-mlg-30 {
    top: 30% !important;
  }
  .top-mlg-35 {
    top: 35% !important;
  }
  .top-mlg-40 {
    top: 40% !important;
  }
  .top-mlg-45 {
    top: 45% !important;
  }
  .top-mlg-55 {
    top: 55% !important;
  }
  .top-mlg-60 {
    top: 60% !important;
  }
  .top-mlg-65 {
    top: 65% !important;
  }
  .top-mlg-70 {
    top: 70% !important;
  }
  .top-mlg-75 {
    top: 75% !important;
  }
  .top-mlg-80 {
    top: 80% !important;
  }
  .top-mlg-85 {
    top: 85% !important;
  }
  .top-mlg-90 {
    top: 90% !important;
  }
  .top-mlg-95 {
    top: 95% !important;
  }
  .top-mlg-n50 {
    top: -50% !important;
  }
  .bottom-mlg-0 {
    bottom: 0 !important;
  }
  .bottom-mlg-50 {
    bottom: 50% !important;
  }
  .bottom-mlg-100 {
    bottom: 100% !important;
  }
  .bottom-mlg-1 {
    bottom: 1% !important;
  }
  .bottom-mlg-2 {
    bottom: 2% !important;
  }
  .bottom-mlg-3 {
    bottom: 3% !important;
  }
  .bottom-mlg-4 {
    bottom: 4% !important;
  }
  .bottom-mlg-5 {
    bottom: 5% !important;
  }
  .bottom-mlg-10 {
    bottom: 10% !important;
  }
  .bottom-mlg-15 {
    bottom: 15% !important;
  }
  .bottom-mlg-20 {
    bottom: 20% !important;
  }
  .bottom-mlg-25 {
    bottom: 25% !important;
  }
  .bottom-mlg-30 {
    bottom: 30% !important;
  }
  .bottom-mlg-35 {
    bottom: 35% !important;
  }
  .bottom-mlg-40 {
    bottom: 40% !important;
  }
  .bottom-mlg-45 {
    bottom: 45% !important;
  }
  .bottom-mlg-55 {
    bottom: 55% !important;
  }
  .bottom-mlg-60 {
    bottom: 60% !important;
  }
  .bottom-mlg-65 {
    bottom: 65% !important;
  }
  .bottom-mlg-70 {
    bottom: 70% !important;
  }
  .bottom-mlg-75 {
    bottom: 75% !important;
  }
  .bottom-mlg-80 {
    bottom: 80% !important;
  }
  .bottom-mlg-85 {
    bottom: 85% !important;
  }
  .bottom-mlg-90 {
    bottom: 90% !important;
  }
  .bottom-mlg-95 {
    bottom: 95% !important;
  }
  .bottom-mlg-n50 {
    bottom: -50% !important;
  }
  .start-mlg-0 {
    left: 0 !important;
  }
  .start-mlg-50 {
    left: 50% !important;
  }
  .start-mlg-100 {
    left: 100% !important;
  }
  .start-mlg-1 {
    left: 1% !important;
  }
  .start-mlg-2 {
    left: 2% !important;
  }
  .start-mlg-3 {
    left: 3% !important;
  }
  .start-mlg-4 {
    left: 4% !important;
  }
  .start-mlg-5 {
    left: 5% !important;
  }
  .start-mlg-10 {
    left: 10% !important;
  }
  .start-mlg-15 {
    left: 15% !important;
  }
  .start-mlg-20 {
    left: 20% !important;
  }
  .start-mlg-25 {
    left: 25% !important;
  }
  .start-mlg-30 {
    left: 30% !important;
  }
  .start-mlg-35 {
    left: 35% !important;
  }
  .start-mlg-40 {
    left: 40% !important;
  }
  .start-mlg-45 {
    left: 45% !important;
  }
  .start-mlg-55 {
    left: 55% !important;
  }
  .start-mlg-60 {
    left: 60% !important;
  }
  .start-mlg-65 {
    left: 65% !important;
  }
  .start-mlg-70 {
    left: 70% !important;
  }
  .start-mlg-75 {
    left: 75% !important;
  }
  .start-mlg-80 {
    left: 80% !important;
  }
  .start-mlg-85 {
    left: 85% !important;
  }
  .start-mlg-90 {
    left: 90% !important;
  }
  .start-mlg-95 {
    left: 95% !important;
  }
  .start-mlg-n50 {
    left: -50% !important;
  }
  .end-mlg-0 {
    right: 0 !important;
  }
  .end-mlg-50 {
    right: 50% !important;
  }
  .end-mlg-100 {
    right: 100% !important;
  }
  .end-mlg-1 {
    right: 1% !important;
  }
  .end-mlg-2 {
    right: 2% !important;
  }
  .end-mlg-3 {
    right: 3% !important;
  }
  .end-mlg-4 {
    right: 4% !important;
  }
  .end-mlg-5 {
    right: 5% !important;
  }
  .end-mlg-10 {
    right: 10% !important;
  }
  .end-mlg-15 {
    right: 15% !important;
  }
  .end-mlg-20 {
    right: 20% !important;
  }
  .end-mlg-25 {
    right: 25% !important;
  }
  .end-mlg-30 {
    right: 30% !important;
  }
  .end-mlg-35 {
    right: 35% !important;
  }
  .end-mlg-40 {
    right: 40% !important;
  }
  .end-mlg-45 {
    right: 45% !important;
  }
  .end-mlg-55 {
    right: 55% !important;
  }
  .end-mlg-60 {
    right: 60% !important;
  }
  .end-mlg-65 {
    right: 65% !important;
  }
  .end-mlg-70 {
    right: 70% !important;
  }
  .end-mlg-75 {
    right: 75% !important;
  }
  .end-mlg-80 {
    right: 80% !important;
  }
  .end-mlg-85 {
    right: 85% !important;
  }
  .end-mlg-90 {
    right: 90% !important;
  }
  .end-mlg-95 {
    right: 95% !important;
  }
  .end-mlg-n50 {
    right: -50% !important;
  }
  .w-mlg-25 {
    width: 25% !important;
  }
  .w-mlg-50 {
    width: 50% !important;
  }
  .w-mlg-75 {
    width: 75% !important;
  }
  .w-mlg-100 {
    width: 100% !important;
  }
  .w-mlg-auto {
    width: auto !important;
  }
  .w-mlg-5 {
    width: 5% !important;
  }
  .w-mlg-10 {
    width: 10% !important;
  }
  .w-mlg-15 {
    width: 15% !important;
  }
  .w-mlg-20 {
    width: 20% !important;
  }
  .w-mlg-30 {
    width: 30% !important;
  }
  .w-mlg-35 {
    width: 35% !important;
  }
  .w-mlg-40 {
    width: 40% !important;
  }
  .w-mlg-45 {
    width: 45% !important;
  }
  .w-mlg-55 {
    width: 55% !important;
  }
  .w-mlg-60 {
    width: 60% !important;
  }
  .w-mlg-65 {
    width: 65% !important;
  }
  .w-mlg-70 {
    width: 70% !important;
  }
  .w-mlg-80 {
    width: 80% !important;
  }
  .w-mlg-85 {
    width: 85% !important;
  }
  .w-mlg-90 {
    width: 90% !important;
  }
  .w-mlg-95 {
    width: 95% !important;
  }
  .h-mlg-25 {
    height: 25% !important;
  }
  .h-mlg-50 {
    height: 50% !important;
  }
  .h-mlg-75 {
    height: 75% !important;
  }
  .h-mlg-100 {
    height: 100% !important;
  }
  .h-mlg-auto {
    height: auto !important;
  }
  .h-mlg-5 {
    height: 5% !important;
  }
  .h-mlg-10 {
    height: 10% !important;
  }
  .h-mlg-15 {
    height: 15% !important;
  }
  .h-mlg-20 {
    height: 20% !important;
  }
  .h-mlg-30 {
    height: 30% !important;
  }
  .h-mlg-35 {
    height: 35% !important;
  }
  .h-mlg-40 {
    height: 40% !important;
  }
  .h-mlg-45 {
    height: 45% !important;
  }
  .h-mlg-55 {
    height: 55% !important;
  }
  .h-mlg-60 {
    height: 60% !important;
  }
  .h-mlg-65 {
    height: 65% !important;
  }
  .h-mlg-70 {
    height: 70% !important;
  }
  .h-mlg-80 {
    height: 80% !important;
  }
  .h-mlg-85 {
    height: 85% !important;
  }
  .h-mlg-90 {
    height: 90% !important;
  }
  .h-mlg-95 {
    height: 95% !important;
  }
  .flex-mlg-fill {
    flex: 1 1 auto !important;
  }
  .flex-mlg-row {
    flex-direction: row !important;
  }
  .flex-mlg-column {
    flex-direction: column !important;
  }
  .flex-mlg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-mlg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-mlg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-mlg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-mlg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-mlg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-mlg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-mlg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-mlg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-mlg-start {
    justify-content: flex-start !important;
  }
  .justify-content-mlg-end {
    justify-content: flex-end !important;
  }
  .justify-content-mlg-center {
    justify-content: center !important;
  }
  .justify-content-mlg-between {
    justify-content: space-between !important;
  }
  .justify-content-mlg-around {
    justify-content: space-around !important;
  }
  .justify-content-mlg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-mlg-start {
    align-items: flex-start !important;
  }
  .align-items-mlg-end {
    align-items: flex-end !important;
  }
  .align-items-mlg-center {
    align-items: center !important;
  }
  .align-items-mlg-baseline {
    align-items: baseline !important;
  }
  .align-items-mlg-stretch {
    align-items: stretch !important;
  }
  .align-content-mlg-start {
    align-content: flex-start !important;
  }
  .align-content-mlg-end {
    align-content: flex-end !important;
  }
  .align-content-mlg-center {
    align-content: center !important;
  }
  .align-content-mlg-between {
    align-content: space-between !important;
  }
  .align-content-mlg-around {
    align-content: space-around !important;
  }
  .align-content-mlg-stretch {
    align-content: stretch !important;
  }
  .align-self-mlg-auto {
    align-self: auto !important;
  }
  .align-self-mlg-start {
    align-self: flex-start !important;
  }
  .align-self-mlg-end {
    align-self: flex-end !important;
  }
  .align-self-mlg-center {
    align-self: center !important;
  }
  .align-self-mlg-baseline {
    align-self: baseline !important;
  }
  .align-self-mlg-stretch {
    align-self: stretch !important;
  }
  .order-mlg-first {
    order: -1 !important;
  }
  .order-mlg-0 {
    order: 0 !important;
  }
  .order-mlg-1 {
    order: 1 !important;
  }
  .order-mlg-2 {
    order: 2 !important;
  }
  .order-mlg-3 {
    order: 3 !important;
  }
  .order-mlg-4 {
    order: 4 !important;
  }
  .order-mlg-5 {
    order: 5 !important;
  }
  .order-mlg-last {
    order: 6 !important;
  }
  .m-mlg-0 {
    margin: 0 !important;
  }
  .m-mlg-1 {
    margin: 0.25rem !important;
  }
  .m-mlg-2 {
    margin: 0.5rem !important;
  }
  .m-mlg-3 {
    margin: 1rem !important;
  }
  .m-mlg-4 {
    margin: 1.5rem !important;
  }
  .m-mlg-5 {
    margin: 3rem !important;
  }
  .m-mlg-6 {
    margin: 4.5rem !important;
  }
  .m-mlg-7 {
    margin: 6rem !important;
  }
  .m-mlg-8 {
    margin: 8rem !important;
  }
  .m-mlg-9 {
    margin: 12rem !important;
  }
  .m-mlg-auto {
    margin: auto !important;
  }
  .mx-mlg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-mlg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-mlg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-mlg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-mlg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-mlg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-mlg-6 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-mlg-7 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-mlg-8 {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-mlg-9 {
    margin-right: 12rem !important;
    margin-left: 12rem !important;
  }
  .mx-mlg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-mlg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-mlg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-mlg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-mlg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-mlg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-mlg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-mlg-6 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-mlg-7 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-mlg-8 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-mlg-9 {
    margin-top: 12rem !important;
    margin-bottom: 12rem !important;
  }
  .my-mlg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-mlg-0 {
    margin-top: 0 !important;
  }
  .mt-mlg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-mlg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-mlg-3 {
    margin-top: 1rem !important;
  }
  .mt-mlg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-mlg-5 {
    margin-top: 3rem !important;
  }
  .mt-mlg-6 {
    margin-top: 4.5rem !important;
  }
  .mt-mlg-7 {
    margin-top: 6rem !important;
  }
  .mt-mlg-8 {
    margin-top: 8rem !important;
  }
  .mt-mlg-9 {
    margin-top: 12rem !important;
  }
  .mt-mlg-auto {
    margin-top: auto !important;
  }
  .me-mlg-0 {
    margin-right: 0 !important;
  }
  .me-mlg-1 {
    margin-right: 0.25rem !important;
  }
  .me-mlg-2 {
    margin-right: 0.5rem !important;
  }
  .me-mlg-3 {
    margin-right: 1rem !important;
  }
  .me-mlg-4 {
    margin-right: 1.5rem !important;
  }
  .me-mlg-5 {
    margin-right: 3rem !important;
  }
  .me-mlg-6 {
    margin-right: 4.5rem !important;
  }
  .me-mlg-7 {
    margin-right: 6rem !important;
  }
  .me-mlg-8 {
    margin-right: 8rem !important;
  }
  .me-mlg-9 {
    margin-right: 12rem !important;
  }
  .me-mlg-auto {
    margin-right: auto !important;
  }
  .mb-mlg-0 {
    margin-bottom: 0 !important;
  }
  .mb-mlg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-mlg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-mlg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-mlg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-mlg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-mlg-6 {
    margin-bottom: 4.5rem !important;
  }
  .mb-mlg-7 {
    margin-bottom: 6rem !important;
  }
  .mb-mlg-8 {
    margin-bottom: 8rem !important;
  }
  .mb-mlg-9 {
    margin-bottom: 12rem !important;
  }
  .mb-mlg-auto {
    margin-bottom: auto !important;
  }
  .ms-mlg-0 {
    margin-left: 0 !important;
  }
  .ms-mlg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-mlg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-mlg-3 {
    margin-left: 1rem !important;
  }
  .ms-mlg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-mlg-5 {
    margin-left: 3rem !important;
  }
  .ms-mlg-6 {
    margin-left: 4.5rem !important;
  }
  .ms-mlg-7 {
    margin-left: 6rem !important;
  }
  .ms-mlg-8 {
    margin-left: 8rem !important;
  }
  .ms-mlg-9 {
    margin-left: 12rem !important;
  }
  .ms-mlg-auto {
    margin-left: auto !important;
  }
  .m-mlg-n1 {
    margin: -0.25rem !important;
  }
  .m-mlg-n2 {
    margin: -0.5rem !important;
  }
  .m-mlg-n3 {
    margin: -1rem !important;
  }
  .m-mlg-n4 {
    margin: -1.5rem !important;
  }
  .m-mlg-n5 {
    margin: -3rem !important;
  }
  .m-mlg-n6 {
    margin: -4.5rem !important;
  }
  .m-mlg-n7 {
    margin: -6rem !important;
  }
  .m-mlg-n8 {
    margin: -8rem !important;
  }
  .m-mlg-n9 {
    margin: -12rem !important;
  }
  .mx-mlg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-mlg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-mlg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-mlg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-mlg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-mlg-n6 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-mlg-n7 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-mlg-n8 {
    margin-right: -8rem !important;
    margin-left: -8rem !important;
  }
  .mx-mlg-n9 {
    margin-right: -12rem !important;
    margin-left: -12rem !important;
  }
  .my-mlg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-mlg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-mlg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-mlg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-mlg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-mlg-n6 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-mlg-n7 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-mlg-n8 {
    margin-top: -8rem !important;
    margin-bottom: -8rem !important;
  }
  .my-mlg-n9 {
    margin-top: -12rem !important;
    margin-bottom: -12rem !important;
  }
  .mt-mlg-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-mlg-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-mlg-n3 {
    margin-top: -1rem !important;
  }
  .mt-mlg-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-mlg-n5 {
    margin-top: -3rem !important;
  }
  .mt-mlg-n6 {
    margin-top: -4.5rem !important;
  }
  .mt-mlg-n7 {
    margin-top: -6rem !important;
  }
  .mt-mlg-n8 {
    margin-top: -8rem !important;
  }
  .mt-mlg-n9 {
    margin-top: -12rem !important;
  }
  .me-mlg-n1 {
    margin-right: -0.25rem !important;
  }
  .me-mlg-n2 {
    margin-right: -0.5rem !important;
  }
  .me-mlg-n3 {
    margin-right: -1rem !important;
  }
  .me-mlg-n4 {
    margin-right: -1.5rem !important;
  }
  .me-mlg-n5 {
    margin-right: -3rem !important;
  }
  .me-mlg-n6 {
    margin-right: -4.5rem !important;
  }
  .me-mlg-n7 {
    margin-right: -6rem !important;
  }
  .me-mlg-n8 {
    margin-right: -8rem !important;
  }
  .me-mlg-n9 {
    margin-right: -12rem !important;
  }
  .mb-mlg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-mlg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-mlg-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-mlg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-mlg-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-mlg-n6 {
    margin-bottom: -4.5rem !important;
  }
  .mb-mlg-n7 {
    margin-bottom: -6rem !important;
  }
  .mb-mlg-n8 {
    margin-bottom: -8rem !important;
  }
  .mb-mlg-n9 {
    margin-bottom: -12rem !important;
  }
  .ms-mlg-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-mlg-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-mlg-n3 {
    margin-left: -1rem !important;
  }
  .ms-mlg-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-mlg-n5 {
    margin-left: -3rem !important;
  }
  .ms-mlg-n6 {
    margin-left: -4.5rem !important;
  }
  .ms-mlg-n7 {
    margin-left: -6rem !important;
  }
  .ms-mlg-n8 {
    margin-left: -8rem !important;
  }
  .ms-mlg-n9 {
    margin-left: -12rem !important;
  }
  .p-mlg-0 {
    padding: 0 !important;
  }
  .p-mlg-1 {
    padding: 0.25rem !important;
  }
  .p-mlg-2 {
    padding: 0.5rem !important;
  }
  .p-mlg-3 {
    padding: 1rem !important;
  }
  .p-mlg-4 {
    padding: 1.5rem !important;
  }
  .p-mlg-5 {
    padding: 3rem !important;
  }
  .p-mlg-6 {
    padding: 4.5rem !important;
  }
  .p-mlg-7 {
    padding: 6rem !important;
  }
  .p-mlg-8 {
    padding: 8rem !important;
  }
  .p-mlg-9 {
    padding: 12rem !important;
  }
  .px-mlg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-mlg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-mlg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-mlg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-mlg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-mlg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-mlg-6 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-mlg-7 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-mlg-8 {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .px-mlg-9 {
    padding-right: 12rem !important;
    padding-left: 12rem !important;
  }
  .py-mlg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-mlg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-mlg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-mlg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-mlg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-mlg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-mlg-6 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-mlg-7 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-mlg-8 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .py-mlg-9 {
    padding-top: 12rem !important;
    padding-bottom: 12rem !important;
  }
  .pt-mlg-0 {
    padding-top: 0 !important;
  }
  .pt-mlg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-mlg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-mlg-3 {
    padding-top: 1rem !important;
  }
  .pt-mlg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-mlg-5 {
    padding-top: 3rem !important;
  }
  .pt-mlg-6 {
    padding-top: 4.5rem !important;
  }
  .pt-mlg-7 {
    padding-top: 6rem !important;
  }
  .pt-mlg-8 {
    padding-top: 8rem !important;
  }
  .pt-mlg-9 {
    padding-top: 12rem !important;
  }
  .pe-mlg-0 {
    padding-right: 0 !important;
  }
  .pe-mlg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-mlg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-mlg-3 {
    padding-right: 1rem !important;
  }
  .pe-mlg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-mlg-5 {
    padding-right: 3rem !important;
  }
  .pe-mlg-6 {
    padding-right: 4.5rem !important;
  }
  .pe-mlg-7 {
    padding-right: 6rem !important;
  }
  .pe-mlg-8 {
    padding-right: 8rem !important;
  }
  .pe-mlg-9 {
    padding-right: 12rem !important;
  }
  .pb-mlg-0 {
    padding-bottom: 0 !important;
  }
  .pb-mlg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-mlg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-mlg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-mlg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-mlg-5 {
    padding-bottom: 3rem !important;
  }
  .pb-mlg-6 {
    padding-bottom: 4.5rem !important;
  }
  .pb-mlg-7 {
    padding-bottom: 6rem !important;
  }
  .pb-mlg-8 {
    padding-bottom: 8rem !important;
  }
  .pb-mlg-9 {
    padding-bottom: 12rem !important;
  }
  .ps-mlg-0 {
    padding-left: 0 !important;
  }
  .ps-mlg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-mlg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-mlg-3 {
    padding-left: 1rem !important;
  }
  .ps-mlg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-mlg-5 {
    padding-left: 3rem !important;
  }
  .ps-mlg-6 {
    padding-left: 4.5rem !important;
  }
  .ps-mlg-7 {
    padding-left: 6rem !important;
  }
  .ps-mlg-8 {
    padding-left: 8rem !important;
  }
  .ps-mlg-9 {
    padding-left: 12rem !important;
  }
  .gap-mlg-0 {
    gap: 0 !important;
  }
  .gap-mlg-1 {
    gap: 0.25rem !important;
  }
  .gap-mlg-2 {
    gap: 0.5rem !important;
  }
  .gap-mlg-3 {
    gap: 1rem !important;
  }
  .gap-mlg-4 {
    gap: 1.5rem !important;
  }
  .gap-mlg-5 {
    gap: 3rem !important;
  }
  .gap-mlg-6 {
    gap: 4.5rem !important;
  }
  .gap-mlg-7 {
    gap: 6rem !important;
  }
  .gap-mlg-8 {
    gap: 8rem !important;
  }
  .gap-mlg-9 {
    gap: 12rem !important;
  }
  .row-gap-mlg-0 {
    row-gap: 0 !important;
  }
  .row-gap-mlg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-mlg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-mlg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-mlg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-mlg-5 {
    row-gap: 3rem !important;
  }
  .row-gap-mlg-6 {
    row-gap: 4.5rem !important;
  }
  .row-gap-mlg-7 {
    row-gap: 6rem !important;
  }
  .row-gap-mlg-8 {
    row-gap: 8rem !important;
  }
  .row-gap-mlg-9 {
    row-gap: 12rem !important;
  }
  .column-gap-mlg-0 {
    column-gap: 0 !important;
  }
  .column-gap-mlg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-mlg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-mlg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-mlg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-mlg-5 {
    column-gap: 3rem !important;
  }
  .column-gap-mlg-6 {
    column-gap: 4.5rem !important;
  }
  .column-gap-mlg-7 {
    column-gap: 6rem !important;
  }
  .column-gap-mlg-8 {
    column-gap: 8rem !important;
  }
  .column-gap-mlg-9 {
    column-gap: 12rem !important;
  }
  .fs-mlg-1 {
    font-size: calc(1.4125rem + 1.95vw) !important;
  }
  .fs-mlg-2 {
    font-size: calc(1.355rem + 1.26vw) !important;
  }
  .fs-mlg-3 {
    font-size: calc(1.32625rem + 0.915vw) !important;
  }
  .fs-mlg-4 {
    font-size: calc(1.2975rem + 0.57vw) !important;
  }
  .fs-mlg-5 {
    font-size: calc(1.26875rem + 0.225vw) !important;
  }
  .fs-mlg-6 {
    font-size: 1.15rem !important;
  }
  .text-mlg-start {
    text-align: left !important;
  }
  .text-mlg-end {
    text-align: right !important;
  }
  .text-mlg-center {
    text-align: center !important;
  }
  .text-mlg-primary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mlg-secondary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mlg-success {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mlg-info {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mlg-warning {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mlg-danger {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mlg-light {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mlg-dark {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mlg-black {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mlg-white {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mlg-body {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
  }
  .text-mlg-muted {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important;
  }
  .text-mlg-black-50 {
    --bs-text-opacity: 1;
    color: rgba(0, 0, 0, 0.5) !important;
  }
  .text-mlg-white-50 {
    --bs-text-opacity: 1;
    color: rgba(255, 255, 255, 0.5) !important;
  }
  .text-mlg-body-secondary {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important;
  }
  .text-mlg-body-tertiary {
    --bs-text-opacity: 1;
    color: var(--bs-tertiary-color) !important;
  }
  .text-mlg-body-emphasis {
    --bs-text-opacity: 1;
    color: var(--bs-emphasis-color) !important;
  }
  .text-mlg-reset {
    --bs-text-opacity: 1;
    color: inherit !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .opacity-lg-0 {
    opacity: 0 !important;
  }
  .opacity-lg-25 {
    opacity: 0.25 !important;
  }
  .opacity-lg-50 {
    opacity: 0.5 !important;
  }
  .opacity-lg-75 {
    opacity: 0.75 !important;
  }
  .opacity-lg-100 {
    opacity: 1 !important;
  }
  .opacity-lg-5 {
    opacity: 0.5 !important;
  }
  .opacity-lg-10 {
    opacity: 0.1 !important;
  }
  .opacity-lg-15 {
    opacity: 0.15 !important;
  }
  .opacity-lg-20 {
    opacity: 0.2 !important;
  }
  .opacity-lg-30 {
    opacity: 0.3 !important;
  }
  .opacity-lg-35 {
    opacity: 0.35 !important;
  }
  .opacity-lg-40 {
    opacity: 0.4 !important;
  }
  .opacity-lg-45 {
    opacity: 0.45 !important;
  }
  .opacity-lg-60 {
    opacity: 0.6 !important;
  }
  .opacity-lg-65 {
    opacity: 0.65 !important;
  }
  .opacity-lg-70 {
    opacity: 0.7 !important;
  }
  .opacity-lg-80 {
    opacity: 0.8 !important;
  }
  .opacity-lg-85 {
    opacity: 0.85 !important;
  }
  .opacity-lg-90 {
    opacity: 0.9 !important;
  }
  .opacity-lg-95 {
    opacity: 0.95 !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .top-lg-0 {
    top: 0 !important;
  }
  .top-lg-50 {
    top: 50% !important;
  }
  .top-lg-100 {
    top: 100% !important;
  }
  .top-lg-1 {
    top: 1% !important;
  }
  .top-lg-2 {
    top: 2% !important;
  }
  .top-lg-3 {
    top: 3% !important;
  }
  .top-lg-4 {
    top: 4% !important;
  }
  .top-lg-5 {
    top: 5% !important;
  }
  .top-lg-10 {
    top: 10% !important;
  }
  .top-lg-15 {
    top: 15% !important;
  }
  .top-lg-20 {
    top: 20% !important;
  }
  .top-lg-25 {
    top: 25% !important;
  }
  .top-lg-30 {
    top: 30% !important;
  }
  .top-lg-35 {
    top: 35% !important;
  }
  .top-lg-40 {
    top: 40% !important;
  }
  .top-lg-45 {
    top: 45% !important;
  }
  .top-lg-55 {
    top: 55% !important;
  }
  .top-lg-60 {
    top: 60% !important;
  }
  .top-lg-65 {
    top: 65% !important;
  }
  .top-lg-70 {
    top: 70% !important;
  }
  .top-lg-75 {
    top: 75% !important;
  }
  .top-lg-80 {
    top: 80% !important;
  }
  .top-lg-85 {
    top: 85% !important;
  }
  .top-lg-90 {
    top: 90% !important;
  }
  .top-lg-95 {
    top: 95% !important;
  }
  .top-lg-n50 {
    top: -50% !important;
  }
  .bottom-lg-0 {
    bottom: 0 !important;
  }
  .bottom-lg-50 {
    bottom: 50% !important;
  }
  .bottom-lg-100 {
    bottom: 100% !important;
  }
  .bottom-lg-1 {
    bottom: 1% !important;
  }
  .bottom-lg-2 {
    bottom: 2% !important;
  }
  .bottom-lg-3 {
    bottom: 3% !important;
  }
  .bottom-lg-4 {
    bottom: 4% !important;
  }
  .bottom-lg-5 {
    bottom: 5% !important;
  }
  .bottom-lg-10 {
    bottom: 10% !important;
  }
  .bottom-lg-15 {
    bottom: 15% !important;
  }
  .bottom-lg-20 {
    bottom: 20% !important;
  }
  .bottom-lg-25 {
    bottom: 25% !important;
  }
  .bottom-lg-30 {
    bottom: 30% !important;
  }
  .bottom-lg-35 {
    bottom: 35% !important;
  }
  .bottom-lg-40 {
    bottom: 40% !important;
  }
  .bottom-lg-45 {
    bottom: 45% !important;
  }
  .bottom-lg-55 {
    bottom: 55% !important;
  }
  .bottom-lg-60 {
    bottom: 60% !important;
  }
  .bottom-lg-65 {
    bottom: 65% !important;
  }
  .bottom-lg-70 {
    bottom: 70% !important;
  }
  .bottom-lg-75 {
    bottom: 75% !important;
  }
  .bottom-lg-80 {
    bottom: 80% !important;
  }
  .bottom-lg-85 {
    bottom: 85% !important;
  }
  .bottom-lg-90 {
    bottom: 90% !important;
  }
  .bottom-lg-95 {
    bottom: 95% !important;
  }
  .bottom-lg-n50 {
    bottom: -50% !important;
  }
  .start-lg-0 {
    left: 0 !important;
  }
  .start-lg-50 {
    left: 50% !important;
  }
  .start-lg-100 {
    left: 100% !important;
  }
  .start-lg-1 {
    left: 1% !important;
  }
  .start-lg-2 {
    left: 2% !important;
  }
  .start-lg-3 {
    left: 3% !important;
  }
  .start-lg-4 {
    left: 4% !important;
  }
  .start-lg-5 {
    left: 5% !important;
  }
  .start-lg-10 {
    left: 10% !important;
  }
  .start-lg-15 {
    left: 15% !important;
  }
  .start-lg-20 {
    left: 20% !important;
  }
  .start-lg-25 {
    left: 25% !important;
  }
  .start-lg-30 {
    left: 30% !important;
  }
  .start-lg-35 {
    left: 35% !important;
  }
  .start-lg-40 {
    left: 40% !important;
  }
  .start-lg-45 {
    left: 45% !important;
  }
  .start-lg-55 {
    left: 55% !important;
  }
  .start-lg-60 {
    left: 60% !important;
  }
  .start-lg-65 {
    left: 65% !important;
  }
  .start-lg-70 {
    left: 70% !important;
  }
  .start-lg-75 {
    left: 75% !important;
  }
  .start-lg-80 {
    left: 80% !important;
  }
  .start-lg-85 {
    left: 85% !important;
  }
  .start-lg-90 {
    left: 90% !important;
  }
  .start-lg-95 {
    left: 95% !important;
  }
  .start-lg-n50 {
    left: -50% !important;
  }
  .end-lg-0 {
    right: 0 !important;
  }
  .end-lg-50 {
    right: 50% !important;
  }
  .end-lg-100 {
    right: 100% !important;
  }
  .end-lg-1 {
    right: 1% !important;
  }
  .end-lg-2 {
    right: 2% !important;
  }
  .end-lg-3 {
    right: 3% !important;
  }
  .end-lg-4 {
    right: 4% !important;
  }
  .end-lg-5 {
    right: 5% !important;
  }
  .end-lg-10 {
    right: 10% !important;
  }
  .end-lg-15 {
    right: 15% !important;
  }
  .end-lg-20 {
    right: 20% !important;
  }
  .end-lg-25 {
    right: 25% !important;
  }
  .end-lg-30 {
    right: 30% !important;
  }
  .end-lg-35 {
    right: 35% !important;
  }
  .end-lg-40 {
    right: 40% !important;
  }
  .end-lg-45 {
    right: 45% !important;
  }
  .end-lg-55 {
    right: 55% !important;
  }
  .end-lg-60 {
    right: 60% !important;
  }
  .end-lg-65 {
    right: 65% !important;
  }
  .end-lg-70 {
    right: 70% !important;
  }
  .end-lg-75 {
    right: 75% !important;
  }
  .end-lg-80 {
    right: 80% !important;
  }
  .end-lg-85 {
    right: 85% !important;
  }
  .end-lg-90 {
    right: 90% !important;
  }
  .end-lg-95 {
    right: 95% !important;
  }
  .end-lg-n50 {
    right: -50% !important;
  }
  .w-lg-25 {
    width: 25% !important;
  }
  .w-lg-50 {
    width: 50% !important;
  }
  .w-lg-75 {
    width: 75% !important;
  }
  .w-lg-100 {
    width: 100% !important;
  }
  .w-lg-auto {
    width: auto !important;
  }
  .w-lg-5 {
    width: 5% !important;
  }
  .w-lg-10 {
    width: 10% !important;
  }
  .w-lg-15 {
    width: 15% !important;
  }
  .w-lg-20 {
    width: 20% !important;
  }
  .w-lg-30 {
    width: 30% !important;
  }
  .w-lg-35 {
    width: 35% !important;
  }
  .w-lg-40 {
    width: 40% !important;
  }
  .w-lg-45 {
    width: 45% !important;
  }
  .w-lg-55 {
    width: 55% !important;
  }
  .w-lg-60 {
    width: 60% !important;
  }
  .w-lg-65 {
    width: 65% !important;
  }
  .w-lg-70 {
    width: 70% !important;
  }
  .w-lg-80 {
    width: 80% !important;
  }
  .w-lg-85 {
    width: 85% !important;
  }
  .w-lg-90 {
    width: 90% !important;
  }
  .w-lg-95 {
    width: 95% !important;
  }
  .h-lg-25 {
    height: 25% !important;
  }
  .h-lg-50 {
    height: 50% !important;
  }
  .h-lg-75 {
    height: 75% !important;
  }
  .h-lg-100 {
    height: 100% !important;
  }
  .h-lg-auto {
    height: auto !important;
  }
  .h-lg-5 {
    height: 5% !important;
  }
  .h-lg-10 {
    height: 10% !important;
  }
  .h-lg-15 {
    height: 15% !important;
  }
  .h-lg-20 {
    height: 20% !important;
  }
  .h-lg-30 {
    height: 30% !important;
  }
  .h-lg-35 {
    height: 35% !important;
  }
  .h-lg-40 {
    height: 40% !important;
  }
  .h-lg-45 {
    height: 45% !important;
  }
  .h-lg-55 {
    height: 55% !important;
  }
  .h-lg-60 {
    height: 60% !important;
  }
  .h-lg-65 {
    height: 65% !important;
  }
  .h-lg-70 {
    height: 70% !important;
  }
  .h-lg-80 {
    height: 80% !important;
  }
  .h-lg-85 {
    height: 85% !important;
  }
  .h-lg-90 {
    height: 90% !important;
  }
  .h-lg-95 {
    height: 95% !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-6 {
    margin: 4.5rem !important;
  }
  .m-lg-7 {
    margin: 6rem !important;
  }
  .m-lg-8 {
    margin: 8rem !important;
  }
  .m-lg-9 {
    margin: 12rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-6 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-lg-7 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-lg-8 {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-lg-9 {
    margin-right: 12rem !important;
    margin-left: 12rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-6 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-lg-7 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-lg-8 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-lg-9 {
    margin-top: 12rem !important;
    margin-bottom: 12rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-6 {
    margin-top: 4.5rem !important;
  }
  .mt-lg-7 {
    margin-top: 6rem !important;
  }
  .mt-lg-8 {
    margin-top: 8rem !important;
  }
  .mt-lg-9 {
    margin-top: 12rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-6 {
    margin-right: 4.5rem !important;
  }
  .me-lg-7 {
    margin-right: 6rem !important;
  }
  .me-lg-8 {
    margin-right: 8rem !important;
  }
  .me-lg-9 {
    margin-right: 12rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-6 {
    margin-bottom: 4.5rem !important;
  }
  .mb-lg-7 {
    margin-bottom: 6rem !important;
  }
  .mb-lg-8 {
    margin-bottom: 8rem !important;
  }
  .mb-lg-9 {
    margin-bottom: 12rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-6 {
    margin-left: 4.5rem !important;
  }
  .ms-lg-7 {
    margin-left: 6rem !important;
  }
  .ms-lg-8 {
    margin-left: 8rem !important;
  }
  .ms-lg-9 {
    margin-left: 12rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .m-lg-n6 {
    margin: -4.5rem !important;
  }
  .m-lg-n7 {
    margin: -6rem !important;
  }
  .m-lg-n8 {
    margin: -8rem !important;
  }
  .m-lg-n9 {
    margin: -12rem !important;
  }
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-lg-n6 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-lg-n7 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-lg-n8 {
    margin-right: -8rem !important;
    margin-left: -8rem !important;
  }
  .mx-lg-n9 {
    margin-right: -12rem !important;
    margin-left: -12rem !important;
  }
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-lg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-lg-n6 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-lg-n7 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-lg-n8 {
    margin-top: -8rem !important;
    margin-bottom: -8rem !important;
  }
  .my-lg-n9 {
    margin-top: -12rem !important;
    margin-bottom: -12rem !important;
  }
  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-lg-n3 {
    margin-top: -1rem !important;
  }
  .mt-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-lg-n5 {
    margin-top: -3rem !important;
  }
  .mt-lg-n6 {
    margin-top: -4.5rem !important;
  }
  .mt-lg-n7 {
    margin-top: -6rem !important;
  }
  .mt-lg-n8 {
    margin-top: -8rem !important;
  }
  .mt-lg-n9 {
    margin-top: -12rem !important;
  }
  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .me-lg-n3 {
    margin-right: -1rem !important;
  }
  .me-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .me-lg-n5 {
    margin-right: -3rem !important;
  }
  .me-lg-n6 {
    margin-right: -4.5rem !important;
  }
  .me-lg-n7 {
    margin-right: -6rem !important;
  }
  .me-lg-n8 {
    margin-right: -8rem !important;
  }
  .me-lg-n9 {
    margin-right: -12rem !important;
  }
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-lg-n6 {
    margin-bottom: -4.5rem !important;
  }
  .mb-lg-n7 {
    margin-bottom: -6rem !important;
  }
  .mb-lg-n8 {
    margin-bottom: -8rem !important;
  }
  .mb-lg-n9 {
    margin-bottom: -12rem !important;
  }
  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-lg-n3 {
    margin-left: -1rem !important;
  }
  .ms-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-lg-n5 {
    margin-left: -3rem !important;
  }
  .ms-lg-n6 {
    margin-left: -4.5rem !important;
  }
  .ms-lg-n7 {
    margin-left: -6rem !important;
  }
  .ms-lg-n8 {
    margin-left: -8rem !important;
  }
  .ms-lg-n9 {
    margin-left: -12rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .p-lg-6 {
    padding: 4.5rem !important;
  }
  .p-lg-7 {
    padding: 6rem !important;
  }
  .p-lg-8 {
    padding: 8rem !important;
  }
  .p-lg-9 {
    padding: 12rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-lg-6 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-lg-7 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-lg-8 {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .px-lg-9 {
    padding-right: 12rem !important;
    padding-left: 12rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-lg-6 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-lg-7 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-lg-8 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .py-lg-9 {
    padding-top: 12rem !important;
    padding-bottom: 12rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pt-lg-6 {
    padding-top: 4.5rem !important;
  }
  .pt-lg-7 {
    padding-top: 6rem !important;
  }
  .pt-lg-8 {
    padding-top: 8rem !important;
  }
  .pt-lg-9 {
    padding-top: 12rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pe-lg-6 {
    padding-right: 4.5rem !important;
  }
  .pe-lg-7 {
    padding-right: 6rem !important;
  }
  .pe-lg-8 {
    padding-right: 8rem !important;
  }
  .pe-lg-9 {
    padding-right: 12rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pb-lg-6 {
    padding-bottom: 4.5rem !important;
  }
  .pb-lg-7 {
    padding-bottom: 6rem !important;
  }
  .pb-lg-8 {
    padding-bottom: 8rem !important;
  }
  .pb-lg-9 {
    padding-bottom: 12rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .ps-lg-6 {
    padding-left: 4.5rem !important;
  }
  .ps-lg-7 {
    padding-left: 6rem !important;
  }
  .ps-lg-8 {
    padding-left: 8rem !important;
  }
  .ps-lg-9 {
    padding-left: 12rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .gap-lg-6 {
    gap: 4.5rem !important;
  }
  .gap-lg-7 {
    gap: 6rem !important;
  }
  .gap-lg-8 {
    gap: 8rem !important;
  }
  .gap-lg-9 {
    gap: 12rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .row-gap-lg-6 {
    row-gap: 4.5rem !important;
  }
  .row-gap-lg-7 {
    row-gap: 6rem !important;
  }
  .row-gap-lg-8 {
    row-gap: 8rem !important;
  }
  .row-gap-lg-9 {
    row-gap: 12rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .column-gap-lg-6 {
    column-gap: 4.5rem !important;
  }
  .column-gap-lg-7 {
    column-gap: 6rem !important;
  }
  .column-gap-lg-8 {
    column-gap: 8rem !important;
  }
  .column-gap-lg-9 {
    column-gap: 12rem !important;
  }
  .fs-lg-1 {
    font-size: calc(1.4125rem + 1.95vw) !important;
  }
  .fs-lg-2 {
    font-size: calc(1.355rem + 1.26vw) !important;
  }
  .fs-lg-3 {
    font-size: calc(1.32625rem + 0.915vw) !important;
  }
  .fs-lg-4 {
    font-size: calc(1.2975rem + 0.57vw) !important;
  }
  .fs-lg-5 {
    font-size: calc(1.26875rem + 0.225vw) !important;
  }
  .fs-lg-6 {
    font-size: 1.15rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
  .text-lg-primary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
  }
  .text-lg-secondary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
  }
  .text-lg-success {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
  }
  .text-lg-info {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
  }
  .text-lg-warning {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
  }
  .text-lg-danger {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
  }
  .text-lg-light {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
  }
  .text-lg-dark {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
  }
  .text-lg-black {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
  }
  .text-lg-white {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
  }
  .text-lg-body {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
  }
  .text-lg-muted {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important;
  }
  .text-lg-black-50 {
    --bs-text-opacity: 1;
    color: rgba(0, 0, 0, 0.5) !important;
  }
  .text-lg-white-50 {
    --bs-text-opacity: 1;
    color: rgba(255, 255, 255, 0.5) !important;
  }
  .text-lg-body-secondary {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important;
  }
  .text-lg-body-tertiary {
    --bs-text-opacity: 1;
    color: var(--bs-tertiary-color) !important;
  }
  .text-lg-body-emphasis {
    --bs-text-opacity: 1;
    color: var(--bs-emphasis-color) !important;
  }
  .text-lg-reset {
    --bs-text-opacity: 1;
    color: inherit !important;
  }
}
@media (min-width: 1199px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .opacity-xl-0 {
    opacity: 0 !important;
  }
  .opacity-xl-25 {
    opacity: 0.25 !important;
  }
  .opacity-xl-50 {
    opacity: 0.5 !important;
  }
  .opacity-xl-75 {
    opacity: 0.75 !important;
  }
  .opacity-xl-100 {
    opacity: 1 !important;
  }
  .opacity-xl-5 {
    opacity: 0.5 !important;
  }
  .opacity-xl-10 {
    opacity: 0.1 !important;
  }
  .opacity-xl-15 {
    opacity: 0.15 !important;
  }
  .opacity-xl-20 {
    opacity: 0.2 !important;
  }
  .opacity-xl-30 {
    opacity: 0.3 !important;
  }
  .opacity-xl-35 {
    opacity: 0.35 !important;
  }
  .opacity-xl-40 {
    opacity: 0.4 !important;
  }
  .opacity-xl-45 {
    opacity: 0.45 !important;
  }
  .opacity-xl-60 {
    opacity: 0.6 !important;
  }
  .opacity-xl-65 {
    opacity: 0.65 !important;
  }
  .opacity-xl-70 {
    opacity: 0.7 !important;
  }
  .opacity-xl-80 {
    opacity: 0.8 !important;
  }
  .opacity-xl-85 {
    opacity: 0.85 !important;
  }
  .opacity-xl-90 {
    opacity: 0.9 !important;
  }
  .opacity-xl-95 {
    opacity: 0.95 !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .top-xl-0 {
    top: 0 !important;
  }
  .top-xl-50 {
    top: 50% !important;
  }
  .top-xl-100 {
    top: 100% !important;
  }
  .top-xl-1 {
    top: 1% !important;
  }
  .top-xl-2 {
    top: 2% !important;
  }
  .top-xl-3 {
    top: 3% !important;
  }
  .top-xl-4 {
    top: 4% !important;
  }
  .top-xl-5 {
    top: 5% !important;
  }
  .top-xl-10 {
    top: 10% !important;
  }
  .top-xl-15 {
    top: 15% !important;
  }
  .top-xl-20 {
    top: 20% !important;
  }
  .top-xl-25 {
    top: 25% !important;
  }
  .top-xl-30 {
    top: 30% !important;
  }
  .top-xl-35 {
    top: 35% !important;
  }
  .top-xl-40 {
    top: 40% !important;
  }
  .top-xl-45 {
    top: 45% !important;
  }
  .top-xl-55 {
    top: 55% !important;
  }
  .top-xl-60 {
    top: 60% !important;
  }
  .top-xl-65 {
    top: 65% !important;
  }
  .top-xl-70 {
    top: 70% !important;
  }
  .top-xl-75 {
    top: 75% !important;
  }
  .top-xl-80 {
    top: 80% !important;
  }
  .top-xl-85 {
    top: 85% !important;
  }
  .top-xl-90 {
    top: 90% !important;
  }
  .top-xl-95 {
    top: 95% !important;
  }
  .top-xl-n50 {
    top: -50% !important;
  }
  .bottom-xl-0 {
    bottom: 0 !important;
  }
  .bottom-xl-50 {
    bottom: 50% !important;
  }
  .bottom-xl-100 {
    bottom: 100% !important;
  }
  .bottom-xl-1 {
    bottom: 1% !important;
  }
  .bottom-xl-2 {
    bottom: 2% !important;
  }
  .bottom-xl-3 {
    bottom: 3% !important;
  }
  .bottom-xl-4 {
    bottom: 4% !important;
  }
  .bottom-xl-5 {
    bottom: 5% !important;
  }
  .bottom-xl-10 {
    bottom: 10% !important;
  }
  .bottom-xl-15 {
    bottom: 15% !important;
  }
  .bottom-xl-20 {
    bottom: 20% !important;
  }
  .bottom-xl-25 {
    bottom: 25% !important;
  }
  .bottom-xl-30 {
    bottom: 30% !important;
  }
  .bottom-xl-35 {
    bottom: 35% !important;
  }
  .bottom-xl-40 {
    bottom: 40% !important;
  }
  .bottom-xl-45 {
    bottom: 45% !important;
  }
  .bottom-xl-55 {
    bottom: 55% !important;
  }
  .bottom-xl-60 {
    bottom: 60% !important;
  }
  .bottom-xl-65 {
    bottom: 65% !important;
  }
  .bottom-xl-70 {
    bottom: 70% !important;
  }
  .bottom-xl-75 {
    bottom: 75% !important;
  }
  .bottom-xl-80 {
    bottom: 80% !important;
  }
  .bottom-xl-85 {
    bottom: 85% !important;
  }
  .bottom-xl-90 {
    bottom: 90% !important;
  }
  .bottom-xl-95 {
    bottom: 95% !important;
  }
  .bottom-xl-n50 {
    bottom: -50% !important;
  }
  .start-xl-0 {
    left: 0 !important;
  }
  .start-xl-50 {
    left: 50% !important;
  }
  .start-xl-100 {
    left: 100% !important;
  }
  .start-xl-1 {
    left: 1% !important;
  }
  .start-xl-2 {
    left: 2% !important;
  }
  .start-xl-3 {
    left: 3% !important;
  }
  .start-xl-4 {
    left: 4% !important;
  }
  .start-xl-5 {
    left: 5% !important;
  }
  .start-xl-10 {
    left: 10% !important;
  }
  .start-xl-15 {
    left: 15% !important;
  }
  .start-xl-20 {
    left: 20% !important;
  }
  .start-xl-25 {
    left: 25% !important;
  }
  .start-xl-30 {
    left: 30% !important;
  }
  .start-xl-35 {
    left: 35% !important;
  }
  .start-xl-40 {
    left: 40% !important;
  }
  .start-xl-45 {
    left: 45% !important;
  }
  .start-xl-55 {
    left: 55% !important;
  }
  .start-xl-60 {
    left: 60% !important;
  }
  .start-xl-65 {
    left: 65% !important;
  }
  .start-xl-70 {
    left: 70% !important;
  }
  .start-xl-75 {
    left: 75% !important;
  }
  .start-xl-80 {
    left: 80% !important;
  }
  .start-xl-85 {
    left: 85% !important;
  }
  .start-xl-90 {
    left: 90% !important;
  }
  .start-xl-95 {
    left: 95% !important;
  }
  .start-xl-n50 {
    left: -50% !important;
  }
  .end-xl-0 {
    right: 0 !important;
  }
  .end-xl-50 {
    right: 50% !important;
  }
  .end-xl-100 {
    right: 100% !important;
  }
  .end-xl-1 {
    right: 1% !important;
  }
  .end-xl-2 {
    right: 2% !important;
  }
  .end-xl-3 {
    right: 3% !important;
  }
  .end-xl-4 {
    right: 4% !important;
  }
  .end-xl-5 {
    right: 5% !important;
  }
  .end-xl-10 {
    right: 10% !important;
  }
  .end-xl-15 {
    right: 15% !important;
  }
  .end-xl-20 {
    right: 20% !important;
  }
  .end-xl-25 {
    right: 25% !important;
  }
  .end-xl-30 {
    right: 30% !important;
  }
  .end-xl-35 {
    right: 35% !important;
  }
  .end-xl-40 {
    right: 40% !important;
  }
  .end-xl-45 {
    right: 45% !important;
  }
  .end-xl-55 {
    right: 55% !important;
  }
  .end-xl-60 {
    right: 60% !important;
  }
  .end-xl-65 {
    right: 65% !important;
  }
  .end-xl-70 {
    right: 70% !important;
  }
  .end-xl-75 {
    right: 75% !important;
  }
  .end-xl-80 {
    right: 80% !important;
  }
  .end-xl-85 {
    right: 85% !important;
  }
  .end-xl-90 {
    right: 90% !important;
  }
  .end-xl-95 {
    right: 95% !important;
  }
  .end-xl-n50 {
    right: -50% !important;
  }
  .w-xl-25 {
    width: 25% !important;
  }
  .w-xl-50 {
    width: 50% !important;
  }
  .w-xl-75 {
    width: 75% !important;
  }
  .w-xl-100 {
    width: 100% !important;
  }
  .w-xl-auto {
    width: auto !important;
  }
  .w-xl-5 {
    width: 5% !important;
  }
  .w-xl-10 {
    width: 10% !important;
  }
  .w-xl-15 {
    width: 15% !important;
  }
  .w-xl-20 {
    width: 20% !important;
  }
  .w-xl-30 {
    width: 30% !important;
  }
  .w-xl-35 {
    width: 35% !important;
  }
  .w-xl-40 {
    width: 40% !important;
  }
  .w-xl-45 {
    width: 45% !important;
  }
  .w-xl-55 {
    width: 55% !important;
  }
  .w-xl-60 {
    width: 60% !important;
  }
  .w-xl-65 {
    width: 65% !important;
  }
  .w-xl-70 {
    width: 70% !important;
  }
  .w-xl-80 {
    width: 80% !important;
  }
  .w-xl-85 {
    width: 85% !important;
  }
  .w-xl-90 {
    width: 90% !important;
  }
  .w-xl-95 {
    width: 95% !important;
  }
  .h-xl-25 {
    height: 25% !important;
  }
  .h-xl-50 {
    height: 50% !important;
  }
  .h-xl-75 {
    height: 75% !important;
  }
  .h-xl-100 {
    height: 100% !important;
  }
  .h-xl-auto {
    height: auto !important;
  }
  .h-xl-5 {
    height: 5% !important;
  }
  .h-xl-10 {
    height: 10% !important;
  }
  .h-xl-15 {
    height: 15% !important;
  }
  .h-xl-20 {
    height: 20% !important;
  }
  .h-xl-30 {
    height: 30% !important;
  }
  .h-xl-35 {
    height: 35% !important;
  }
  .h-xl-40 {
    height: 40% !important;
  }
  .h-xl-45 {
    height: 45% !important;
  }
  .h-xl-55 {
    height: 55% !important;
  }
  .h-xl-60 {
    height: 60% !important;
  }
  .h-xl-65 {
    height: 65% !important;
  }
  .h-xl-70 {
    height: 70% !important;
  }
  .h-xl-80 {
    height: 80% !important;
  }
  .h-xl-85 {
    height: 85% !important;
  }
  .h-xl-90 {
    height: 90% !important;
  }
  .h-xl-95 {
    height: 95% !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-6 {
    margin: 4.5rem !important;
  }
  .m-xl-7 {
    margin: 6rem !important;
  }
  .m-xl-8 {
    margin: 8rem !important;
  }
  .m-xl-9 {
    margin: 12rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-6 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-xl-7 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-xl-8 {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-xl-9 {
    margin-right: 12rem !important;
    margin-left: 12rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-6 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-xl-7 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-xl-8 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-xl-9 {
    margin-top: 12rem !important;
    margin-bottom: 12rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-6 {
    margin-top: 4.5rem !important;
  }
  .mt-xl-7 {
    margin-top: 6rem !important;
  }
  .mt-xl-8 {
    margin-top: 8rem !important;
  }
  .mt-xl-9 {
    margin-top: 12rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-6 {
    margin-right: 4.5rem !important;
  }
  .me-xl-7 {
    margin-right: 6rem !important;
  }
  .me-xl-8 {
    margin-right: 8rem !important;
  }
  .me-xl-9 {
    margin-right: 12rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-6 {
    margin-bottom: 4.5rem !important;
  }
  .mb-xl-7 {
    margin-bottom: 6rem !important;
  }
  .mb-xl-8 {
    margin-bottom: 8rem !important;
  }
  .mb-xl-9 {
    margin-bottom: 12rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-6 {
    margin-left: 4.5rem !important;
  }
  .ms-xl-7 {
    margin-left: 6rem !important;
  }
  .ms-xl-8 {
    margin-left: 8rem !important;
  }
  .ms-xl-9 {
    margin-left: 12rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .m-xl-n6 {
    margin: -4.5rem !important;
  }
  .m-xl-n7 {
    margin: -6rem !important;
  }
  .m-xl-n8 {
    margin: -8rem !important;
  }
  .m-xl-n9 {
    margin: -12rem !important;
  }
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-xl-n6 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-xl-n7 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-xl-n8 {
    margin-right: -8rem !important;
    margin-left: -8rem !important;
  }
  .mx-xl-n9 {
    margin-right: -12rem !important;
    margin-left: -12rem !important;
  }
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-xl-n6 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-xl-n7 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-xl-n8 {
    margin-top: -8rem !important;
    margin-bottom: -8rem !important;
  }
  .my-xl-n9 {
    margin-top: -12rem !important;
    margin-bottom: -12rem !important;
  }
  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xl-n5 {
    margin-top: -3rem !important;
  }
  .mt-xl-n6 {
    margin-top: -4.5rem !important;
  }
  .mt-xl-n7 {
    margin-top: -6rem !important;
  }
  .mt-xl-n8 {
    margin-top: -8rem !important;
  }
  .mt-xl-n9 {
    margin-top: -12rem !important;
  }
  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xl-n3 {
    margin-right: -1rem !important;
  }
  .me-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xl-n5 {
    margin-right: -3rem !important;
  }
  .me-xl-n6 {
    margin-right: -4.5rem !important;
  }
  .me-xl-n7 {
    margin-right: -6rem !important;
  }
  .me-xl-n8 {
    margin-right: -8rem !important;
  }
  .me-xl-n9 {
    margin-right: -12rem !important;
  }
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-xl-n6 {
    margin-bottom: -4.5rem !important;
  }
  .mb-xl-n7 {
    margin-bottom: -6rem !important;
  }
  .mb-xl-n8 {
    margin-bottom: -8rem !important;
  }
  .mb-xl-n9 {
    margin-bottom: -12rem !important;
  }
  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xl-n5 {
    margin-left: -3rem !important;
  }
  .ms-xl-n6 {
    margin-left: -4.5rem !important;
  }
  .ms-xl-n7 {
    margin-left: -6rem !important;
  }
  .ms-xl-n8 {
    margin-left: -8rem !important;
  }
  .ms-xl-n9 {
    margin-left: -12rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .p-xl-6 {
    padding: 4.5rem !important;
  }
  .p-xl-7 {
    padding: 6rem !important;
  }
  .p-xl-8 {
    padding: 8rem !important;
  }
  .p-xl-9 {
    padding: 12rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-xl-6 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-xl-7 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-xl-8 {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .px-xl-9 {
    padding-right: 12rem !important;
    padding-left: 12rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-xl-6 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-xl-7 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-xl-8 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .py-xl-9 {
    padding-top: 12rem !important;
    padding-bottom: 12rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pt-xl-6 {
    padding-top: 4.5rem !important;
  }
  .pt-xl-7 {
    padding-top: 6rem !important;
  }
  .pt-xl-8 {
    padding-top: 8rem !important;
  }
  .pt-xl-9 {
    padding-top: 12rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pe-xl-6 {
    padding-right: 4.5rem !important;
  }
  .pe-xl-7 {
    padding-right: 6rem !important;
  }
  .pe-xl-8 {
    padding-right: 8rem !important;
  }
  .pe-xl-9 {
    padding-right: 12rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pb-xl-6 {
    padding-bottom: 4.5rem !important;
  }
  .pb-xl-7 {
    padding-bottom: 6rem !important;
  }
  .pb-xl-8 {
    padding-bottom: 8rem !important;
  }
  .pb-xl-9 {
    padding-bottom: 12rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .ps-xl-6 {
    padding-left: 4.5rem !important;
  }
  .ps-xl-7 {
    padding-left: 6rem !important;
  }
  .ps-xl-8 {
    padding-left: 8rem !important;
  }
  .ps-xl-9 {
    padding-left: 12rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .gap-xl-6 {
    gap: 4.5rem !important;
  }
  .gap-xl-7 {
    gap: 6rem !important;
  }
  .gap-xl-8 {
    gap: 8rem !important;
  }
  .gap-xl-9 {
    gap: 12rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .row-gap-xl-6 {
    row-gap: 4.5rem !important;
  }
  .row-gap-xl-7 {
    row-gap: 6rem !important;
  }
  .row-gap-xl-8 {
    row-gap: 8rem !important;
  }
  .row-gap-xl-9 {
    row-gap: 12rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .column-gap-xl-6 {
    column-gap: 4.5rem !important;
  }
  .column-gap-xl-7 {
    column-gap: 6rem !important;
  }
  .column-gap-xl-8 {
    column-gap: 8rem !important;
  }
  .column-gap-xl-9 {
    column-gap: 12rem !important;
  }
  .fs-xl-1 {
    font-size: calc(1.4125rem + 1.95vw) !important;
  }
  .fs-xl-2 {
    font-size: calc(1.355rem + 1.26vw) !important;
  }
  .fs-xl-3 {
    font-size: calc(1.32625rem + 0.915vw) !important;
  }
  .fs-xl-4 {
    font-size: calc(1.2975rem + 0.57vw) !important;
  }
  .fs-xl-5 {
    font-size: calc(1.26875rem + 0.225vw) !important;
  }
  .fs-xl-6 {
    font-size: 1.15rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
  .text-xl-primary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xl-secondary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xl-success {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xl-info {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xl-warning {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xl-danger {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xl-light {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xl-dark {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xl-black {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xl-white {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xl-body {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xl-muted {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important;
  }
  .text-xl-black-50 {
    --bs-text-opacity: 1;
    color: rgba(0, 0, 0, 0.5) !important;
  }
  .text-xl-white-50 {
    --bs-text-opacity: 1;
    color: rgba(255, 255, 255, 0.5) !important;
  }
  .text-xl-body-secondary {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important;
  }
  .text-xl-body-tertiary {
    --bs-text-opacity: 1;
    color: var(--bs-tertiary-color) !important;
  }
  .text-xl-body-emphasis {
    --bs-text-opacity: 1;
    color: var(--bs-emphasis-color) !important;
  }
  .text-xl-reset {
    --bs-text-opacity: 1;
    color: inherit !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .opacity-xxl-0 {
    opacity: 0 !important;
  }
  .opacity-xxl-25 {
    opacity: 0.25 !important;
  }
  .opacity-xxl-50 {
    opacity: 0.5 !important;
  }
  .opacity-xxl-75 {
    opacity: 0.75 !important;
  }
  .opacity-xxl-100 {
    opacity: 1 !important;
  }
  .opacity-xxl-5 {
    opacity: 0.5 !important;
  }
  .opacity-xxl-10 {
    opacity: 0.1 !important;
  }
  .opacity-xxl-15 {
    opacity: 0.15 !important;
  }
  .opacity-xxl-20 {
    opacity: 0.2 !important;
  }
  .opacity-xxl-30 {
    opacity: 0.3 !important;
  }
  .opacity-xxl-35 {
    opacity: 0.35 !important;
  }
  .opacity-xxl-40 {
    opacity: 0.4 !important;
  }
  .opacity-xxl-45 {
    opacity: 0.45 !important;
  }
  .opacity-xxl-60 {
    opacity: 0.6 !important;
  }
  .opacity-xxl-65 {
    opacity: 0.65 !important;
  }
  .opacity-xxl-70 {
    opacity: 0.7 !important;
  }
  .opacity-xxl-80 {
    opacity: 0.8 !important;
  }
  .opacity-xxl-85 {
    opacity: 0.85 !important;
  }
  .opacity-xxl-90 {
    opacity: 0.9 !important;
  }
  .opacity-xxl-95 {
    opacity: 0.95 !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .top-xxl-0 {
    top: 0 !important;
  }
  .top-xxl-50 {
    top: 50% !important;
  }
  .top-xxl-100 {
    top: 100% !important;
  }
  .top-xxl-1 {
    top: 1% !important;
  }
  .top-xxl-2 {
    top: 2% !important;
  }
  .top-xxl-3 {
    top: 3% !important;
  }
  .top-xxl-4 {
    top: 4% !important;
  }
  .top-xxl-5 {
    top: 5% !important;
  }
  .top-xxl-10 {
    top: 10% !important;
  }
  .top-xxl-15 {
    top: 15% !important;
  }
  .top-xxl-20 {
    top: 20% !important;
  }
  .top-xxl-25 {
    top: 25% !important;
  }
  .top-xxl-30 {
    top: 30% !important;
  }
  .top-xxl-35 {
    top: 35% !important;
  }
  .top-xxl-40 {
    top: 40% !important;
  }
  .top-xxl-45 {
    top: 45% !important;
  }
  .top-xxl-55 {
    top: 55% !important;
  }
  .top-xxl-60 {
    top: 60% !important;
  }
  .top-xxl-65 {
    top: 65% !important;
  }
  .top-xxl-70 {
    top: 70% !important;
  }
  .top-xxl-75 {
    top: 75% !important;
  }
  .top-xxl-80 {
    top: 80% !important;
  }
  .top-xxl-85 {
    top: 85% !important;
  }
  .top-xxl-90 {
    top: 90% !important;
  }
  .top-xxl-95 {
    top: 95% !important;
  }
  .top-xxl-n50 {
    top: -50% !important;
  }
  .bottom-xxl-0 {
    bottom: 0 !important;
  }
  .bottom-xxl-50 {
    bottom: 50% !important;
  }
  .bottom-xxl-100 {
    bottom: 100% !important;
  }
  .bottom-xxl-1 {
    bottom: 1% !important;
  }
  .bottom-xxl-2 {
    bottom: 2% !important;
  }
  .bottom-xxl-3 {
    bottom: 3% !important;
  }
  .bottom-xxl-4 {
    bottom: 4% !important;
  }
  .bottom-xxl-5 {
    bottom: 5% !important;
  }
  .bottom-xxl-10 {
    bottom: 10% !important;
  }
  .bottom-xxl-15 {
    bottom: 15% !important;
  }
  .bottom-xxl-20 {
    bottom: 20% !important;
  }
  .bottom-xxl-25 {
    bottom: 25% !important;
  }
  .bottom-xxl-30 {
    bottom: 30% !important;
  }
  .bottom-xxl-35 {
    bottom: 35% !important;
  }
  .bottom-xxl-40 {
    bottom: 40% !important;
  }
  .bottom-xxl-45 {
    bottom: 45% !important;
  }
  .bottom-xxl-55 {
    bottom: 55% !important;
  }
  .bottom-xxl-60 {
    bottom: 60% !important;
  }
  .bottom-xxl-65 {
    bottom: 65% !important;
  }
  .bottom-xxl-70 {
    bottom: 70% !important;
  }
  .bottom-xxl-75 {
    bottom: 75% !important;
  }
  .bottom-xxl-80 {
    bottom: 80% !important;
  }
  .bottom-xxl-85 {
    bottom: 85% !important;
  }
  .bottom-xxl-90 {
    bottom: 90% !important;
  }
  .bottom-xxl-95 {
    bottom: 95% !important;
  }
  .bottom-xxl-n50 {
    bottom: -50% !important;
  }
  .start-xxl-0 {
    left: 0 !important;
  }
  .start-xxl-50 {
    left: 50% !important;
  }
  .start-xxl-100 {
    left: 100% !important;
  }
  .start-xxl-1 {
    left: 1% !important;
  }
  .start-xxl-2 {
    left: 2% !important;
  }
  .start-xxl-3 {
    left: 3% !important;
  }
  .start-xxl-4 {
    left: 4% !important;
  }
  .start-xxl-5 {
    left: 5% !important;
  }
  .start-xxl-10 {
    left: 10% !important;
  }
  .start-xxl-15 {
    left: 15% !important;
  }
  .start-xxl-20 {
    left: 20% !important;
  }
  .start-xxl-25 {
    left: 25% !important;
  }
  .start-xxl-30 {
    left: 30% !important;
  }
  .start-xxl-35 {
    left: 35% !important;
  }
  .start-xxl-40 {
    left: 40% !important;
  }
  .start-xxl-45 {
    left: 45% !important;
  }
  .start-xxl-55 {
    left: 55% !important;
  }
  .start-xxl-60 {
    left: 60% !important;
  }
  .start-xxl-65 {
    left: 65% !important;
  }
  .start-xxl-70 {
    left: 70% !important;
  }
  .start-xxl-75 {
    left: 75% !important;
  }
  .start-xxl-80 {
    left: 80% !important;
  }
  .start-xxl-85 {
    left: 85% !important;
  }
  .start-xxl-90 {
    left: 90% !important;
  }
  .start-xxl-95 {
    left: 95% !important;
  }
  .start-xxl-n50 {
    left: -50% !important;
  }
  .end-xxl-0 {
    right: 0 !important;
  }
  .end-xxl-50 {
    right: 50% !important;
  }
  .end-xxl-100 {
    right: 100% !important;
  }
  .end-xxl-1 {
    right: 1% !important;
  }
  .end-xxl-2 {
    right: 2% !important;
  }
  .end-xxl-3 {
    right: 3% !important;
  }
  .end-xxl-4 {
    right: 4% !important;
  }
  .end-xxl-5 {
    right: 5% !important;
  }
  .end-xxl-10 {
    right: 10% !important;
  }
  .end-xxl-15 {
    right: 15% !important;
  }
  .end-xxl-20 {
    right: 20% !important;
  }
  .end-xxl-25 {
    right: 25% !important;
  }
  .end-xxl-30 {
    right: 30% !important;
  }
  .end-xxl-35 {
    right: 35% !important;
  }
  .end-xxl-40 {
    right: 40% !important;
  }
  .end-xxl-45 {
    right: 45% !important;
  }
  .end-xxl-55 {
    right: 55% !important;
  }
  .end-xxl-60 {
    right: 60% !important;
  }
  .end-xxl-65 {
    right: 65% !important;
  }
  .end-xxl-70 {
    right: 70% !important;
  }
  .end-xxl-75 {
    right: 75% !important;
  }
  .end-xxl-80 {
    right: 80% !important;
  }
  .end-xxl-85 {
    right: 85% !important;
  }
  .end-xxl-90 {
    right: 90% !important;
  }
  .end-xxl-95 {
    right: 95% !important;
  }
  .end-xxl-n50 {
    right: -50% !important;
  }
  .w-xxl-25 {
    width: 25% !important;
  }
  .w-xxl-50 {
    width: 50% !important;
  }
  .w-xxl-75 {
    width: 75% !important;
  }
  .w-xxl-100 {
    width: 100% !important;
  }
  .w-xxl-auto {
    width: auto !important;
  }
  .w-xxl-5 {
    width: 5% !important;
  }
  .w-xxl-10 {
    width: 10% !important;
  }
  .w-xxl-15 {
    width: 15% !important;
  }
  .w-xxl-20 {
    width: 20% !important;
  }
  .w-xxl-30 {
    width: 30% !important;
  }
  .w-xxl-35 {
    width: 35% !important;
  }
  .w-xxl-40 {
    width: 40% !important;
  }
  .w-xxl-45 {
    width: 45% !important;
  }
  .w-xxl-55 {
    width: 55% !important;
  }
  .w-xxl-60 {
    width: 60% !important;
  }
  .w-xxl-65 {
    width: 65% !important;
  }
  .w-xxl-70 {
    width: 70% !important;
  }
  .w-xxl-80 {
    width: 80% !important;
  }
  .w-xxl-85 {
    width: 85% !important;
  }
  .w-xxl-90 {
    width: 90% !important;
  }
  .w-xxl-95 {
    width: 95% !important;
  }
  .h-xxl-25 {
    height: 25% !important;
  }
  .h-xxl-50 {
    height: 50% !important;
  }
  .h-xxl-75 {
    height: 75% !important;
  }
  .h-xxl-100 {
    height: 100% !important;
  }
  .h-xxl-auto {
    height: auto !important;
  }
  .h-xxl-5 {
    height: 5% !important;
  }
  .h-xxl-10 {
    height: 10% !important;
  }
  .h-xxl-15 {
    height: 15% !important;
  }
  .h-xxl-20 {
    height: 20% !important;
  }
  .h-xxl-30 {
    height: 30% !important;
  }
  .h-xxl-35 {
    height: 35% !important;
  }
  .h-xxl-40 {
    height: 40% !important;
  }
  .h-xxl-45 {
    height: 45% !important;
  }
  .h-xxl-55 {
    height: 55% !important;
  }
  .h-xxl-60 {
    height: 60% !important;
  }
  .h-xxl-65 {
    height: 65% !important;
  }
  .h-xxl-70 {
    height: 70% !important;
  }
  .h-xxl-80 {
    height: 80% !important;
  }
  .h-xxl-85 {
    height: 85% !important;
  }
  .h-xxl-90 {
    height: 90% !important;
  }
  .h-xxl-95 {
    height: 95% !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-6 {
    margin: 4.5rem !important;
  }
  .m-xxl-7 {
    margin: 6rem !important;
  }
  .m-xxl-8 {
    margin: 8rem !important;
  }
  .m-xxl-9 {
    margin: 12rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-6 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-xxl-7 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-xxl-8 {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-xxl-9 {
    margin-right: 12rem !important;
    margin-left: 12rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-6 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-xxl-7 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-xxl-8 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-xxl-9 {
    margin-top: 12rem !important;
    margin-bottom: 12rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-6 {
    margin-top: 4.5rem !important;
  }
  .mt-xxl-7 {
    margin-top: 6rem !important;
  }
  .mt-xxl-8 {
    margin-top: 8rem !important;
  }
  .mt-xxl-9 {
    margin-top: 12rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-6 {
    margin-right: 4.5rem !important;
  }
  .me-xxl-7 {
    margin-right: 6rem !important;
  }
  .me-xxl-8 {
    margin-right: 8rem !important;
  }
  .me-xxl-9 {
    margin-right: 12rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-6 {
    margin-bottom: 4.5rem !important;
  }
  .mb-xxl-7 {
    margin-bottom: 6rem !important;
  }
  .mb-xxl-8 {
    margin-bottom: 8rem !important;
  }
  .mb-xxl-9 {
    margin-bottom: 12rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-6 {
    margin-left: 4.5rem !important;
  }
  .ms-xxl-7 {
    margin-left: 6rem !important;
  }
  .ms-xxl-8 {
    margin-left: 8rem !important;
  }
  .ms-xxl-9 {
    margin-left: 12rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .m-xxl-n1 {
    margin: -0.25rem !important;
  }
  .m-xxl-n2 {
    margin: -0.5rem !important;
  }
  .m-xxl-n3 {
    margin: -1rem !important;
  }
  .m-xxl-n4 {
    margin: -1.5rem !important;
  }
  .m-xxl-n5 {
    margin: -3rem !important;
  }
  .m-xxl-n6 {
    margin: -4.5rem !important;
  }
  .m-xxl-n7 {
    margin: -6rem !important;
  }
  .m-xxl-n8 {
    margin: -8rem !important;
  }
  .m-xxl-n9 {
    margin: -12rem !important;
  }
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-xxl-n6 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-xxl-n7 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-xxl-n8 {
    margin-right: -8rem !important;
    margin-left: -8rem !important;
  }
  .mx-xxl-n9 {
    margin-right: -12rem !important;
    margin-left: -12rem !important;
  }
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-xxl-n6 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-xxl-n7 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-xxl-n8 {
    margin-top: -8rem !important;
    margin-bottom: -8rem !important;
  }
  .my-xxl-n9 {
    margin-top: -12rem !important;
    margin-bottom: -12rem !important;
  }
  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xxl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xxl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xxl-n5 {
    margin-top: -3rem !important;
  }
  .mt-xxl-n6 {
    margin-top: -4.5rem !important;
  }
  .mt-xxl-n7 {
    margin-top: -6rem !important;
  }
  .mt-xxl-n8 {
    margin-top: -8rem !important;
  }
  .mt-xxl-n9 {
    margin-top: -12rem !important;
  }
  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xxl-n3 {
    margin-right: -1rem !important;
  }
  .me-xxl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xxl-n5 {
    margin-right: -3rem !important;
  }
  .me-xxl-n6 {
    margin-right: -4.5rem !important;
  }
  .me-xxl-n7 {
    margin-right: -6rem !important;
  }
  .me-xxl-n8 {
    margin-right: -8rem !important;
  }
  .me-xxl-n9 {
    margin-right: -12rem !important;
  }
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xxl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xxl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxl-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-xxl-n6 {
    margin-bottom: -4.5rem !important;
  }
  .mb-xxl-n7 {
    margin-bottom: -6rem !important;
  }
  .mb-xxl-n8 {
    margin-bottom: -8rem !important;
  }
  .mb-xxl-n9 {
    margin-bottom: -12rem !important;
  }
  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xxl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xxl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xxl-n5 {
    margin-left: -3rem !important;
  }
  .ms-xxl-n6 {
    margin-left: -4.5rem !important;
  }
  .ms-xxl-n7 {
    margin-left: -6rem !important;
  }
  .ms-xxl-n8 {
    margin-left: -8rem !important;
  }
  .ms-xxl-n9 {
    margin-left: -12rem !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .p-xxl-6 {
    padding: 4.5rem !important;
  }
  .p-xxl-7 {
    padding: 6rem !important;
  }
  .p-xxl-8 {
    padding: 8rem !important;
  }
  .p-xxl-9 {
    padding: 12rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-xxl-6 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-xxl-7 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-xxl-8 {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .px-xxl-9 {
    padding-right: 12rem !important;
    padding-left: 12rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-xxl-6 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-xxl-7 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-xxl-8 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .py-xxl-9 {
    padding-top: 12rem !important;
    padding-bottom: 12rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pt-xxl-6 {
    padding-top: 4.5rem !important;
  }
  .pt-xxl-7 {
    padding-top: 6rem !important;
  }
  .pt-xxl-8 {
    padding-top: 8rem !important;
  }
  .pt-xxl-9 {
    padding-top: 12rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pe-xxl-6 {
    padding-right: 4.5rem !important;
  }
  .pe-xxl-7 {
    padding-right: 6rem !important;
  }
  .pe-xxl-8 {
    padding-right: 8rem !important;
  }
  .pe-xxl-9 {
    padding-right: 12rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .pb-xxl-6 {
    padding-bottom: 4.5rem !important;
  }
  .pb-xxl-7 {
    padding-bottom: 6rem !important;
  }
  .pb-xxl-8 {
    padding-bottom: 8rem !important;
  }
  .pb-xxl-9 {
    padding-bottom: 12rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .ps-xxl-6 {
    padding-left: 4.5rem !important;
  }
  .ps-xxl-7 {
    padding-left: 6rem !important;
  }
  .ps-xxl-8 {
    padding-left: 8rem !important;
  }
  .ps-xxl-9 {
    padding-left: 12rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .gap-xxl-6 {
    gap: 4.5rem !important;
  }
  .gap-xxl-7 {
    gap: 6rem !important;
  }
  .gap-xxl-8 {
    gap: 8rem !important;
  }
  .gap-xxl-9 {
    gap: 12rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .row-gap-xxl-6 {
    row-gap: 4.5rem !important;
  }
  .row-gap-xxl-7 {
    row-gap: 6rem !important;
  }
  .row-gap-xxl-8 {
    row-gap: 8rem !important;
  }
  .row-gap-xxl-9 {
    row-gap: 12rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .column-gap-xxl-6 {
    column-gap: 4.5rem !important;
  }
  .column-gap-xxl-7 {
    column-gap: 6rem !important;
  }
  .column-gap-xxl-8 {
    column-gap: 8rem !important;
  }
  .column-gap-xxl-9 {
    column-gap: 12rem !important;
  }
  .fs-xxl-1 {
    font-size: calc(1.4125rem + 1.95vw) !important;
  }
  .fs-xxl-2 {
    font-size: calc(1.355rem + 1.26vw) !important;
  }
  .fs-xxl-3 {
    font-size: calc(1.32625rem + 0.915vw) !important;
  }
  .fs-xxl-4 {
    font-size: calc(1.2975rem + 0.57vw) !important;
  }
  .fs-xxl-5 {
    font-size: calc(1.26875rem + 0.225vw) !important;
  }
  .fs-xxl-6 {
    font-size: 1.15rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
  .text-xxl-primary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxl-secondary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxl-success {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxl-info {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxl-warning {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxl-danger {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxl-light {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxl-dark {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxl-black {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxl-white {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxl-body {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
  }
  .text-xxl-muted {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important;
  }
  .text-xxl-black-50 {
    --bs-text-opacity: 1;
    color: rgba(0, 0, 0, 0.5) !important;
  }
  .text-xxl-white-50 {
    --bs-text-opacity: 1;
    color: rgba(255, 255, 255, 0.5) !important;
  }
  .text-xxl-body-secondary {
    --bs-text-opacity: 1;
    color: var(--bs-secondary-color) !important;
  }
  .text-xxl-body-tertiary {
    --bs-text-opacity: 1;
    color: var(--bs-tertiary-color) !important;
  }
  .text-xxl-body-emphasis {
    --bs-text-opacity: 1;
    color: var(--bs-emphasis-color) !important;
  }
  .text-xxl-reset {
    --bs-text-opacity: 1;
    color: inherit !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.875rem !important;
  }
  .fs-2 {
    font-size: 2.3rem !important;
  }
  .fs-3 {
    font-size: 2.0125rem !important;
  }
  .fs-4 {
    font-size: 1.725rem !important;
  }
  .fs-5 {
    font-size: 1.4375rem !important;
  }
  .fs-xxs-1 {
    font-size: 2.875rem !important;
  }
  .fs-xxs-2 {
    font-size: 2.3rem !important;
  }
  .fs-xxs-3 {
    font-size: 2.0125rem !important;
  }
  .fs-xxs-4 {
    font-size: 1.725rem !important;
  }
  .fs-xxs-5 {
    font-size: 1.4375rem !important;
  }
  .fs-sm-1 {
    font-size: 2.875rem !important;
  }
  .fs-sm-2 {
    font-size: 2.3rem !important;
  }
  .fs-sm-3 {
    font-size: 2.0125rem !important;
  }
  .fs-sm-4 {
    font-size: 1.725rem !important;
  }
  .fs-sm-5 {
    font-size: 1.4375rem !important;
  }
  .fs-mmd-1 {
    font-size: 2.875rem !important;
  }
  .fs-mmd-2 {
    font-size: 2.3rem !important;
  }
  .fs-mmd-3 {
    font-size: 2.0125rem !important;
  }
  .fs-mmd-4 {
    font-size: 1.725rem !important;
  }
  .fs-mmd-5 {
    font-size: 1.4375rem !important;
  }
  .fs-md-1 {
    font-size: 2.875rem !important;
  }
  .fs-md-2 {
    font-size: 2.3rem !important;
  }
  .fs-md-3 {
    font-size: 2.0125rem !important;
  }
  .fs-md-4 {
    font-size: 1.725rem !important;
  }
  .fs-md-5 {
    font-size: 1.4375rem !important;
  }
  .fs-mlg-1 {
    font-size: 2.875rem !important;
  }
  .fs-mlg-2 {
    font-size: 2.3rem !important;
  }
  .fs-mlg-3 {
    font-size: 2.0125rem !important;
  }
  .fs-mlg-4 {
    font-size: 1.725rem !important;
  }
  .fs-mlg-5 {
    font-size: 1.4375rem !important;
  }
  .fs-lg-1 {
    font-size: 2.875rem !important;
  }
  .fs-lg-2 {
    font-size: 2.3rem !important;
  }
  .fs-lg-3 {
    font-size: 2.0125rem !important;
  }
  .fs-lg-4 {
    font-size: 1.725rem !important;
  }
  .fs-lg-5 {
    font-size: 1.4375rem !important;
  }
  .fs-xl-1 {
    font-size: 2.875rem !important;
  }
  .fs-xl-2 {
    font-size: 2.3rem !important;
  }
  .fs-xl-3 {
    font-size: 2.0125rem !important;
  }
  .fs-xl-4 {
    font-size: 1.725rem !important;
  }
  .fs-xl-5 {
    font-size: 1.4375rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/bootstrap.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACShB;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;ADZF;;ACmBA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;ADjBF;ACoBE;EC5CI,mCD6CF;EACA,8BEk8CgC;AHp9CpC;AExBM;EDwCJ;ICvCM,gBAAA;EF2BN;AACF;ACeE;EACE,eEg8CgC;AH78CpC;ACiBE;EACE,sBE67CgC;AH58CpC;;ACmBA;EACE,+CAAA;ADhBF;ACkBE;EACE,gBAAA;EACA,gBAAA;ADhBJ;ACmBE;EACE,gBAAA;ADjBJ;;ACqBA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;ADlBF;;ACsBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EGrFE,4CAAA;EHyFF,UAAA;ADtBF;;AC0BA;EAEE,0BAAA;EACA,yBAAA;EACA,0BAAA;EIlHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCJkH0B;EIjH1B,YAAA;EACA,aAAA;EACA,uCJ+G4D;ADpB9D;AKxFE;EAAS,UAAA;AL2FX;AK1FE;EAAS,mCJ2GiF;ADd5F;;ACmBA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;EGrGE,2DAAA;EACA,4DAAA;AJsFJ;ACiBE;EACE,kGAAA;EACA,sJAAA;ADfJ;;ACoBA;EACE,gBAAA;EACA,8CAAA;ADjBF;;ACsBA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;ADrBF;;ACyBA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;EGzHE,+DAAA;EACA,8DAAA;AJoGJ;AC0BE;EACE,8CAAA;ADxBJ;;AMnFI;ELiHF;IACE,0BAAA;IACA,2CAAA;ED1BF;EC8BA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;ED5BF;EC+BA;IACE,uBAAA;ED7BF;AACF;AMlGI;ELmIF;;IAEE,uBAAA;ED9BF;AACF;AMxGI;EL0IF;IACE,wBAAA;ED/BF;AACF;ACwCI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;ADtCN;ACwCM;EACE,YAAA;EACA,SAAA;EGzMJ,gBAAA;AJoKJ;ACyCM;;EG7MF,gBAAA;AJwKJ;AC0CM;EACE,gBAAA;ADxCR;;AMlHI;ELwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EDlBJ;ECoBI;IACE,YAAA;IACA,SAAA;IGzMJ,gBAAA;EJwLF;ECqBI;;IG7MF,gBAAA;EJ4LF;ECsBI;IACE,gBAAA;EDpBN;AACF;AMvII;ELwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EDEJ;ECAI;IACE,YAAA;IACA,SAAA;IGzMJ,gBAAA;EJ4MF;ECCI;;IG7MF,gBAAA;EJgNF;ECEI;IACE,gBAAA;EDAN;AACF;AM3JI;ELwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EDsBJ;ECpBI;IACE,YAAA;IACA,SAAA;IGzMJ,gBAAA;EJgOF;ECnBI;;IG7MF,gBAAA;EJoOF;EClBI;IACE,gBAAA;EDoBN;AACF;AM/KI;ELwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ED0CJ;ECxCI;IACE,YAAA;IACA,SAAA;IGzMJ,gBAAA;EJoPF;ECvCI;;IG7MF,gBAAA;EJwPF;ECtCI;IACE,gBAAA;EDwCN;AACF;AMnMI;ELwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ED8DJ;EC5DI;IACE,YAAA;IACA,SAAA;IGzMJ,gBAAA;EJwQF;EC3DI;;IG7MF,gBAAA;EJ4QF;EC1DI;IACE,gBAAA;ED4DN;AACF;AOlSE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,eAAA;EAIA,8BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,sBAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,2CAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,4BALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,qBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,8BAAA;EACA,uCAAA;EAMA,wBAAA;EACA,0BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,iDAAA;EACA,2DAAA;EACA,kDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;ARiSF;;AUjZI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,gCAAA;EAGE,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,wCAAA;EAEA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;ARiSJ;;AWzcA;;;EAGE,sBAAA;AX4cF;;AW7bI;EANJ;IAOM,uBAAA;EXicJ;AACF;;AWpbA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AXubF;;AW9aA;EACE,cAAA;EACA,cXlEQ;EWmER,SAAA;EACA,qBAAA;EACA,UX3CW;AA4db;;AWvaA;EACE,aAAA;EACA,mBXiBuB;EWdvB,iBX/DqB;EWgErB,gBRwjB4B;EQvjB5B,8BAAA;AXwaF;;AWraA;EFuMQ,mCAAA;ATkOR;AS9XI;EE3CJ;IF8MQ,mBAAA;ET+NN;AACF;;AWzaA;EFkMQ,kCAAA;AT2OR;ASvYI;EEtCJ;IFyMQ,iBAAA;ETwON;AACF;;AW7aA;EF6LQ,qCAAA;AToPR;AShZI;EEjCJ;IFoMQ,oBAAA;ETiPN;AACF;;AWjbA;EFwLQ,mCAAA;AT6PR;ASzZI;EE5BJ;IF+LQ,mBAAA;ET0PN;AACF;;AWrbA;EFmLQ,qCAAA;ATsQR;ASlaI;EEvBJ;IF0LQ,oBAAA;ETmQN;AACF;;AWzbA;EF0KM,kBALI;ATwRV;;AWlbA;EACE,aAAA;EACA,mBRwV0B;AH6F5B;;AW3aA;EACE,iCAAA;EACA,YAAA;EACA,8BAAA;AX8aF;;AWxaA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AX2aF;;AWraA;;EAEE,kBAAA;AXwaF;;AWraA;;;EAGE,aAAA;EACA,mBAAA;AXwaF;;AWraA;;;;EAIE,gBAAA;AXwaF;;AWraA;EACE,gBR6b4B;AHrB9B;;AWnaA;EACE,qBAAA;EACA,cAAA;AXsaF;;AWhaA;EACE,gBAAA;AXmaF;;AW3ZA;;EAEE,mBRsa4B;AHR9B;;AWtZA;EF6EM,kBALI;ATkVV;;AWnZA;EACE,iBRqf4B;EQpf5B,gCAAA;EACA,wCAAA;AXsZF;;AW7YA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;AXgZF;;AW7YA;EAAM,eAAA;AXiZN;;AWhZA;EAAM,WAAA;AXoZN;;AW/YA;EACE,gEAAA;EACA,0BRgNwC;AHkM1C;AWhZE;EACE,mDAAA;AXkZJ;;AWvYE;EAEE,cAAA;EACA,qBAAA;AXyYJ;;AWlYA;;;;EAIE,qCRgV4B;EMlUxB,cALI;AT6XV;;AW9XA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;ATqYV;AW7XE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;AX+XJ;;AW3XA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;AX8XF;AW3XE;EACE,cAAA;AX6XJ;;AWzXA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBRy5CkC;EQx5ClC,sCRy5CkC;EC9rDhC,sBAAA;AJkqBJ;AW1XE;EACE,UAAA;EF7BE,cALI;AT+ZV;;AWlXA;EACE,gBAAA;AXqXF;;AW/WA;;EAEE,sBAAA;AXkXF;;AW1WA;EACE,oBAAA;EACA,yBAAA;AX6WF;;AW1WA;EACE,mBR4X4B;EQ3X5B,sBR2X4B;EQ1X5B,gCR4Z4B;EQ3Z5B,gBAAA;AX6WF;;AWtWA;EAEE,mBAAA;EACA,gCAAA;AXwWF;;AWrWA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AXwWF;;AWhWA;EACE,qBAAA;AXmWF;;AW7VA;EAEE,gBAAA;AX+VF;;AWvVA;EACE,UAAA;AX0VF;;AWrVA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;AXwVF;;AWpVA;;EAEE,oBAAA;AXuVF;;AWlVA;EACE,eAAA;AXqVF;;AWlVA;EAGE,iBAAA;AXmVF;AWhVE;EACE,UAAA;AXkVJ;;AW3UA;EACE,wBAAA;AX8UF;;AWtUA;;;;EAIE,0BAAA;AXyUF;AWtUI;;;;EACE,eAAA;AX2UN;;AWpUA;EACE,UAAA;EACA,kBAAA;AXuUF;;AWlUA;EACE,gBAAA;AXqUF;;AW3TA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AX8TF;;AWtTA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBRmN4B;EMpatB,iCAAA;EEoNN,oBAAA;AXwTF;ASxqBI;EEyWJ;IFtMQ,iBAAA;ETygBN;AACF;AW3TE;EACE,WAAA;AX6TJ;;AWtTA;;;;;;;EAOE,UAAA;AXyTF;;AWtTA;EACE,YAAA;AXyTF;;AWhTA;EACE,6BAAA;EACA,oBAAA;AXmTF;;AW3SA;;;;;;;CAAA;AAWA;EACE,wBAAA;AX2SF;;AWtSA;EACE,UAAA;AXySF;;AWlSA;EACE,aAAA;EACA,0BAAA;AXqSF;;AWhSA;EACE,qBAAA;AXmSF;;AW9RA;EACE,SAAA;AXiSF;;AW1RA;EACE,kBAAA;EACA,eAAA;AX6RF;;AWrRA;EACE,wBAAA;AXwRF;;AWhRA;EACE,wBAAA;AXmRF;;AYx1BA;EHuQQ,qCAAA;EGrQN,gBTwoB4B;AHmN9B;ASlvBI;EG3GJ;IH8QQ,oBAAA;ETmlBN;AACF;;AY31BE;EHgQM,iCAAA;EG5PJ,gBTynBkB;ESxnBlB,gBTwmB0B;AHoP9B;AS7vBI;EGpGF;IHuQM,eAAA;ET8lBN;AACF;;AYt2BE;EHgQM,iCAAA;EG5PJ,gBTynBkB;ESxnBlB,gBTwmB0B;AH+P9B;ASxwBI;EGpGF;IHuQM,iBAAA;ETymBN;AACF;;AYj3BE;EHgQM,iCAAA;EG5PJ,gBTynBkB;ESxnBlB,gBTwmB0B;AH0Q9B;ASnxBI;EGpGF;IHuQM,eAAA;ETonBN;AACF;;AY53BE;EHgQM,iCAAA;EG5PJ,gBTynBkB;ESxnBlB,gBTwmB0B;AHqR9B;AS9xBI;EGpGF;IHuQM,iBAAA;ET+nBN;AACF;;AYv4BE;EHgQM,iCAAA;EG5PJ,gBTynBkB;ESxnBlB,gBTwmB0B;AHgS9B;ASzyBI;EGpGF;IHuQM,eAAA;ET0oBN;AACF;;AYl5BE;EHgQM,iCAAA;EG5PJ,gBTynBkB;ESxnBlB,gBTwmB0B;AH2S9B;ASpzBI;EGpGF;IHuQM,iBAAA;ETqpBN;AACF;;AYr4BA;ECvDE,eAAA;EACA,gBAAA;Abg8BF;;AYr4BA;EC5DE,eAAA;EACA,gBAAA;Abq8BF;;AYv4BA;EACE,qBAAA;AZ04BF;AYx4BE;EACE,oBTsoB0B;AHoQ9B;;AYh4BA;EH8MM,kBALI;EGvMR,yBAAA;AZm4BF;;AY/3BA;EACE,mBZDO;ES4MD,qCAAA;ATwrBR;ASp1BI;EGhDJ;IHmNQ,oBAAA;ETqrBN;AACF;AYr4BE;EACE,gBAAA;AZu4BJ;;AYn4BA;EACE,iBAAA;EACA,mBZXO;ESwMH,kBALI;EGtLR,cTtFS;AH49BX;AYp4BE;EACE,aAAA;AZs4BJ;;Act+BA;ECIE,eAAA;EAGA,YAAA;Afo+BF;;Acr+BA;EACE,gBX+jDkC;EW9jDlC,mCX+jDkC;EW9jDlC,2DAAA;EVGE,sCAAA;EWRF,eAAA;EAGA,YAAA;Af6+BF;;Ac/9BA;EAEE,qBAAA;Adi+BF;;Ac99BA;EACE,qBAAA;EACA,cAAA;Adi+BF;;Ac99BA;ELyPM,kBALI;EKlPR,gCXkjDkC;AHjlBpC;;AgBngCE;;;;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AjBmhCF;;AM79BI;EU5CE;IACE,gBhB2He;EAk5BrB;AACF;AMn+BI;EU5CE;IACE,gBhB2He;EAu5BrB;AACF;AMx+BI;EU5CE;IACE,gBhB2He;EA45BrB;AACF;AM7+BI;EU5CE;IACE,gBhB2He;EAi6BrB;AACF;AMl/BI;EU5CE;IACE,gBhB2He;EAs6BrB;AACF;AMv/BI;EU5CE;IACE,gBhB2He;EA26BrB;AACF;AM5/BI;EU5CE;IACE,iBhB2He;EAg7BrB;AACF;AMjgCI;EU5CE;IACE,iBhB2He;EAq7BrB;AACF;AkBjkCA;EAEI,qBAAA;EAAA,0BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AlB0kCJ;;AkBrkCE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AnB8kCF;AkB5kCI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AnBwkCF;;AmBzhCM;EACE,YAAA;AnB4hCR;;AmBzhCM;EApCJ,cAAA;EACA,WAAA;AnBikCF;;AmBnjCE;EACE,cAAA;EACA,WAAA;AnBsjCJ;;AmBxjCE;EACE,cAAA;EACA,UAAA;AnB2jCJ;;AmB7jCE;EACE,cAAA;EACA,mBAAA;AnBgkCJ;;AmBlkCE;EACE,cAAA;EACA,UAAA;AnBqkCJ;;AmBvkCE;EACE,cAAA;EACA,UAAA;AnB0kCJ;;AmB5kCE;EACE,cAAA;EACA,mBAAA;AnB+kCJ;;AmBhjCM;EAhDJ,cAAA;EACA,WAAA;AnBomCF;;AmB/iCU;EAhEN,cAAA;EACA,kBAAA;AnBmnCJ;;AmBpjCU;EAhEN,cAAA;EACA,mBAAA;AnBwnCJ;;AmBzjCU;EAhEN,cAAA;EACA,UAAA;AnB6nCJ;;AmB9jCU;EAhEN,cAAA;EACA,mBAAA;AnBkoCJ;;AmBnkCU;EAhEN,cAAA;EACA,mBAAA;AnBuoCJ;;AmBxkCU;EAhEN,cAAA;EACA,UAAA;AnB4oCJ;;AmB7kCU;EAhEN,cAAA;EACA,mBAAA;AnBipCJ;;AmBllCU;EAhEN,cAAA;EACA,mBAAA;AnBspCJ;;AmBvlCU;EAhEN,cAAA;EACA,UAAA;AnB2pCJ;;AmB5lCU;EAhEN,cAAA;EACA,mBAAA;AnBgqCJ;;AmBjmCU;EAhEN,cAAA;EACA,mBAAA;AnBqqCJ;;AmBtmCU;EAhEN,cAAA;EACA,WAAA;AnB0qCJ;;AmBnmCY;EAxDV,wBAAA;AnB+pCF;;AmBvmCY;EAxDV,yBAAA;AnBmqCF;;AmB3mCY;EAxDV,gBAAA;AnBuqCF;;AmB/mCY;EAxDV,yBAAA;AnB2qCF;;AmBnnCY;EAxDV,yBAAA;AnB+qCF;;AmBvnCY;EAxDV,gBAAA;AnBmrCF;;AmB3nCY;EAxDV,yBAAA;AnBurCF;;AmB/nCY;EAxDV,yBAAA;AnB2rCF;;AmBnoCY;EAxDV,gBAAA;AnB+rCF;;AmBvoCY;EAxDV,yBAAA;AnBmsCF;;AmB3oCY;EAxDV,yBAAA;AnBusCF;;AmBpoCQ;;EAEE,gBAAA;AnBuoCV;;AmBpoCQ;;EAEE,gBAAA;AnBuoCV;;AmB9oCQ;;EAEE,sBAAA;AnBipCV;;AmB9oCQ;;EAEE,sBAAA;AnBipCV;;AmBxpCQ;;EAEE,qBAAA;AnB2pCV;;AmBxpCQ;;EAEE,qBAAA;AnB2pCV;;AmBlqCQ;;EAEE,mBAAA;AnBqqCV;;AmBlqCQ;;EAEE,mBAAA;AnBqqCV;;AmB5qCQ;;EAEE,qBAAA;AnB+qCV;;AmB5qCQ;;EAEE,qBAAA;AnB+qCV;;AmBtrCQ;;EAEE,mBAAA;AnByrCV;;AmBtrCQ;;EAEE,mBAAA;AnByrCV;;AmBhsCQ;;EAEE,qBAAA;AnBmsCV;;AmBhsCQ;;EAEE,qBAAA;AnBmsCV;;AmB1sCQ;;EAEE,mBAAA;AnB6sCV;;AmB1sCQ;;EAEE,mBAAA;AnB6sCV;;AmBptCQ;;EAEE,mBAAA;AnButCV;;AmBptCQ;;EAEE,mBAAA;AnButCV;;AmB9tCQ;;EAEE,oBAAA;AnBiuCV;;AmB9tCQ;;EAEE,oBAAA;AnBiuCV;;AM3xCI;EaUE;IACE,YAAA;EnBqxCN;EmBlxCI;IApCJ,cAAA;IACA,WAAA;EnByzCA;EmB3yCA;IACE,cAAA;IACA,WAAA;EnB6yCF;EmB/yCA;IACE,cAAA;IACA,UAAA;EnBizCF;EmBnzCA;IACE,cAAA;IACA,mBAAA;EnBqzCF;EmBvzCA;IACE,cAAA;IACA,UAAA;EnByzCF;EmB3zCA;IACE,cAAA;IACA,UAAA;EnB6zCF;EmB/zCA;IACE,cAAA;IACA,mBAAA;EnBi0CF;EmBlyCI;IAhDJ,cAAA;IACA,WAAA;EnBq1CA;EmBhyCQ;IAhEN,cAAA;IACA,kBAAA;EnBm2CF;EmBpyCQ;IAhEN,cAAA;IACA,mBAAA;EnBu2CF;EmBxyCQ;IAhEN,cAAA;IACA,UAAA;EnB22CF;EmB5yCQ;IAhEN,cAAA;IACA,mBAAA;EnB+2CF;EmBhzCQ;IAhEN,cAAA;IACA,mBAAA;EnBm3CF;EmBpzCQ;IAhEN,cAAA;IACA,UAAA;EnBu3CF;EmBxzCQ;IAhEN,cAAA;IACA,mBAAA;EnB23CF;EmB5zCQ;IAhEN,cAAA;IACA,mBAAA;EnB+3CF;EmBh0CQ;IAhEN,cAAA;IACA,UAAA;EnBm4CF;EmBp0CQ;IAhEN,cAAA;IACA,mBAAA;EnBu4CF;EmBx0CQ;IAhEN,cAAA;IACA,mBAAA;EnB24CF;EmB50CQ;IAhEN,cAAA;IACA,WAAA;EnB+4CF;EmBx0CU;IAxDV,cAAA;EnBm4CA;EmB30CU;IAxDV,wBAAA;EnBs4CA;EmB90CU;IAxDV,yBAAA;EnBy4CA;EmBj1CU;IAxDV,gBAAA;EnB44CA;EmBp1CU;IAxDV,yBAAA;EnB+4CA;EmBv1CU;IAxDV,yBAAA;EnBk5CA;EmB11CU;IAxDV,gBAAA;EnBq5CA;EmB71CU;IAxDV,yBAAA;EnBw5CA;EmBh2CU;IAxDV,yBAAA;EnB25CA;EmBn2CU;IAxDV,gBAAA;EnB85CA;EmBt2CU;IAxDV,yBAAA;EnBi6CA;EmBz2CU;IAxDV,yBAAA;EnBo6CA;EmBj2CM;;IAEE,gBAAA;EnBm2CR;EmBh2CM;;IAEE,gBAAA;EnBk2CR;EmBz2CM;;IAEE,sBAAA;EnB22CR;EmBx2CM;;IAEE,sBAAA;EnB02CR;EmBj3CM;;IAEE,qBAAA;EnBm3CR;EmBh3CM;;IAEE,qBAAA;EnBk3CR;EmBz3CM;;IAEE,mBAAA;EnB23CR;EmBx3CM;;IAEE,mBAAA;EnB03CR;EmBj4CM;;IAEE,qBAAA;EnBm4CR;EmBh4CM;;IAEE,qBAAA;EnBk4CR;EmBz4CM;;IAEE,mBAAA;EnB24CR;EmBx4CM;;IAEE,mBAAA;EnB04CR;EmBj5CM;;IAEE,qBAAA;EnBm5CR;EmBh5CM;;IAEE,qBAAA;EnBk5CR;EmBz5CM;;IAEE,mBAAA;EnB25CR;EmBx5CM;;IAEE,mBAAA;EnB05CR;EmBj6CM;;IAEE,mBAAA;EnBm6CR;EmBh6CM;;IAEE,mBAAA;EnBk6CR;EmBz6CM;;IAEE,oBAAA;EnB26CR;EmBx6CM;;IAEE,oBAAA;EnB06CR;AACF;AMr+CI;EaUE;IACE,YAAA;EnB89CN;EmB39CI;IApCJ,cAAA;IACA,WAAA;EnBkgDA;EmBp/CA;IACE,cAAA;IACA,WAAA;EnBs/CF;EmBx/CA;IACE,cAAA;IACA,UAAA;EnB0/CF;EmB5/CA;IACE,cAAA;IACA,mBAAA;EnB8/CF;EmBhgDA;IACE,cAAA;IACA,UAAA;EnBkgDF;EmBpgDA;IACE,cAAA;IACA,UAAA;EnBsgDF;EmBxgDA;IACE,cAAA;IACA,mBAAA;EnB0gDF;EmB3+CI;IAhDJ,cAAA;IACA,WAAA;EnB8hDA;EmBz+CQ;IAhEN,cAAA;IACA,kBAAA;EnB4iDF;EmB7+CQ;IAhEN,cAAA;IACA,mBAAA;EnBgjDF;EmBj/CQ;IAhEN,cAAA;IACA,UAAA;EnBojDF;EmBr/CQ;IAhEN,cAAA;IACA,mBAAA;EnBwjDF;EmBz/CQ;IAhEN,cAAA;IACA,mBAAA;EnB4jDF;EmB7/CQ;IAhEN,cAAA;IACA,UAAA;EnBgkDF;EmBjgDQ;IAhEN,cAAA;IACA,mBAAA;EnBokDF;EmBrgDQ;IAhEN,cAAA;IACA,mBAAA;EnBwkDF;EmBzgDQ;IAhEN,cAAA;IACA,UAAA;EnB4kDF;EmB7gDQ;IAhEN,cAAA;IACA,mBAAA;EnBglDF;EmBjhDQ;IAhEN,cAAA;IACA,mBAAA;EnBolDF;EmBrhDQ;IAhEN,cAAA;IACA,WAAA;EnBwlDF;EmBjhDU;IAxDV,cAAA;EnB4kDA;EmBphDU;IAxDV,wBAAA;EnB+kDA;EmBvhDU;IAxDV,yBAAA;EnBklDA;EmB1hDU;IAxDV,gBAAA;EnBqlDA;EmB7hDU;IAxDV,yBAAA;EnBwlDA;EmBhiDU;IAxDV,yBAAA;EnB2lDA;EmBniDU;IAxDV,gBAAA;EnB8lDA;EmBtiDU;IAxDV,yBAAA;EnBimDA;EmBziDU;IAxDV,yBAAA;EnBomDA;EmB5iDU;IAxDV,gBAAA;EnBumDA;EmB/iDU;IAxDV,yBAAA;EnB0mDA;EmBljDU;IAxDV,yBAAA;EnB6mDA;EmB1iDM;;IAEE,gBAAA;EnB4iDR;EmBziDM;;IAEE,gBAAA;EnB2iDR;EmBljDM;;IAEE,sBAAA;EnBojDR;EmBjjDM;;IAEE,sBAAA;EnBmjDR;EmB1jDM;;IAEE,qBAAA;EnB4jDR;EmBzjDM;;IAEE,qBAAA;EnB2jDR;EmBlkDM;;IAEE,mBAAA;EnBokDR;EmBjkDM;;IAEE,mBAAA;EnBmkDR;EmB1kDM;;IAEE,qBAAA;EnB4kDR;EmBzkDM;;IAEE,qBAAA;EnB2kDR;EmBllDM;;IAEE,mBAAA;EnBolDR;EmBjlDM;;IAEE,mBAAA;EnBmlDR;EmB1lDM;;IAEE,qBAAA;EnB4lDR;EmBzlDM;;IAEE,qBAAA;EnB2lDR;EmBlmDM;;IAEE,mBAAA;EnBomDR;EmBjmDM;;IAEE,mBAAA;EnBmmDR;EmB1mDM;;IAEE,mBAAA;EnB4mDR;EmBzmDM;;IAEE,mBAAA;EnB2mDR;EmBlnDM;;IAEE,oBAAA;EnBonDR;EmBjnDM;;IAEE,oBAAA;EnBmnDR;AACF;AM9qDI;EaUE;IACE,YAAA;EnBuqDN;EmBpqDI;IApCJ,cAAA;IACA,WAAA;EnB2sDA;EmB7rDA;IACE,cAAA;IACA,WAAA;EnB+rDF;EmBjsDA;IACE,cAAA;IACA,UAAA;EnBmsDF;EmBrsDA;IACE,cAAA;IACA,mBAAA;EnBusDF;EmBzsDA;IACE,cAAA;IACA,UAAA;EnB2sDF;EmB7sDA;IACE,cAAA;IACA,UAAA;EnB+sDF;EmBjtDA;IACE,cAAA;IACA,mBAAA;EnBmtDF;EmBprDI;IAhDJ,cAAA;IACA,WAAA;EnBuuDA;EmBlrDQ;IAhEN,cAAA;IACA,kBAAA;EnBqvDF;EmBtrDQ;IAhEN,cAAA;IACA,mBAAA;EnByvDF;EmB1rDQ;IAhEN,cAAA;IACA,UAAA;EnB6vDF;EmB9rDQ;IAhEN,cAAA;IACA,mBAAA;EnBiwDF;EmBlsDQ;IAhEN,cAAA;IACA,mBAAA;EnBqwDF;EmBtsDQ;IAhEN,cAAA;IACA,UAAA;EnBywDF;EmB1sDQ;IAhEN,cAAA;IACA,mBAAA;EnB6wDF;EmB9sDQ;IAhEN,cAAA;IACA,mBAAA;EnBixDF;EmBltDQ;IAhEN,cAAA;IACA,UAAA;EnBqxDF;EmBttDQ;IAhEN,cAAA;IACA,mBAAA;EnByxDF;EmB1tDQ;IAhEN,cAAA;IACA,mBAAA;EnB6xDF;EmB9tDQ;IAhEN,cAAA;IACA,WAAA;EnBiyDF;EmB1tDU;IAxDV,cAAA;EnBqxDA;EmB7tDU;IAxDV,wBAAA;EnBwxDA;EmBhuDU;IAxDV,yBAAA;EnB2xDA;EmBnuDU;IAxDV,gBAAA;EnB8xDA;EmBtuDU;IAxDV,yBAAA;EnBiyDA;EmBzuDU;IAxDV,yBAAA;EnBoyDA;EmB5uDU;IAxDV,gBAAA;EnBuyDA;EmB/uDU;IAxDV,yBAAA;EnB0yDA;EmBlvDU;IAxDV,yBAAA;EnB6yDA;EmBrvDU;IAxDV,gBAAA;EnBgzDA;EmBxvDU;IAxDV,yBAAA;EnBmzDA;EmB3vDU;IAxDV,yBAAA;EnBszDA;EmBnvDM;;IAEE,gBAAA;EnBqvDR;EmBlvDM;;IAEE,gBAAA;EnBovDR;EmB3vDM;;IAEE,sBAAA;EnB6vDR;EmB1vDM;;IAEE,sBAAA;EnB4vDR;EmBnwDM;;IAEE,qBAAA;EnBqwDR;EmBlwDM;;IAEE,qBAAA;EnBowDR;EmB3wDM;;IAEE,mBAAA;EnB6wDR;EmB1wDM;;IAEE,mBAAA;EnB4wDR;EmBnxDM;;IAEE,qBAAA;EnBqxDR;EmBlxDM;;IAEE,qBAAA;EnBoxDR;EmB3xDM;;IAEE,mBAAA;EnB6xDR;EmB1xDM;;IAEE,mBAAA;EnB4xDR;EmBnyDM;;IAEE,qBAAA;EnBqyDR;EmBlyDM;;IAEE,qBAAA;EnBoyDR;EmB3yDM;;IAEE,mBAAA;EnB6yDR;EmB1yDM;;IAEE,mBAAA;EnB4yDR;EmBnzDM;;IAEE,mBAAA;EnBqzDR;EmBlzDM;;IAEE,mBAAA;EnBozDR;EmB3zDM;;IAEE,oBAAA;EnB6zDR;EmB1zDM;;IAEE,oBAAA;EnB4zDR;AACF;AMv3DI;EaUE;IACE,YAAA;EnBg3DN;EmB72DI;IApCJ,cAAA;IACA,WAAA;EnBo5DA;EmBt4DA;IACE,cAAA;IACA,WAAA;EnBw4DF;EmB14DA;IACE,cAAA;IACA,UAAA;EnB44DF;EmB94DA;IACE,cAAA;IACA,mBAAA;EnBg5DF;EmBl5DA;IACE,cAAA;IACA,UAAA;EnBo5DF;EmBt5DA;IACE,cAAA;IACA,UAAA;EnBw5DF;EmB15DA;IACE,cAAA;IACA,mBAAA;EnB45DF;EmB73DI;IAhDJ,cAAA;IACA,WAAA;EnBg7DA;EmB33DQ;IAhEN,cAAA;IACA,kBAAA;EnB87DF;EmB/3DQ;IAhEN,cAAA;IACA,mBAAA;EnBk8DF;EmBn4DQ;IAhEN,cAAA;IACA,UAAA;EnBs8DF;EmBv4DQ;IAhEN,cAAA;IACA,mBAAA;EnB08DF;EmB34DQ;IAhEN,cAAA;IACA,mBAAA;EnB88DF;EmB/4DQ;IAhEN,cAAA;IACA,UAAA;EnBk9DF;EmBn5DQ;IAhEN,cAAA;IACA,mBAAA;EnBs9DF;EmBv5DQ;IAhEN,cAAA;IACA,mBAAA;EnB09DF;EmB35DQ;IAhEN,cAAA;IACA,UAAA;EnB89DF;EmB/5DQ;IAhEN,cAAA;IACA,mBAAA;EnBk+DF;EmBn6DQ;IAhEN,cAAA;IACA,mBAAA;EnBs+DF;EmBv6DQ;IAhEN,cAAA;IACA,WAAA;EnB0+DF;EmBn6DU;IAxDV,cAAA;EnB89DA;EmBt6DU;IAxDV,wBAAA;EnBi+DA;EmBz6DU;IAxDV,yBAAA;EnBo+DA;EmB56DU;IAxDV,gBAAA;EnBu+DA;EmB/6DU;IAxDV,yBAAA;EnB0+DA;EmBl7DU;IAxDV,yBAAA;EnB6+DA;EmBr7DU;IAxDV,gBAAA;EnBg/DA;EmBx7DU;IAxDV,yBAAA;EnBm/DA;EmB37DU;IAxDV,yBAAA;EnBs/DA;EmB97DU;IAxDV,gBAAA;EnBy/DA;EmBj8DU;IAxDV,yBAAA;EnB4/DA;EmBp8DU;IAxDV,yBAAA;EnB+/DA;EmB57DM;;IAEE,gBAAA;EnB87DR;EmB37DM;;IAEE,gBAAA;EnB67DR;EmBp8DM;;IAEE,sBAAA;EnBs8DR;EmBn8DM;;IAEE,sBAAA;EnBq8DR;EmB58DM;;IAEE,qBAAA;EnB88DR;EmB38DM;;IAEE,qBAAA;EnB68DR;EmBp9DM;;IAEE,mBAAA;EnBs9DR;EmBn9DM;;IAEE,mBAAA;EnBq9DR;EmB59DM;;IAEE,qBAAA;EnB89DR;EmB39DM;;IAEE,qBAAA;EnB69DR;EmBp+DM;;IAEE,mBAAA;EnBs+DR;EmBn+DM;;IAEE,mBAAA;EnBq+DR;EmB5+DM;;IAEE,qBAAA;EnB8+DR;EmB3+DM;;IAEE,qBAAA;EnB6+DR;EmBp/DM;;IAEE,mBAAA;EnBs/DR;EmBn/DM;;IAEE,mBAAA;EnBq/DR;EmB5/DM;;IAEE,mBAAA;EnB8/DR;EmB3/DM;;IAEE,mBAAA;EnB6/DR;EmBpgEM;;IAEE,oBAAA;EnBsgER;EmBngEM;;IAEE,oBAAA;EnBqgER;AACF;AMhkEI;EaUE;IACE,YAAA;EnByjEN;EmBtjEI;IApCJ,cAAA;IACA,WAAA;EnB6lEA;EmB/kEA;IACE,cAAA;IACA,WAAA;EnBilEF;EmBnlEA;IACE,cAAA;IACA,UAAA;EnBqlEF;EmBvlEA;IACE,cAAA;IACA,mBAAA;EnBylEF;EmB3lEA;IACE,cAAA;IACA,UAAA;EnB6lEF;EmB/lEA;IACE,cAAA;IACA,UAAA;EnBimEF;EmBnmEA;IACE,cAAA;IACA,mBAAA;EnBqmEF;EmBtkEI;IAhDJ,cAAA;IACA,WAAA;EnBynEA;EmBpkEQ;IAhEN,cAAA;IACA,kBAAA;EnBuoEF;EmBxkEQ;IAhEN,cAAA;IACA,mBAAA;EnB2oEF;EmB5kEQ;IAhEN,cAAA;IACA,UAAA;EnB+oEF;EmBhlEQ;IAhEN,cAAA;IACA,mBAAA;EnBmpEF;EmBplEQ;IAhEN,cAAA;IACA,mBAAA;EnBupEF;EmBxlEQ;IAhEN,cAAA;IACA,UAAA;EnB2pEF;EmB5lEQ;IAhEN,cAAA;IACA,mBAAA;EnB+pEF;EmBhmEQ;IAhEN,cAAA;IACA,mBAAA;EnBmqEF;EmBpmEQ;IAhEN,cAAA;IACA,UAAA;EnBuqEF;EmBxmEQ;IAhEN,cAAA;IACA,mBAAA;EnB2qEF;EmB5mEQ;IAhEN,cAAA;IACA,mBAAA;EnB+qEF;EmBhnEQ;IAhEN,cAAA;IACA,WAAA;EnBmrEF;EmB5mEU;IAxDV,cAAA;EnBuqEA;EmB/mEU;IAxDV,wBAAA;EnB0qEA;EmBlnEU;IAxDV,yBAAA;EnB6qEA;EmBrnEU;IAxDV,gBAAA;EnBgrEA;EmBxnEU;IAxDV,yBAAA;EnBmrEA;EmB3nEU;IAxDV,yBAAA;EnBsrEA;EmB9nEU;IAxDV,gBAAA;EnByrEA;EmBjoEU;IAxDV,yBAAA;EnB4rEA;EmBpoEU;IAxDV,yBAAA;EnB+rEA;EmBvoEU;IAxDV,gBAAA;EnBksEA;EmB1oEU;IAxDV,yBAAA;EnBqsEA;EmB7oEU;IAxDV,yBAAA;EnBwsEA;EmBroEM;;IAEE,gBAAA;EnBuoER;EmBpoEM;;IAEE,gBAAA;EnBsoER;EmB7oEM;;IAEE,sBAAA;EnB+oER;EmB5oEM;;IAEE,sBAAA;EnB8oER;EmBrpEM;;IAEE,qBAAA;EnBupER;EmBppEM;;IAEE,qBAAA;EnBspER;EmB7pEM;;IAEE,mBAAA;EnB+pER;EmB5pEM;;IAEE,mBAAA;EnB8pER;EmBrqEM;;IAEE,qBAAA;EnBuqER;EmBpqEM;;IAEE,qBAAA;EnBsqER;EmB7qEM;;IAEE,mBAAA;EnB+qER;EmB5qEM;;IAEE,mBAAA;EnB8qER;EmBrrEM;;IAEE,qBAAA;EnBurER;EmBprEM;;IAEE,qBAAA;EnBsrER;EmB7rEM;;IAEE,mBAAA;EnB+rER;EmB5rEM;;IAEE,mBAAA;EnB8rER;EmBrsEM;;IAEE,mBAAA;EnBusER;EmBpsEM;;IAEE,mBAAA;EnBssER;EmB7sEM;;IAEE,oBAAA;EnB+sER;EmB5sEM;;IAEE,oBAAA;EnB8sER;AACF;AMzwEI;EaUE;IACE,YAAA;EnBkwEN;EmB/vEI;IApCJ,cAAA;IACA,WAAA;EnBsyEA;EmBxxEA;IACE,cAAA;IACA,WAAA;EnB0xEF;EmB5xEA;IACE,cAAA;IACA,UAAA;EnB8xEF;EmBhyEA;IACE,cAAA;IACA,mBAAA;EnBkyEF;EmBpyEA;IACE,cAAA;IACA,UAAA;EnBsyEF;EmBxyEA;IACE,cAAA;IACA,UAAA;EnB0yEF;EmB5yEA;IACE,cAAA;IACA,mBAAA;EnB8yEF;EmB/wEI;IAhDJ,cAAA;IACA,WAAA;EnBk0EA;EmB7wEQ;IAhEN,cAAA;IACA,kBAAA;EnBg1EF;EmBjxEQ;IAhEN,cAAA;IACA,mBAAA;EnBo1EF;EmBrxEQ;IAhEN,cAAA;IACA,UAAA;EnBw1EF;EmBzxEQ;IAhEN,cAAA;IACA,mBAAA;EnB41EF;EmB7xEQ;IAhEN,cAAA;IACA,mBAAA;EnBg2EF;EmBjyEQ;IAhEN,cAAA;IACA,UAAA;EnBo2EF;EmBryEQ;IAhEN,cAAA;IACA,mBAAA;EnBw2EF;EmBzyEQ;IAhEN,cAAA;IACA,mBAAA;EnB42EF;EmB7yEQ;IAhEN,cAAA;IACA,UAAA;EnBg3EF;EmBjzEQ;IAhEN,cAAA;IACA,mBAAA;EnBo3EF;EmBrzEQ;IAhEN,cAAA;IACA,mBAAA;EnBw3EF;EmBzzEQ;IAhEN,cAAA;IACA,WAAA;EnB43EF;EmBrzEU;IAxDV,cAAA;EnBg3EA;EmBxzEU;IAxDV,wBAAA;EnBm3EA;EmB3zEU;IAxDV,yBAAA;EnBs3EA;EmB9zEU;IAxDV,gBAAA;EnBy3EA;EmBj0EU;IAxDV,yBAAA;EnB43EA;EmBp0EU;IAxDV,yBAAA;EnB+3EA;EmBv0EU;IAxDV,gBAAA;EnBk4EA;EmB10EU;IAxDV,yBAAA;EnBq4EA;EmB70EU;IAxDV,yBAAA;EnBw4EA;EmBh1EU;IAxDV,gBAAA;EnB24EA;EmBn1EU;IAxDV,yBAAA;EnB84EA;EmBt1EU;IAxDV,yBAAA;EnBi5EA;EmB90EM;;IAEE,gBAAA;EnBg1ER;EmB70EM;;IAEE,gBAAA;EnB+0ER;EmBt1EM;;IAEE,sBAAA;EnBw1ER;EmBr1EM;;IAEE,sBAAA;EnBu1ER;EmB91EM;;IAEE,qBAAA;EnBg2ER;EmB71EM;;IAEE,qBAAA;EnB+1ER;EmBt2EM;;IAEE,mBAAA;EnBw2ER;EmBr2EM;;IAEE,mBAAA;EnBu2ER;EmB92EM;;IAEE,qBAAA;EnBg3ER;EmB72EM;;IAEE,qBAAA;EnB+2ER;EmBt3EM;;IAEE,mBAAA;EnBw3ER;EmBr3EM;;IAEE,mBAAA;EnBu3ER;EmB93EM;;IAEE,qBAAA;EnBg4ER;EmB73EM;;IAEE,qBAAA;EnB+3ER;EmBt4EM;;IAEE,mBAAA;EnBw4ER;EmBr4EM;;IAEE,mBAAA;EnBu4ER;EmB94EM;;IAEE,mBAAA;EnBg5ER;EmB74EM;;IAEE,mBAAA;EnB+4ER;EmBt5EM;;IAEE,oBAAA;EnBw5ER;EmBr5EM;;IAEE,oBAAA;EnBu5ER;AACF;AMl9EI;EaUE;IACE,YAAA;EnB28EN;EmBx8EI;IApCJ,cAAA;IACA,WAAA;EnB++EA;EmBj+EA;IACE,cAAA;IACA,WAAA;EnBm+EF;EmBr+EA;IACE,cAAA;IACA,UAAA;EnBu+EF;EmBz+EA;IACE,cAAA;IACA,mBAAA;EnB2+EF;EmB7+EA;IACE,cAAA;IACA,UAAA;EnB++EF;EmBj/EA;IACE,cAAA;IACA,UAAA;EnBm/EF;EmBr/EA;IACE,cAAA;IACA,mBAAA;EnBu/EF;EmBx9EI;IAhDJ,cAAA;IACA,WAAA;EnB2gFA;EmBt9EQ;IAhEN,cAAA;IACA,kBAAA;EnByhFF;EmB19EQ;IAhEN,cAAA;IACA,mBAAA;EnB6hFF;EmB99EQ;IAhEN,cAAA;IACA,UAAA;EnBiiFF;EmBl+EQ;IAhEN,cAAA;IACA,mBAAA;EnBqiFF;EmBt+EQ;IAhEN,cAAA;IACA,mBAAA;EnByiFF;EmB1+EQ;IAhEN,cAAA;IACA,UAAA;EnB6iFF;EmB9+EQ;IAhEN,cAAA;IACA,mBAAA;EnBijFF;EmBl/EQ;IAhEN,cAAA;IACA,mBAAA;EnBqjFF;EmBt/EQ;IAhEN,cAAA;IACA,UAAA;EnByjFF;EmB1/EQ;IAhEN,cAAA;IACA,mBAAA;EnB6jFF;EmB9/EQ;IAhEN,cAAA;IACA,mBAAA;EnBikFF;EmBlgFQ;IAhEN,cAAA;IACA,WAAA;EnBqkFF;EmB9/EU;IAxDV,cAAA;EnByjFA;EmBjgFU;IAxDV,wBAAA;EnB4jFA;EmBpgFU;IAxDV,yBAAA;EnB+jFA;EmBvgFU;IAxDV,gBAAA;EnBkkFA;EmB1gFU;IAxDV,yBAAA;EnBqkFA;EmB7gFU;IAxDV,yBAAA;EnBwkFA;EmBhhFU;IAxDV,gBAAA;EnB2kFA;EmBnhFU;IAxDV,yBAAA;EnB8kFA;EmBthFU;IAxDV,yBAAA;EnBilFA;EmBzhFU;IAxDV,gBAAA;EnBolFA;EmB5hFU;IAxDV,yBAAA;EnBulFA;EmB/hFU;IAxDV,yBAAA;EnB0lFA;EmBvhFM;;IAEE,gBAAA;EnByhFR;EmBthFM;;IAEE,gBAAA;EnBwhFR;EmB/hFM;;IAEE,sBAAA;EnBiiFR;EmB9hFM;;IAEE,sBAAA;EnBgiFR;EmBviFM;;IAEE,qBAAA;EnByiFR;EmBtiFM;;IAEE,qBAAA;EnBwiFR;EmB/iFM;;IAEE,mBAAA;EnBijFR;EmB9iFM;;IAEE,mBAAA;EnBgjFR;EmBvjFM;;IAEE,qBAAA;EnByjFR;EmBtjFM;;IAEE,qBAAA;EnBwjFR;EmB/jFM;;IAEE,mBAAA;EnBikFR;EmB9jFM;;IAEE,mBAAA;EnBgkFR;EmBvkFM;;IAEE,qBAAA;EnBykFR;EmBtkFM;;IAEE,qBAAA;EnBwkFR;EmB/kFM;;IAEE,mBAAA;EnBilFR;EmB9kFM;;IAEE,mBAAA;EnBglFR;EmBvlFM;;IAEE,mBAAA;EnBylFR;EmBtlFM;;IAEE,mBAAA;EnBwlFR;EmB/lFM;;IAEE,oBAAA;EnBimFR;EmB9lFM;;IAEE,oBAAA;EnBgmFR;AACF;AM3pFI;EaUE;IACE,YAAA;EnBopFN;EmBjpFI;IApCJ,cAAA;IACA,WAAA;EnBwrFA;EmB1qFA;IACE,cAAA;IACA,WAAA;EnB4qFF;EmB9qFA;IACE,cAAA;IACA,UAAA;EnBgrFF;EmBlrFA;IACE,cAAA;IACA,mBAAA;EnBorFF;EmBtrFA;IACE,cAAA;IACA,UAAA;EnBwrFF;EmB1rFA;IACE,cAAA;IACA,UAAA;EnB4rFF;EmB9rFA;IACE,cAAA;IACA,mBAAA;EnBgsFF;EmBjqFI;IAhDJ,cAAA;IACA,WAAA;EnBotFA;EmB/pFQ;IAhEN,cAAA;IACA,kBAAA;EnBkuFF;EmBnqFQ;IAhEN,cAAA;IACA,mBAAA;EnBsuFF;EmBvqFQ;IAhEN,cAAA;IACA,UAAA;EnB0uFF;EmB3qFQ;IAhEN,cAAA;IACA,mBAAA;EnB8uFF;EmB/qFQ;IAhEN,cAAA;IACA,mBAAA;EnBkvFF;EmBnrFQ;IAhEN,cAAA;IACA,UAAA;EnBsvFF;EmBvrFQ;IAhEN,cAAA;IACA,mBAAA;EnB0vFF;EmB3rFQ;IAhEN,cAAA;IACA,mBAAA;EnB8vFF;EmB/rFQ;IAhEN,cAAA;IACA,UAAA;EnBkwFF;EmBnsFQ;IAhEN,cAAA;IACA,mBAAA;EnBswFF;EmBvsFQ;IAhEN,cAAA;IACA,mBAAA;EnB0wFF;EmB3sFQ;IAhEN,cAAA;IACA,WAAA;EnB8wFF;EmBvsFU;IAxDV,cAAA;EnBkwFA;EmB1sFU;IAxDV,wBAAA;EnBqwFA;EmB7sFU;IAxDV,yBAAA;EnBwwFA;EmBhtFU;IAxDV,gBAAA;EnB2wFA;EmBntFU;IAxDV,yBAAA;EnB8wFA;EmBttFU;IAxDV,yBAAA;EnBixFA;EmBztFU;IAxDV,gBAAA;EnBoxFA;EmB5tFU;IAxDV,yBAAA;EnBuxFA;EmB/tFU;IAxDV,yBAAA;EnB0xFA;EmBluFU;IAxDV,gBAAA;EnB6xFA;EmBruFU;IAxDV,yBAAA;EnBgyFA;EmBxuFU;IAxDV,yBAAA;EnBmyFA;EmBhuFM;;IAEE,gBAAA;EnBkuFR;EmB/tFM;;IAEE,gBAAA;EnBiuFR;EmBxuFM;;IAEE,sBAAA;EnB0uFR;EmBvuFM;;IAEE,sBAAA;EnByuFR;EmBhvFM;;IAEE,qBAAA;EnBkvFR;EmB/uFM;;IAEE,qBAAA;EnBivFR;EmBxvFM;;IAEE,mBAAA;EnB0vFR;EmBvvFM;;IAEE,mBAAA;EnByvFR;EmBhwFM;;IAEE,qBAAA;EnBkwFR;EmB/vFM;;IAEE,qBAAA;EnBiwFR;EmBxwFM;;IAEE,mBAAA;EnB0wFR;EmBvwFM;;IAEE,mBAAA;EnBywFR;EmBhxFM;;IAEE,qBAAA;EnBkxFR;EmB/wFM;;IAEE,qBAAA;EnBixFR;EmBxxFM;;IAEE,mBAAA;EnB0xFR;EmBvxFM;;IAEE,mBAAA;EnByxFR;EmBhyFM;;IAEE,mBAAA;EnBkyFR;EmB/xFM;;IAEE,mBAAA;EnBiyFR;EmBxyFM;;IAEE,oBAAA;EnB0yFR;EmBvyFM;;IAEE,oBAAA;EnByyFR;AACF;AoB/5FA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,mBpBgEO;EoB/DP,mBjBusB4B;EiBtsB5B,0CAAA;ApB85FF;AoBv5FE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CjB+sB0B;EiB9sB1B,2GAAA;ApBw5FJ;AoBr5FE;EACE,uBAAA;ApBu5FJ;AoBp5FE;EACE,sBAAA;ApBs5FJ;;AoBl5FA;EACE,+DAAA;ApBq5FF;;AoB94FA;EACE,iBAAA;ApBi5FF;;AoBv4FE;EACE,wBAAA;ApB04FJ;;AoB33FE;EACE,sCAAA;ApB83FJ;AoB33FI;EACE,sCAAA;ApB63FN;;AoBt3FE;EACE,sBAAA;ApBy3FJ;AoBt3FE;EACE,mBAAA;ApBw3FJ;;AoB92FE;EACE,oDAAA;EACA,8CAAA;ApBi3FJ;;AoB32FE;EACE,oDAAA;EACA,8CAAA;ApB82FJ;;AoBt2FA;EACE,oDAAA;EACA,8CAAA;ApBy2FF;;AoBj2FE;EACE,mDAAA;EACA,6CAAA;ApBo2FJ;;AqBh/FE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ArB4+FJ;;AqB9/FE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ArB0/FJ;;AqB5gGE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ArBwgGJ;;AqB1hGE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ArBshGJ;;AqBxiGE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ArBoiGJ;;AqBtjGE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ArBkjGJ;;AqBpkGE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ArBgkGJ;;AqBllGE;EAOE,sBAAA;EACA,mBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ArB8kGJ;;AoB77FI;EACE,gBAAA;EACA,iCAAA;ApBg8FN;;AM3hGI;EcyFA;IACE,gBAAA;IACA,iCAAA;EpBs8FJ;AACF;AMliGI;EcyFA;IACE,gBAAA;IACA,iCAAA;EpB48FJ;AACF;AMxiGI;EcyFA;IACE,gBAAA;IACA,iCAAA;EpBk9FJ;AACF;AM9iGI;EcyFA;IACE,gBAAA;IACA,iCAAA;EpBw9FJ;AACF;AMpjGI;EcyFA;IACE,gBAAA;IACA,iCAAA;EpB89FJ;AACF;AM1jGI;EcyFA;IACE,gBAAA;IACA,iCAAA;EpBo+FJ;AACF;AMhkGI;EcyFA;IACE,gBAAA;IACA,iCAAA;EpB0+FJ;AACF;AMtkGI;EcyFA;IACE,gBAAA;IACA,iCAAA;EpBg/FJ;AACF;AsBppGA;EACE,qBnBu2BsC;AH+yExC;;AsB7oGA;EACE,gDAAA;EACA,mDAAA;EACA,gBAAA;Eb8QI,kBALI;EarQR,gBtBiFiB;AA6jGnB;;AsB1oGA;EACE,kDAAA;EACA,qDAAA;EbwQM,qCAAA;ATs4FR;ASliGI;Ea9GJ;IbiRQ,oBAAA;ETm4FN;AACF;;AsB/oGA;EACE,mDAAA;EACA,sDAAA;Eb8PI,qBALI;AT05FV;;AuBhrGA;EACE,mBpB+1BsC;EMrkBlC,kBALI;EcjRR,gCpB+1BsC;AHk1ExC;;AwBtrGA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EfwRI,kBALI;EehRR,gBrBkmB4B;EqBjmB5B,gBxB2FiB;EwB1FjB,2BrB43BsC;EqB33BtC,gBAAA;EACA,mCrBq3BsC;EqBp3BtC,4BAAA;EACA,yCAAA;EpBGE,gBAAA;EFHE,wEsBMJ;AxBorGF;AEtrGM;EsBhBN;ItBiBQ,gBAAA;EFyrGN;AACF;AwBvrGE;EACE,gBAAA;AxByrGJ;AwBvrGI;EACE,eAAA;AxByrGN;AwBprGE;EACE,2BrBs2BoC;EqBr2BpC,mCrBg2BoC;EqB/1BpC,qBrB82BoC;EqB72BpC,UAAA;EAKE,kDrBkhBkB;AHgqFxB;AwB9qGE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AxBkqGJ;AwB7pGE;EACE,cAAA;EACA,UAAA;AxB+pGJ;AwB3pGE;EACE,yBxBFsB;EwBItB,UAAA;AxB4pGJ;AwBppGE;EAEE,wCrB8yBoC;EqB3yBpC,UAAA;AxBmpGJ;AwB/oGE;EACE,kBAAA;EACA,mBAAA;EACA,uBxB7BkB;EwB8BlB,2BrBsyBoC;EsBp4BtC,uCtBqiCgC;EqBr8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CrBgsB0B;EqB/rB1B,gBAAA;EtBzFE,qIsB0FF;AxBipGJ;AEvuGM;EsB0EJ;ItBzEM,gBAAA;EF0uGN;AACF;AwBnpGE;EACE,wCrB47B8B;AHytElC;;AwB5oGA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBxBtBiB;EwBuBjB,2BrB2xBsC;EqB1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;AxB+oGF;AwB7oGE;EACE,UAAA;AxB+oGJ;AwB5oGE;EAEE,gBAAA;EACA,eAAA;AxB6oGJ;;AwBloGA;EACE,mErB4wBsC;EqB3wBtC,uBAAA;EfyII,qBALI;ELvQN,gBAAA;AJ0wGJ;AwBnoGE;EACE,uBAAA;EACA,wBAAA;EACA,yBrBooB0B;AHigF9B;;AwBjoGA;EACE,iErBgwBsC;EqB/vBtC,oBAAA;EfgIM,qCAAA;ELhRJ,gBAAA;AJsxGJ;ASlqGI;Ee0BJ;IfyIQ,oBAAA;ETmgGN;AACF;AwBvoGE;EACE,oBAAA;EACA,qBAAA;EACA,uBrB2nB0B;AH8gF9B;;AwBjoGE;EACE,iErB6uBoC;AHu5ExC;AwBjoGE;EACE,mErB0uBoC;AHy5ExC;AwBhoGE;EACE,iErBuuBoC;AH25ExC;;AwB7nGA;EACE,WrBquBsC;EqBpuBtC,6DrB8tBsC;EqB7tBtC,axBhIoB;AAgwGtB;AwB9nGE;EACE,eAAA;AxBgoGJ;AwB7nGE;EACE,oBAAA;EpBvLA,gBAAA;AJuzGJ;AwB5nGE;EACE,oBAAA;EpB5LA,gBAAA;AJ2zGJ;AwB3nGE;EAAoB,+DrB8sBkB;AHg7ExC;AwB7nGE;EAAoB,6DrB8sBkB;AHk7ExC;;A0B/0GA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,4BAAA;EjBqRI,kBALI;EiB7QR,gBvB+lB4B;EuB9lB5B,gB1BwFiB;E0BvFjB,2BvBy3BsC;EuBx3BtC,gBAAA;EACA,mCvBk3BsC;EuBj3BtC,mFAAA;EACA,4BAAA;EACA,sCvB+9BkC;EuB99BlC,0BvB+9BkC;EuB99BlC,yCAAA;EtBHE,gBAAA;EFHE,wEwBSJ;A1B+0GF;AEp1GM;EwBfN;IxBgBQ,gBAAA;EFu1GN;AACF;A0Bl1GE;EACE,qBvBs3BoC;EuBr3BpC,UAAA;EAKE,kDvBi+B4B;AH+2ElC;A0B50GE;EAEE,mB1B4BkB;E0B3BlB,sBAAA;A1B60GJ;A0B10GE;EAEE,wCvBu1BoC;AHo/ExC;A0Bt0GE;EACE,kBAAA;EACA,uCAAA;A1Bw0GJ;;A0Bp0GA;EACE,oBvBsuB4B;EuBruB5B,uBvBquB4B;EuBpuB5B,oBvBquB4B;EMlgBxB,qBALI;ELvQN,gBAAA;AJk3GJ;;A0Bp0GA;EACE,mBvBkuB4B;EuBjuB5B,sBvBiuB4B;EuBhuB5B,kBvBiuB4B;EMlgBtB,qCAAA;ELhRJ,gBAAA;AJ03GJ;AStwGI;EiBtEJ;IjByOQ,oBAAA;ETumGN;AACF;;A0Bv0GI;EACE,gEAAA;A1B00GN;;A2Bl5GA;EACE,cAAA;EACA,oBxBq6BwC;EwBp6BxC,mBxBq6BwC;EwBp6BxC,uBxBq6BwC;AHg/E1C;A2Bn5GE;EACE,WAAA;EACA,mBAAA;A3Bq5GJ;;A2Bj5GA;EACE,oBxB25BwC;EwB15BxC,eAAA;EACA,iBAAA;A3Bo5GF;A2Bl5GE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A3Bo5GJ;;A2Bh5GA;EACE,qCAAA;EAEA,cAAA;EACA,UxB04BwC;EwBz4BxC,WxBy4BwC;EwBx4BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DxB24BwC;EwB14BxC,yBAAA;A3Bk5GF;A2B/4GE;EvB3BE,gBAAA;AJ66GJ;A2B94GE;EAEE,kBxBm4BsC;AH4gF1C;A2B54GE;EACE,uBxB03BsC;AHohF1C;A2B34GE;EACE,qBxBs1BoC;EwBr1BpC,UAAA;EACA,kDxB8foB;AH+4FxB;A2B14GE;EACE,yB3B/DM;E2BgEN,qB3BhEM;AA48GV;A2B14GI;EAII,iEAAA;A3By4GR;A2Br4GI;EAII,iEAAA;A3Bo4GR;A2B/3GE;EACE,yB3BpFM;E2BqFN,qB3BrFM;E2B0FJ,iEAAA;A3B63GN;A2Bz3GE;EACE,oBAAA;EACA,YAAA;EACA,YxBk2BuC;AHyhF3C;A2Bp3GI;EACE,eAAA;EACA,YxBy1BqC;AH6hF3C;;A2Bx2GA;EACE,mBxBo1BgC;AHuhFlC;A2Bz2GE;EACE,4DAAA;EAEA,UxB80B8B;EwB70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;EvBjHA,kBAAA;EFHE,iDyBsHF;A3B02GJ;AE59GM;EyB0GJ;IzBzGM,gBAAA;EF+9GN;AACF;A2B72GI;EACE,4DAAA;A3B+2GN;A2B52GI;EACE,iCxB60B4B;EwBx0B1B,4DAAA;A3B02GR;A2Br2GE;EACE,oBxBwzB8B;EwBvzB9B,eAAA;A3Bu2GJ;A2Br2GI;EACE,oBAAA;EACA,cAAA;A3Bu2GN;;A2Bl2GA;EACE,qBAAA;EACA,kBxBsyBgC;AH+jFlC;;A2Bl2GA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A3Bq2GF;A2Bj2GI;EACE,oBAAA;EACA,YAAA;EACA,axBspBwB;AH6sF9B;;A2B51GI;EACE,4DAAA;A3B+1GN;;A4BlhHA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A5BqhHF;A4BnhHE;EACE,UAAA;A5BqhHJ;A4BjhHI;EAA0B,qEzB8gCa;AHsgF3C;A4BnhHI;EAA0B,qEzB6gCa;AHygF3C;A4BnhHE;EACE,SAAA;A5BqhHJ;A4BlhHE;EACE,WzB+/BuC;EyB9/BvC,YzB8/BuC;EyB7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBzBDQ;E4B6BN,SzB6/BuC;EC1gCvC,mBAAA;EFHE,4G0BmBF;A5BmhHJ;AEliHM;E0BMJ;I1BLM,gBAAA;EFqiHN;AACF;A4BthHI;EHjCF,yBtB8hCyC;AH4hF3C;A4BphHE;EACE,WzBw+B8B;EyBv+B9B,czBw+B8B;EyBv+B9B,kBAAA;EACA,ezBu+B8B;EyBt+B9B,wCzBu+B8B;EyBt+B9B,yBAAA;ExB7BA,mBAAA;AJojHJ;A4BlhHE;EACE,WzBo+BuC;EyBn+BvC,YzBm+BuC;EyBl+BvC,gBAAA;EHpDF,yBzBDQ;E4BuDN,SzBm+BuC;EC1gCvC,mBAAA;EFHE,4G0B6CF;A5BmhHJ;AE5jHM;E0BiCJ;I1BhCM,gBAAA;EF+jHN;AACF;A4BthHI;EH3DF,yBtB8hCyC;AHsjF3C;A4BphHE;EACE,WzB88B8B;EyB78B9B,czB88B8B;EyB78B9B,kBAAA;EACA,ezB68B8B;EyB58B9B,wCzB68B8B;EyB58B9B,yBAAA;ExBvDA,mBAAA;AJ8kHJ;A4BlhHE;EACE,oBAAA;A5BohHJ;A4BlhHI;EACE,2CzBg9BqC;AHokF3C;A4BjhHI;EACE,2CzB48BqC;AHukF3C;;A6B1mHA;EACE,kBAAA;A7B6mHF;A6B3mHE;;;EAGE,uD1BwiCoC;E0BviCpC,2D1BuiCoC;E0BtiCpC,iB1BuiCoC;AHskFxC;A6B1mHE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;E3BRE,gE2BSF;A7B4mHJ;AEjnHM;E2BTJ;I3BUM,gBAAA;EFonHN;AACF;A6B9mHE;;EAEE,kBAAA;A7BgnHJ;A6B9mHI;;EACE,kBAAA;A7BinHN;A6B9mHI;;;EAEE,qB1B4gCkC;E0B3gClC,wB1B4gCkC;AHqmFxC;A6B9mHI;;EACE,qB1BugCkC;E0BtgClC,wB1BugCkC;AH0mFxC;A6B7mHE;EACE,qB1BigCoC;E0BhgCpC,wB1BigCoC;AH8mFxC;A6BxmHI;;;;EACE,2CAAA;EACA,8D1B2/BkC;AHknFxC;A6B3mHM;;;;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,a1Bm/BgC;E0Bl/BhC,WAAA;EACA,mC1Bg0BgC;ECh3BpC,gBAAA;AJiqHJ;A6B1mHI;EACE,2CAAA;EACA,8D1B0+BkC;AHkoFxC;A6BvmHI;EACE,sCAAA;A7BymHN;A6BrmHE;;EAEE,c1B1EO;AHirHX;A6BrmHI;;EACE,wC1B0yBkC;AH8zFxC;;A8B/rHA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A9BksHF;A8BhsHE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A9BksHJ;A8B9rHE;;;EAGE,UAAA;A9BgsHJ;A8B1rHE;EACE,kBAAA;EACA,UAAA;A9B4rHJ;A8B1rHI;EACE,UAAA;A9B4rHN;;A8BjrHA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;ErB8OI,kBALI;EqBvOR,gB3ByjB4B;E2BxjB5B,gB9BkDiB;E8BjDjB,2B3Bm1BsC;E2Bl1BtC,kBAAA;EACA,mBAAA;EACA,uC3B06BsC;E2Bz6BtC,yCAAA;E1BtCE,gBAAA;AJ2tHJ;;A8B3qHA;;;;EAIE,oBAAA;ErB4NM,qCAAA;ELhRJ,gBAAA;AJouHJ;AShnHI;EqBpEJ;;;;IrBuOQ,oBAAA;ETo9GN;AACF;;A8BnrHA;;;;EAIE,uBAAA;ErB+MI,qBALI;ELvQN,gBAAA;AJqvHJ;;A8BnrHA;;EAEE,mBAAA;A9BsrHF;;A8BzqHI;;;;E1BjEA,0BAAA;EACA,6BAAA;AJivHJ;A8BxqHI;;;;E1B1EA,0BAAA;EACA,6BAAA;AJwvHJ;A8BlqHE;EACE,8CAAA;E1B1EA,yBAAA;EACA,4BAAA;AJ+uHJ;A8BlqHE;;E1B9EE,yBAAA;EACA,4BAAA;AJovHJ;;A+B5wHE;EACE,aAAA;EACA,WAAA;EACA,mB5Bu0BoC;EMrkBlC,kBALI;EsB1PN,iC5BkjCqB;AH4tFzB;;A+B3wHE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EtBqPE,qBALI;EsB7ON,W5BqiCqB;E4BpiCrB,mC5BoiCqB;EC/jCrB,sCAAA;AJyyHJ;;A+BzwHI;;;;EAEE,cAAA;A/B8wHN;;A+B7zHI;EAqDE,+C5BuhCmB;E4BphCjB,iC5B81BgC;E4B71BhC,yDAAA;EACA,4BAAA;EACA,wDAAA;EACA,wDAAA;A/B0wHR;A+BvwHM;EACE,+C5B4gCiB;E4BvgCf,2D5BugCe;AH8vFzB;;A+B10HI;EA+EI,iC5Bu0BgC;E4Bt0BhC,4EAAA;A/B+vHR;;A+B/0HI;EAuFE,+C5Bq/BmB;AHuwFzB;A+BzvHQ;EAEE,iEAAA;EACA,qB5Bq5B8B;E4Bp5B9B,yDAAA;EACA,mEAAA;A/B0vHV;A+BtvHM;EACE,+C5Bw+BiB;E4Bn+Bf,2D5Bm+Be;AHixFzB;;A+B71HI;EAkHI,sCAAA;A/B+uHR;;A+Bj2HI;EAyHE,+C5Bm9BmB;AHyxFzB;A+B1uHM;EACE,4C5Bg9BiB;AH4xFzB;A+BzuHM;EACE,2D5B48BiB;AH+xFzB;A+BxuHM;EACE,iC5Bw8BiB;AHkyFzB;;A+BruHI;EACE,kBAAA;A/BwuHN;;A+Bl3HI;;;;;EAoJM,UAAA;A/BsuHV;;A+Bt2HE;EACE,aAAA;EACA,WAAA;EACA,mB5Bu0BoC;EMrkBlC,kBALI;EsB1PN,mC5BkjCqB;AHszFzB;;A+Br2HE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EtBqPE,qBALI;EsB7ON,W5BqiCqB;E4BpiCrB,kC5BoiCqB;EC/jCrB,sCAAA;AJm4HJ;;A+Bn2HI;;;;EAEE,cAAA;A/Bw2HN;;A+Bv5HI;EAqDE,iD5BuhCmB;E4BphCjB,iC5B81BgC;E4B71BhC,0DAAA;EACA,4BAAA;EACA,wDAAA;EACA,wDAAA;A/Bo2HR;A+Bj2HM;EACE,iD5B4gCiB;E4BvgCf,0D5BugCe;AHw1FzB;;A+Bp6HI;EA+EI,iC5Bu0BgC;E4Bt0BhC,4EAAA;A/By1HR;;A+Bz6HI;EAuFE,iD5Bq/BmB;AHi2FzB;A+Bn1HQ;EAEE,kEAAA;EACA,qB5Bq5B8B;E4Bp5B9B,yDAAA;EACA,mEAAA;A/Bo1HV;A+Bh1HM;EACE,iD5Bw+BiB;E4Bn+Bf,0D5Bm+Be;AH22FzB;;A+Bv7HI;EAkHI,sCAAA;A/By0HR;;A+B37HI;EAyHE,iD5Bm9BmB;AHm3FzB;A+Bp0HM;EACE,8C5Bg9BiB;AHs3FzB;A+Bn0HM;EACE,0D5B48BiB;AHy3FzB;A+Bl0HM;EACE,mC5Bw8BiB;AH43FzB;;A+B/zHI;EACE,kBAAA;A/Bk0HN;;A+B58HI;;;;;EAsJM,UAAA;A/B8zHV;;AgCt9HA;EAEE,wBAAA;EACA,wBAAA;EACA,sBAAA;EvBuRI,2BALI;EuBhRR,yBAAA;EACA,yBAAA;EACA,+BAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,4BAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;EvBsQI,kCALI;EuB/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,mEAAA;E5BjBE,0CAAA;EqBfF,kCOkCqB;E9BtBjB,qI8BwBJ;AhCo9HF;AEx+HM;E8BhBN;I9BiBQ,gBAAA;EF2+HN;AACF;AgCv9HE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;AhCw9HJ;AgCr9HE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;AhCs9HJ;AgCn9HE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;AhCi9HN;AgC78HE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;AhC28HN;AgCv8HE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;AhCm8HJ;AgCh8HI;EAKI,0CAAA;AhC87HR;AgCz7HE;EAKI,0CAAA;AhCu7HN;AgCn7HE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;AhCk7HJ;;AgCt6HE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AjCyhIF;;AgCv7HE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AjC0iIF;;AgCx8HE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AjC2jIF;;AgCz9HE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AjC4kIF;;AgC1+HE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AjC6lIF;;AgC3/HE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AjC8mIF;;AgC5gIE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AjC+nIF;;AgC7hIE;EC/GA,oBAAA;EACA,iBAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;AjCgpIF;;AgCphIE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCwoIF;;AgCriIE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCypIF;;AgCtjIE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC0qIF;;AgCvkIE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC2rIF;;AgCxlIE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC4sIF;;AgCzmIE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC6tIF;;AgC1nIE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC8uIF;;AgC3oIE;EChHA,oBAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,kCAAA;EACA,2BAAA;EACA,wBAAA;EACA,kCAAA;EACA,4DAAA;EACA,6BAAA;EACA,iCAAA;EACA,oCAAA;EACA,mBAAA;AjC+vIF;;AgChpIA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,sCAAA;EAEA,0B7B8QwC;AHo4H1C;AgCxoIE;EACE,0BAAA;AhC0oIJ;AgCvoIE;EACE,gCAAA;AhCyoIJ;;AgC9nIA;ECjJE,wBAAA;EACA,wBAAA;ExB8NI,2BALI;EwBvNR,4BAAA;AjCmxIF;;AgCjoIA;ECrJE,wBAAA;EACA,wBAAA;ExB8NI,2BALI;EwBvNR,4BAAA;AjC0xIF;;AkC71IA;EhCgBM,gCgCfJ;AlCg2IF;AE70IM;EgCpBN;IhCqBQ,gBAAA;EFg1IN;AACF;AkCn2IE;EACE,UAAA;AlCq2IJ;;AkC/1IE;EACE,aAAA;AlCk2IJ;;AkC91IA;EACE,SAAA;EACA,gBAAA;EhCDI,6BgCEJ;AlCi2IF;AE/1IM;EgCLN;IhCMQ,gBAAA;EFk2IN;AACF;AkCp2IE;EACE,QAAA;EACA,YAAA;EhCNE,4BgCOF;AlCs2IJ;AEz2IM;EgCAJ;IhCCM,gBAAA;EF42IN;AACF;;AmCj4IA;;;;;;EAME,kBAAA;AnCo4IF;;AmCj4IA;EACE,mBAAA;AnCo4IF;AoC52II;EACE,qBAAA;EACA,oBjC6hBwB;EiC5hBxB,uBjC2hBwB;EiC1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;ApCo5IF;AoC11II;EACE,cAAA;ApC41IN;;AmC14IA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E1BuQI,gCALI;E0BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E1B0OI,uCALI;E0BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E/BzCE,+CAAA;AJo7IJ;AmCv4IE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AnCy4IJ;;AmCj3II;EACE,oBAAA;AnCo3IN;AmCl3IM;EACE,WAAA;EACA,OAAA;AnCo3IR;;AmCh3II;EACE,kBAAA;AnCm3IN;AmCj3IM;EACE,QAAA;EACA,UAAA;AnCm3IR;;AM75II;E6B4BA;IACE,oBAAA;EnCq4IJ;EmCn4II;IACE,WAAA;IACA,OAAA;EnCq4IN;EmCj4IE;IACE,kBAAA;EnCm4IJ;EmCj4II;IACE,QAAA;IACA,UAAA;EnCm4IN;AACF;AM96II;E6B4BA;IACE,oBAAA;EnCq5IJ;EmCn5II;IACE,WAAA;IACA,OAAA;EnCq5IN;EmCj5IE;IACE,kBAAA;EnCm5IJ;EmCj5II;IACE,QAAA;IACA,UAAA;EnCm5IN;AACF;AM97II;E6B4BA;IACE,oBAAA;EnCq6IJ;EmCn6II;IACE,WAAA;IACA,OAAA;EnCq6IN;EmCj6IE;IACE,kBAAA;EnCm6IJ;EmCj6II;IACE,QAAA;IACA,UAAA;EnCm6IN;AACF;AM98II;E6B4BA;IACE,oBAAA;EnCq7IJ;EmCn7II;IACE,WAAA;IACA,OAAA;EnCq7IN;EmCj7IE;IACE,kBAAA;EnCm7IJ;EmCj7II;IACE,QAAA;IACA,UAAA;EnCm7IN;AACF;AM99II;E6B4BA;IACE,oBAAA;EnCq8IJ;EmCn8II;IACE,WAAA;IACA,OAAA;EnCq8IN;EmCj8IE;IACE,kBAAA;EnCm8IJ;EmCj8II;IACE,QAAA;IACA,UAAA;EnCm8IN;AACF;AM9+II;E6B4BA;IACE,oBAAA;EnCq9IJ;EmCn9II;IACE,WAAA;IACA,OAAA;EnCq9IN;EmCj9IE;IACE,kBAAA;EnCm9IJ;EmCj9II;IACE,QAAA;IACA,UAAA;EnCm9IN;AACF;AM9/II;E6B4BA;IACE,oBAAA;EnCq+IJ;EmCn+II;IACE,WAAA;IACA,OAAA;EnCq+IN;EmCj+IE;IACE,kBAAA;EnCm+IJ;EmCj+II;IACE,QAAA;IACA,UAAA;EnCm+IN;AACF;AM9gJI;E6B4BA;IACE,oBAAA;EnCq/IJ;EmCn/II;IACE,WAAA;IACA,OAAA;EnCq/IN;EmCj/IE;IACE,kBAAA;EnCm/IJ;EmCj/II;IACE,QAAA;IACA,UAAA;EnCm/IN;AACF;AmC1+IE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AnC4+IJ;AoChkJI;EACE,qBAAA;EACA,oBjC6hBwB;EiC5hBxB,uBjC2hBwB;EiC1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;ApCimJF;AoC9iJI;EACE,cAAA;ApCgjJN;;AmCh/IE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AnCm/IJ;AoCrlJI;EACE,qBAAA;EACA,oBjC6hBwB;EiC5hBxB,uBjC2hBwB;EiC1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;ApC+mJF;AoCnkJI;EACE,cAAA;ApCqkJN;AmC3/II;EACE,iBAAA;AnC6/IN;;AmCv/IE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AnC0/IJ;AoC7mJI;EACE,qBAAA;EACA,oBjC6hBwB;EiC5hBxB,uBjC2hBwB;EiC1hBxB,WAAA;ApC+mJN;AoCpmJM;EACE,aAAA;ApCsmJR;AoCnmJM;EACE,qBAAA;EACA,qBjC0gBsB;EiCzgBtB,uBjCwgBsB;EiCvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;ApCyoJF;AoCnmJI;EACE,cAAA;ApCqmJN;AmC1gJI;EACE,iBAAA;AnC4gJN;;AmCrgJA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AnCwgJF;;AmClgJA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gBhCyb4B;EgCxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E/BtKE,uDAAA;AJ4qJJ;AmCngJE;EAEE,0CAAA;EV1LF,kDU4LuB;AnCmgJzB;AmChgJE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AnCigJzB;AmC9/IE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AnC+/IJ;;AmCz/IA;EACE,cAAA;AnC4/IF;;AmCx/IA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E1BmEI,qBALI;E0B5DR,sCAAA;EACA,mBAAA;AnC2/IF;;AmCv/IA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AnC0/IF;;AmCt/IA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AnCw/IF;;AqC9uJA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ArCivJF;AqC/uJE;;EACE,kBAAA;EACA,cAAA;ArCkvJJ;AqC7uJE;;;;;;;;;;;;EAME,UAAA;ArCqvJJ;;AqChvJA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ArCmvJF;AqCjvJE;EACE,WAAA;ArCmvJJ;;AqC/uJA;EjChBI,mBAAA;AJmwJJ;AqC/uJE;;EAEE,8CAAA;ArCivJJ;AqC7uJE;;;EjCVE,0BAAA;EACA,6BAAA;AJ4vJJ;AqCzuJE;;;EjCNE,yBAAA;EACA,4BAAA;AJovJJ;;AqC5tJA;EACE,qBAAA;EACA,oBAAA;ArC+tJF;AqC7tJE;EAGE,cAAA;ArC6tJJ;AqC1tJE;EACE,eAAA;ArC4tJJ;;AqCxtJA;EACE,qBAAA;EACA,oBAAA;ArC2tJF;;AqCxtJA;EACE,qBAAA;EACA,oBAAA;ArC2tJF;;AqCvsJA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ArC0sJF;AqCxsJE;;EAEE,WAAA;ArC0sJJ;AqCvsJE;;EAEE,6CAAA;ArCysJJ;AqCrsJE;;EjC1FE,6BAAA;EACA,4BAAA;AJmyJJ;AqCrsJE;;EjC7GE,yBAAA;EACA,0BAAA;AJszJJ;;AsC90JA;EAEE,6BAAA;EACA,+BAAA;E7BuRI,gCALI;E6BhRR,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AtC80JF;;AsC30JA;EACE,cAAA;EACA,kEAAA;E7BsQI,uCALI;E6B/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EpCfI,uGoCgBJ;AtC80JF;AE11JM;EoCGN;IpCFQ,gBAAA;EF61JN;AACF;AsCj1JE;EAEE,qCAAA;AtCk1JJ;AsC90JE;EACE,UAAA;EACA,kDnCkhBoB;AH8zIxB;AsC50JE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;AtC60JJ;;AsCr0JA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;AtCq0JF;AsCn0JE;EACE,yDAAA;EACA,yDAAA;ElC7CA,wDAAA;EACA,yDAAA;AJm3JJ;AsCp0JI;EAGE,kBAAA;EACA,wDAAA;AtCo0JN;AsCh0JE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AtCk0JJ;AsC/zJE;EAEE,sDAAA;ElCjEA,yBAAA;EACA,0BAAA;AJk4JJ;;AsCvzJA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;AtCyzJF;AsCtzJE;ElC5FE,gDAAA;AJq5JJ;AsCrzJE;;EAEE,4CAAA;EbjHF,oDakHuB;AtCuzJzB;;AsC9yJA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;AtC8yJF;AsC5yJE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;AtC8yJJ;AsC5yJI;EAEE,iCAAA;AtC6yJN;AsCzyJE;;EAEE,gBnC0d0B;EmCzd1B,gDAAA;EACA,iCAAA;AtC2yJJ;;AsCjyJE;;EAEE,cAAA;EACA,kBAAA;AtCoyJJ;;AsC/xJE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AtCkyJJ;;AsC5xJE;;EACE,WAAA;AtCgyJJ;;AsCtxJE;EACE,aAAA;AtCyxJJ;AsCvxJE;EACE,cAAA;AtCyxJJ;;AuCt9JA;EAEE,wBAAA;EACA,2BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,wCAAA;EACA,kCAAA;EACA,sCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,wCAAA;EACA,qEAAA;EACA,0EAAA;EACA,sCAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AvCs9JF;AuCh9JE;;;;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AvC29JJ;AuCv8JA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;E9B4NI,2CALI;E8BrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;AvCy8JF;AuCv8JE;EAEE,yCAAA;AvCw8JJ;;AuC97JA;EAEE,0BAAA;EACA,+BAAA;E9BuMI,gCALI;E8BhMR,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AvC87JF;AuC37JI;EAEE,oCAAA;AvC47JN;AuCx7JE;EACE,gBAAA;AvC07JJ;;AuCj7JA;EACE,mBpC8gCkC;EoC7gClC,sBpC6gCkC;EoC5gClC,6BAAA;AvCo7JF;AuCl7JE;;;EAGE,oCAAA;AvCo7JJ;;AuCv6JA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AvCw6JF;;AuCp6JA;EACE,8EAAA;E9ByII,6CALI;E8BlIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;EnCxIE,qDAAA;EFHE,+CqC6IJ;AvCu6JF;AEhjKM;EqCiIN;IrChIQ,gBAAA;EFmjKN;AACF;AuC16JE;EACE,qBAAA;AvC46JJ;AuCz6JE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AvC26JJ;;AuCr6JA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AvCw6JF;;AuCr6JA;EACE,yCAAA;EACA,gBAAA;AvCw6JF;;AMliKI;EiCsIA;IAEI,iBAAA;IACA,2BAAA;EvC+5JN;EuC75JM;IACE,mBAAA;EvC+5JR;EuC75JQ;IACE,kBAAA;EvC+5JV;EuC55JQ;IACE,kDAAA;IACA,iDAAA;EvC85JV;EuC15JM;IACE,iBAAA;EvC45JR;EuCz5JM;IACE,wBAAA;IACA,gBAAA;EvC25JR;EuCx5JM;IACE,aAAA;EvC05JR;EuCv5JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IrC9NJ,gBqCgOI;EvCu5JR;EuCp5JQ;IACE,aAAA;EvCs5JV;EuCn5JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCq5JV;AACF;AMllKI;EiCsIA;IAEI,iBAAA;IACA,2BAAA;EvC88JN;EuC58JM;IACE,mBAAA;EvC88JR;EuC58JQ;IACE,kBAAA;EvC88JV;EuC38JQ;IACE,kDAAA;IACA,iDAAA;EvC68JV;EuCz8JM;IACE,iBAAA;EvC28JR;EuCx8JM;IACE,wBAAA;IACA,gBAAA;EvC08JR;EuCv8JM;IACE,aAAA;EvCy8JR;EuCt8JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IrC9NJ,gBqCgOI;EvCs8JR;EuCn8JQ;IACE,aAAA;EvCq8JV;EuCl8JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCo8JV;AACF;AMjoKI;EiCsIA;IAEI,iBAAA;IACA,2BAAA;EvC6/JN;EuC3/JM;IACE,mBAAA;EvC6/JR;EuC3/JQ;IACE,kBAAA;EvC6/JV;EuC1/JQ;IACE,kDAAA;IACA,iDAAA;EvC4/JV;EuCx/JM;IACE,iBAAA;EvC0/JR;EuCv/JM;IACE,wBAAA;IACA,gBAAA;EvCy/JR;EuCt/JM;IACE,aAAA;EvCw/JR;EuCr/JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IrC9NJ,gBqCgOI;EvCq/JR;EuCl/JQ;IACE,aAAA;EvCo/JV;EuCj/JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCm/JV;AACF;AMhrKI;EiCsIA;IAEI,iBAAA;IACA,2BAAA;EvC4iKN;EuC1iKM;IACE,mBAAA;EvC4iKR;EuC1iKQ;IACE,kBAAA;EvC4iKV;EuCziKQ;IACE,kDAAA;IACA,iDAAA;EvC2iKV;EuCviKM;IACE,iBAAA;EvCyiKR;EuCtiKM;IACE,wBAAA;IACA,gBAAA;EvCwiKR;EuCriKM;IACE,aAAA;EvCuiKR;EuCpiKM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IrC9NJ,gBqCgOI;EvCoiKR;EuCjiKQ;IACE,aAAA;EvCmiKV;EuChiKQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCkiKV;AACF;AM/tKI;EiCsIA;IAEI,iBAAA;IACA,2BAAA;EvC2lKN;EuCzlKM;IACE,mBAAA;EvC2lKR;EuCzlKQ;IACE,kBAAA;EvC2lKV;EuCxlKQ;IACE,kDAAA;IACA,iDAAA;EvC0lKV;EuCtlKM;IACE,iBAAA;EvCwlKR;EuCrlKM;IACE,wBAAA;IACA,gBAAA;EvCulKR;EuCplKM;IACE,aAAA;EvCslKR;EuCnlKM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IrC9NJ,gBqCgOI;EvCmlKR;EuChlKQ;IACE,aAAA;EvCklKV;EuC/kKQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCilKV;AACF;AM9wKI;EiCsIA;IAEI,iBAAA;IACA,2BAAA;EvC0oKN;EuCxoKM;IACE,mBAAA;EvC0oKR;EuCxoKQ;IACE,kBAAA;EvC0oKV;EuCvoKQ;IACE,kDAAA;IACA,iDAAA;EvCyoKV;EuCroKM;IACE,iBAAA;EvCuoKR;EuCpoKM;IACE,wBAAA;IACA,gBAAA;EvCsoKR;EuCnoKM;IACE,aAAA;EvCqoKR;EuCloKM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IrC9NJ,gBqCgOI;EvCkoKR;EuC/nKQ;IACE,aAAA;EvCioKV;EuC9nKQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCgoKV;AACF;AM7zKI;EiCsIA;IAEI,iBAAA;IACA,2BAAA;EvCyrKN;EuCvrKM;IACE,mBAAA;EvCyrKR;EuCvrKQ;IACE,kBAAA;EvCyrKV;EuCtrKQ;IACE,kDAAA;IACA,iDAAA;EvCwrKV;EuCprKM;IACE,iBAAA;EvCsrKR;EuCnrKM;IACE,wBAAA;IACA,gBAAA;EvCqrKR;EuClrKM;IACE,aAAA;EvCorKR;EuCjrKM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IrC9NJ,gBqCgOI;EvCirKR;EuC9qKQ;IACE,aAAA;EvCgrKV;EuC7qKQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvC+qKV;AACF;AM52KI;EiCsIA;IAEI,iBAAA;IACA,2BAAA;EvCwuKN;EuCtuKM;IACE,mBAAA;EvCwuKR;EuCtuKQ;IACE,kBAAA;EvCwuKV;EuCruKQ;IACE,kDAAA;IACA,iDAAA;EvCuuKV;EuCnuKM;IACE,iBAAA;EvCquKR;EuCluKM;IACE,wBAAA;IACA,gBAAA;EvCouKR;EuCjuKM;IACE,aAAA;EvCmuKR;EuChuKM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IrC9NJ,gBqCgOI;EvCguKR;EuC7tKQ;IACE,aAAA;EvC+tKV;EuC5tKQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvC8tKV;AACF;AuCrxKI;EAEI,iBAAA;EACA,2BAAA;AvCsxKR;AuCpxKQ;EACE,mBAAA;AvCsxKV;AuCpxKU;EACE,kBAAA;AvCsxKZ;AuCnxKU;EACE,kDAAA;EACA,iDAAA;AvCqxKZ;AuCjxKQ;EACE,iBAAA;AvCmxKV;AuChxKQ;EACE,wBAAA;EACA,gBAAA;AvCkxKV;AuC/wKQ;EACE,aAAA;AvCixKV;AuC9wKQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;ErC9NJ,gBqCgOI;AvC8wKV;AuC3wKU;EACE,aAAA;AvC6wKZ;AuC1wKU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AvC4wKZ;;AuC3vKA;;EAGE,uBAAA;EACA,gCAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;AvC6vKF;;AuCvvKI;EACE,qEAAA;AvC0vKN;;AwCnhLA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;EpCjBE,2CAAA;AJqiLJ;AwChhLE;EACE,eAAA;EACA,cAAA;AxCkhLJ;AwC/gLE;EACE,mBAAA;EACA,sBAAA;AxCihLJ;AwC/gLI;EACE,mBAAA;EpCtBF,0DAAA;EACA,2DAAA;AJwiLJ;AwC/gLI;EACE,sBAAA;EpCbF,8DAAA;EACA,6DAAA;AJ+hLJ;AwC5gLE;;EAEE,aAAA;AxC8gLJ;;AwC1gLA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AxC2gLF;;AwCxgLA;EACE,4CAAA;EACA,iCAAA;AxC2gLF;;AwCxgLA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AxC2gLF;;AwCxgLA;EACE,gBAAA;AxC2gLF;;AwCngLE;EACE,oCAAA;AxCsgLJ;;AwC9/KA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AxCigLF;AwC//KE;EpC7FE,wFAAA;AJ+lLJ;;AwC7/KA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AxCggLF;AwC9/KE;EpCxGE,wFAAA;AJymLJ;;AwCv/KA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AxC0/KF;AwCx/KE;EACE,mCAAA;EACA,sCAAA;AxC0/KJ;;AwCt/KA;EACE,uDAAA;EACA,sDAAA;AxCy/KF;;AwCr/KA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;EpC1IE,iDAAA;AJmoLJ;;AwCr/KA;;;EAGE,WAAA;AxCw/KF;;AwCr/KA;;EpC3II,0DAAA;EACA,2DAAA;AJqoLJ;;AwCt/KA;;EpClII,8DAAA;EACA,6DAAA;AJ6nLJ;;AwC/+KE;EACE,0CAAA;AxCk/KJ;AM7mLI;EkCuHJ;IAQI,aAAA;IACA,mBAAA;ExCk/KF;EwC/+KE;IAEE,YAAA;IACA,gBAAA;ExCg/KJ;EwC9+KI;IACE,cAAA;IACA,cAAA;ExCg/KN;EwC3+KM;IpC3KJ,0BAAA;IACA,6BAAA;EJypLF;EwC5+KQ;;IAGE,0BAAA;ExC6+KV;EwC3+KQ;;IAGE,6BAAA;ExC4+KV;EwCx+KM;IpC5KJ,yBAAA;IACA,4BAAA;EJupLF;EwCz+KQ;;IAGE,yBAAA;ExC0+KV;EwCx+KQ;;IAGE,4BAAA;ExCy+KV;AACF;;AyC9sLA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AzCgtLF;;AyC5sLA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EhC4PI,kBALI;EgCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;ErCrBE,gBAAA;EqCuBF,qBAAA;EvC1BI,0CuC2BJ;AzC+sLF;AEtuLM;EuCUN;IvCTQ,gBAAA;EFyuLN;AACF;AyCltLE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AzCotLJ;AyCltLI;EACE,qDAAA;EACA,iDAAA;AzCotLN;AyC/sLE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EvCjDE,mDuCkDF;AzCitLJ;AE/vLM;EuCqCJ;IvCpCM,gBAAA;EFkwLN;AACF;AyCntLE;EACE,UAAA;AzCqtLJ;AyCltLE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AzCotLJ;;AyChtLA;EACE,gBAAA;AzCmtLF;;AyChtLA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AzCmtLF;AyCjtLE;ErC7DE,yDAAA;EACA,0DAAA;AJixLJ;AyCltLI;ErChEA,+DAAA;EACA,gEAAA;AJqxLJ;AyCjtLE;EACE,aAAA;AzCmtLJ;AyC/sLE;ErC5DE,6DAAA;EACA,4DAAA;AJ8wLJ;AyC/sLM;ErChEF,mEAAA;EACA,kEAAA;AJkxLJ;AyC9sLI;ErCrEA,6DAAA;EACA,4DAAA;AJsxLJ;;AyC5sLA;EACE,8EAAA;AzC+sLF;;AyCtsLE;EACE,eAAA;EACA,cAAA;ErC9GA,gBAAA;AJwzLJ;AyCvsLI;EAAgB,aAAA;AzC0sLpB;AyCzsLI;EAAe,gBAAA;AzC4sLnB;AyCxsLM;ErCtHF,gBAAA;AJi0LJ;AyCpsLI;ErC7HA,gBAAA;AJo0LJ;;AyC/rLI;EACE,iEAAA;EACA,wEAAA;AzCksLN;;A0C51LA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EjC+QI,yCALI;EiCxQR,gBAAA;EACA,yCAAA;EtCAE,iDAAA;AJ41LJ;;A0Ct1LE;EACE,iDAAA;A1Cy1LJ;A0Cv1LI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;A1Cy1LN;A0Cr1LE;EACE,6CAAA;A1Cu1LJ;;A2C53LA;EAEE,kCAAA;EACA,mCAAA;ElC4RI,kCALI;EkCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;E9BpBA,eAAA;EACA,gBAAA;Abi5LF;;A2C13LA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;ElCgQI,yCALI;EkCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EzCpBI,qIyCqBJ;A3C63LF;AE94LM;EyCQN;IzCPQ,gBAAA;EFi5LN;AACF;A2Ch4LE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A3Ci4LJ;A2C93LE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UxC2uCgC;EwC1uChC,iDAAA;A3Cg4LJ;A2C73LE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A3C83LJ;A2C33LE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A3C43LJ;;A2Cv3LE;EACE,8CxC8sCgC;AH4qJpC;A2Cr3LM;EvC9BF,0DAAA;EACA,6DAAA;AJs5LJ;A2Cn3LM;EvClDF,2DAAA;EACA,8DAAA;AJw6LJ;;A2Ct2LA;EClGE,iCAAA;EACA,kCAAA;EnC8RM,qDAAA;EmC5RN,yDAAA;A5C48LF;AS50LI;EkCjCJ;IlCoMQ,oCAAA;ET6qLN;AACF;;A2C92LA;ECtGE,iCAAA;EACA,kCAAA;EnC0RI,qCALI;EmCnRR,yDAAA;A5Cw9LF;;A6C19LA;EAEE,4BAAA;EACA,4BAAA;EpCuRI,4BALI;EoChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;EpC+QI,oCALI;EoCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EzCJE,4CAAA;AJ+9LJ;A6Ct9LE;EACE,aAAA;A7Cw9LJ;;A6Cn9LA;EACE,kBAAA;EACA,SAAA;A7Cs9LF;;A8Ct/LA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;E1CHE,4CAAA;AJ0/LJ;;A8Cl/LA;EAEE,cAAA;A9Co/LF;;A8Ch/LA;EACE,gB3C6kB4B;E2C5kB5B,iCAAA;A9Cm/LF;;A8C3+LA;EACE,mB3Cs+C8B;AHwgJhC;A8C3+LE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A9C6+LJ;;A8Cr+LE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9Cw+LJ;;A8C5+LE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A9C++LJ;;A8Cn/LE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9Cs/LJ;;A8C1/LE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9C6/LJ;;A8CjgME;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9CogMJ;;A8CxgME;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A9C2gMJ;;A8C/gME;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9CkhMJ;;A8CthME;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9CyhMJ;;A+CrlME;EACE;IAAK,2B5CyhD2B;EHgkJlC;AACF;A+CrlMA;;EAGE,0BAAA;EtCkRI,kCALI;EsC3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;EtCsQI,uCALI;EsC/PR,uCAAA;E3CRE,+CAAA;AJ6lMJ;;A+ChlMA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;E7CxBI,6C6CyBJ;A/CmlMF;AExmMM;E6CYN;I7CXQ,gBAAA;EF2mMN;AACF;;A+CrlMA;EtBAE,qMAAA;EsBEA,oEAAA;A/CwlMF;;A+CrlMA;EACE,iBAAA;A/CwlMF;;A+CrlMA;EACE,WAAA;A/CwlMF;;A+CplME;EACE,kDAAA;A/CulMJ;A+CplMM;EAJJ;IAKM,eAAA;E/CulMN;AACF;;AgDnpMA;EAEE,2CAAA;EACA,2BAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,oCAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;E5CXE,iDAAA;AJ6pMJ;;AgD9oMA;EACE,qBAAA;EACA,sBAAA;AhDipMF;AgD/oME;EAEE,oCAAA;EACA,0BAAA;AhDgpMJ;;AgDvoMA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;AhD0oMF;AgDvoME;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;AhDwoMJ;AgDroME;EACE,+CAAA;EACA,uDAAA;AhDuoMJ;;AgD/nMA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;AhDkoMF;AgDhoME;E5CvDE,+BAAA;EACA,gCAAA;AJ0rMJ;AgDhoME;E5C7CE,mCAAA;EACA,kCAAA;AJgrMJ;AgDhoME;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;AhDioMJ;AgD7nME;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AhD+nMJ;AgD3nME;EACE,mBAAA;AhD6nMJ;AgD3nMI;EACE,wDAAA;EACA,mDAAA;AhD6nMN;;AgDhnMI;EACE,mBAAA;AhDmnMN;AgDhnMQ;E5CvDJ,6DAAA;EAZA,0BAAA;AJurMJ;AgD/mMQ;E5CxEJ,2DAAA;EAYA,4BAAA;AJ+qMJ;AgD9mMQ;EACE,aAAA;AhDgnMV;AgD7mMQ;EACE,mDAAA;EACA,oBAAA;AhD+mMV;AgD7mMU;EACE,yDAAA;EACA,oDAAA;AhD+mMZ;;AMrsMI;E0C8DA;IACE,mBAAA;EhD2oMJ;EgDxoMM;I5CvDJ,6DAAA;IAZA,0BAAA;EJ+sMF;EgDvoMM;I5CxEJ,2DAAA;IAYA,4BAAA;EJusMF;EgDtoMM;IACE,aAAA;EhDwoMR;EgDroMM;IACE,mDAAA;IACA,oBAAA;EhDuoMR;EgDroMQ;IACE,yDAAA;IACA,oDAAA;EhDuoMV;AACF;AM9tMI;E0C8DA;IACE,mBAAA;EhDmqMJ;EgDhqMM;I5CvDJ,6DAAA;IAZA,0BAAA;EJuuMF;EgD/pMM;I5CxEJ,2DAAA;IAYA,4BAAA;EJ+tMF;EgD9pMM;IACE,aAAA;EhDgqMR;EgD7pMM;IACE,mDAAA;IACA,oBAAA;EhD+pMR;EgD7pMQ;IACE,yDAAA;IACA,oDAAA;EhD+pMV;AACF;AMtvMI;E0C8DA;IACE,mBAAA;EhD2rMJ;EgDxrMM;I5CvDJ,6DAAA;IAZA,0BAAA;EJ+vMF;EgDvrMM;I5CxEJ,2DAAA;IAYA,4BAAA;EJuvMF;EgDtrMM;IACE,aAAA;EhDwrMR;EgDrrMM;IACE,mDAAA;IACA,oBAAA;EhDurMR;EgDrrMQ;IACE,yDAAA;IACA,oDAAA;EhDurMV;AACF;AM9wMI;E0C8DA;IACE,mBAAA;EhDmtMJ;EgDhtMM;I5CvDJ,6DAAA;IAZA,0BAAA;EJuxMF;EgD/sMM;I5CxEJ,2DAAA;IAYA,4BAAA;EJ+wMF;EgD9sMM;IACE,aAAA;EhDgtMR;EgD7sMM;IACE,mDAAA;IACA,oBAAA;EhD+sMR;EgD7sMQ;IACE,yDAAA;IACA,oDAAA;EhD+sMV;AACF;AMtyMI;E0C8DA;IACE,mBAAA;EhD2uMJ;EgDxuMM;I5CvDJ,6DAAA;IAZA,0BAAA;EJ+yMF;EgDvuMM;I5CxEJ,2DAAA;IAYA,4BAAA;EJuyMF;EgDtuMM;IACE,aAAA;EhDwuMR;EgDruMM;IACE,mDAAA;IACA,oBAAA;EhDuuMR;EgDruMQ;IACE,yDAAA;IACA,oDAAA;EhDuuMV;AACF;AM9zMI;E0C8DA;IACE,mBAAA;EhDmwMJ;EgDhwMM;I5CvDJ,6DAAA;IAZA,0BAAA;EJu0MF;EgD/vMM;I5CxEJ,2DAAA;IAYA,4BAAA;EJ+zMF;EgD9vMM;IACE,aAAA;EhDgwMR;EgD7vMM;IACE,mDAAA;IACA,oBAAA;EhD+vMR;EgD7vMQ;IACE,yDAAA;IACA,oDAAA;EhD+vMV;AACF;AMt1MI;E0C8DA;IACE,mBAAA;EhD2xMJ;EgDxxMM;I5CvDJ,6DAAA;IAZA,0BAAA;EJ+1MF;EgDvxMM;I5CxEJ,2DAAA;IAYA,4BAAA;EJu1MF;EgDtxMM;IACE,aAAA;EhDwxMR;EgDrxMM;IACE,mDAAA;IACA,oBAAA;EhDuxMR;EgDrxMQ;IACE,yDAAA;IACA,oDAAA;EhDuxMV;AACF;AM92MI;E0C8DA;IACE,mBAAA;EhDmzMJ;EgDhzMM;I5CvDJ,6DAAA;IAZA,0BAAA;EJu3MF;EgD/yMM;I5CxEJ,2DAAA;IAYA,4BAAA;EJ+2MF;EgD9yMM;IACE,aAAA;EhDgzMR;EgD7yMM;IACE,mDAAA;IACA,oBAAA;EhD+yMR;EgD7yMQ;IACE,yDAAA;IACA,oDAAA;EhD+yMV;AACF;AgDlyMA;E5ChJI,gBAAA;AJq7MJ;AgDlyME;EACE,mDAAA;AhDoyMJ;AgDlyMI;EACE,sBAAA;AhDoyMN;;AgDvxME;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhD0xMJ;;AgDpyME;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;AhDuyMJ;;AgDjzME;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhDozMJ;;AgD9zME;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhDi0MJ;;AgD30ME;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhD80MJ;;AgDx1ME;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AhD21MJ;;AgDr2ME;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhDw2MJ;;AgDl3ME;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhDq3MJ;;AiDjjNA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,U9CqpD2B;E8CppD3B,W9CopD2B;E8CnpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;E7CJE,uBAAA;E6CMF,oCAAA;AjDijNF;AiD9iNE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AjDgjNJ;AiD7iNE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AjD+iNJ;AiD5iNE;EAEE,oBAAA;EACA,iBAAA;EACA,6CAAA;AjD6iNJ;;AiDriNA;EAHE,wCAAA;AjD4iNF;;AiDniNI;EATF,wCAAA;AjDgjNF;;AkDjmNA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;EzCyRI,8BALI;EyClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;EzC2QI,oCALI;EyCpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;E9CRE,4CAAA;AJ0mNJ;AkD/lNE;EACE,UAAA;AlDimNJ;AkD9lNE;EACE,aAAA;AlDgmNJ;;AkD5lNA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AlD8lNF;AkD5lNE;EACE,sCAAA;AlD8lNJ;;AkD1lNA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;E9ChCE,0FAAA;EACA,2FAAA;AJ8nNJ;AkD5lNE;EACE,oDAAA;EACA,sCAAA;AlD8lNJ;;AkD1lNA;EACE,kCAAA;EACA,qBAAA;AlD6lNF;;AC3pNA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;ADypNF;;AClpNA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;ADopNF;ACjpNE;EC5CI,mCD6CF;EACA,8BEk8CgC;AHitKpC;AE7rNM;EDwCJ;ICvCM,gBAAA;EFgsNN;AACF;ACtpNE;EACE,eEg8CgC;AHwtKpC;ACppNE;EACE,sBE67CgC;AHytKpC;;AClpNA;EACE,+CAAA;ADqpNF;ACnpNE;EACE,gBAAA;EACA,gBAAA;ADqpNJ;AClpNE;EACE,gBAAA;ADopNJ;;AChpNA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;ADmpNF;;AC/oNA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EGrFE,4CAAA;EHyFF,UAAA;AD+oNF;;AC3oNA;EAEE,0BAAA;EACA,yBAAA;EACA,0BAAA;EIlHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCJkH0B;EIjH1B,YAAA;EACA,aAAA;EACA,uCJ+G4D;ADipN9D;AK7vNE;EAAS,UAAA;ALgwNX;AK/vNE;EAAS,mCJ2GiF;ADupN5F;;AClpNA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;EGrGE,2DAAA;EACA,4DAAA;AJ2vNJ;ACppNE;EACE,kGAAA;EACA,sJAAA;ADspNJ;;ACjpNA;EACE,gBAAA;EACA,8CAAA;ADopNF;;AC/oNA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;ADgpNF;;AC5oNA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;EGzHE,+DAAA;EACA,8DAAA;AJywNJ;AC3oNE;EACE,8CAAA;AD6oNJ;;AMxvNI;ELiHF;IACE,0BAAA;IACA,2CAAA;ED2oNF;ECvoNA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EDyoNF;ECtoNA;IACE,uBAAA;EDwoNF;AACF;AMvwNI;ELmIF;;IAEE,uBAAA;EDuoNF;AACF;AM7wNI;EL0IF;IACE,wBAAA;EDsoNF;AACF;AC7nNI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AD+nNN;AC7nNM;EACE,YAAA;EACA,SAAA;EGzMJ,gBAAA;AJy0NJ;AC5nNM;;EG7MF,gBAAA;AJ60NJ;AC3nNM;EACE,gBAAA;AD6nNR;;AMvxNI;ELwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EDmpNJ;ECjpNI;IACE,YAAA;IACA,SAAA;IGzMJ,gBAAA;EJ61NF;EChpNI;;IG7MF,gBAAA;EJi2NF;EC/oNI;IACE,gBAAA;EDipNN;AACF;AM5yNI;ELwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EDuqNJ;ECrqNI;IACE,YAAA;IACA,SAAA;IGzMJ,gBAAA;EJi3NF;ECpqNI;;IG7MF,gBAAA;EJq3NF;ECnqNI;IACE,gBAAA;EDqqNN;AACF;AMh0NI;ELwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ED2rNJ;ECzrNI;IACE,YAAA;IACA,SAAA;IGzMJ,gBAAA;EJq4NF;ECxrNI;;IG7MF,gBAAA;EJy4NF;ECvrNI;IACE,gBAAA;EDyrNN;AACF;AMp1NI;ELwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ED+sNJ;EC7sNI;IACE,YAAA;IACA,SAAA;IGzMJ,gBAAA;EJy5NF;EC5sNI;;IG7MF,gBAAA;EJ65NF;EC3sNI;IACE,gBAAA;ED6sNN;AACF;AMx2NI;ELwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EDmuNJ;ECjuNI;IACE,YAAA;IACA,SAAA;IGzMJ,gBAAA;EJ66NF;EChuNI;;IG7MF,gBAAA;EJi7NF;EC/tNI;IACE,gBAAA;EDiuNN;AACF;AM53NI;ELwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EDuvNJ;ECrvNI;IACE,YAAA;IACA,SAAA;IGzMJ,gBAAA;EJi8NF;ECpvNI;;IG7MF,gBAAA;EJq8NF;ECnvNI;IACE,gBAAA;EDqvNN;AACF;AMh5NI;ELwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ED2wNJ;ECzwNI;IACE,YAAA;IACA,SAAA;IGzMJ,gBAAA;EJq9NF;ECxwNI;;IG7MF,gBAAA;EJy9NF;ECvwNI;IACE,gBAAA;EDywNN;AACF;AMp6NI;ELwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ED+xNJ;EC7xNI;IACE,YAAA;IACA,SAAA;IGzMJ,gBAAA;EJy+NF;EC5xNI;;IG7MF,gBAAA;EJ6+NF;EC3xNI;IACE,gBAAA;ED6xNN;AACF;AmDngOA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;E1CwRI,kCALI;E0CjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sCjD+lB4B;EiD7lB5B,kBAAA;EACA,gBjDwmB4B;EiDvmB5B,gBpDiGiB;EoDhGjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E3CgRI,sCALI;E0ChQR,qBAAA;EACA,UAAA;AnD2gOF;AmDzgOE;EAAS,kCAAA;AnD4gOX;AmD1gOE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AnD4gOJ;AmD1gOI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnD4gON;;AmDvgOA;EACE,iDAAA;AnD0gOF;AmDxgOE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AnD0gOJ;;AmDtgOA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AnDygOF;AmDvgOE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AnDygOJ;;AmDrgOA,mBAAA;AAEA;EACE,8CAAA;AnDugOF;AmDrgOE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AnDugOJ;;AmDngOA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AnDsgOF;AmDpgOE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AnDsgOJ;;AmDlgOA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E/CjGE,8CAAA;AJslOJ;;AqDzmOA;EAEE,yBAAA;EACA,6BAAA;E5C4RI,kCALI;E4CrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;E5CmRI,sCALI;E4C5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sCjD+lB4B;EiD7lB5B,kBAAA;EACA,gBjDwmB4B;EiDvmB5B,gBpDiGiB;EoDhGjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E3CgRI,sCALI;E4C1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;EjDhBE,8CAAA;AJooOJ;AqDhnOE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArDknOJ;AqDhnOI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;ArDinON;;AqD3mOE;EACE,oFAAA;ArD8mOJ;AqD5mOI;EAEE,wFAAA;ArD6mON;AqD1mOI;EACE,SAAA;EACA,gDAAA;ArD4mON;AqDzmOI;EACE,sCAAA;EACA,sCAAA;ArD2mON;;AqDtmOA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;ArDwmOJ;AqDtmOI;EAEE,kIAAA;ArDumON;AqDpmOI;EACE,OAAA;EACA,kDAAA;ArDsmON;AqDnmOI;EACE,oCAAA;EACA,wCAAA;ArDqmON;;AqDhmOA,mBAAA;AAGE;EACE,iFAAA;ArDimOJ;AqD/lOI;EAEE,wFAAA;ArDgmON;AqD7lOI;EACE,MAAA;EACA,mDAAA;ArD+lON;AqD5lOI;EACE,mCAAA;EACA,yCAAA;ArD8lON;AqDzlOE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;ArD2lOJ;;AqDvlOA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;ArDylOJ;AqDvlOI;EAEE,kIAAA;ArDwlON;AqDrlOI;EACE,QAAA;EACA,iDAAA;ArDulON;AqDplOI;EACE,qCAAA;EACA,uCAAA;ArDslON;;AqDjlOA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;E5C2GI,6CALI;E4CpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;EjD5JE,6DAAA;EACA,8DAAA;AJguOJ;AqDlkOE;EACE,aAAA;ArDokOJ;;AqDhkOA;EACE,0EAAA;EACA,mCAAA;ArDmkOF;;AsDxvOA;EACE,kBAAA;AtD2vOF;;AsDxvOA;EACE,mBAAA;AtD2vOF;;AsDxvOA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtD2vOF;AuDjxOE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDmxOJ;;AsD5vOA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EpDlBI,sCoDmBJ;AtD+vOF;AE9wOM;EoDQN;IpDPQ,gBAAA;EFixON;AACF;;AsDjwOA;;;EAGE,cAAA;AtDowOF;;AsDjwOA;;EAEE,2BAAA;AtDowOF;;AsDjwOA;;EAEE,4BAAA;AtDowOF;;AsD3vOE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtD8vOJ;AsD3vOE;;;EAGE,UAAA;EACA,UAAA;AtD6vOJ;AsD1vOE;;EAEE,UAAA;EACA,UAAA;EpD5DE,2BoD6DF;AtD4vOJ;AErzOM;EoDqDJ;;IpDpDM,gBAAA;EFyzON;AACF;;AsDzvOA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UnDkhDmC;EmDjhDnC,UAAA;EACA,WnD1FS;EmD2FT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YnD6gDmC;EDnmD/B,8BoDuFJ;AtD2vOF;AE90OM;EoDkEN;;IpDjEQ,gBAAA;EFk1ON;AACF;AsD9vOE;;;EAEE,WnDpGO;EmDqGP,qBAAA;EACA,UAAA;EACA,YnDqgDiC;AH4vLrC;;AsD9vOA;EACE,OAAA;AtDiwOF;;AsD9vOA;EACE,QAAA;AtDiwOF;;AsD5vOA;;EAEE,qBAAA;EACA,WnDsgDmC;EmDrgDnC,YnDqgDmC;EmDpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AtD+vOF;;AsD5vOA;EACE,2TAAA;AtD+vOF;;AsD7vOA;EACE,0TAAA;AtDgwOF;;AsDxvOA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBnDs9CmC;EmDr9CnC,mBAAA;EACA,gBnDo9CmC;AHsyLrC;AsDxvOE;EACE,uBAAA;EACA,cAAA;EACA,WnDo9CiC;EmDn9CjC,WnDo9CiC;EmDn9CjC,UAAA;EACA,iBnDo9CiC;EmDn9CjC,gBnDm9CiC;EmDl9CjC,mBAAA;EACA,eAAA;EACA,sBnDlKO;EmDmKP,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YnD28CiC;ED3mD/B,6BoDiKF;AtDyvOJ;AEt5OM;EoD4IJ;IpD3IM,gBAAA;EFy5ON;AACF;AsD3vOE;EACE,UnDw8CiC;AHqzLrC;;AsDpvOA;EACE,kBAAA;EACA,UAAA;EACA,enDk8CmC;EmDj8CnC,SAAA;EACA,oBnD+7CmC;EmD97CnC,uBnD87CmC;EmD77CnC,WnD7LS;EmD8LT,kBAAA;AtDuvOF;;AsDjvOE;;EAEE,gCnDm8CiC;AHizLrC;AsDjvOE;EACE,sBnDhMO;AHm7OX;AsDhvOE;EACE,WnDpMO;AHs7OX;;AsD5vOE;;;EAEE,gCnDm8CiC;AH6zLrC;AsD7vOE;EACE,sBnDhMO;AH+7OX;AsD5vOE;EACE,WnDpMO;AHk8OX;;AwDh9OA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AxDk9OF;;AwD98OA;EACE;IAAK,0CAAA;ExDk9OL;AACF;AwD/8OA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AxD88OF;;AwD38OA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AxD68OF;;AwDp8OA;EACE;IACE,mBAAA;ExDu8OF;EwDr8OA;IACE,UAAA;IACA,eAAA;ExDu8OF;AACF;AwDn8OA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AxDk8OF;;AwD/7OA;EACE,wBAAA;EACA,yBAAA;AxDk8OF;;AwD97OE;EACE;;IAEE,kCAAA;ExDi8OJ;AACF;AyDjhPA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;AzDkhPF;;AMr9OI;EmD5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IvD5BA,0CuD8BA;EzDmgPJ;AACF;AE9hPM;EuDYJ;IvDXM,gBAAA;EFiiPN;AACF;AM3+OI;EmD5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD0gPN;EyDvgPI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDygPN;EyDtgPI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDwgPN;EyDrgPI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDugPN;EyDpgPI;IAEE,eAAA;EzDqgPN;EyDlgPI;IAGE,mBAAA;EzDkgPN;AACF;AM/hPI;EmD/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDigPN;EyD//OM;IACE,aAAA;EzDigPR;EyD9/OM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzD+/OR;AACF;;AMniPI;EmD5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IvD5BA,0CuD8BA;EzDilPJ;AACF;AE5mPM;EuDYJ;IvDXM,gBAAA;EF+mPN;AACF;AMzjPI;EmD5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDwlPN;EyDrlPI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDulPN;EyDplPI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDslPN;EyDnlPI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDqlPN;EyDllPI;IAEE,eAAA;EzDmlPN;EyDhlPI;IAGE,mBAAA;EzDglPN;AACF;AM7mPI;EmD/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzD+kPN;EyD7kPM;IACE,aAAA;EzD+kPR;EyD5kPM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzD6kPR;AACF;;AMjnPI;EmD5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IvD5BA,0CuD8BA;EzD+pPJ;AACF;AE1rPM;EuDYJ;IvDXM,gBAAA;EF6rPN;AACF;AMvoPI;EmD5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDsqPN;EyDnqPI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDqqPN;EyDlqPI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDoqPN;EyDjqPI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDmqPN;EyDhqPI;IAEE,eAAA;EzDiqPN;EyD9pPI;IAGE,mBAAA;EzD8pPN;AACF;AM3rPI;EmD/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzD6pPN;EyD3pPM;IACE,aAAA;EzD6pPR;EyD1pPM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzD2pPR;AACF;;AM/rPI;EmD5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IvD5BA,0CuD8BA;EzD6uPJ;AACF;AExwPM;EuDYJ;IvDXM,gBAAA;EF2wPN;AACF;AMrtPI;EmD5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDovPN;EyDjvPI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDmvPN;EyDhvPI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDkvPN;EyD/uPI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDivPN;EyD9uPI;IAEE,eAAA;EzD+uPN;EyD5uPI;IAGE,mBAAA;EzD4uPN;AACF;AMzwPI;EmD/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzD2uPN;EyDzuPM;IACE,aAAA;EzD2uPR;EyDxuPM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDyuPR;AACF;;AM7wPI;EmD5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IvD5BA,0CuD8BA;EzD2zPJ;AACF;AEt1PM;EuDYJ;IvDXM,gBAAA;EFy1PN;AACF;AMnyPI;EmD5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDk0PN;EyD/zPI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDi0PN;EyD9zPI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDg0PN;EyD7zPI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD+zPN;EyD5zPI;IAEE,eAAA;EzD6zPN;EyD1zPI;IAGE,mBAAA;EzD0zPN;AACF;AMv1PI;EmD/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDyzPN;EyDvzPM;IACE,aAAA;EzDyzPR;EyDtzPM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDuzPR;AACF;;AM31PI;EmD5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IvD5BA,0CuD8BA;EzDy4PJ;AACF;AEp6PM;EuDYJ;IvDXM,gBAAA;EFu6PN;AACF;AMj3PI;EmD5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDg5PN;EyD74PI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD+4PN;EyD54PI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD84PN;EyD34PI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD64PN;EyD14PI;IAEE,eAAA;EzD24PN;EyDx4PI;IAGE,mBAAA;EzDw4PN;AACF;AMr6PI;EmD/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDu4PN;EyDr4PM;IACE,aAAA;EzDu4PR;EyDp4PM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDq4PR;AACF;;AMz6PI;EmD5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IvD5BA,0CuD8BA;EzDu9PJ;AACF;AEl/PM;EuDYJ;IvDXM,gBAAA;EFq/PN;AACF;AM/7PI;EmD5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD89PN;EyD39PI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD69PN;EyD19PI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD49PN;EyDz9PI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD29PN;EyDx9PI;IAEE,eAAA;EzDy9PN;EyDt9PI;IAGE,mBAAA;EzDs9PN;AACF;AMn/PI;EmD/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDq9PN;EyDn9PM;IACE,aAAA;EzDq9PR;EyDl9PM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDm9PR;AACF;;AMv/PI;EmD5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IvD5BA,0CuD8BA;EzDqiQJ;AACF;AEhkQM;EuDYJ;IvDXM,gBAAA;EFmkQN;AACF;AM7gQI;EmD5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD4iQN;EyDziQI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD2iQN;EyDxiQI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD0iQN;EyDviQI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDyiQN;EyDtiQI;IAEE,eAAA;EzDuiQN;EyDpiQI;IAGE,mBAAA;EzDoiQN;AACF;AMjkQI;EmD/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDmiQN;EyDjiQM;IACE,aAAA;EzDmiQR;EyDhiQM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDiiQR;AACF;;AyDjnQE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EvD5BA,0CuD8BA;AzDknQN;AE5oQM;EuDYJ;IvDXM,gBAAA;EF+oQN;AACF;AyDrnQM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AzDunQR;AyDpnQM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AzDsnQR;AyDnnQM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AzDqnQR;AyDlnQM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AzDonQR;AyDjnQM;EAEE,eAAA;AzDknQR;AyD/mQM;EAGE,mBAAA;AzD+mQR;;AyDplQA;EpDpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aF0mCkC;EEzmClC,YAAA;EACA,aAAA;EACA,yBLyEkB;AAmoQpB;AKzsQE;EAAS,UAAA;AL4sQX;AK3sQE;EAAS,YLsEc;AAwoQzB;;AyDhmQA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;AzDmmQF;AyDjmQE;EACE,4FAAA;EACA,6IAAA;AzDmmQJ;;AyD/lQA;EACE,gBAAA;EACA,kDAAA;AzDkmQF;;AyD/lQA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AzDkmQF;;A0D/uQA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YvDgzCkC;AHk8NpC;A0DhvQE;EACE,qBAAA;EACA,WAAA;A1DkvQJ;;A0D7uQA;EACE,iBAAA;A1DgvQF;;A0D7uQA;EACE,iBAAA;A1DgvQF;;A0D7uQA;EACE,iBAAA;A1DgvQF;;A0D3uQE;EACE,mDAAA;A1D8uQJ;;A0D1uQA;EACE;IACE,YvDmxCgC;EH09NlC;AACF;A0D1uQA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;A1D4uQF;;A0DzuQA;EACE;IACE,uBAAA;E1D4uQF;AACF;AuD3xQE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvD6xQJ;;A2DhyQE;EACE,sBAAA;EACA,iFAAA;A3DmyQJ;;A2DryQE;EACE,sBAAA;EACA,mFAAA;A3DwyQJ;;A2D1yQE;EACE,sBAAA;EACA,iFAAA;A3D6yQJ;;A2D/yQE;EACE,sBAAA;EACA,8EAAA;A3DkzQJ;;A2DpzQE;EACE,sBAAA;EACA,iFAAA;A3DuzQJ;;A2DzzQE;EACE,sBAAA;EACA,gFAAA;A3D4zQJ;;A2D9zQE;EACE,sBAAA;EACA,+EAAA;A3Di0QJ;;A2Dn0QE;EACE,sBAAA;EACA,8EAAA;A3Ds0QJ;;A4Dx0QE;EACE,wEAAA;EACA,kGAAA;A5D20QJ;A4Dx0QM;EAGE,+DAAA;EACA,yFAAA;A5Dw0QR;;A4Dj1QE;EACE,0EAAA;EACA,oGAAA;A5Do1QJ;A4Dj1QM;EAGE,6DAAA;EACA,uFAAA;A5Di1QR;;A4D11QE;EACE,wEAAA;EACA,kGAAA;A5D61QJ;A4D11QM;EAGE,8DAAA;EACA,wFAAA;A5D01QR;;A4Dn2QE;EACE,qEAAA;EACA,+FAAA;A5Ds2QJ;A4Dn2QM;EAGE,+DAAA;EACA,yFAAA;A5Dm2QR;;A4D52QE;EACE,wEAAA;EACA,kGAAA;A5D+2QJ;A4D52QM;EAGE,+DAAA;EACA,yFAAA;A5D42QR;;A4Dr3QE;EACE,uEAAA;EACA,iGAAA;A5Dw3QJ;A4Dr3QM;EAGE,8DAAA;EACA,wFAAA;A5Dq3QR;;A4D93QE;EACE,sEAAA;EACA,gGAAA;A5Di4QJ;A4D93QM;EAGE,gEAAA;EACA,0FAAA;A5D83QR;;A4Dv4QE;EACE,qEAAA;EACA,+FAAA;A5D04QJ;A4Dv4QM;EAGE,0DAAA;EACA,oFAAA;A5Du4QR;;A4Dh4QA;EACE,+EAAA;EACA,yGAAA;A5Dm4QF;A4Dh4QI;EAEE,kFAAA;EACA,4GAAA;A5Di4QN;;A6D35QA;EACE,UAAA;EAEA,kJAAA;A7D65QF;;A8Dh6QA;EACE,oBAAA;EACA,a3D6c4B;E2D5c5B,mBAAA;EACA,kFAAA;EACA,6B3D2c4B;E2D1c5B,2BAAA;A9Dm6QF;A8Dj6QE;EACE,cAAA;EACA,U3Duc0B;E2Dtc1B,W3Dsc0B;E2Drc1B,kBAAA;E5DIE,sC4DHF;A9Dm6QJ;AE55QM;E4DZJ;I5DaM,gBAAA;EF+5QN;AACF;;A8Dj6QI;EACE,mEAAA;A9Do6QN;;A+Dv7QA;EACE,kBAAA;EACA,WAAA;A/D07QF;A+Dx7QE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A/D07QJ;A+Dv7QE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A/Dy7QJ;;A+Dp7QE;EACE,uBAAA;A/Du7QJ;;A+Dx7QE;EACE,sBAAA;A/D27QJ;;A+D57QE;EACE,yBAAA;A/D+7QJ;;A+Dh8QE;EACE,iCAAA;A/Dm8QJ;;AgEx9QA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a7DumCkC;AHo3OpC;;AgEx9QA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a7D+lCkC;AH43OpC;;AgEn9QI;EACE,gBAAA;EACA,MAAA;EACA,a7DmlC8B;AHm4OpC;;AgEn9QI;EACE,gBAAA;EACA,SAAA;EACA,a7D6kC8B;AHy4OpC;;AMv7QI;E0DxCA;IACE,gBAAA;IACA,MAAA;IACA,a7DmlC8B;EHg5OlC;EgEh+QE;IACE,gBAAA;IACA,SAAA;IACA,a7D6kC8B;EHq5OlC;AACF;AMp8QI;E0DxCA;IACE,gBAAA;IACA,MAAA;IACA,a7DmlC8B;EH45OlC;EgE5+QE;IACE,gBAAA;IACA,SAAA;IACA,a7D6kC8B;EHi6OlC;AACF;AMh9QI;E0DxCA;IACE,gBAAA;IACA,MAAA;IACA,a7DmlC8B;EHw6OlC;EgEx/QE;IACE,gBAAA;IACA,SAAA;IACA,a7D6kC8B;EH66OlC;AACF;AM59QI;E0DxCA;IACE,gBAAA;IACA,MAAA;IACA,a7DmlC8B;EHo7OlC;EgEpgRE;IACE,gBAAA;IACA,SAAA;IACA,a7D6kC8B;EHy7OlC;AACF;AMx+QI;E0DxCA;IACE,gBAAA;IACA,MAAA;IACA,a7DmlC8B;EHg8OlC;EgEhhRE;IACE,gBAAA;IACA,SAAA;IACA,a7D6kC8B;EHq8OlC;AACF;AMp/QI;E0DxCA;IACE,gBAAA;IACA,MAAA;IACA,a7DmlC8B;EH48OlC;EgE5hRE;IACE,gBAAA;IACA,SAAA;IACA,a7D6kC8B;EHi9OlC;AACF;AMhgRI;E0DxCA;IACE,gBAAA;IACA,MAAA;IACA,a7DmlC8B;EHw9OlC;EgExiRE;IACE,gBAAA;IACA,SAAA;IACA,a7D6kC8B;EH69OlC;AACF;AM5gRI;E0DxCA;IACE,gBAAA;IACA,MAAA;IACA,a7DmlC8B;EHo+OlC;EgEpjRE;IACE,gBAAA;IACA,SAAA;IACA,a7D6kC8B;EHy+OlC;AACF;AiEtlRA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AjEwlRF;;AiErlRA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AjEwlRF;;AkEhmRA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AnEimRF;AmE9lRE;;EACE,6BAAA;AnEimRJ;;AoE/mRE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UjEgcsC;EiE/btC,WAAA;ApEknRJ;;AqE1nRA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AtE8nRF;;AuEpoRA;EACE,qBAAA;EACA,mBAAA;EACA,6BpEisB4B;EoEhsB5B,eAAA;EACA,8BAAA;EACA,UvEuBW;AAgnRb;;AwE3kRQ;EAOI,mCAAA;AxEwkRZ;;AwE/kRQ;EAOI,8BAAA;AxE4kRZ;;AwEnlRQ;EAOI,iCAAA;AxEglRZ;;AwEvlRQ;EAOI,iCAAA;AxEolRZ;;AwE3lRQ;EAOI,sCAAA;AxEwlRZ;;AwE/lRQ;EAOI,mCAAA;AxE4lRZ;;AwEnmRQ;EAOI,sBAAA;AxEgmRZ;;AwEvmRQ;EAOI,uBAAA;AxEomRZ;;AwE3mRQ;EAOI,sBAAA;AxEwmRZ;;AwE/mRQ;EAOI,8BAAA;AxE4mRZ;;AwEnnRQ;EAOI,4BAAA;AxEgnRZ;;AwEvnRQ;EAOI,2BAAA;AxEonRZ;;AwE3nRQ;EAOI,iCAAA;AxEwnRZ;;AwE/nRQ;EAOI,2BAAA;AxE4nRZ;;AwEnoRQ;EAOI,qBAAA;AxEgoRZ;;AwEvoRQ;EAOI,wBAAA;AxEooRZ;;AwE3oRQ;EAOI,uBAAA;AxEwoRZ;;AwE/oRQ;EAOI,wBAAA;AxE4oRZ;;AwEnpRQ;EAOI,qBAAA;AxEgpRZ;;AwEvpRQ;EAOI,uBAAA;AxEopRZ;;AwE3pRQ;EAOI,uBAAA;AxEwpRZ;;AwE/pRQ;EAOI,wBAAA;AxE4pRZ;;AwEnqRQ;EAOI,uBAAA;AxEgqRZ;;AwEvqRQ;EAOI,uBAAA;AxEoqRZ;;AwE3qRQ;EAOI,wBAAA;AxEwqRZ;;AwE/qRQ;EAOI,uBAAA;AxE4qRZ;;AwEnrRQ;EAOI,wBAAA;AxEgrRZ;;AwEvrRQ;EAOI,uBAAA;AxEorRZ;;AwE3rRQ;EAOI,wBAAA;AxEwrRZ;;AwE/rRQ;EAOI,uBAAA;AxE4rRZ;;AwEnsRQ;EAOI,uBAAA;AxEgsRZ;;AwEvsRQ;EAOI,wBAAA;AxEosRZ;;AwE3sRQ;EAOI,uBAAA;AxEwsRZ;;AwE/sRQ;EAOI,wBAAA;AxE4sRZ;;AwEntRQ;EAOI,yBAAA;AxEgtRZ;;AwEvtRQ;EAOI,2BAAA;AxEotRZ;;AwE3tRQ;EAOI,4BAAA;AxEwtRZ;;AwE/tRQ;EAOI,2BAAA;AxE4tRZ;;AwEnuRQ;EAOI,2BAAA;AxEguRZ;;AwEvuRQ;EAOI,6BAAA;AxEouRZ;;AwE3uRQ;EAOI,8BAAA;AxEwuRZ;;AwE/uRQ;EAOI,6BAAA;AxE4uRZ;;AwEnvRQ;EAOI,2BAAA;AxEgvRZ;;AwEvvRQ;EAOI,6BAAA;AxEovRZ;;AwE3vRQ;EAOI,8BAAA;AxEwvRZ;;AwE/vRQ;EAOI,6BAAA;AxE4vRZ;;AwEnwRQ;EAOI,0BAAA;AxEgwRZ;;AwEvwRQ;EAOI,gCAAA;AxEowRZ;;AwE3wRQ;EAOI,yBAAA;AxEwwRZ;;AwE/wRQ;EAOI,wBAAA;AxE4wRZ;;AwEnxRQ;EAOI,+BAAA;AxEgxRZ;;AwEvxRQ;EAOI,yBAAA;AxEoxRZ;;AwE3xRQ;EAOI,6BAAA;AxEwxRZ;;AwE/xRQ;EAOI,8BAAA;AxE4xRZ;;AwEnyRQ;EAOI,wBAAA;AxEgyRZ;;AwEvyRQ;EAOI,+BAAA;AxEoyRZ;;AwE3yRQ;EAOI,wBAAA;AxEwyRZ;;AwE/yRQ;EAOI,2CAAA;AxE4yRZ;;AwEnzRQ;EAOI,8CAAA;AxEgzRZ;;AwEvzRQ;EAOI,8CAAA;AxEozRZ;;AwE3zRQ;EAOI,2BAAA;AxEwzRZ;;AwEz0RQ;EACE,gFAAA;AxE40RV;;AwE70RQ;EACE,kFAAA;AxEg1RV;;AwEj1RQ;EACE,gFAAA;AxEo1RV;;AwEr1RQ;EACE,6EAAA;AxEw1RV;;AwEz1RQ;EACE,gFAAA;AxE41RV;;AwE71RQ;EACE,+EAAA;AxEg2RV;;AwEj2RQ;EACE,8EAAA;AxEo2RV;;AwEr2RQ;EACE,6EAAA;AxEw2RV;;AwE/1RQ;EAOI,2BAAA;AxE41RZ;;AwEn2RQ;EAOI,6BAAA;AxEg2RZ;;AwEv2RQ;EAOI,6BAAA;AxEo2RZ;;AwE32RQ;EAOI,0BAAA;AxEw2RZ;;AwE/2RQ;EAOI,2BAAA;AxE42RZ;;AwEn3RQ;EAOI,iBAAA;AxEg3RZ;;AwEv3RQ;EAOI,mBAAA;AxEo3RZ;;AwE33RQ;EAOI,oBAAA;AxEw3RZ;;AwE/3RQ;EAOI,kBAAA;AxE43RZ;;AwEn4RQ;EAOI,kBAAA;AxEg4RZ;;AwEv4RQ;EAOI,kBAAA;AxEo4RZ;;AwE34RQ;EAOI,kBAAA;AxEw4RZ;;AwE/4RQ;EAOI,kBAAA;AxE44RZ;;AwEn5RQ;EAOI,mBAAA;AxEg5RZ;;AwEv5RQ;EAOI,mBAAA;AxEo5RZ;;AwE35RQ;EAOI,mBAAA;AxEw5RZ;;AwE/5RQ;EAOI,mBAAA;AxE45RZ;;AwEn6RQ;EAOI,mBAAA;AxEg6RZ;;AwEv6RQ;EAOI,mBAAA;AxEo6RZ;;AwE36RQ;EAOI,mBAAA;AxEw6RZ;;AwE/6RQ;EAOI,mBAAA;AxE46RZ;;AwEn7RQ;EAOI,mBAAA;AxEg7RZ;;AwEv7RQ;EAOI,mBAAA;AxEo7RZ;;AwE37RQ;EAOI,mBAAA;AxEw7RZ;;AwE/7RQ;EAOI,mBAAA;AxE47RZ;;AwEn8RQ;EAOI,mBAAA;AxEg8RZ;;AwEv8RQ;EAOI,mBAAA;AxEo8RZ;;AwE38RQ;EAOI,mBAAA;AxEw8RZ;;AwE/8RQ;EAOI,mBAAA;AxE48RZ;;AwEn9RQ;EAOI,mBAAA;AxEg9RZ;;AwEv9RQ;EAOI,oBAAA;AxEo9RZ;;AwE39RQ;EAOI,oBAAA;AxEw9RZ;;AwE/9RQ;EAOI,sBAAA;AxE49RZ;;AwEn+RQ;EAOI,uBAAA;AxEg+RZ;;AwEv+RQ;EAOI,qBAAA;AxEo+RZ;;AwE3+RQ;EAOI,qBAAA;AxEw+RZ;;AwE/+RQ;EAOI,qBAAA;AxE4+RZ;;AwEn/RQ;EAOI,qBAAA;AxEg/RZ;;AwEv/RQ;EAOI,qBAAA;AxEo/RZ;;AwE3/RQ;EAOI,sBAAA;AxEw/RZ;;AwE//RQ;EAOI,sBAAA;AxE4/RZ;;AwEngSQ;EAOI,sBAAA;AxEggSZ;;AwEvgSQ;EAOI,sBAAA;AxEogSZ;;AwE3gSQ;EAOI,sBAAA;AxEwgSZ;;AwE/gSQ;EAOI,sBAAA;AxE4gSZ;;AwEnhSQ;EAOI,sBAAA;AxEghSZ;;AwEvhSQ;EAOI,sBAAA;AxEohSZ;;AwE3hSQ;EAOI,sBAAA;AxEwhSZ;;AwE/hSQ;EAOI,sBAAA;AxE4hSZ;;AwEniSQ;EAOI,sBAAA;AxEgiSZ;;AwEviSQ;EAOI,sBAAA;AxEoiSZ;;AwE3iSQ;EAOI,sBAAA;AxEwiSZ;;AwE/iSQ;EAOI,sBAAA;AxE4iSZ;;AwEnjSQ;EAOI,sBAAA;AxEgjSZ;;AwEvjSQ;EAOI,sBAAA;AxEojSZ;;AwE3jSQ;EAOI,sBAAA;AxEwjSZ;;AwE/jSQ;EAOI,uBAAA;AxE4jSZ;;AwEnkSQ;EAOI,kBAAA;AxEgkSZ;;AwEvkSQ;EAOI,oBAAA;AxEokSZ;;AwE3kSQ;EAOI,qBAAA;AxEwkSZ;;AwE/kSQ;EAOI,mBAAA;AxE4kSZ;;AwEnlSQ;EAOI,mBAAA;AxEglSZ;;AwEvlSQ;EAOI,mBAAA;AxEolSZ;;AwE3lSQ;EAOI,mBAAA;AxEwlSZ;;AwE/lSQ;EAOI,mBAAA;AxE4lSZ;;AwEnmSQ;EAOI,oBAAA;AxEgmSZ;;AwEvmSQ;EAOI,oBAAA;AxEomSZ;;AwE3mSQ;EAOI,oBAAA;AxEwmSZ;;AwE/mSQ;EAOI,oBAAA;AxE4mSZ;;AwEnnSQ;EAOI,oBAAA;AxEgnSZ;;AwEvnSQ;EAOI,oBAAA;AxEonSZ;;AwE3nSQ;EAOI,oBAAA;AxEwnSZ;;AwE/nSQ;EAOI,oBAAA;AxE4nSZ;;AwEnoSQ;EAOI,oBAAA;AxEgoSZ;;AwEvoSQ;EAOI,oBAAA;AxEooSZ;;AwE3oSQ;EAOI,oBAAA;AxEwoSZ;;AwE/oSQ;EAOI,oBAAA;AxE4oSZ;;AwEnpSQ;EAOI,oBAAA;AxEgpSZ;;AwEvpSQ;EAOI,oBAAA;AxEopSZ;;AwE3pSQ;EAOI,oBAAA;AxEwpSZ;;AwE/pSQ;EAOI,oBAAA;AxE4pSZ;;AwEnqSQ;EAOI,oBAAA;AxEgqSZ;;AwEvqSQ;EAOI,qBAAA;AxEoqSZ;;AwE3qSQ;EAOI,mBAAA;AxEwqSZ;;AwE/qSQ;EAOI,qBAAA;AxE4qSZ;;AwEnrSQ;EAOI,sBAAA;AxEgrSZ;;AwEvrSQ;EAOI,oBAAA;AxEorSZ;;AwE3rSQ;EAOI,oBAAA;AxEwrSZ;;AwE/rSQ;EAOI,oBAAA;AxE4rSZ;;AwEnsSQ;EAOI,oBAAA;AxEgsSZ;;AwEvsSQ;EAOI,oBAAA;AxEosSZ;;AwE3sSQ;EAOI,qBAAA;AxEwsSZ;;AwE/sSQ;EAOI,qBAAA;AxE4sSZ;;AwEntSQ;EAOI,qBAAA;AxEgtSZ;;AwEvtSQ;EAOI,qBAAA;AxEotSZ;;AwE3tSQ;EAOI,qBAAA;AxEwtSZ;;AwE/tSQ;EAOI,qBAAA;AxE4tSZ;;AwEnuSQ;EAOI,qBAAA;AxEguSZ;;AwEvuSQ;EAOI,qBAAA;AxEouSZ;;AwE3uSQ;EAOI,qBAAA;AxEwuSZ;;AwE/uSQ;EAOI,qBAAA;AxE4uSZ;;AwEnvSQ;EAOI,qBAAA;AxEgvSZ;;AwEvvSQ;EAOI,qBAAA;AxEovSZ;;AwE3vSQ;EAOI,qBAAA;AxEwvSZ;;AwE/vSQ;EAOI,qBAAA;AxE4vSZ;;AwEnwSQ;EAOI,qBAAA;AxEgwSZ;;AwEvwSQ;EAOI,qBAAA;AxEowSZ;;AwE3wSQ;EAOI,qBAAA;AxEwwSZ;;AwE/wSQ;EAOI,sBAAA;AxE4wSZ;;AwEnxSQ;EAOI,2CAAA;AxEgxSZ;;AwEvxSQ;EAOI,sCAAA;AxEoxSZ;;AwE3xSQ;EAOI,sCAAA;AxEwxSZ;;AwE/xSQ;EAOI,uFAAA;AxE4xSZ;;AwEnySQ;EAOI,oBAAA;AxEgySZ;;AwEvySQ;EAOI,2FAAA;AxEoySZ;;AwE3ySQ;EAOI,wBAAA;AxEwySZ;;AwE/ySQ;EAOI,6FAAA;AxE4ySZ;;AwEnzSQ;EAOI,0BAAA;AxEgzSZ;;AwEvzSQ;EAOI,8FAAA;AxEozSZ;;AwE3zSQ;EAOI,2BAAA;AxEwzSZ;;AwE/zSQ;EAOI,4FAAA;AxE4zSZ;;AwEn0SQ;EAOI,yBAAA;AxEg0SZ;;AwEv0SQ;EAIQ,sBAAA;EAGJ,8EAAA;AxEq0SZ;;AwE50SQ;EAIQ,sBAAA;EAGJ,gFAAA;AxE00SZ;;AwEj1SQ;EAIQ,sBAAA;EAGJ,8EAAA;AxE+0SZ;;AwEt1SQ;EAIQ,sBAAA;EAGJ,2EAAA;AxEo1SZ;;AwE31SQ;EAIQ,sBAAA;EAGJ,8EAAA;AxEy1SZ;;AwEh2SQ;EAIQ,sBAAA;EAGJ,6EAAA;AxE81SZ;;AwEr2SQ;EAIQ,sBAAA;EAGJ,4EAAA;AxEm2SZ;;AwE12SQ;EAIQ,sBAAA;EAGJ,2EAAA;AxEw2SZ;;AwE/2SQ;EAIQ,sBAAA;EAGJ,4EAAA;AxE62SZ;;AwEp3SQ;EAIQ,sBAAA;EAGJ,4EAAA;AxEk3SZ;;AwEz3SQ;EAOI,wDAAA;AxEs3SZ;;AwE73SQ;EAOI,0DAAA;AxE03SZ;;AwEj4SQ;EAOI,wDAAA;AxE83SZ;;AwEr4SQ;EAOI,qDAAA;AxEk4SZ;;AwEz4SQ;EAOI,wDAAA;AxEs4SZ;;AwE74SQ;EAOI,uDAAA;AxE04SZ;;AwEj5SQ;EAOI,sDAAA;AxE84SZ;;AwEr5SQ;EAOI,qDAAA;AxEk5SZ;;AwEz5SQ;EAOI,4BAAA;AxEs5SZ;;AwE75SQ;EAOI,4BAAA;AxE05SZ;;AwEj6SQ;EAOI,4BAAA;AxE85SZ;;AwEr6SQ;EAOI,4BAAA;AxEk6SZ;;AwEz6SQ;EAOI,4BAAA;AxEs6SZ;;AwEv7SQ;EACE,wBAAA;AxE07SV;;AwE37SQ;EACE,yBAAA;AxE87SV;;AwE/7SQ;EACE,wBAAA;AxEk8SV;;AwEn8SQ;EACE,yBAAA;AxEs8SV;;AwEv8SQ;EACE,sBAAA;AxE08SV;;AwEj8SQ;EAOI,qBAAA;AxE87SZ;;AwEr8SQ;EAOI,qBAAA;AxEk8SZ;;AwEz8SQ;EAOI,qBAAA;AxEs8SZ;;AwE78SQ;EAOI,sBAAA;AxE08SZ;;AwEj9SQ;EAOI,sBAAA;AxE88SZ;;AwEr9SQ;EAOI,oBAAA;AxEk9SZ;;AwEz9SQ;EAOI,qBAAA;AxEs9SZ;;AwE79SQ;EAOI,qBAAA;AxE09SZ;;AwEj+SQ;EAOI,qBAAA;AxE89SZ;;AwEr+SQ;EAOI,qBAAA;AxEk+SZ;;AwEz+SQ;EAOI,qBAAA;AxEs+SZ;;AwE7+SQ;EAOI,qBAAA;AxE0+SZ;;AwEj/SQ;EAOI,qBAAA;AxE8+SZ;;AwEr/SQ;EAOI,qBAAA;AxEk/SZ;;AwEz/SQ;EAOI,qBAAA;AxEs/SZ;;AwE7/SQ;EAOI,qBAAA;AxE0/SZ;;AwEjgTQ;EAOI,qBAAA;AxE8/SZ;;AwErgTQ;EAOI,qBAAA;AxEkgTZ;;AwEzgTQ;EAOI,qBAAA;AxEsgTZ;;AwE7gTQ;EAOI,qBAAA;AxE0gTZ;;AwEjhTQ;EAOI,qBAAA;AxE8gTZ;;AwErhTQ;EAOI,0BAAA;AxEkhTZ;;AwEzhTQ;EAOI,uBAAA;AxEshTZ;;AwE7hTQ;EAOI,2BAAA;AxE0hTZ;;AwEjiTQ;EAOI,sBAAA;AxE8hTZ;;AwEriTQ;EAOI,sBAAA;AxEkiTZ;;AwEziTQ;EAOI,sBAAA;AxEsiTZ;;AwE7iTQ;EAOI,uBAAA;AxE0iTZ;;AwEjjTQ;EAOI,uBAAA;AxE8iTZ;;AwErjTQ;EAOI,qBAAA;AxEkjTZ;;AwEzjTQ;EAOI,sBAAA;AxEsjTZ;;AwE7jTQ;EAOI,sBAAA;AxE0jTZ;;AwEjkTQ;EAOI,sBAAA;AxE8jTZ;;AwErkTQ;EAOI,sBAAA;AxEkkTZ;;AwEzkTQ;EAOI,sBAAA;AxEskTZ;;AwE7kTQ;EAOI,sBAAA;AxE0kTZ;;AwEjlTQ;EAOI,sBAAA;AxE8kTZ;;AwErlTQ;EAOI,sBAAA;AxEklTZ;;AwEzlTQ;EAOI,sBAAA;AxEslTZ;;AwE7lTQ;EAOI,sBAAA;AxE0lTZ;;AwEjmTQ;EAOI,sBAAA;AxE8lTZ;;AwErmTQ;EAOI,sBAAA;AxEkmTZ;;AwEzmTQ;EAOI,sBAAA;AxEsmTZ;;AwE7mTQ;EAOI,sBAAA;AxE0mTZ;;AwEjnTQ;EAOI,sBAAA;AxE8mTZ;;AwErnTQ;EAOI,2BAAA;AxEknTZ;;AwEznTQ;EAOI,wBAAA;AxEsnTZ;;AwE7nTQ;EAOI,4BAAA;AxE0nTZ;;AwEjoTQ;EAOI,yBAAA;AxE8nTZ;;AwEroTQ;EAOI,8BAAA;AxEkoTZ;;AwEzoTQ;EAOI,iCAAA;AxEsoTZ;;AwE7oTQ;EAOI,sCAAA;AxE0oTZ;;AwEjpTQ;EAOI,yCAAA;AxE8oTZ;;AwErpTQ;EAOI,uBAAA;AxEkpTZ;;AwEzpTQ;EAOI,uBAAA;AxEspTZ;;AwE7pTQ;EAOI,yBAAA;AxE0pTZ;;AwEjqTQ;EAOI,yBAAA;AxE8pTZ;;AwErqTQ;EAOI,0BAAA;AxEkqTZ;;AwEzqTQ;EAOI,4BAAA;AxEsqTZ;;AwE7qTQ;EAOI,kCAAA;AxE0qTZ;;AwEjrTQ;EAOI,sCAAA;AxE8qTZ;;AwErrTQ;EAOI,oCAAA;AxEkrTZ;;AwEzrTQ;EAOI,kCAAA;AxEsrTZ;;AwE7rTQ;EAOI,yCAAA;AxE0rTZ;;AwEjsTQ;EAOI,wCAAA;AxE8rTZ;;AwErsTQ;EAOI,wCAAA;AxEksTZ;;AwEzsTQ;EAOI,kCAAA;AxEssTZ;;AwE7sTQ;EAOI,gCAAA;AxE0sTZ;;AwEjtTQ;EAOI,8BAAA;AxE8sTZ;;AwErtTQ;EAOI,gCAAA;AxEktTZ;;AwEztTQ;EAOI,+BAAA;AxEstTZ;;AwE7tTQ;EAOI,oCAAA;AxE0tTZ;;AwEjuTQ;EAOI,kCAAA;AxE8tTZ;;AwEruTQ;EAOI,gCAAA;AxEkuTZ;;AwEzuTQ;EAOI,uCAAA;AxEsuTZ;;AwE7uTQ;EAOI,sCAAA;AxE0uTZ;;AwEjvTQ;EAOI,iCAAA;AxE8uTZ;;AwErvTQ;EAOI,2BAAA;AxEkvTZ;;AwEzvTQ;EAOI,iCAAA;AxEsvTZ;;AwE7vTQ;EAOI,+BAAA;AxE0vTZ;;AwEjwTQ;EAOI,6BAAA;AxE8vTZ;;AwErwTQ;EAOI,+BAAA;AxEkwTZ;;AwEzwTQ;EAOI,8BAAA;AxEswTZ;;AwE7wTQ;EAOI,oBAAA;AxE0wTZ;;AwEjxTQ;EAOI,mBAAA;AxE8wTZ;;AwErxTQ;EAOI,mBAAA;AxEkxTZ;;AwEzxTQ;EAOI,mBAAA;AxEsxTZ;;AwE7xTQ;EAOI,mBAAA;AxE0xTZ;;AwEjyTQ;EAOI,mBAAA;AxE8xTZ;;AwEryTQ;EAOI,mBAAA;AxEkyTZ;;AwEzyTQ;EAOI,mBAAA;AxEsyTZ;;AwE7yTQ;EAOI,oBAAA;AxE0yTZ;;AwEjzTQ;EAOI,0BAAA;AxE8yTZ;;AwErzTQ;EAOI,yBAAA;AxEkzTZ;;AwEzzTQ;EAOI,uBAAA;AxEszTZ;;AwE7zTQ;EAOI,yBAAA;AxE0zTZ;;AwEj0TQ;EAOI,uBAAA;AxE8zTZ;;AwEr0TQ;EAOI,yBAAA;AxEk0TZ;;AwEz0TQ;EAOI,uBAAA;AxEs0TZ;;AwE70TQ;EAOI,uBAAA;AxE00TZ;;AwEj1TQ;EAOI,wBAAA;AxE80TZ;;AwEr1TQ;EAOI,uBAAA;AxEk1TZ;;AwEz1TQ;EAOI,0BAAA;EAAA,yBAAA;AxEu1TZ;;AwE91TQ;EAOI,gCAAA;EAAA,+BAAA;AxE41TZ;;AwEn2TQ;EAOI,+BAAA;EAAA,8BAAA;AxEi2TZ;;AwEx2TQ;EAOI,6BAAA;EAAA,4BAAA;AxEs2TZ;;AwE72TQ;EAOI,+BAAA;EAAA,8BAAA;AxE22TZ;;AwEl3TQ;EAOI,6BAAA;EAAA,4BAAA;AxEg3TZ;;AwEv3TQ;EAOI,+BAAA;EAAA,8BAAA;AxEq3TZ;;AwE53TQ;EAOI,6BAAA;EAAA,4BAAA;AxE03TZ;;AwEj4TQ;EAOI,6BAAA;EAAA,4BAAA;AxE+3TZ;;AwEt4TQ;EAOI,8BAAA;EAAA,6BAAA;AxEo4TZ;;AwE34TQ;EAOI,6BAAA;EAAA,4BAAA;AxEy4TZ;;AwEh5TQ;EAOI,wBAAA;EAAA,2BAAA;AxE84TZ;;AwEr5TQ;EAOI,8BAAA;EAAA,iCAAA;AxEm5TZ;;AwE15TQ;EAOI,6BAAA;EAAA,gCAAA;AxEw5TZ;;AwE/5TQ;EAOI,2BAAA;EAAA,8BAAA;AxE65TZ;;AwEp6TQ;EAOI,6BAAA;EAAA,gCAAA;AxEk6TZ;;AwEz6TQ;EAOI,2BAAA;EAAA,8BAAA;AxEu6TZ;;AwE96TQ;EAOI,6BAAA;EAAA,gCAAA;AxE46TZ;;AwEn7TQ;EAOI,2BAAA;EAAA,8BAAA;AxEi7TZ;;AwEx7TQ;EAOI,2BAAA;EAAA,8BAAA;AxEs7TZ;;AwE77TQ;EAOI,4BAAA;EAAA,+BAAA;AxE27TZ;;AwEl8TQ;EAOI,2BAAA;EAAA,8BAAA;AxEg8TZ;;AwEv8TQ;EAOI,wBAAA;AxEo8TZ;;AwE38TQ;EAOI,8BAAA;AxEw8TZ;;AwE/8TQ;EAOI,6BAAA;AxE48TZ;;AwEn9TQ;EAOI,2BAAA;AxEg9TZ;;AwEv9TQ;EAOI,6BAAA;AxEo9TZ;;AwE39TQ;EAOI,2BAAA;AxEw9TZ;;AwE/9TQ;EAOI,6BAAA;AxE49TZ;;AwEn+TQ;EAOI,2BAAA;AxEg+TZ;;AwEv+TQ;EAOI,2BAAA;AxEo+TZ;;AwE3+TQ;EAOI,4BAAA;AxEw+TZ;;AwE/+TQ;EAOI,2BAAA;AxE4+TZ;;AwEn/TQ;EAOI,0BAAA;AxEg/TZ;;AwEv/TQ;EAOI,gCAAA;AxEo/TZ;;AwE3/TQ;EAOI,+BAAA;AxEw/TZ;;AwE//TQ;EAOI,6BAAA;AxE4/TZ;;AwEngUQ;EAOI,+BAAA;AxEggUZ;;AwEvgUQ;EAOI,6BAAA;AxEogUZ;;AwE3gUQ;EAOI,+BAAA;AxEwgUZ;;AwE/gUQ;EAOI,6BAAA;AxE4gUZ;;AwEnhUQ;EAOI,6BAAA;AxEghUZ;;AwEvhUQ;EAOI,8BAAA;AxEohUZ;;AwE3hUQ;EAOI,6BAAA;AxEwhUZ;;AwE/hUQ;EAOI,2BAAA;AxE4hUZ;;AwEniUQ;EAOI,iCAAA;AxEgiUZ;;AwEviUQ;EAOI,gCAAA;AxEoiUZ;;AwE3iUQ;EAOI,8BAAA;AxEwiUZ;;AwE/iUQ;EAOI,gCAAA;AxE4iUZ;;AwEnjUQ;EAOI,8BAAA;AxEgjUZ;;AwEvjUQ;EAOI,gCAAA;AxEojUZ;;AwE3jUQ;EAOI,8BAAA;AxEwjUZ;;AwE/jUQ;EAOI,8BAAA;AxE4jUZ;;AwEnkUQ;EAOI,+BAAA;AxEgkUZ;;AwEvkUQ;EAOI,8BAAA;AxEokUZ;;AwE3kUQ;EAOI,yBAAA;AxEwkUZ;;AwE/kUQ;EAOI,+BAAA;AxE4kUZ;;AwEnlUQ;EAOI,8BAAA;AxEglUZ;;AwEvlUQ;EAOI,4BAAA;AxEolUZ;;AwE3lUQ;EAOI,8BAAA;AxEwlUZ;;AwE/lUQ;EAOI,4BAAA;AxE4lUZ;;AwEnmUQ;EAOI,8BAAA;AxEgmUZ;;AwEvmUQ;EAOI,4BAAA;AxEomUZ;;AwE3mUQ;EAOI,4BAAA;AxEwmUZ;;AwE/mUQ;EAOI,6BAAA;AxE4mUZ;;AwEnnUQ;EAOI,4BAAA;AxEgnUZ;;AwEvnUQ;EAOI,2BAAA;AxEonUZ;;AwE3nUQ;EAOI,0BAAA;AxEwnUZ;;AwE/nUQ;EAOI,wBAAA;AxE4nUZ;;AwEnoUQ;EAOI,0BAAA;AxEgoUZ;;AwEvoUQ;EAOI,wBAAA;AxEooUZ;;AwE3oUQ;EAOI,0BAAA;AxEwoUZ;;AwE/oUQ;EAOI,wBAAA;AxE4oUZ;;AwEnpUQ;EAOI,wBAAA;AxEgpUZ;;AwEvpUQ;EAOI,yBAAA;AxEopUZ;;AwE3pUQ;EAOI,iCAAA;EAAA,gCAAA;AxEypUZ;;AwEhqUQ;EAOI,gCAAA;EAAA,+BAAA;AxE8pUZ;;AwErqUQ;EAOI,8BAAA;EAAA,6BAAA;AxEmqUZ;;AwE1qUQ;EAOI,gCAAA;EAAA,+BAAA;AxEwqUZ;;AwE/qUQ;EAOI,8BAAA;EAAA,6BAAA;AxE6qUZ;;AwEprUQ;EAOI,gCAAA;EAAA,+BAAA;AxEkrUZ;;AwEzrUQ;EAOI,8BAAA;EAAA,6BAAA;AxEurUZ;;AwE9rUQ;EAOI,8BAAA;EAAA,6BAAA;AxE4rUZ;;AwEnsUQ;EAOI,+BAAA;EAAA,8BAAA;AxEisUZ;;AwExsUQ;EAOI,+BAAA;EAAA,kCAAA;AxEssUZ;;AwE7sUQ;EAOI,8BAAA;EAAA,iCAAA;AxE2sUZ;;AwEltUQ;EAOI,4BAAA;EAAA,+BAAA;AxEgtUZ;;AwEvtUQ;EAOI,8BAAA;EAAA,iCAAA;AxEqtUZ;;AwE5tUQ;EAOI,4BAAA;EAAA,+BAAA;AxE0tUZ;;AwEjuUQ;EAOI,8BAAA;EAAA,iCAAA;AxE+tUZ;;AwEtuUQ;EAOI,4BAAA;EAAA,+BAAA;AxEouUZ;;AwE3uUQ;EAOI,4BAAA;EAAA,+BAAA;AxEyuUZ;;AwEhvUQ;EAOI,6BAAA;EAAA,gCAAA;AxE8uUZ;;AwErvUQ;EAOI,+BAAA;AxEkvUZ;;AwEzvUQ;EAOI,8BAAA;AxEsvUZ;;AwE7vUQ;EAOI,4BAAA;AxE0vUZ;;AwEjwUQ;EAOI,8BAAA;AxE8vUZ;;AwErwUQ;EAOI,4BAAA;AxEkwUZ;;AwEzwUQ;EAOI,8BAAA;AxEswUZ;;AwE7wUQ;EAOI,4BAAA;AxE0wUZ;;AwEjxUQ;EAOI,4BAAA;AxE8wUZ;;AwErxUQ;EAOI,6BAAA;AxEkxUZ;;AwEzxUQ;EAOI,iCAAA;AxEsxUZ;;AwE7xUQ;EAOI,gCAAA;AxE0xUZ;;AwEjyUQ;EAOI,8BAAA;AxE8xUZ;;AwEryUQ;EAOI,gCAAA;AxEkyUZ;;AwEzyUQ;EAOI,8BAAA;AxEsyUZ;;AwE7yUQ;EAOI,gCAAA;AxE0yUZ;;AwEjzUQ;EAOI,8BAAA;AxE8yUZ;;AwErzUQ;EAOI,8BAAA;AxEkzUZ;;AwEzzUQ;EAOI,+BAAA;AxEszUZ;;AwE7zUQ;EAOI,kCAAA;AxE0zUZ;;AwEj0UQ;EAOI,iCAAA;AxE8zUZ;;AwEr0UQ;EAOI,+BAAA;AxEk0UZ;;AwEz0UQ;EAOI,iCAAA;AxEs0UZ;;AwE70UQ;EAOI,+BAAA;AxE00UZ;;AwEj1UQ;EAOI,iCAAA;AxE80UZ;;AwEr1UQ;EAOI,+BAAA;AxEk1UZ;;AwEz1UQ;EAOI,+BAAA;AxEs1UZ;;AwE71UQ;EAOI,gCAAA;AxE01UZ;;AwEj2UQ;EAOI,gCAAA;AxE81UZ;;AwEr2UQ;EAOI,+BAAA;AxEk2UZ;;AwEz2UQ;EAOI,6BAAA;AxEs2UZ;;AwE72UQ;EAOI,+BAAA;AxE02UZ;;AwEj3UQ;EAOI,6BAAA;AxE82UZ;;AwEr3UQ;EAOI,+BAAA;AxEk3UZ;;AwEz3UQ;EAOI,6BAAA;AxEs3UZ;;AwE73UQ;EAOI,6BAAA;AxE03UZ;;AwEj4UQ;EAOI,8BAAA;AxE83UZ;;AwEr4UQ;EAOI,qBAAA;AxEk4UZ;;AwEz4UQ;EAOI,2BAAA;AxEs4UZ;;AwE74UQ;EAOI,0BAAA;AxE04UZ;;AwEj5UQ;EAOI,wBAAA;AxE84UZ;;AwEr5UQ;EAOI,0BAAA;AxEk5UZ;;AwEz5UQ;EAOI,wBAAA;AxEs5UZ;;AwE75UQ;EAOI,0BAAA;AxE05UZ;;AwEj6UQ;EAOI,wBAAA;AxE85UZ;;AwEr6UQ;EAOI,wBAAA;AxEk6UZ;;AwEz6UQ;EAOI,yBAAA;AxEs6UZ;;AwE76UQ;EAOI,2BAAA;EAAA,0BAAA;AxE26UZ;;AwEl7UQ;EAOI,iCAAA;EAAA,gCAAA;AxEg7UZ;;AwEv7UQ;EAOI,gCAAA;EAAA,+BAAA;AxEq7UZ;;AwE57UQ;EAOI,8BAAA;EAAA,6BAAA;AxE07UZ;;AwEj8UQ;EAOI,gCAAA;EAAA,+BAAA;AxE+7UZ;;AwEt8UQ;EAOI,8BAAA;EAAA,6BAAA;AxEo8UZ;;AwE38UQ;EAOI,gCAAA;EAAA,+BAAA;AxEy8UZ;;AwEh9UQ;EAOI,8BAAA;EAAA,6BAAA;AxE88UZ;;AwEr9UQ;EAOI,8BAAA;EAAA,6BAAA;AxEm9UZ;;AwE19UQ;EAOI,+BAAA;EAAA,8BAAA;AxEw9UZ;;AwE/9UQ;EAOI,yBAAA;EAAA,4BAAA;AxE69UZ;;AwEp+UQ;EAOI,+BAAA;EAAA,kCAAA;AxEk+UZ;;AwEz+UQ;EAOI,8BAAA;EAAA,iCAAA;AxEu+UZ;;AwE9+UQ;EAOI,4BAAA;EAAA,+BAAA;AxE4+UZ;;AwEn/UQ;EAOI,8BAAA;EAAA,iCAAA;AxEi/UZ;;AwEx/UQ;EAOI,4BAAA;EAAA,+BAAA;AxEs/UZ;;AwE7/UQ;EAOI,8BAAA;EAAA,iCAAA;AxE2/UZ;;AwElgVQ;EAOI,4BAAA;EAAA,+BAAA;AxEggVZ;;AwEvgVQ;EAOI,4BAAA;EAAA,+BAAA;AxEqgVZ;;AwE5gVQ;EAOI,6BAAA;EAAA,gCAAA;AxE0gVZ;;AwEjhVQ;EAOI,yBAAA;AxE8gVZ;;AwErhVQ;EAOI,+BAAA;AxEkhVZ;;AwEzhVQ;EAOI,8BAAA;AxEshVZ;;AwE7hVQ;EAOI,4BAAA;AxE0hVZ;;AwEjiVQ;EAOI,8BAAA;AxE8hVZ;;AwEriVQ;EAOI,4BAAA;AxEkiVZ;;AwEziVQ;EAOI,8BAAA;AxEsiVZ;;AwE7iVQ;EAOI,4BAAA;AxE0iVZ;;AwEjjVQ;EAOI,4BAAA;AxE8iVZ;;AwErjVQ;EAOI,6BAAA;AxEkjVZ;;AwEzjVQ;EAOI,2BAAA;AxEsjVZ;;AwE7jVQ;EAOI,iCAAA;AxE0jVZ;;AwEjkVQ;EAOI,gCAAA;AxE8jVZ;;AwErkVQ;EAOI,8BAAA;AxEkkVZ;;AwEzkVQ;EAOI,gCAAA;AxEskVZ;;AwE7kVQ;EAOI,8BAAA;AxE0kVZ;;AwEjlVQ;EAOI,gCAAA;AxE8kVZ;;AwErlVQ;EAOI,8BAAA;AxEklVZ;;AwEzlVQ;EAOI,8BAAA;AxEslVZ;;AwE7lVQ;EAOI,+BAAA;AxE0lVZ;;AwEjmVQ;EAOI,4BAAA;AxE8lVZ;;AwErmVQ;EAOI,kCAAA;AxEkmVZ;;AwEzmVQ;EAOI,iCAAA;AxEsmVZ;;AwE7mVQ;EAOI,+BAAA;AxE0mVZ;;AwEjnVQ;EAOI,iCAAA;AxE8mVZ;;AwErnVQ;EAOI,+BAAA;AxEknVZ;;AwEznVQ;EAOI,iCAAA;AxEsnVZ;;AwE7nVQ;EAOI,+BAAA;AxE0nVZ;;AwEjoVQ;EAOI,+BAAA;AxE8nVZ;;AwEroVQ;EAOI,gCAAA;AxEkoVZ;;AwEzoVQ;EAOI,0BAAA;AxEsoVZ;;AwE7oVQ;EAOI,gCAAA;AxE0oVZ;;AwEjpVQ;EAOI,+BAAA;AxE8oVZ;;AwErpVQ;EAOI,6BAAA;AxEkpVZ;;AwEzpVQ;EAOI,+BAAA;AxEspVZ;;AwE7pVQ;EAOI,6BAAA;AxE0pVZ;;AwEjqVQ;EAOI,+BAAA;AxE8pVZ;;AwErqVQ;EAOI,6BAAA;AxEkqVZ;;AwEzqVQ;EAOI,6BAAA;AxEsqVZ;;AwE7qVQ;EAOI,8BAAA;AxE0qVZ;;AwEjrVQ;EAOI,iBAAA;AxE8qVZ;;AwErrVQ;EAOI,uBAAA;AxEkrVZ;;AwEzrVQ;EAOI,sBAAA;AxEsrVZ;;AwE7rVQ;EAOI,oBAAA;AxE0rVZ;;AwEjsVQ;EAOI,sBAAA;AxE8rVZ;;AwErsVQ;EAOI,oBAAA;AxEksVZ;;AwEzsVQ;EAOI,sBAAA;AxEssVZ;;AwE7sVQ;EAOI,oBAAA;AxE0sVZ;;AwEjtVQ;EAOI,oBAAA;AxE8sVZ;;AwErtVQ;EAOI,qBAAA;AxEktVZ;;AwEztVQ;EAOI,qBAAA;AxEstVZ;;AwE7tVQ;EAOI,2BAAA;AxE0tVZ;;AwEjuVQ;EAOI,0BAAA;AxE8tVZ;;AwEruVQ;EAOI,wBAAA;AxEkuVZ;;AwEzuVQ;EAOI,0BAAA;AxEsuVZ;;AwE7uVQ;EAOI,wBAAA;AxE0uVZ;;AwEjvVQ;EAOI,0BAAA;AxE8uVZ;;AwErvVQ;EAOI,wBAAA;AxEkvVZ;;AwEzvVQ;EAOI,wBAAA;AxEsvVZ;;AwE7vVQ;EAOI,yBAAA;AxE0vVZ;;AwEjwVQ;EAOI,wBAAA;AxE8vVZ;;AwErwVQ;EAOI,8BAAA;AxEkwVZ;;AwEzwVQ;EAOI,6BAAA;AxEswVZ;;AwE7wVQ;EAOI,2BAAA;AxE0wVZ;;AwEjxVQ;EAOI,6BAAA;AxE8wVZ;;AwErxVQ;EAOI,2BAAA;AxEkxVZ;;AwEzxVQ;EAOI,6BAAA;AxEsxVZ;;AwE7xVQ;EAOI,2BAAA;AxE0xVZ;;AwEjyVQ;EAOI,2BAAA;AxE8xVZ;;AwEryVQ;EAOI,4BAAA;AxEkyVZ;;AwEzyVQ;EAOI,gDAAA;AxEsyVZ;;AwE7yVQ;EAOI,8CAAA;AxE0yVZ;;AwEjzVQ;EAOI,6CAAA;AxE8yVZ;;AwErzVQ;EAOI,gDAAA;AxEkzVZ;;AwEzzVQ;EAOI,8CAAA;AxEszVZ;;AwE7zVQ;EAOI,gDAAA;AxE0zVZ;;AwEj0VQ;EAOI,6BAAA;AxE8zVZ;;AwEr0VQ;EAOI,6BAAA;AxEk0VZ;;AwEz0VQ;EAOI,6BAAA;AxEs0VZ;;AwE70VQ;EAOI,+BAAA;AxE00VZ;;AwEj1VQ;EAOI,2BAAA;AxE80VZ;;AwEr1VQ;EAOI,2BAAA;AxEk1VZ;;AwEz1VQ;EAOI,2BAAA;AxEs1VZ;;AwE71VQ;EAOI,2BAAA;AxE01VZ;;AwEj2VQ;EAOI,2BAAA;AxE81VZ;;AwEr2VQ;EAOI,8BAAA;AxEk2VZ;;AwEz2VQ;EAOI,yBAAA;AxEs2VZ;;AwE72VQ;EAOI,4BAAA;AxE02VZ;;AwEj3VQ;EAOI,2BAAA;AxE82VZ;;AwEr3VQ;EAOI,yBAAA;AxEk3VZ;;AwEz3VQ;EAOI,2BAAA;AxEs3VZ;;AwE73VQ;EAOI,4BAAA;AxE03VZ;;AwEj4VQ;EAOI,6BAAA;AxE83VZ;;AwEr4VQ;EAOI,gCAAA;AxEk4VZ;;AwEz4VQ;EAOI,qCAAA;AxEs4VZ;;AwE74VQ;EAOI,wCAAA;AxE04VZ;;AwEj5VQ;EAOI,oCAAA;AxE84VZ;;AwEr5VQ;EAOI,oCAAA;AxEk5VZ;;AwEz5VQ;EAOI,qCAAA;AxEs5VZ;;AwE75VQ;EAOI,8BAAA;AxE05VZ;;AwEj6VQ;EAOI,8BAAA;AxE85VZ;;AwEn7VQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AxEo6VZ;;AwEj5VQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AxE06VZ;;AwEj7VQ;EAIQ,oBAAA;EAGJ,uEAAA;AxE+6VZ;;AwEt7VQ;EAIQ,oBAAA;EAGJ,qEAAA;AxEo7VZ;;AwE37VQ;EAIQ,oBAAA;EAGJ,kEAAA;AxEy7VZ;;AwEh8VQ;EAIQ,oBAAA;EAGJ,qEAAA;AxE87VZ;;AwEr8VQ;EAIQ,oBAAA;EAGJ,oEAAA;AxEm8VZ;;AwE18VQ;EAIQ,oBAAA;EAGJ,mEAAA;AxEw8VZ;;AwE/8VQ;EAIQ,oBAAA;EAGJ,kEAAA;AxE68VZ;;AwEp9VQ;EAIQ,oBAAA;EAGJ,mEAAA;AxEk9VZ;;AwEz9VQ;EAIQ,oBAAA;EAGJ,mEAAA;AxEu9VZ;;AwE99VQ;EAIQ,oBAAA;EAGJ,wEAAA;AxE49VZ;;AwEn+VQ;EAIQ,oBAAA;EAGJ,2CAAA;AxEi+VZ;;AwEx+VQ;EAIQ,oBAAA;EAGJ,oCAAA;AxEs+VZ;;AwE7+VQ;EAIQ,oBAAA;EAGJ,0CAAA;AxE2+VZ;;AwEl/VQ;EAIQ,oBAAA;EAGJ,2CAAA;AxEg/VZ;;AwEv/VQ;EAIQ,oBAAA;EAGJ,0CAAA;AxEq/VZ;;AwE5/VQ;EAIQ,oBAAA;EAGJ,0CAAA;AxE0/VZ;;AwEjgWQ;EAIQ,oBAAA;EAGJ,yBAAA;AxE+/VZ;;AwEhhWQ;EACE,uBAAA;AxEmhWV;;AwEphWQ;EACE,sBAAA;AxEuhWV;;AwExhWQ;EACE,uBAAA;AxE2hWV;;AwE5hWQ;EACE,oBAAA;AxE+hWV;;AwEthWQ;EAOI,iDAAA;AxEmhWZ;;AwE1hWQ;EAOI,mDAAA;AxEuhWZ;;AwE9hWQ;EAOI,iDAAA;AxE2hWZ;;AwEliWQ;EAOI,8CAAA;AxE+hWZ;;AwEtiWQ;EAOI,iDAAA;AxEmiWZ;;AwE1iWQ;EAOI,gDAAA;AxEuiWZ;;AwE9iWQ;EAOI,+CAAA;AxE2iWZ;;AwEljWQ;EAOI,8CAAA;AxE+iWZ;;AwEhkWQ;EACE,sBAAA;AxEmkWV;;AwE/jWU;EACE,sBAAA;AxEkkWZ;;AwExkWQ;EACE,uBAAA;AxE2kWV;;AwEvkWU;EACE,uBAAA;AxE0kWZ;;AwEhlWQ;EACE,sBAAA;AxEmlWV;;AwE/kWU;EACE,sBAAA;AxEklWZ;;AwExlWQ;EACE,uBAAA;AxE2lWV;;AwEvlWU;EACE,uBAAA;AxE0lWZ;;AwEhmWQ;EACE,oBAAA;AxEmmWV;;AwE/lWU;EACE,oBAAA;AxEkmWZ;;AwE9lWQ;EAOI,yCAAA;AxE2lWZ;;AwEtlWU;EAOI,yCAAA;AxEmlWd;;AwEtmWQ;EAOI,wCAAA;AxEmmWZ;;AwE9lWU;EAOI,wCAAA;AxE2lWd;;AwE9mWQ;EAOI,yCAAA;AxE2mWZ;;AwEtmWU;EAOI,yCAAA;AxEmmWd;;AwEtnWQ;EAIQ,8BAAA;EAGJ,+FAAA;AxEonWZ;;AwE3nWQ;EAIQ,8BAAA;EAGJ,iGAAA;AxEynWZ;;AwEhoWQ;EAIQ,8BAAA;EAGJ,+FAAA;AxE8nWZ;;AwEroWQ;EAIQ,8BAAA;EAGJ,4FAAA;AxEmoWZ;;AwE1oWQ;EAIQ,8BAAA;EAGJ,+FAAA;AxEwoWZ;;AwE/oWQ;EAIQ,8BAAA;EAGJ,8FAAA;AxE6oWZ;;AwEppWQ;EAIQ,8BAAA;EAGJ,6FAAA;AxEkpWZ;;AwEzpWQ;EAIQ,8BAAA;EAGJ,4FAAA;AxEupWZ;;AwE9pWQ;EAIQ,8BAAA;EAGJ,qGAAA;AxE4pWZ;;AwE7qWQ;EACE,8BAAA;AxEgrWV;;AwE5qWU;EACE,8BAAA;AxE+qWZ;;AwErrWQ;EACE,gCAAA;AxEwrWV;;AwEprWU;EACE,gCAAA;AxEurWZ;;AwE7rWQ;EACE,iCAAA;AxEgsWV;;AwE5rWU;EACE,iCAAA;AxE+rWZ;;AwErsWQ;EACE,gCAAA;AxEwsWV;;AwEpsWU;EACE,gCAAA;AxEusWZ;;AwE7sWQ;EACE,iCAAA;AxEgtWV;;AwE5sWU;EACE,iCAAA;AxE+sWZ;;AwErtWQ;EACE,8BAAA;AxEwtWV;;AwEptWU;EACE,8BAAA;AxEutWZ;;AwEntWQ;EAIQ,kBAAA;EAGJ,8EAAA;AxEitWZ;;AwExtWQ;EAIQ,kBAAA;EAGJ,gFAAA;AxEstWZ;;AwE7tWQ;EAIQ,kBAAA;EAGJ,8EAAA;AxE2tWZ;;AwEluWQ;EAIQ,kBAAA;EAGJ,2EAAA;AxEguWZ;;AwEvuWQ;EAIQ,kBAAA;EAGJ,8EAAA;AxEquWZ;;AwE5uWQ;EAIQ,kBAAA;EAGJ,6EAAA;AxE0uWZ;;AwEjvWQ;EAIQ,kBAAA;EAGJ,4EAAA;AxE+uWZ;;AwEtvWQ;EAIQ,kBAAA;EAGJ,2EAAA;AxEovWZ;;AwE3vWQ;EAIQ,kBAAA;EAGJ,4EAAA;AxEyvWZ;;AwEhwWQ;EAIQ,kBAAA;EAGJ,4EAAA;AxE8vWZ;;AwErwWQ;EAIQ,kBAAA;EAGJ,8EAAA;AxEmwWZ;;AwE1wWQ;EAIQ,kBAAA;EAGJ,wCAAA;AxEwwWZ;;AwE/wWQ;EAIQ,kBAAA;EAGJ,mFAAA;AxE6wWZ;;AwEpxWQ;EAIQ,kBAAA;EAGJ,kFAAA;AxEkxWZ;;AwEnyWQ;EACE,oBAAA;AxEsyWV;;AwEvyWQ;EACE,qBAAA;AxE0yWV;;AwE3yWQ;EACE,oBAAA;AxE8yWV;;AwE/yWQ;EACE,qBAAA;AxEkzWV;;AwEnzWQ;EACE,kBAAA;AxEszWV;;AwE7yWQ;EAOI,wDAAA;AxE0yWZ;;AwEjzWQ;EAOI,0DAAA;AxE8yWZ;;AwErzWQ;EAOI,wDAAA;AxEkzWZ;;AwEzzWQ;EAOI,qDAAA;AxEszWZ;;AwE7zWQ;EAOI,wDAAA;AxE0zWZ;;AwEj0WQ;EAOI,uDAAA;AxE8zWZ;;AwEr0WQ;EAOI,sDAAA;AxEk0WZ;;AwEz0WQ;EAOI,qDAAA;AxEs0WZ;;AwE70WQ;EAOI,+CAAA;AxE00WZ;;AwEj1WQ;EAOI,2BAAA;AxE80WZ;;AwEr1WQ;EAOI,4BAAA;AxEk1WZ;;AwEz1WQ;EAOI,4BAAA;AxEs1WZ;;AwE71WQ;EAOI,+BAAA;AxE01WZ;;AwEj2WQ;EAOI,+BAAA;AxE81WZ;;AwEr2WQ;EAOI,iDAAA;AxEk2WZ;;AwEz2WQ;EAOI,2BAAA;AxEs2WZ;;AwE72WQ;EAOI,oDAAA;AxE02WZ;;AwEj3WQ;EAOI,iDAAA;AxE82WZ;;AwEr3WQ;EAOI,oDAAA;AxEk3WZ;;AwEz3WQ;EAOI,oDAAA;AxEs3WZ;;AwE73WQ;EAOI,qDAAA;AxE03WZ;;AwEj4WQ;EAOI,6BAAA;AxE83WZ;;AwEr4WQ;EAOI,sDAAA;AxEk4WZ;;AwEz4WQ;EAOI,8BAAA;AxEs4WZ;;AwE74WQ;EAOI,8BAAA;AxE04WZ;;AwEj5WQ;EAOI,8BAAA;AxE84WZ;;AwEr5WQ;EAOI,0DAAA;EAAA,2DAAA;AxEm5WZ;;AwE15WQ;EAOI,oCAAA;EAAA,qCAAA;AxEw5WZ;;AwE/5WQ;EAOI,6DAAA;EAAA,8DAAA;AxE65WZ;;AwEp6WQ;EAOI,0DAAA;EAAA,2DAAA;AxEk6WZ;;AwEz6WQ;EAOI,6DAAA;EAAA,8DAAA;AxEu6WZ;;AwE96WQ;EAOI,6DAAA;EAAA,8DAAA;AxE46WZ;;AwEn7WQ;EAOI,8DAAA;EAAA,+DAAA;AxEi7WZ;;AwEx7WQ;EAOI,sCAAA;EAAA,uCAAA;AxEs7WZ;;AwE77WQ;EAOI,+DAAA;EAAA,gEAAA;AxE27WZ;;AwEl8WQ;EAOI,2DAAA;EAAA,8DAAA;AxEg8WZ;;AwEv8WQ;EAOI,qCAAA;EAAA,wCAAA;AxEq8WZ;;AwE58WQ;EAOI,8DAAA;EAAA,iEAAA;AxE08WZ;;AwEj9WQ;EAOI,2DAAA;EAAA,8DAAA;AxE+8WZ;;AwEt9WQ;EAOI,8DAAA;EAAA,iEAAA;AxEo9WZ;;AwE39WQ;EAOI,8DAAA;EAAA,iEAAA;AxEy9WZ;;AwEh+WQ;EAOI,+DAAA;EAAA,kEAAA;AxE89WZ;;AwEr+WQ;EAOI,uCAAA;EAAA,0CAAA;AxEm+WZ;;AwE1+WQ;EAOI,gEAAA;EAAA,mEAAA;AxEw+WZ;;AwE/+WQ;EAOI,8DAAA;EAAA,6DAAA;AxE6+WZ;;AwEp/WQ;EAOI,wCAAA;EAAA,uCAAA;AxEk/WZ;;AwEz/WQ;EAOI,iEAAA;EAAA,gEAAA;AxEu/WZ;;AwE9/WQ;EAOI,8DAAA;EAAA,6DAAA;AxE4/WZ;;AwEngXQ;EAOI,iEAAA;EAAA,gEAAA;AxEigXZ;;AwExgXQ;EAOI,iEAAA;EAAA,gEAAA;AxEsgXZ;;AwE7gXQ;EAOI,kEAAA;EAAA,iEAAA;AxE2gXZ;;AwElhXQ;EAOI,0CAAA;EAAA,yCAAA;AxEghXZ;;AwEvhXQ;EAOI,mEAAA;EAAA,kEAAA;AxEqhXZ;;AwE5hXQ;EAOI,6DAAA;EAAA,0DAAA;AxE0hXZ;;AwEjiXQ;EAOI,uCAAA;EAAA,oCAAA;AxE+hXZ;;AwEtiXQ;EAOI,gEAAA;EAAA,6DAAA;AxEoiXZ;;AwE3iXQ;EAOI,6DAAA;EAAA,0DAAA;AxEyiXZ;;AwEhjXQ;EAOI,gEAAA;EAAA,6DAAA;AxE8iXZ;;AwErjXQ;EAOI,gEAAA;EAAA,6DAAA;AxEmjXZ;;AwE1jXQ;EAOI,iEAAA;EAAA,8DAAA;AxEwjXZ;;AwE/jXQ;EAOI,yCAAA;EAAA,sCAAA;AxE6jXZ;;AwEpkXQ;EAOI,kEAAA;EAAA,+DAAA;AxEkkXZ;;AwEzkXQ;EAOI,8BAAA;AxEskXZ;;AwE7kXQ;EAOI,6BAAA;AxE0kXZ;;AwEjlXQ;EAOI,sBAAA;AxE8kXZ;;AwErlXQ;EAOI,qBAAA;AxEklXZ;;AwEzlXQ;EAOI,qBAAA;AxEslXZ;;AwE7lXQ;EAOI,qBAAA;AxE0lXZ;;AwEjmXQ;EAOI,qBAAA;AxE8lXZ;;AMxmXI;EkEGI;IAOI,sBAAA;ExEmmXV;EwE1mXM;IAOI,uBAAA;ExEsmXV;EwE7mXM;IAOI,sBAAA;ExEymXV;EwEhnXM;IAOI,8BAAA;ExE4mXV;EwEnnXM;IAOI,4BAAA;ExE+mXV;EwEtnXM;IAOI,2BAAA;ExEknXV;EwEznXM;IAOI,iCAAA;ExEqnXV;EwE5nXM;IAOI,2BAAA;ExEwnXV;EwE/nXM;IAOI,qBAAA;ExE2nXV;EwEloXM;IAOI,wBAAA;ExE8nXV;EwEroXM;IAOI,uBAAA;ExEioXV;EwExoXM;IAOI,wBAAA;ExEooXV;EwE3oXM;IAOI,qBAAA;ExEuoXV;EwE9oXM;IAOI,uBAAA;ExE0oXV;EwEjpXM;IAOI,uBAAA;ExE6oXV;EwEppXM;IAOI,wBAAA;ExEgpXV;EwEvpXM;IAOI,uBAAA;ExEmpXV;EwE1pXM;IAOI,uBAAA;ExEspXV;EwE7pXM;IAOI,wBAAA;ExEypXV;EwEhqXM;IAOI,uBAAA;ExE4pXV;EwEnqXM;IAOI,wBAAA;ExE+pXV;EwEtqXM;IAOI,uBAAA;ExEkqXV;EwEzqXM;IAOI,wBAAA;ExEqqXV;EwE5qXM;IAOI,uBAAA;ExEwqXV;EwE/qXM;IAOI,uBAAA;ExE2qXV;EwElrXM;IAOI,wBAAA;ExE8qXV;EwErrXM;IAOI,uBAAA;ExEirXV;EwExrXM;IAOI,wBAAA;ExEorXV;EwE3rXM;IAOI,0BAAA;ExEurXV;EwE9rXM;IAOI,gCAAA;ExE0rXV;EwEjsXM;IAOI,yBAAA;ExE6rXV;EwEpsXM;IAOI,wBAAA;ExEgsXV;EwEvsXM;IAOI,+BAAA;ExEmsXV;EwE1sXM;IAOI,yBAAA;ExEssXV;EwE7sXM;IAOI,6BAAA;ExEysXV;EwEhtXM;IAOI,8BAAA;ExE4sXV;EwEntXM;IAOI,wBAAA;ExE+sXV;EwEttXM;IAOI,+BAAA;ExEktXV;EwEztXM;IAOI,wBAAA;ExEqtXV;EwE5tXM;IAOI,iBAAA;ExEwtXV;EwE/tXM;IAOI,mBAAA;ExE2tXV;EwEluXM;IAOI,oBAAA;ExE8tXV;EwEruXM;IAOI,kBAAA;ExEiuXV;EwExuXM;IAOI,kBAAA;ExEouXV;EwE3uXM;IAOI,kBAAA;ExEuuXV;EwE9uXM;IAOI,kBAAA;ExE0uXV;EwEjvXM;IAOI,kBAAA;ExE6uXV;EwEpvXM;IAOI,mBAAA;ExEgvXV;EwEvvXM;IAOI,mBAAA;ExEmvXV;EwE1vXM;IAOI,mBAAA;ExEsvXV;EwE7vXM;IAOI,mBAAA;ExEyvXV;EwEhwXM;IAOI,mBAAA;ExE4vXV;EwEnwXM;IAOI,mBAAA;ExE+vXV;EwEtwXM;IAOI,mBAAA;ExEkwXV;EwEzwXM;IAOI,mBAAA;ExEqwXV;EwE5wXM;IAOI,mBAAA;ExEwwXV;EwE/wXM;IAOI,mBAAA;ExE2wXV;EwElxXM;IAOI,mBAAA;ExE8wXV;EwErxXM;IAOI,mBAAA;ExEixXV;EwExxXM;IAOI,mBAAA;ExEoxXV;EwE3xXM;IAOI,mBAAA;ExEuxXV;EwE9xXM;IAOI,mBAAA;ExE0xXV;EwEjyXM;IAOI,mBAAA;ExE6xXV;EwEpyXM;IAOI,mBAAA;ExEgyXV;EwEvyXM;IAOI,oBAAA;ExEmyXV;EwE1yXM;IAOI,oBAAA;ExEsyXV;EwE7yXM;IAOI,sBAAA;ExEyyXV;EwEhzXM;IAOI,uBAAA;ExE4yXV;EwEnzXM;IAOI,qBAAA;ExE+yXV;EwEtzXM;IAOI,qBAAA;ExEkzXV;EwEzzXM;IAOI,qBAAA;ExEqzXV;EwE5zXM;IAOI,qBAAA;ExEwzXV;EwE/zXM;IAOI,qBAAA;ExE2zXV;EwEl0XM;IAOI,sBAAA;ExE8zXV;EwEr0XM;IAOI,sBAAA;ExEi0XV;EwEx0XM;IAOI,sBAAA;ExEo0XV;EwE30XM;IAOI,sBAAA;ExEu0XV;EwE90XM;IAOI,sBAAA;ExE00XV;EwEj1XM;IAOI,sBAAA;ExE60XV;EwEp1XM;IAOI,sBAAA;ExEg1XV;EwEv1XM;IAOI,sBAAA;ExEm1XV;EwE11XM;IAOI,sBAAA;ExEs1XV;EwE71XM;IAOI,sBAAA;ExEy1XV;EwEh2XM;IAOI,sBAAA;ExE41XV;EwEn2XM;IAOI,sBAAA;ExE+1XV;EwEt2XM;IAOI,sBAAA;ExEk2XV;EwEz2XM;IAOI,sBAAA;ExEq2XV;EwE52XM;IAOI,sBAAA;ExEw2XV;EwE/2XM;IAOI,sBAAA;ExE22XV;EwEl3XM;IAOI,sBAAA;ExE82XV;EwEr3XM;IAOI,uBAAA;ExEi3XV;EwEx3XM;IAOI,kBAAA;ExEo3XV;EwE33XM;IAOI,oBAAA;ExEu3XV;EwE93XM;IAOI,qBAAA;ExE03XV;EwEj4XM;IAOI,mBAAA;ExE63XV;EwEp4XM;IAOI,mBAAA;ExEg4XV;EwEv4XM;IAOI,mBAAA;ExEm4XV;EwE14XM;IAOI,mBAAA;ExEs4XV;EwE74XM;IAOI,mBAAA;ExEy4XV;EwEh5XM;IAOI,oBAAA;ExE44XV;EwEn5XM;IAOI,oBAAA;ExE+4XV;EwEt5XM;IAOI,oBAAA;ExEk5XV;EwEz5XM;IAOI,oBAAA;ExEq5XV;EwE55XM;IAOI,oBAAA;ExEw5XV;EwE/5XM;IAOI,oBAAA;ExE25XV;EwEl6XM;IAOI,oBAAA;ExE85XV;EwEr6XM;IAOI,oBAAA;ExEi6XV;EwEx6XM;IAOI,oBAAA;ExEo6XV;EwE36XM;IAOI,oBAAA;ExEu6XV;EwE96XM;IAOI,oBAAA;ExE06XV;EwEj7XM;IAOI,oBAAA;ExE66XV;EwEp7XM;IAOI,oBAAA;ExEg7XV;EwEv7XM;IAOI,oBAAA;ExEm7XV;EwE17XM;IAOI,oBAAA;ExEs7XV;EwE77XM;IAOI,oBAAA;ExEy7XV;EwEh8XM;IAOI,oBAAA;ExE47XV;EwEn8XM;IAOI,qBAAA;ExE+7XV;EwEt8XM;IAOI,mBAAA;ExEk8XV;EwEz8XM;IAOI,qBAAA;ExEq8XV;EwE58XM;IAOI,sBAAA;ExEw8XV;EwE/8XM;IAOI,oBAAA;ExE28XV;EwEl9XM;IAOI,oBAAA;ExE88XV;EwEr9XM;IAOI,oBAAA;ExEi9XV;EwEx9XM;IAOI,oBAAA;ExEo9XV;EwE39XM;IAOI,oBAAA;ExEu9XV;EwE99XM;IAOI,qBAAA;ExE09XV;EwEj+XM;IAOI,qBAAA;ExE69XV;EwEp+XM;IAOI,qBAAA;ExEg+XV;EwEv+XM;IAOI,qBAAA;ExEm+XV;EwE1+XM;IAOI,qBAAA;ExEs+XV;EwE7+XM;IAOI,qBAAA;ExEy+XV;EwEh/XM;IAOI,qBAAA;ExE4+XV;EwEn/XM;IAOI,qBAAA;ExE++XV;EwEt/XM;IAOI,qBAAA;ExEk/XV;EwEz/XM;IAOI,qBAAA;ExEq/XV;EwE5/XM;IAOI,qBAAA;ExEw/XV;EwE//XM;IAOI,qBAAA;ExE2/XV;EwElgYM;IAOI,qBAAA;ExE8/XV;EwErgYM;IAOI,qBAAA;ExEigYV;EwExgYM;IAOI,qBAAA;ExEogYV;EwE3gYM;IAOI,qBAAA;ExEugYV;EwE9gYM;IAOI,qBAAA;ExE0gYV;EwEjhYM;IAOI,sBAAA;ExE6gYV;EwEphYM;IAOI,qBAAA;ExEghYV;EwEvhYM;IAOI,qBAAA;ExEmhYV;EwE1hYM;IAOI,qBAAA;ExEshYV;EwE7hYM;IAOI,sBAAA;ExEyhYV;EwEhiYM;IAOI,sBAAA;ExE4hYV;EwEniYM;IAOI,oBAAA;ExE+hYV;EwEtiYM;IAOI,qBAAA;ExEkiYV;EwEziYM;IAOI,qBAAA;ExEqiYV;EwE5iYM;IAOI,qBAAA;ExEwiYV;EwE/iYM;IAOI,qBAAA;ExE2iYV;EwEljYM;IAOI,qBAAA;ExE8iYV;EwErjYM;IAOI,qBAAA;ExEijYV;EwExjYM;IAOI,qBAAA;ExEojYV;EwE3jYM;IAOI,qBAAA;ExEujYV;EwE9jYM;IAOI,qBAAA;ExE0jYV;EwEjkYM;IAOI,qBAAA;ExE6jYV;EwEpkYM;IAOI,qBAAA;ExEgkYV;EwEvkYM;IAOI,qBAAA;ExEmkYV;EwE1kYM;IAOI,qBAAA;ExEskYV;EwE7kYM;IAOI,qBAAA;ExEykYV;EwEhlYM;IAOI,qBAAA;ExE4kYV;EwEnlYM;IAOI,sBAAA;ExE+kYV;EwEtlYM;IAOI,sBAAA;ExEklYV;EwEzlYM;IAOI,sBAAA;ExEqlYV;EwE5lYM;IAOI,uBAAA;ExEwlYV;EwE/lYM;IAOI,uBAAA;ExE2lYV;EwElmYM;IAOI,qBAAA;ExE8lYV;EwErmYM;IAOI,sBAAA;ExEimYV;EwExmYM;IAOI,sBAAA;ExEomYV;EwE3mYM;IAOI,sBAAA;ExEumYV;EwE9mYM;IAOI,sBAAA;ExE0mYV;EwEjnYM;IAOI,sBAAA;ExE6mYV;EwEpnYM;IAOI,sBAAA;ExEgnYV;EwEvnYM;IAOI,sBAAA;ExEmnYV;EwE1nYM;IAOI,sBAAA;ExEsnYV;EwE7nYM;IAOI,sBAAA;ExEynYV;EwEhoYM;IAOI,sBAAA;ExE4nYV;EwEnoYM;IAOI,sBAAA;ExE+nYV;EwEtoYM;IAOI,sBAAA;ExEkoYV;EwEzoYM;IAOI,sBAAA;ExEqoYV;EwE5oYM;IAOI,sBAAA;ExEwoYV;EwE/oYM;IAOI,sBAAA;ExE2oYV;EwElpYM;IAOI,yBAAA;ExE8oYV;EwErpYM;IAOI,8BAAA;ExEipYV;EwExpYM;IAOI,iCAAA;ExEopYV;EwE3pYM;IAOI,sCAAA;ExEupYV;EwE9pYM;IAOI,yCAAA;ExE0pYV;EwEjqYM;IAOI,uBAAA;ExE6pYV;EwEpqYM;IAOI,uBAAA;ExEgqYV;EwEvqYM;IAOI,yBAAA;ExEmqYV;EwE1qYM;IAOI,yBAAA;ExEsqYV;EwE7qYM;IAOI,0BAAA;ExEyqYV;EwEhrYM;IAOI,4BAAA;ExE4qYV;EwEnrYM;IAOI,kCAAA;ExE+qYV;EwEtrYM;IAOI,sCAAA;ExEkrYV;EwEzrYM;IAOI,oCAAA;ExEqrYV;EwE5rYM;IAOI,kCAAA;ExEwrYV;EwE/rYM;IAOI,yCAAA;ExE2rYV;EwElsYM;IAOI,wCAAA;ExE8rYV;EwErsYM;IAOI,wCAAA;ExEisYV;EwExsYM;IAOI,kCAAA;ExEosYV;EwE3sYM;IAOI,gCAAA;ExEusYV;EwE9sYM;IAOI,8BAAA;ExE0sYV;EwEjtYM;IAOI,gCAAA;ExE6sYV;EwEptYM;IAOI,+BAAA;ExEgtYV;EwEvtYM;IAOI,oCAAA;ExEmtYV;EwE1tYM;IAOI,kCAAA;ExEstYV;EwE7tYM;IAOI,gCAAA;ExEytYV;EwEhuYM;IAOI,uCAAA;ExE4tYV;EwEnuYM;IAOI,sCAAA;ExE+tYV;EwEtuYM;IAOI,iCAAA;ExEkuYV;EwEzuYM;IAOI,2BAAA;ExEquYV;EwE5uYM;IAOI,iCAAA;ExEwuYV;EwE/uYM;IAOI,+BAAA;ExE2uYV;EwElvYM;IAOI,6BAAA;ExE8uYV;EwErvYM;IAOI,+BAAA;ExEivYV;EwExvYM;IAOI,8BAAA;ExEovYV;EwE3vYM;IAOI,oBAAA;ExEuvYV;EwE9vYM;IAOI,mBAAA;ExE0vYV;EwEjwYM;IAOI,mBAAA;ExE6vYV;EwEpwYM;IAOI,mBAAA;ExEgwYV;EwEvwYM;IAOI,mBAAA;ExEmwYV;EwE1wYM;IAOI,mBAAA;ExEswYV;EwE7wYM;IAOI,mBAAA;ExEywYV;EwEhxYM;IAOI,mBAAA;ExE4wYV;EwEnxYM;IAOI,oBAAA;ExE+wYV;EwEtxYM;IAOI,0BAAA;ExEkxYV;EwEzxYM;IAOI,yBAAA;ExEqxYV;EwE5xYM;IAOI,uBAAA;ExEwxYV;EwE/xYM;IAOI,yBAAA;ExE2xYV;EwElyYM;IAOI,uBAAA;ExE8xYV;EwEryYM;IAOI,yBAAA;ExEiyYV;EwExyYM;IAOI,uBAAA;ExEoyYV;EwE3yYM;IAOI,uBAAA;ExEuyYV;EwE9yYM;IAOI,wBAAA;ExE0yYV;EwEjzYM;IAOI,uBAAA;ExE6yYV;EwEpzYM;IAOI,0BAAA;IAAA,yBAAA;ExEizYV;EwExzYM;IAOI,gCAAA;IAAA,+BAAA;ExEqzYV;EwE5zYM;IAOI,+BAAA;IAAA,8BAAA;ExEyzYV;EwEh0YM;IAOI,6BAAA;IAAA,4BAAA;ExE6zYV;EwEp0YM;IAOI,+BAAA;IAAA,8BAAA;ExEi0YV;EwEx0YM;IAOI,6BAAA;IAAA,4BAAA;ExEq0YV;EwE50YM;IAOI,+BAAA;IAAA,8BAAA;ExEy0YV;EwEh1YM;IAOI,6BAAA;IAAA,4BAAA;ExE60YV;EwEp1YM;IAOI,6BAAA;IAAA,4BAAA;ExEi1YV;EwEx1YM;IAOI,8BAAA;IAAA,6BAAA;ExEq1YV;EwE51YM;IAOI,6BAAA;IAAA,4BAAA;ExEy1YV;EwEh2YM;IAOI,wBAAA;IAAA,2BAAA;ExE61YV;EwEp2YM;IAOI,8BAAA;IAAA,iCAAA;ExEi2YV;EwEx2YM;IAOI,6BAAA;IAAA,gCAAA;ExEq2YV;EwE52YM;IAOI,2BAAA;IAAA,8BAAA;ExEy2YV;EwEh3YM;IAOI,6BAAA;IAAA,gCAAA;ExE62YV;EwEp3YM;IAOI,2BAAA;IAAA,8BAAA;ExEi3YV;EwEx3YM;IAOI,6BAAA;IAAA,gCAAA;ExEq3YV;EwE53YM;IAOI,2BAAA;IAAA,8BAAA;ExEy3YV;EwEh4YM;IAOI,2BAAA;IAAA,8BAAA;ExE63YV;EwEp4YM;IAOI,4BAAA;IAAA,+BAAA;ExEi4YV;EwEx4YM;IAOI,2BAAA;IAAA,8BAAA;ExEq4YV;EwE54YM;IAOI,wBAAA;ExEw4YV;EwE/4YM;IAOI,8BAAA;ExE24YV;EwEl5YM;IAOI,6BAAA;ExE84YV;EwEr5YM;IAOI,2BAAA;ExEi5YV;EwEx5YM;IAOI,6BAAA;ExEo5YV;EwE35YM;IAOI,2BAAA;ExEu5YV;EwE95YM;IAOI,6BAAA;ExE05YV;EwEj6YM;IAOI,2BAAA;ExE65YV;EwEp6YM;IAOI,2BAAA;ExEg6YV;EwEv6YM;IAOI,4BAAA;ExEm6YV;EwE16YM;IAOI,2BAAA;ExEs6YV;EwE76YM;IAOI,0BAAA;ExEy6YV;EwEh7YM;IAOI,gCAAA;ExE46YV;EwEn7YM;IAOI,+BAAA;ExE+6YV;EwEt7YM;IAOI,6BAAA;ExEk7YV;EwEz7YM;IAOI,+BAAA;ExEq7YV;EwE57YM;IAOI,6BAAA;ExEw7YV;EwE/7YM;IAOI,+BAAA;ExE27YV;EwEl8YM;IAOI,6BAAA;ExE87YV;EwEr8YM;IAOI,6BAAA;ExEi8YV;EwEx8YM;IAOI,8BAAA;ExEo8YV;EwE38YM;IAOI,6BAAA;ExEu8YV;EwE98YM;IAOI,2BAAA;ExE08YV;EwEj9YM;IAOI,iCAAA;ExE68YV;EwEp9YM;IAOI,gCAAA;ExEg9YV;EwEv9YM;IAOI,8BAAA;ExEm9YV;EwE19YM;IAOI,gCAAA;ExEs9YV;EwE79YM;IAOI,8BAAA;ExEy9YV;EwEh+YM;IAOI,gCAAA;ExE49YV;EwEn+YM;IAOI,8BAAA;ExE+9YV;EwEt+YM;IAOI,8BAAA;ExEk+YV;EwEz+YM;IAOI,+BAAA;ExEq+YV;EwE5+YM;IAOI,8BAAA;ExEw+YV;EwE/+YM;IAOI,yBAAA;ExE2+YV;EwEl/YM;IAOI,+BAAA;ExE8+YV;EwEr/YM;IAOI,8BAAA;ExEi/YV;EwEx/YM;IAOI,4BAAA;ExEo/YV;EwE3/YM;IAOI,8BAAA;ExEu/YV;EwE9/YM;IAOI,4BAAA;ExE0/YV;EwEjgZM;IAOI,8BAAA;ExE6/YV;EwEpgZM;IAOI,4BAAA;ExEggZV;EwEvgZM;IAOI,4BAAA;ExEmgZV;EwE1gZM;IAOI,6BAAA;ExEsgZV;EwE7gZM;IAOI,4BAAA;ExEygZV;EwEhhZM;IAOI,2BAAA;ExE4gZV;EwEnhZM;IAOI,0BAAA;ExE+gZV;EwEthZM;IAOI,wBAAA;ExEkhZV;EwEzhZM;IAOI,0BAAA;ExEqhZV;EwE5hZM;IAOI,wBAAA;ExEwhZV;EwE/hZM;IAOI,0BAAA;ExE2hZV;EwEliZM;IAOI,wBAAA;ExE8hZV;EwEriZM;IAOI,wBAAA;ExEiiZV;EwExiZM;IAOI,yBAAA;ExEoiZV;EwE3iZM;IAOI,iCAAA;IAAA,gCAAA;ExEwiZV;EwE/iZM;IAOI,gCAAA;IAAA,+BAAA;ExE4iZV;EwEnjZM;IAOI,8BAAA;IAAA,6BAAA;ExEgjZV;EwEvjZM;IAOI,gCAAA;IAAA,+BAAA;ExEojZV;EwE3jZM;IAOI,8BAAA;IAAA,6BAAA;ExEwjZV;EwE/jZM;IAOI,gCAAA;IAAA,+BAAA;ExE4jZV;EwEnkZM;IAOI,8BAAA;IAAA,6BAAA;ExEgkZV;EwEvkZM;IAOI,8BAAA;IAAA,6BAAA;ExEokZV;EwE3kZM;IAOI,+BAAA;IAAA,8BAAA;ExEwkZV;EwE/kZM;IAOI,+BAAA;IAAA,kCAAA;ExE4kZV;EwEnlZM;IAOI,8BAAA;IAAA,iCAAA;ExEglZV;EwEvlZM;IAOI,4BAAA;IAAA,+BAAA;ExEolZV;EwE3lZM;IAOI,8BAAA;IAAA,iCAAA;ExEwlZV;EwE/lZM;IAOI,4BAAA;IAAA,+BAAA;ExE4lZV;EwEnmZM;IAOI,8BAAA;IAAA,iCAAA;ExEgmZV;EwEvmZM;IAOI,4BAAA;IAAA,+BAAA;ExEomZV;EwE3mZM;IAOI,4BAAA;IAAA,+BAAA;ExEwmZV;EwE/mZM;IAOI,6BAAA;IAAA,gCAAA;ExE4mZV;EwEnnZM;IAOI,+BAAA;ExE+mZV;EwEtnZM;IAOI,8BAAA;ExEknZV;EwEznZM;IAOI,4BAAA;ExEqnZV;EwE5nZM;IAOI,8BAAA;ExEwnZV;EwE/nZM;IAOI,4BAAA;ExE2nZV;EwEloZM;IAOI,8BAAA;ExE8nZV;EwEroZM;IAOI,4BAAA;ExEioZV;EwExoZM;IAOI,4BAAA;ExEooZV;EwE3oZM;IAOI,6BAAA;ExEuoZV;EwE9oZM;IAOI,iCAAA;ExE0oZV;EwEjpZM;IAOI,gCAAA;ExE6oZV;EwEppZM;IAOI,8BAAA;ExEgpZV;EwEvpZM;IAOI,gCAAA;ExEmpZV;EwE1pZM;IAOI,8BAAA;ExEspZV;EwE7pZM;IAOI,gCAAA;ExEypZV;EwEhqZM;IAOI,8BAAA;ExE4pZV;EwEnqZM;IAOI,8BAAA;ExE+pZV;EwEtqZM;IAOI,+BAAA;ExEkqZV;EwEzqZM;IAOI,kCAAA;ExEqqZV;EwE5qZM;IAOI,iCAAA;ExEwqZV;EwE/qZM;IAOI,+BAAA;ExE2qZV;EwElrZM;IAOI,iCAAA;ExE8qZV;EwErrZM;IAOI,+BAAA;ExEirZV;EwExrZM;IAOI,iCAAA;ExEorZV;EwE3rZM;IAOI,+BAAA;ExEurZV;EwE9rZM;IAOI,+BAAA;ExE0rZV;EwEjsZM;IAOI,gCAAA;ExE6rZV;EwEpsZM;IAOI,gCAAA;ExEgsZV;EwEvsZM;IAOI,+BAAA;ExEmsZV;EwE1sZM;IAOI,6BAAA;ExEssZV;EwE7sZM;IAOI,+BAAA;ExEysZV;EwEhtZM;IAOI,6BAAA;ExE4sZV;EwEntZM;IAOI,+BAAA;ExE+sZV;EwEttZM;IAOI,6BAAA;ExEktZV;EwEztZM;IAOI,6BAAA;ExEqtZV;EwE5tZM;IAOI,8BAAA;ExEwtZV;EwE/tZM;IAOI,qBAAA;ExE2tZV;EwEluZM;IAOI,2BAAA;ExE8tZV;EwEruZM;IAOI,0BAAA;ExEiuZV;EwExuZM;IAOI,wBAAA;ExEouZV;EwE3uZM;IAOI,0BAAA;ExEuuZV;EwE9uZM;IAOI,wBAAA;ExE0uZV;EwEjvZM;IAOI,0BAAA;ExE6uZV;EwEpvZM;IAOI,wBAAA;ExEgvZV;EwEvvZM;IAOI,wBAAA;ExEmvZV;EwE1vZM;IAOI,yBAAA;ExEsvZV;EwE7vZM;IAOI,2BAAA;IAAA,0BAAA;ExE0vZV;EwEjwZM;IAOI,iCAAA;IAAA,gCAAA;ExE8vZV;EwErwZM;IAOI,gCAAA;IAAA,+BAAA;ExEkwZV;EwEzwZM;IAOI,8BAAA;IAAA,6BAAA;ExEswZV;EwE7wZM;IAOI,gCAAA;IAAA,+BAAA;ExE0wZV;EwEjxZM;IAOI,8BAAA;IAAA,6BAAA;ExE8wZV;EwErxZM;IAOI,gCAAA;IAAA,+BAAA;ExEkxZV;EwEzxZM;IAOI,8BAAA;IAAA,6BAAA;ExEsxZV;EwE7xZM;IAOI,8BAAA;IAAA,6BAAA;ExE0xZV;EwEjyZM;IAOI,+BAAA;IAAA,8BAAA;ExE8xZV;EwEryZM;IAOI,yBAAA;IAAA,4BAAA;ExEkyZV;EwEzyZM;IAOI,+BAAA;IAAA,kCAAA;ExEsyZV;EwE7yZM;IAOI,8BAAA;IAAA,iCAAA;ExE0yZV;EwEjzZM;IAOI,4BAAA;IAAA,+BAAA;ExE8yZV;EwErzZM;IAOI,8BAAA;IAAA,iCAAA;ExEkzZV;EwEzzZM;IAOI,4BAAA;IAAA,+BAAA;ExEszZV;EwE7zZM;IAOI,8BAAA;IAAA,iCAAA;ExE0zZV;EwEj0ZM;IAOI,4BAAA;IAAA,+BAAA;ExE8zZV;EwEr0ZM;IAOI,4BAAA;IAAA,+BAAA;ExEk0ZV;EwEz0ZM;IAOI,6BAAA;IAAA,gCAAA;ExEs0ZV;EwE70ZM;IAOI,yBAAA;ExEy0ZV;EwEh1ZM;IAOI,+BAAA;ExE40ZV;EwEn1ZM;IAOI,8BAAA;ExE+0ZV;EwEt1ZM;IAOI,4BAAA;ExEk1ZV;EwEz1ZM;IAOI,8BAAA;ExEq1ZV;EwE51ZM;IAOI,4BAAA;ExEw1ZV;EwE/1ZM;IAOI,8BAAA;ExE21ZV;EwEl2ZM;IAOI,4BAAA;ExE81ZV;EwEr2ZM;IAOI,4BAAA;ExEi2ZV;EwEx2ZM;IAOI,6BAAA;ExEo2ZV;EwE32ZM;IAOI,2BAAA;ExEu2ZV;EwE92ZM;IAOI,iCAAA;ExE02ZV;EwEj3ZM;IAOI,gCAAA;ExE62ZV;EwEp3ZM;IAOI,8BAAA;ExEg3ZV;EwEv3ZM;IAOI,gCAAA;ExEm3ZV;EwE13ZM;IAOI,8BAAA;ExEs3ZV;EwE73ZM;IAOI,gCAAA;ExEy3ZV;EwEh4ZM;IAOI,8BAAA;ExE43ZV;EwEn4ZM;IAOI,8BAAA;ExE+3ZV;EwEt4ZM;IAOI,+BAAA;ExEk4ZV;EwEz4ZM;IAOI,4BAAA;ExEq4ZV;EwE54ZM;IAOI,kCAAA;ExEw4ZV;EwE/4ZM;IAOI,iCAAA;ExE24ZV;EwEl5ZM;IAOI,+BAAA;ExE84ZV;EwEr5ZM;IAOI,iCAAA;ExEi5ZV;EwEx5ZM;IAOI,+BAAA;ExEo5ZV;EwE35ZM;IAOI,iCAAA;ExEu5ZV;EwE95ZM;IAOI,+BAAA;ExE05ZV;EwEj6ZM;IAOI,+BAAA;ExE65ZV;EwEp6ZM;IAOI,gCAAA;ExEg6ZV;EwEv6ZM;IAOI,0BAAA;ExEm6ZV;EwE16ZM;IAOI,gCAAA;ExEs6ZV;EwE76ZM;IAOI,+BAAA;ExEy6ZV;EwEh7ZM;IAOI,6BAAA;ExE46ZV;EwEn7ZM;IAOI,+BAAA;ExE+6ZV;EwEt7ZM;IAOI,6BAAA;ExEk7ZV;EwEz7ZM;IAOI,+BAAA;ExEq7ZV;EwE57ZM;IAOI,6BAAA;ExEw7ZV;EwE/7ZM;IAOI,6BAAA;ExE27ZV;EwEl8ZM;IAOI,8BAAA;ExE87ZV;EwEr8ZM;IAOI,iBAAA;ExEi8ZV;EwEx8ZM;IAOI,uBAAA;ExEo8ZV;EwE38ZM;IAOI,sBAAA;ExEu8ZV;EwE98ZM;IAOI,oBAAA;ExE08ZV;EwEj9ZM;IAOI,sBAAA;ExE68ZV;EwEp9ZM;IAOI,oBAAA;ExEg9ZV;EwEv9ZM;IAOI,sBAAA;ExEm9ZV;EwE19ZM;IAOI,oBAAA;ExEs9ZV;EwE79ZM;IAOI,oBAAA;ExEy9ZV;EwEh+ZM;IAOI,qBAAA;ExE49ZV;EwEn+ZM;IAOI,qBAAA;ExE+9ZV;EwEt+ZM;IAOI,2BAAA;ExEk+ZV;EwEz+ZM;IAOI,0BAAA;ExEq+ZV;EwE5+ZM;IAOI,wBAAA;ExEw+ZV;EwE/+ZM;IAOI,0BAAA;ExE2+ZV;EwEl/ZM;IAOI,wBAAA;ExE8+ZV;EwEr/ZM;IAOI,0BAAA;ExEi/ZV;EwEx/ZM;IAOI,wBAAA;ExEo/ZV;EwE3/ZM;IAOI,wBAAA;ExEu/ZV;EwE9/ZM;IAOI,yBAAA;ExE0/ZV;EwEjgaM;IAOI,wBAAA;ExE6/ZV;EwEpgaM;IAOI,8BAAA;ExEggaV;EwEvgaM;IAOI,6BAAA;ExEmgaV;EwE1gaM;IAOI,2BAAA;ExEsgaV;EwE7gaM;IAOI,6BAAA;ExEygaV;EwEhhaM;IAOI,2BAAA;ExE4gaV;EwEnhaM;IAOI,6BAAA;ExE+gaV;EwEthaM;IAOI,2BAAA;ExEkhaV;EwEzhaM;IAOI,2BAAA;ExEqhaV;EwE5haM;IAOI,4BAAA;ExEwhaV;EwE/haM;IAOI,8CAAA;ExE2haV;EwEliaM;IAOI,6CAAA;ExE8haV;EwEriaM;IAOI,gDAAA;ExEiiaV;EwExiaM;IAOI,8CAAA;ExEoiaV;EwE3iaM;IAOI,gDAAA;ExEuiaV;EwE9iaM;IAOI,6BAAA;ExE0iaV;EwEjjaM;IAOI,2BAAA;ExE6iaV;EwEpjaM;IAOI,4BAAA;ExEgjaV;EwEvjaM;IAOI,6BAAA;ExEmjaV;EwE1jaM;IAIQ,oBAAA;IAGJ,qEAAA;ExEujaV;EwE9jaM;IAIQ,oBAAA;IAGJ,uEAAA;ExE2jaV;EwElkaM;IAIQ,oBAAA;IAGJ,qEAAA;ExE+jaV;EwEtkaM;IAIQ,oBAAA;IAGJ,kEAAA;ExEmkaV;EwE1kaM;IAIQ,oBAAA;IAGJ,qEAAA;ExEukaV;EwE9kaM;IAIQ,oBAAA;IAGJ,oEAAA;ExE2kaV;EwEllaM;IAIQ,oBAAA;IAGJ,mEAAA;ExE+kaV;EwEtlaM;IAIQ,oBAAA;IAGJ,kEAAA;ExEmlaV;EwE1laM;IAIQ,oBAAA;IAGJ,mEAAA;ExEulaV;EwE9laM;IAIQ,oBAAA;IAGJ,mEAAA;ExE2laV;EwElmaM;IAIQ,oBAAA;IAGJ,wEAAA;ExE+laV;EwEtmaM;IAIQ,oBAAA;IAGJ,2CAAA;ExEmmaV;EwE1maM;IAIQ,oBAAA;IAGJ,oCAAA;ExEumaV;EwE9maM;IAIQ,oBAAA;IAGJ,0CAAA;ExE2maV;EwElnaM;IAIQ,oBAAA;IAGJ,2CAAA;ExE+maV;EwEtnaM;IAIQ,oBAAA;IAGJ,0CAAA;ExEmnaV;EwE1naM;IAIQ,oBAAA;IAGJ,0CAAA;ExEunaV;EwE9naM;IAIQ,oBAAA;IAGJ,yBAAA;ExE2naV;AACF;AMtoaI;EkEGI;IAOI,sBAAA;ExEgoaV;EwEvoaM;IAOI,uBAAA;ExEmoaV;EwE1oaM;IAOI,sBAAA;ExEsoaV;EwE7oaM;IAOI,8BAAA;ExEyoaV;EwEhpaM;IAOI,4BAAA;ExE4oaV;EwEnpaM;IAOI,2BAAA;ExE+oaV;EwEtpaM;IAOI,iCAAA;ExEkpaV;EwEzpaM;IAOI,2BAAA;ExEqpaV;EwE5paM;IAOI,qBAAA;ExEwpaV;EwE/paM;IAOI,wBAAA;ExE2paV;EwElqaM;IAOI,uBAAA;ExE8paV;EwErqaM;IAOI,wBAAA;ExEiqaV;EwExqaM;IAOI,qBAAA;ExEoqaV;EwE3qaM;IAOI,uBAAA;ExEuqaV;EwE9qaM;IAOI,uBAAA;ExE0qaV;EwEjraM;IAOI,wBAAA;ExE6qaV;EwEpraM;IAOI,uBAAA;ExEgraV;EwEvraM;IAOI,uBAAA;ExEmraV;EwE1raM;IAOI,wBAAA;ExEsraV;EwE7raM;IAOI,uBAAA;ExEyraV;EwEhsaM;IAOI,wBAAA;ExE4raV;EwEnsaM;IAOI,uBAAA;ExE+raV;EwEtsaM;IAOI,wBAAA;ExEksaV;EwEzsaM;IAOI,uBAAA;ExEqsaV;EwE5saM;IAOI,uBAAA;ExEwsaV;EwE/saM;IAOI,wBAAA;ExE2saV;EwEltaM;IAOI,uBAAA;ExE8saV;EwErtaM;IAOI,wBAAA;ExEitaV;EwExtaM;IAOI,0BAAA;ExEotaV;EwE3taM;IAOI,gCAAA;ExEutaV;EwE9taM;IAOI,yBAAA;ExE0taV;EwEjuaM;IAOI,wBAAA;ExE6taV;EwEpuaM;IAOI,+BAAA;ExEguaV;EwEvuaM;IAOI,yBAAA;ExEmuaV;EwE1uaM;IAOI,6BAAA;ExEsuaV;EwE7uaM;IAOI,8BAAA;ExEyuaV;EwEhvaM;IAOI,wBAAA;ExE4uaV;EwEnvaM;IAOI,+BAAA;ExE+uaV;EwEtvaM;IAOI,wBAAA;ExEkvaV;EwEzvaM;IAOI,iBAAA;ExEqvaV;EwE5vaM;IAOI,mBAAA;ExEwvaV;EwE/vaM;IAOI,oBAAA;ExE2vaV;EwElwaM;IAOI,kBAAA;ExE8vaV;EwErwaM;IAOI,kBAAA;ExEiwaV;EwExwaM;IAOI,kBAAA;ExEowaV;EwE3waM;IAOI,kBAAA;ExEuwaV;EwE9waM;IAOI,kBAAA;ExE0waV;EwEjxaM;IAOI,mBAAA;ExE6waV;EwEpxaM;IAOI,mBAAA;ExEgxaV;EwEvxaM;IAOI,mBAAA;ExEmxaV;EwE1xaM;IAOI,mBAAA;ExEsxaV;EwE7xaM;IAOI,mBAAA;ExEyxaV;EwEhyaM;IAOI,mBAAA;ExE4xaV;EwEnyaM;IAOI,mBAAA;ExE+xaV;EwEtyaM;IAOI,mBAAA;ExEkyaV;EwEzyaM;IAOI,mBAAA;ExEqyaV;EwE5yaM;IAOI,mBAAA;ExEwyaV;EwE/yaM;IAOI,mBAAA;ExE2yaV;EwElzaM;IAOI,mBAAA;ExE8yaV;EwErzaM;IAOI,mBAAA;ExEizaV;EwExzaM;IAOI,mBAAA;ExEozaV;EwE3zaM;IAOI,mBAAA;ExEuzaV;EwE9zaM;IAOI,mBAAA;ExE0zaV;EwEj0aM;IAOI,mBAAA;ExE6zaV;EwEp0aM;IAOI,oBAAA;ExEg0aV;EwEv0aM;IAOI,oBAAA;ExEm0aV;EwE10aM;IAOI,sBAAA;ExEs0aV;EwE70aM;IAOI,uBAAA;ExEy0aV;EwEh1aM;IAOI,qBAAA;ExE40aV;EwEn1aM;IAOI,qBAAA;ExE+0aV;EwEt1aM;IAOI,qBAAA;ExEk1aV;EwEz1aM;IAOI,qBAAA;ExEq1aV;EwE51aM;IAOI,qBAAA;ExEw1aV;EwE/1aM;IAOI,sBAAA;ExE21aV;EwEl2aM;IAOI,sBAAA;ExE81aV;EwEr2aM;IAOI,sBAAA;ExEi2aV;EwEx2aM;IAOI,sBAAA;ExEo2aV;EwE32aM;IAOI,sBAAA;ExEu2aV;EwE92aM;IAOI,sBAAA;ExE02aV;EwEj3aM;IAOI,sBAAA;ExE62aV;EwEp3aM;IAOI,sBAAA;ExEg3aV;EwEv3aM;IAOI,sBAAA;ExEm3aV;EwE13aM;IAOI,sBAAA;ExEs3aV;EwE73aM;IAOI,sBAAA;ExEy3aV;EwEh4aM;IAOI,sBAAA;ExE43aV;EwEn4aM;IAOI,sBAAA;ExE+3aV;EwEt4aM;IAOI,sBAAA;ExEk4aV;EwEz4aM;IAOI,sBAAA;ExEq4aV;EwE54aM;IAOI,sBAAA;ExEw4aV;EwE/4aM;IAOI,sBAAA;ExE24aV;EwEl5aM;IAOI,uBAAA;ExE84aV;EwEr5aM;IAOI,kBAAA;ExEi5aV;EwEx5aM;IAOI,oBAAA;ExEo5aV;EwE35aM;IAOI,qBAAA;ExEu5aV;EwE95aM;IAOI,mBAAA;ExE05aV;EwEj6aM;IAOI,mBAAA;ExE65aV;EwEp6aM;IAOI,mBAAA;ExEg6aV;EwEv6aM;IAOI,mBAAA;ExEm6aV;EwE16aM;IAOI,mBAAA;ExEs6aV;EwE76aM;IAOI,oBAAA;ExEy6aV;EwEh7aM;IAOI,oBAAA;ExE46aV;EwEn7aM;IAOI,oBAAA;ExE+6aV;EwEt7aM;IAOI,oBAAA;ExEk7aV;EwEz7aM;IAOI,oBAAA;ExEq7aV;EwE57aM;IAOI,oBAAA;ExEw7aV;EwE/7aM;IAOI,oBAAA;ExE27aV;EwEl8aM;IAOI,oBAAA;ExE87aV;EwEr8aM;IAOI,oBAAA;ExEi8aV;EwEx8aM;IAOI,oBAAA;ExEo8aV;EwE38aM;IAOI,oBAAA;ExEu8aV;EwE98aM;IAOI,oBAAA;ExE08aV;EwEj9aM;IAOI,oBAAA;ExE68aV;EwEp9aM;IAOI,oBAAA;ExEg9aV;EwEv9aM;IAOI,oBAAA;ExEm9aV;EwE19aM;IAOI,oBAAA;ExEs9aV;EwE79aM;IAOI,oBAAA;ExEy9aV;EwEh+aM;IAOI,qBAAA;ExE49aV;EwEn+aM;IAOI,mBAAA;ExE+9aV;EwEt+aM;IAOI,qBAAA;ExEk+aV;EwEz+aM;IAOI,sBAAA;ExEq+aV;EwE5+aM;IAOI,oBAAA;ExEw+aV;EwE/+aM;IAOI,oBAAA;ExE2+aV;EwEl/aM;IAOI,oBAAA;ExE8+aV;EwEr/aM;IAOI,oBAAA;ExEi/aV;EwEx/aM;IAOI,oBAAA;ExEo/aV;EwE3/aM;IAOI,qBAAA;ExEu/aV;EwE9/aM;IAOI,qBAAA;ExE0/aV;EwEjgbM;IAOI,qBAAA;ExE6/aV;EwEpgbM;IAOI,qBAAA;ExEggbV;EwEvgbM;IAOI,qBAAA;ExEmgbV;EwE1gbM;IAOI,qBAAA;ExEsgbV;EwE7gbM;IAOI,qBAAA;ExEygbV;EwEhhbM;IAOI,qBAAA;ExE4gbV;EwEnhbM;IAOI,qBAAA;ExE+gbV;EwEthbM;IAOI,qBAAA;ExEkhbV;EwEzhbM;IAOI,qBAAA;ExEqhbV;EwE5hbM;IAOI,qBAAA;ExEwhbV;EwE/hbM;IAOI,qBAAA;ExE2hbV;EwElibM;IAOI,qBAAA;ExE8hbV;EwEribM;IAOI,qBAAA;ExEiibV;EwExibM;IAOI,qBAAA;ExEoibV;EwE3ibM;IAOI,qBAAA;ExEuibV;EwE9ibM;IAOI,sBAAA;ExE0ibV;EwEjjbM;IAOI,qBAAA;ExE6ibV;EwEpjbM;IAOI,qBAAA;ExEgjbV;EwEvjbM;IAOI,qBAAA;ExEmjbV;EwE1jbM;IAOI,sBAAA;ExEsjbV;EwE7jbM;IAOI,sBAAA;ExEyjbV;EwEhkbM;IAOI,oBAAA;ExE4jbV;EwEnkbM;IAOI,qBAAA;ExE+jbV;EwEtkbM;IAOI,qBAAA;ExEkkbV;EwEzkbM;IAOI,qBAAA;ExEqkbV;EwE5kbM;IAOI,qBAAA;ExEwkbV;EwE/kbM;IAOI,qBAAA;ExE2kbV;EwEllbM;IAOI,qBAAA;ExE8kbV;EwErlbM;IAOI,qBAAA;ExEilbV;EwExlbM;IAOI,qBAAA;ExEolbV;EwE3lbM;IAOI,qBAAA;ExEulbV;EwE9lbM;IAOI,qBAAA;ExE0lbV;EwEjmbM;IAOI,qBAAA;ExE6lbV;EwEpmbM;IAOI,qBAAA;ExEgmbV;EwEvmbM;IAOI,qBAAA;ExEmmbV;EwE1mbM;IAOI,qBAAA;ExEsmbV;EwE7mbM;IAOI,qBAAA;ExEymbV;EwEhnbM;IAOI,sBAAA;ExE4mbV;EwEnnbM;IAOI,sBAAA;ExE+mbV;EwEtnbM;IAOI,sBAAA;ExEknbV;EwEznbM;IAOI,uBAAA;ExEqnbV;EwE5nbM;IAOI,uBAAA;ExEwnbV;EwE/nbM;IAOI,qBAAA;ExE2nbV;EwElobM;IAOI,sBAAA;ExE8nbV;EwErobM;IAOI,sBAAA;ExEiobV;EwExobM;IAOI,sBAAA;ExEoobV;EwE3obM;IAOI,sBAAA;ExEuobV;EwE9obM;IAOI,sBAAA;ExE0obV;EwEjpbM;IAOI,sBAAA;ExE6obV;EwEppbM;IAOI,sBAAA;ExEgpbV;EwEvpbM;IAOI,sBAAA;ExEmpbV;EwE1pbM;IAOI,sBAAA;ExEspbV;EwE7pbM;IAOI,sBAAA;ExEypbV;EwEhqbM;IAOI,sBAAA;ExE4pbV;EwEnqbM;IAOI,sBAAA;ExE+pbV;EwEtqbM;IAOI,sBAAA;ExEkqbV;EwEzqbM;IAOI,sBAAA;ExEqqbV;EwE5qbM;IAOI,sBAAA;ExEwqbV;EwE/qbM;IAOI,yBAAA;ExE2qbV;EwElrbM;IAOI,8BAAA;ExE8qbV;EwErrbM;IAOI,iCAAA;ExEirbV;EwExrbM;IAOI,sCAAA;ExEorbV;EwE3rbM;IAOI,yCAAA;ExEurbV;EwE9rbM;IAOI,uBAAA;ExE0rbV;EwEjsbM;IAOI,uBAAA;ExE6rbV;EwEpsbM;IAOI,yBAAA;ExEgsbV;EwEvsbM;IAOI,yBAAA;ExEmsbV;EwE1sbM;IAOI,0BAAA;ExEssbV;EwE7sbM;IAOI,4BAAA;ExEysbV;EwEhtbM;IAOI,kCAAA;ExE4sbV;EwEntbM;IAOI,sCAAA;ExE+sbV;EwEttbM;IAOI,oCAAA;ExEktbV;EwEztbM;IAOI,kCAAA;ExEqtbV;EwE5tbM;IAOI,yCAAA;ExEwtbV;EwE/tbM;IAOI,wCAAA;ExE2tbV;EwElubM;IAOI,wCAAA;ExE8tbV;EwErubM;IAOI,kCAAA;ExEiubV;EwExubM;IAOI,gCAAA;ExEoubV;EwE3ubM;IAOI,8BAAA;ExEuubV;EwE9ubM;IAOI,gCAAA;ExE0ubV;EwEjvbM;IAOI,+BAAA;ExE6ubV;EwEpvbM;IAOI,oCAAA;ExEgvbV;EwEvvbM;IAOI,kCAAA;ExEmvbV;EwE1vbM;IAOI,gCAAA;ExEsvbV;EwE7vbM;IAOI,uCAAA;ExEyvbV;EwEhwbM;IAOI,sCAAA;ExE4vbV;EwEnwbM;IAOI,iCAAA;ExE+vbV;EwEtwbM;IAOI,2BAAA;ExEkwbV;EwEzwbM;IAOI,iCAAA;ExEqwbV;EwE5wbM;IAOI,+BAAA;ExEwwbV;EwE/wbM;IAOI,6BAAA;ExE2wbV;EwElxbM;IAOI,+BAAA;ExE8wbV;EwErxbM;IAOI,8BAAA;ExEixbV;EwExxbM;IAOI,oBAAA;ExEoxbV;EwE3xbM;IAOI,mBAAA;ExEuxbV;EwE9xbM;IAOI,mBAAA;ExE0xbV;EwEjybM;IAOI,mBAAA;ExE6xbV;EwEpybM;IAOI,mBAAA;ExEgybV;EwEvybM;IAOI,mBAAA;ExEmybV;EwE1ybM;IAOI,mBAAA;ExEsybV;EwE7ybM;IAOI,mBAAA;ExEyybV;EwEhzbM;IAOI,oBAAA;ExE4ybV;EwEnzbM;IAOI,0BAAA;ExE+ybV;EwEtzbM;IAOI,yBAAA;ExEkzbV;EwEzzbM;IAOI,uBAAA;ExEqzbV;EwE5zbM;IAOI,yBAAA;ExEwzbV;EwE/zbM;IAOI,uBAAA;ExE2zbV;EwEl0bM;IAOI,yBAAA;ExE8zbV;EwEr0bM;IAOI,uBAAA;ExEi0bV;EwEx0bM;IAOI,uBAAA;ExEo0bV;EwE30bM;IAOI,wBAAA;ExEu0bV;EwE90bM;IAOI,uBAAA;ExE00bV;EwEj1bM;IAOI,0BAAA;IAAA,yBAAA;ExE80bV;EwEr1bM;IAOI,gCAAA;IAAA,+BAAA;ExEk1bV;EwEz1bM;IAOI,+BAAA;IAAA,8BAAA;ExEs1bV;EwE71bM;IAOI,6BAAA;IAAA,4BAAA;ExE01bV;EwEj2bM;IAOI,+BAAA;IAAA,8BAAA;ExE81bV;EwEr2bM;IAOI,6BAAA;IAAA,4BAAA;ExEk2bV;EwEz2bM;IAOI,+BAAA;IAAA,8BAAA;ExEs2bV;EwE72bM;IAOI,6BAAA;IAAA,4BAAA;ExE02bV;EwEj3bM;IAOI,6BAAA;IAAA,4BAAA;ExE82bV;EwEr3bM;IAOI,8BAAA;IAAA,6BAAA;ExEk3bV;EwEz3bM;IAOI,6BAAA;IAAA,4BAAA;ExEs3bV;EwE73bM;IAOI,wBAAA;IAAA,2BAAA;ExE03bV;EwEj4bM;IAOI,8BAAA;IAAA,iCAAA;ExE83bV;EwEr4bM;IAOI,6BAAA;IAAA,gCAAA;ExEk4bV;EwEz4bM;IAOI,2BAAA;IAAA,8BAAA;ExEs4bV;EwE74bM;IAOI,6BAAA;IAAA,gCAAA;ExE04bV;EwEj5bM;IAOI,2BAAA;IAAA,8BAAA;ExE84bV;EwEr5bM;IAOI,6BAAA;IAAA,gCAAA;ExEk5bV;EwEz5bM;IAOI,2BAAA;IAAA,8BAAA;ExEs5bV;EwE75bM;IAOI,2BAAA;IAAA,8BAAA;ExE05bV;EwEj6bM;IAOI,4BAAA;IAAA,+BAAA;ExE85bV;EwEr6bM;IAOI,2BAAA;IAAA,8BAAA;ExEk6bV;EwEz6bM;IAOI,wBAAA;ExEq6bV;EwE56bM;IAOI,8BAAA;ExEw6bV;EwE/6bM;IAOI,6BAAA;ExE26bV;EwEl7bM;IAOI,2BAAA;ExE86bV;EwEr7bM;IAOI,6BAAA;ExEi7bV;EwEx7bM;IAOI,2BAAA;ExEo7bV;EwE37bM;IAOI,6BAAA;ExEu7bV;EwE97bM;IAOI,2BAAA;ExE07bV;EwEj8bM;IAOI,2BAAA;ExE67bV;EwEp8bM;IAOI,4BAAA;ExEg8bV;EwEv8bM;IAOI,2BAAA;ExEm8bV;EwE18bM;IAOI,0BAAA;ExEs8bV;EwE78bM;IAOI,gCAAA;ExEy8bV;EwEh9bM;IAOI,+BAAA;ExE48bV;EwEn9bM;IAOI,6BAAA;ExE+8bV;EwEt9bM;IAOI,+BAAA;ExEk9bV;EwEz9bM;IAOI,6BAAA;ExEq9bV;EwE59bM;IAOI,+BAAA;ExEw9bV;EwE/9bM;IAOI,6BAAA;ExE29bV;EwEl+bM;IAOI,6BAAA;ExE89bV;EwEr+bM;IAOI,8BAAA;ExEi+bV;EwEx+bM;IAOI,6BAAA;ExEo+bV;EwE3+bM;IAOI,2BAAA;ExEu+bV;EwE9+bM;IAOI,iCAAA;ExE0+bV;EwEj/bM;IAOI,gCAAA;ExE6+bV;EwEp/bM;IAOI,8BAAA;ExEg/bV;EwEv/bM;IAOI,gCAAA;ExEm/bV;EwE1/bM;IAOI,8BAAA;ExEs/bV;EwE7/bM;IAOI,gCAAA;ExEy/bV;EwEhgcM;IAOI,8BAAA;ExE4/bV;EwEngcM;IAOI,8BAAA;ExE+/bV;EwEtgcM;IAOI,+BAAA;ExEkgcV;EwEzgcM;IAOI,8BAAA;ExEqgcV;EwE5gcM;IAOI,yBAAA;ExEwgcV;EwE/gcM;IAOI,+BAAA;ExE2gcV;EwElhcM;IAOI,8BAAA;ExE8gcV;EwErhcM;IAOI,4BAAA;ExEihcV;EwExhcM;IAOI,8BAAA;ExEohcV;EwE3hcM;IAOI,4BAAA;ExEuhcV;EwE9hcM;IAOI,8BAAA;ExE0hcV;EwEjicM;IAOI,4BAAA;ExE6hcV;EwEpicM;IAOI,4BAAA;ExEgicV;EwEvicM;IAOI,6BAAA;ExEmicV;EwE1icM;IAOI,4BAAA;ExEsicV;EwE7icM;IAOI,2BAAA;ExEyicV;EwEhjcM;IAOI,0BAAA;ExE4icV;EwEnjcM;IAOI,wBAAA;ExE+icV;EwEtjcM;IAOI,0BAAA;ExEkjcV;EwEzjcM;IAOI,wBAAA;ExEqjcV;EwE5jcM;IAOI,0BAAA;ExEwjcV;EwE/jcM;IAOI,wBAAA;ExE2jcV;EwElkcM;IAOI,wBAAA;ExE8jcV;EwErkcM;IAOI,yBAAA;ExEikcV;EwExkcM;IAOI,iCAAA;IAAA,gCAAA;ExEqkcV;EwE5kcM;IAOI,gCAAA;IAAA,+BAAA;ExEykcV;EwEhlcM;IAOI,8BAAA;IAAA,6BAAA;ExE6kcV;EwEplcM;IAOI,gCAAA;IAAA,+BAAA;ExEilcV;EwExlcM;IAOI,8BAAA;IAAA,6BAAA;ExEqlcV;EwE5lcM;IAOI,gCAAA;IAAA,+BAAA;ExEylcV;EwEhmcM;IAOI,8BAAA;IAAA,6BAAA;ExE6lcV;EwEpmcM;IAOI,8BAAA;IAAA,6BAAA;ExEimcV;EwExmcM;IAOI,+BAAA;IAAA,8BAAA;ExEqmcV;EwE5mcM;IAOI,+BAAA;IAAA,kCAAA;ExEymcV;EwEhncM;IAOI,8BAAA;IAAA,iCAAA;ExE6mcV;EwEpncM;IAOI,4BAAA;IAAA,+BAAA;ExEincV;EwExncM;IAOI,8BAAA;IAAA,iCAAA;ExEqncV;EwE5ncM;IAOI,4BAAA;IAAA,+BAAA;ExEyncV;EwEhocM;IAOI,8BAAA;IAAA,iCAAA;ExE6ncV;EwEpocM;IAOI,4BAAA;IAAA,+BAAA;ExEiocV;EwExocM;IAOI,4BAAA;IAAA,+BAAA;ExEqocV;EwE5ocM;IAOI,6BAAA;IAAA,gCAAA;ExEyocV;EwEhpcM;IAOI,+BAAA;ExE4ocV;EwEnpcM;IAOI,8BAAA;ExE+ocV;EwEtpcM;IAOI,4BAAA;ExEkpcV;EwEzpcM;IAOI,8BAAA;ExEqpcV;EwE5pcM;IAOI,4BAAA;ExEwpcV;EwE/pcM;IAOI,8BAAA;ExE2pcV;EwElqcM;IAOI,4BAAA;ExE8pcV;EwErqcM;IAOI,4BAAA;ExEiqcV;EwExqcM;IAOI,6BAAA;ExEoqcV;EwE3qcM;IAOI,iCAAA;ExEuqcV;EwE9qcM;IAOI,gCAAA;ExE0qcV;EwEjrcM;IAOI,8BAAA;ExE6qcV;EwEprcM;IAOI,gCAAA;ExEgrcV;EwEvrcM;IAOI,8BAAA;ExEmrcV;EwE1rcM;IAOI,gCAAA;ExEsrcV;EwE7rcM;IAOI,8BAAA;ExEyrcV;EwEhscM;IAOI,8BAAA;ExE4rcV;EwEnscM;IAOI,+BAAA;ExE+rcV;EwEtscM;IAOI,kCAAA;ExEkscV;EwEzscM;IAOI,iCAAA;ExEqscV;EwE5scM;IAOI,+BAAA;ExEwscV;EwE/scM;IAOI,iCAAA;ExE2scV;EwEltcM;IAOI,+BAAA;ExE8scV;EwErtcM;IAOI,iCAAA;ExEitcV;EwExtcM;IAOI,+BAAA;ExEotcV;EwE3tcM;IAOI,+BAAA;ExEutcV;EwE9tcM;IAOI,gCAAA;ExE0tcV;EwEjucM;IAOI,gCAAA;ExE6tcV;EwEpucM;IAOI,+BAAA;ExEgucV;EwEvucM;IAOI,6BAAA;ExEmucV;EwE1ucM;IAOI,+BAAA;ExEsucV;EwE7ucM;IAOI,6BAAA;ExEyucV;EwEhvcM;IAOI,+BAAA;ExE4ucV;EwEnvcM;IAOI,6BAAA;ExE+ucV;EwEtvcM;IAOI,6BAAA;ExEkvcV;EwEzvcM;IAOI,8BAAA;ExEqvcV;EwE5vcM;IAOI,qBAAA;ExEwvcV;EwE/vcM;IAOI,2BAAA;ExE2vcV;EwElwcM;IAOI,0BAAA;ExE8vcV;EwErwcM;IAOI,wBAAA;ExEiwcV;EwExwcM;IAOI,0BAAA;ExEowcV;EwE3wcM;IAOI,wBAAA;ExEuwcV;EwE9wcM;IAOI,0BAAA;ExE0wcV;EwEjxcM;IAOI,wBAAA;ExE6wcV;EwEpxcM;IAOI,wBAAA;ExEgxcV;EwEvxcM;IAOI,yBAAA;ExEmxcV;EwE1xcM;IAOI,2BAAA;IAAA,0BAAA;ExEuxcV;EwE9xcM;IAOI,iCAAA;IAAA,gCAAA;ExE2xcV;EwElycM;IAOI,gCAAA;IAAA,+BAAA;ExE+xcV;EwEtycM;IAOI,8BAAA;IAAA,6BAAA;ExEmycV;EwE1ycM;IAOI,gCAAA;IAAA,+BAAA;ExEuycV;EwE9ycM;IAOI,8BAAA;IAAA,6BAAA;ExE2ycV;EwElzcM;IAOI,gCAAA;IAAA,+BAAA;ExE+ycV;EwEtzcM;IAOI,8BAAA;IAAA,6BAAA;ExEmzcV;EwE1zcM;IAOI,8BAAA;IAAA,6BAAA;ExEuzcV;EwE9zcM;IAOI,+BAAA;IAAA,8BAAA;ExE2zcV;EwEl0cM;IAOI,yBAAA;IAAA,4BAAA;ExE+zcV;EwEt0cM;IAOI,+BAAA;IAAA,kCAAA;ExEm0cV;EwE10cM;IAOI,8BAAA;IAAA,iCAAA;ExEu0cV;EwE90cM;IAOI,4BAAA;IAAA,+BAAA;ExE20cV;EwEl1cM;IAOI,8BAAA;IAAA,iCAAA;ExE+0cV;EwEt1cM;IAOI,4BAAA;IAAA,+BAAA;ExEm1cV;EwE11cM;IAOI,8BAAA;IAAA,iCAAA;ExEu1cV;EwE91cM;IAOI,4BAAA;IAAA,+BAAA;ExE21cV;EwEl2cM;IAOI,4BAAA;IAAA,+BAAA;ExE+1cV;EwEt2cM;IAOI,6BAAA;IAAA,gCAAA;ExEm2cV;EwE12cM;IAOI,yBAAA;ExEs2cV;EwE72cM;IAOI,+BAAA;ExEy2cV;EwEh3cM;IAOI,8BAAA;ExE42cV;EwEn3cM;IAOI,4BAAA;ExE+2cV;EwEt3cM;IAOI,8BAAA;ExEk3cV;EwEz3cM;IAOI,4BAAA;ExEq3cV;EwE53cM;IAOI,8BAAA;ExEw3cV;EwE/3cM;IAOI,4BAAA;ExE23cV;EwEl4cM;IAOI,4BAAA;ExE83cV;EwEr4cM;IAOI,6BAAA;ExEi4cV;EwEx4cM;IAOI,2BAAA;ExEo4cV;EwE34cM;IAOI,iCAAA;ExEu4cV;EwE94cM;IAOI,gCAAA;ExE04cV;EwEj5cM;IAOI,8BAAA;ExE64cV;EwEp5cM;IAOI,gCAAA;ExEg5cV;EwEv5cM;IAOI,8BAAA;ExEm5cV;EwE15cM;IAOI,gCAAA;ExEs5cV;EwE75cM;IAOI,8BAAA;ExEy5cV;EwEh6cM;IAOI,8BAAA;ExE45cV;EwEn6cM;IAOI,+BAAA;ExE+5cV;EwEt6cM;IAOI,4BAAA;ExEk6cV;EwEz6cM;IAOI,kCAAA;ExEq6cV;EwE56cM;IAOI,iCAAA;ExEw6cV;EwE/6cM;IAOI,+BAAA;ExE26cV;EwEl7cM;IAOI,iCAAA;ExE86cV;EwEr7cM;IAOI,+BAAA;ExEi7cV;EwEx7cM;IAOI,iCAAA;ExEo7cV;EwE37cM;IAOI,+BAAA;ExEu7cV;EwE97cM;IAOI,+BAAA;ExE07cV;EwEj8cM;IAOI,gCAAA;ExE67cV;EwEp8cM;IAOI,0BAAA;ExEg8cV;EwEv8cM;IAOI,gCAAA;ExEm8cV;EwE18cM;IAOI,+BAAA;ExEs8cV;EwE78cM;IAOI,6BAAA;ExEy8cV;EwEh9cM;IAOI,+BAAA;ExE48cV;EwEn9cM;IAOI,6BAAA;ExE+8cV;EwEt9cM;IAOI,+BAAA;ExEk9cV;EwEz9cM;IAOI,6BAAA;ExEq9cV;EwE59cM;IAOI,6BAAA;ExEw9cV;EwE/9cM;IAOI,8BAAA;ExE29cV;EwEl+cM;IAOI,iBAAA;ExE89cV;EwEr+cM;IAOI,uBAAA;ExEi+cV;EwEx+cM;IAOI,sBAAA;ExEo+cV;EwE3+cM;IAOI,oBAAA;ExEu+cV;EwE9+cM;IAOI,sBAAA;ExE0+cV;EwEj/cM;IAOI,oBAAA;ExE6+cV;EwEp/cM;IAOI,sBAAA;ExEg/cV;EwEv/cM;IAOI,oBAAA;ExEm/cV;EwE1/cM;IAOI,oBAAA;ExEs/cV;EwE7/cM;IAOI,qBAAA;ExEy/cV;EwEhgdM;IAOI,qBAAA;ExE4/cV;EwEngdM;IAOI,2BAAA;ExE+/cV;EwEtgdM;IAOI,0BAAA;ExEkgdV;EwEzgdM;IAOI,wBAAA;ExEqgdV;EwE5gdM;IAOI,0BAAA;ExEwgdV;EwE/gdM;IAOI,wBAAA;ExE2gdV;EwElhdM;IAOI,0BAAA;ExE8gdV;EwErhdM;IAOI,wBAAA;ExEihdV;EwExhdM;IAOI,wBAAA;ExEohdV;EwE3hdM;IAOI,yBAAA;ExEuhdV;EwE9hdM;IAOI,wBAAA;ExE0hdV;EwEjidM;IAOI,8BAAA;ExE6hdV;EwEpidM;IAOI,6BAAA;ExEgidV;EwEvidM;IAOI,2BAAA;ExEmidV;EwE1idM;IAOI,6BAAA;ExEsidV;EwE7idM;IAOI,2BAAA;ExEyidV;EwEhjdM;IAOI,6BAAA;ExE4idV;EwEnjdM;IAOI,2BAAA;ExE+idV;EwEtjdM;IAOI,2BAAA;ExEkjdV;EwEzjdM;IAOI,4BAAA;ExEqjdV;EwE5jdM;IAOI,8CAAA;ExEwjdV;EwE/jdM;IAOI,6CAAA;ExE2jdV;EwElkdM;IAOI,gDAAA;ExE8jdV;EwErkdM;IAOI,8CAAA;ExEikdV;EwExkdM;IAOI,gDAAA;ExEokdV;EwE3kdM;IAOI,6BAAA;ExEukdV;EwE9kdM;IAOI,2BAAA;ExE0kdV;EwEjldM;IAOI,4BAAA;ExE6kdV;EwEpldM;IAOI,6BAAA;ExEgldV;EwEvldM;IAIQ,oBAAA;IAGJ,qEAAA;ExEoldV;EwE3ldM;IAIQ,oBAAA;IAGJ,uEAAA;ExEwldV;EwE/ldM;IAIQ,oBAAA;IAGJ,qEAAA;ExE4ldV;EwEnmdM;IAIQ,oBAAA;IAGJ,kEAAA;ExEgmdV;EwEvmdM;IAIQ,oBAAA;IAGJ,qEAAA;ExEomdV;EwE3mdM;IAIQ,oBAAA;IAGJ,oEAAA;ExEwmdV;EwE/mdM;IAIQ,oBAAA;IAGJ,mEAAA;ExE4mdV;EwEnndM;IAIQ,oBAAA;IAGJ,kEAAA;ExEgndV;EwEvndM;IAIQ,oBAAA;IAGJ,mEAAA;ExEondV;EwE3ndM;IAIQ,oBAAA;IAGJ,mEAAA;ExEwndV;EwE/ndM;IAIQ,oBAAA;IAGJ,wEAAA;ExE4ndV;EwEnodM;IAIQ,oBAAA;IAGJ,2CAAA;ExEgodV;EwEvodM;IAIQ,oBAAA;IAGJ,oCAAA;ExEoodV;EwE3odM;IAIQ,oBAAA;IAGJ,0CAAA;ExEwodV;EwE/odM;IAIQ,oBAAA;IAGJ,2CAAA;ExE4odV;EwEnpdM;IAIQ,oBAAA;IAGJ,0CAAA;ExEgpdV;EwEvpdM;IAIQ,oBAAA;IAGJ,0CAAA;ExEopdV;EwE3pdM;IAIQ,oBAAA;IAGJ,yBAAA;ExEwpdV;AACF;AMnqdI;EkEGI;IAOI,sBAAA;ExE6pdV;EwEpqdM;IAOI,uBAAA;ExEgqdV;EwEvqdM;IAOI,sBAAA;ExEmqdV;EwE1qdM;IAOI,8BAAA;ExEsqdV;EwE7qdM;IAOI,4BAAA;ExEyqdV;EwEhrdM;IAOI,2BAAA;ExE4qdV;EwEnrdM;IAOI,iCAAA;ExE+qdV;EwEtrdM;IAOI,2BAAA;ExEkrdV;EwEzrdM;IAOI,qBAAA;ExEqrdV;EwE5rdM;IAOI,wBAAA;ExEwrdV;EwE/rdM;IAOI,uBAAA;ExE2rdV;EwElsdM;IAOI,wBAAA;ExE8rdV;EwErsdM;IAOI,qBAAA;ExEisdV;EwExsdM;IAOI,uBAAA;ExEosdV;EwE3sdM;IAOI,uBAAA;ExEusdV;EwE9sdM;IAOI,wBAAA;ExE0sdV;EwEjtdM;IAOI,uBAAA;ExE6sdV;EwEptdM;IAOI,uBAAA;ExEgtdV;EwEvtdM;IAOI,wBAAA;ExEmtdV;EwE1tdM;IAOI,uBAAA;ExEstdV;EwE7tdM;IAOI,wBAAA;ExEytdV;EwEhudM;IAOI,uBAAA;ExE4tdV;EwEnudM;IAOI,wBAAA;ExE+tdV;EwEtudM;IAOI,uBAAA;ExEkudV;EwEzudM;IAOI,uBAAA;ExEqudV;EwE5udM;IAOI,wBAAA;ExEwudV;EwE/udM;IAOI,uBAAA;ExE2udV;EwElvdM;IAOI,wBAAA;ExE8udV;EwErvdM;IAOI,0BAAA;ExEivdV;EwExvdM;IAOI,gCAAA;ExEovdV;EwE3vdM;IAOI,yBAAA;ExEuvdV;EwE9vdM;IAOI,wBAAA;ExE0vdV;EwEjwdM;IAOI,+BAAA;ExE6vdV;EwEpwdM;IAOI,yBAAA;ExEgwdV;EwEvwdM;IAOI,6BAAA;ExEmwdV;EwE1wdM;IAOI,8BAAA;ExEswdV;EwE7wdM;IAOI,wBAAA;ExEywdV;EwEhxdM;IAOI,+BAAA;ExE4wdV;EwEnxdM;IAOI,wBAAA;ExE+wdV;EwEtxdM;IAOI,iBAAA;ExEkxdV;EwEzxdM;IAOI,mBAAA;ExEqxdV;EwE5xdM;IAOI,oBAAA;ExEwxdV;EwE/xdM;IAOI,kBAAA;ExE2xdV;EwElydM;IAOI,kBAAA;ExE8xdV;EwErydM;IAOI,kBAAA;ExEiydV;EwExydM;IAOI,kBAAA;ExEoydV;EwE3ydM;IAOI,kBAAA;ExEuydV;EwE9ydM;IAOI,mBAAA;ExE0ydV;EwEjzdM;IAOI,mBAAA;ExE6ydV;EwEpzdM;IAOI,mBAAA;ExEgzdV;EwEvzdM;IAOI,mBAAA;ExEmzdV;EwE1zdM;IAOI,mBAAA;ExEszdV;EwE7zdM;IAOI,mBAAA;ExEyzdV;EwEh0dM;IAOI,mBAAA;ExE4zdV;EwEn0dM;IAOI,mBAAA;ExE+zdV;EwEt0dM;IAOI,mBAAA;ExEk0dV;EwEz0dM;IAOI,mBAAA;ExEq0dV;EwE50dM;IAOI,mBAAA;ExEw0dV;EwE/0dM;IAOI,mBAAA;ExE20dV;EwEl1dM;IAOI,mBAAA;ExE80dV;EwEr1dM;IAOI,mBAAA;ExEi1dV;EwEx1dM;IAOI,mBAAA;ExEo1dV;EwE31dM;IAOI,mBAAA;ExEu1dV;EwE91dM;IAOI,mBAAA;ExE01dV;EwEj2dM;IAOI,oBAAA;ExE61dV;EwEp2dM;IAOI,oBAAA;ExEg2dV;EwEv2dM;IAOI,sBAAA;ExEm2dV;EwE12dM;IAOI,uBAAA;ExEs2dV;EwE72dM;IAOI,qBAAA;ExEy2dV;EwEh3dM;IAOI,qBAAA;ExE42dV;EwEn3dM;IAOI,qBAAA;ExE+2dV;EwEt3dM;IAOI,qBAAA;ExEk3dV;EwEz3dM;IAOI,qBAAA;ExEq3dV;EwE53dM;IAOI,sBAAA;ExEw3dV;EwE/3dM;IAOI,sBAAA;ExE23dV;EwEl4dM;IAOI,sBAAA;ExE83dV;EwEr4dM;IAOI,sBAAA;ExEi4dV;EwEx4dM;IAOI,sBAAA;ExEo4dV;EwE34dM;IAOI,sBAAA;ExEu4dV;EwE94dM;IAOI,sBAAA;ExE04dV;EwEj5dM;IAOI,sBAAA;ExE64dV;EwEp5dM;IAOI,sBAAA;ExEg5dV;EwEv5dM;IAOI,sBAAA;ExEm5dV;EwE15dM;IAOI,sBAAA;ExEs5dV;EwE75dM;IAOI,sBAAA;ExEy5dV;EwEh6dM;IAOI,sBAAA;ExE45dV;EwEn6dM;IAOI,sBAAA;ExE+5dV;EwEt6dM;IAOI,sBAAA;ExEk6dV;EwEz6dM;IAOI,sBAAA;ExEq6dV;EwE56dM;IAOI,sBAAA;ExEw6dV;EwE/6dM;IAOI,uBAAA;ExE26dV;EwEl7dM;IAOI,kBAAA;ExE86dV;EwEr7dM;IAOI,oBAAA;ExEi7dV;EwEx7dM;IAOI,qBAAA;ExEo7dV;EwE37dM;IAOI,mBAAA;ExEu7dV;EwE97dM;IAOI,mBAAA;ExE07dV;EwEj8dM;IAOI,mBAAA;ExE67dV;EwEp8dM;IAOI,mBAAA;ExEg8dV;EwEv8dM;IAOI,mBAAA;ExEm8dV;EwE18dM;IAOI,oBAAA;ExEs8dV;EwE78dM;IAOI,oBAAA;ExEy8dV;EwEh9dM;IAOI,oBAAA;ExE48dV;EwEn9dM;IAOI,oBAAA;ExE+8dV;EwEt9dM;IAOI,oBAAA;ExEk9dV;EwEz9dM;IAOI,oBAAA;ExEq9dV;EwE59dM;IAOI,oBAAA;ExEw9dV;EwE/9dM;IAOI,oBAAA;ExE29dV;EwEl+dM;IAOI,oBAAA;ExE89dV;EwEr+dM;IAOI,oBAAA;ExEi+dV;EwEx+dM;IAOI,oBAAA;ExEo+dV;EwE3+dM;IAOI,oBAAA;ExEu+dV;EwE9+dM;IAOI,oBAAA;ExE0+dV;EwEj/dM;IAOI,oBAAA;ExE6+dV;EwEp/dM;IAOI,oBAAA;ExEg/dV;EwEv/dM;IAOI,oBAAA;ExEm/dV;EwE1/dM;IAOI,oBAAA;ExEs/dV;EwE7/dM;IAOI,qBAAA;ExEy/dV;EwEhgeM;IAOI,mBAAA;ExE4/dV;EwEngeM;IAOI,qBAAA;ExE+/dV;EwEtgeM;IAOI,sBAAA;ExEkgeV;EwEzgeM;IAOI,oBAAA;ExEqgeV;EwE5geM;IAOI,oBAAA;ExEwgeV;EwE/geM;IAOI,oBAAA;ExE2geV;EwElheM;IAOI,oBAAA;ExE8geV;EwErheM;IAOI,oBAAA;ExEiheV;EwExheM;IAOI,qBAAA;ExEoheV;EwE3heM;IAOI,qBAAA;ExEuheV;EwE9heM;IAOI,qBAAA;ExE0heV;EwEjieM;IAOI,qBAAA;ExE6heV;EwEpieM;IAOI,qBAAA;ExEgieV;EwEvieM;IAOI,qBAAA;ExEmieV;EwE1ieM;IAOI,qBAAA;ExEsieV;EwE7ieM;IAOI,qBAAA;ExEyieV;EwEhjeM;IAOI,qBAAA;ExE4ieV;EwEnjeM;IAOI,qBAAA;ExE+ieV;EwEtjeM;IAOI,qBAAA;ExEkjeV;EwEzjeM;IAOI,qBAAA;ExEqjeV;EwE5jeM;IAOI,qBAAA;ExEwjeV;EwE/jeM;IAOI,qBAAA;ExE2jeV;EwElkeM;IAOI,qBAAA;ExE8jeV;EwErkeM;IAOI,qBAAA;ExEikeV;EwExkeM;IAOI,qBAAA;ExEokeV;EwE3keM;IAOI,sBAAA;ExEukeV;EwE9keM;IAOI,qBAAA;ExE0keV;EwEjleM;IAOI,qBAAA;ExE6keV;EwEpleM;IAOI,qBAAA;ExEgleV;EwEvleM;IAOI,sBAAA;ExEmleV;EwE1leM;IAOI,sBAAA;ExEsleV;EwE7leM;IAOI,oBAAA;ExEyleV;EwEhmeM;IAOI,qBAAA;ExE4leV;EwEnmeM;IAOI,qBAAA;ExE+leV;EwEtmeM;IAOI,qBAAA;ExEkmeV;EwEzmeM;IAOI,qBAAA;ExEqmeV;EwE5meM;IAOI,qBAAA;ExEwmeV;EwE/meM;IAOI,qBAAA;ExE2meV;EwElneM;IAOI,qBAAA;ExE8meV;EwErneM;IAOI,qBAAA;ExEineV;EwExneM;IAOI,qBAAA;ExEoneV;EwE3neM;IAOI,qBAAA;ExEuneV;EwE9neM;IAOI,qBAAA;ExE0neV;EwEjoeM;IAOI,qBAAA;ExE6neV;EwEpoeM;IAOI,qBAAA;ExEgoeV;EwEvoeM;IAOI,qBAAA;ExEmoeV;EwE1oeM;IAOI,qBAAA;ExEsoeV;EwE7oeM;IAOI,sBAAA;ExEyoeV;EwEhpeM;IAOI,sBAAA;ExE4oeV;EwEnpeM;IAOI,sBAAA;ExE+oeV;EwEtpeM;IAOI,uBAAA;ExEkpeV;EwEzpeM;IAOI,uBAAA;ExEqpeV;EwE5peM;IAOI,qBAAA;ExEwpeV;EwE/peM;IAOI,sBAAA;ExE2peV;EwElqeM;IAOI,sBAAA;ExE8peV;EwErqeM;IAOI,sBAAA;ExEiqeV;EwExqeM;IAOI,sBAAA;ExEoqeV;EwE3qeM;IAOI,sBAAA;ExEuqeV;EwE9qeM;IAOI,sBAAA;ExE0qeV;EwEjreM;IAOI,sBAAA;ExE6qeV;EwEpreM;IAOI,sBAAA;ExEgreV;EwEvreM;IAOI,sBAAA;ExEmreV;EwE1reM;IAOI,sBAAA;ExEsreV;EwE7reM;IAOI,sBAAA;ExEyreV;EwEhseM;IAOI,sBAAA;ExE4reV;EwEnseM;IAOI,sBAAA;ExE+reV;EwEtseM;IAOI,sBAAA;ExEkseV;EwEzseM;IAOI,sBAAA;ExEqseV;EwE5seM;IAOI,yBAAA;ExEwseV;EwE/seM;IAOI,8BAAA;ExE2seV;EwElteM;IAOI,iCAAA;ExE8seV;EwErteM;IAOI,sCAAA;ExEiteV;EwExteM;IAOI,yCAAA;ExEoteV;EwE3teM;IAOI,uBAAA;ExEuteV;EwE9teM;IAOI,uBAAA;ExE0teV;EwEjueM;IAOI,yBAAA;ExE6teV;EwEpueM;IAOI,yBAAA;ExEgueV;EwEvueM;IAOI,0BAAA;ExEmueV;EwE1ueM;IAOI,4BAAA;ExEsueV;EwE7ueM;IAOI,kCAAA;ExEyueV;EwEhveM;IAOI,sCAAA;ExE4ueV;EwEnveM;IAOI,oCAAA;ExE+ueV;EwEtveM;IAOI,kCAAA;ExEkveV;EwEzveM;IAOI,yCAAA;ExEqveV;EwE5veM;IAOI,wCAAA;ExEwveV;EwE/veM;IAOI,wCAAA;ExE2veV;EwElweM;IAOI,kCAAA;ExE8veV;EwErweM;IAOI,gCAAA;ExEiweV;EwExweM;IAOI,8BAAA;ExEoweV;EwE3weM;IAOI,gCAAA;ExEuweV;EwE9weM;IAOI,+BAAA;ExE0weV;EwEjxeM;IAOI,oCAAA;ExE6weV;EwEpxeM;IAOI,kCAAA;ExEgxeV;EwEvxeM;IAOI,gCAAA;ExEmxeV;EwE1xeM;IAOI,uCAAA;ExEsxeV;EwE7xeM;IAOI,sCAAA;ExEyxeV;EwEhyeM;IAOI,iCAAA;ExE4xeV;EwEnyeM;IAOI,2BAAA;ExE+xeV;EwEtyeM;IAOI,iCAAA;ExEkyeV;EwEzyeM;IAOI,+BAAA;ExEqyeV;EwE5yeM;IAOI,6BAAA;ExEwyeV;EwE/yeM;IAOI,+BAAA;ExE2yeV;EwElzeM;IAOI,8BAAA;ExE8yeV;EwErzeM;IAOI,oBAAA;ExEizeV;EwExzeM;IAOI,mBAAA;ExEozeV;EwE3zeM;IAOI,mBAAA;ExEuzeV;EwE9zeM;IAOI,mBAAA;ExE0zeV;EwEj0eM;IAOI,mBAAA;ExE6zeV;EwEp0eM;IAOI,mBAAA;ExEg0eV;EwEv0eM;IAOI,mBAAA;ExEm0eV;EwE10eM;IAOI,mBAAA;ExEs0eV;EwE70eM;IAOI,oBAAA;ExEy0eV;EwEh1eM;IAOI,0BAAA;ExE40eV;EwEn1eM;IAOI,yBAAA;ExE+0eV;EwEt1eM;IAOI,uBAAA;ExEk1eV;EwEz1eM;IAOI,yBAAA;ExEq1eV;EwE51eM;IAOI,uBAAA;ExEw1eV;EwE/1eM;IAOI,yBAAA;ExE21eV;EwEl2eM;IAOI,uBAAA;ExE81eV;EwEr2eM;IAOI,uBAAA;ExEi2eV;EwEx2eM;IAOI,wBAAA;ExEo2eV;EwE32eM;IAOI,uBAAA;ExEu2eV;EwE92eM;IAOI,0BAAA;IAAA,yBAAA;ExE22eV;EwEl3eM;IAOI,gCAAA;IAAA,+BAAA;ExE+2eV;EwEt3eM;IAOI,+BAAA;IAAA,8BAAA;ExEm3eV;EwE13eM;IAOI,6BAAA;IAAA,4BAAA;ExEu3eV;EwE93eM;IAOI,+BAAA;IAAA,8BAAA;ExE23eV;EwEl4eM;IAOI,6BAAA;IAAA,4BAAA;ExE+3eV;EwEt4eM;IAOI,+BAAA;IAAA,8BAAA;ExEm4eV;EwE14eM;IAOI,6BAAA;IAAA,4BAAA;ExEu4eV;EwE94eM;IAOI,6BAAA;IAAA,4BAAA;ExE24eV;EwEl5eM;IAOI,8BAAA;IAAA,6BAAA;ExE+4eV;EwEt5eM;IAOI,6BAAA;IAAA,4BAAA;ExEm5eV;EwE15eM;IAOI,wBAAA;IAAA,2BAAA;ExEu5eV;EwE95eM;IAOI,8BAAA;IAAA,iCAAA;ExE25eV;EwEl6eM;IAOI,6BAAA;IAAA,gCAAA;ExE+5eV;EwEt6eM;IAOI,2BAAA;IAAA,8BAAA;ExEm6eV;EwE16eM;IAOI,6BAAA;IAAA,gCAAA;ExEu6eV;EwE96eM;IAOI,2BAAA;IAAA,8BAAA;ExE26eV;EwEl7eM;IAOI,6BAAA;IAAA,gCAAA;ExE+6eV;EwEt7eM;IAOI,2BAAA;IAAA,8BAAA;ExEm7eV;EwE17eM;IAOI,2BAAA;IAAA,8BAAA;ExEu7eV;EwE97eM;IAOI,4BAAA;IAAA,+BAAA;ExE27eV;EwEl8eM;IAOI,2BAAA;IAAA,8BAAA;ExE+7eV;EwEt8eM;IAOI,wBAAA;ExEk8eV;EwEz8eM;IAOI,8BAAA;ExEq8eV;EwE58eM;IAOI,6BAAA;ExEw8eV;EwE/8eM;IAOI,2BAAA;ExE28eV;EwEl9eM;IAOI,6BAAA;ExE88eV;EwEr9eM;IAOI,2BAAA;ExEi9eV;EwEx9eM;IAOI,6BAAA;ExEo9eV;EwE39eM;IAOI,2BAAA;ExEu9eV;EwE99eM;IAOI,2BAAA;ExE09eV;EwEj+eM;IAOI,4BAAA;ExE69eV;EwEp+eM;IAOI,2BAAA;ExEg+eV;EwEv+eM;IAOI,0BAAA;ExEm+eV;EwE1+eM;IAOI,gCAAA;ExEs+eV;EwE7+eM;IAOI,+BAAA;ExEy+eV;EwEh/eM;IAOI,6BAAA;ExE4+eV;EwEn/eM;IAOI,+BAAA;ExE++eV;EwEt/eM;IAOI,6BAAA;ExEk/eV;EwEz/eM;IAOI,+BAAA;ExEq/eV;EwE5/eM;IAOI,6BAAA;ExEw/eV;EwE//eM;IAOI,6BAAA;ExE2/eV;EwElgfM;IAOI,8BAAA;ExE8/eV;EwErgfM;IAOI,6BAAA;ExEigfV;EwExgfM;IAOI,2BAAA;ExEogfV;EwE3gfM;IAOI,iCAAA;ExEugfV;EwE9gfM;IAOI,gCAAA;ExE0gfV;EwEjhfM;IAOI,8BAAA;ExE6gfV;EwEphfM;IAOI,gCAAA;ExEghfV;EwEvhfM;IAOI,8BAAA;ExEmhfV;EwE1hfM;IAOI,gCAAA;ExEshfV;EwE7hfM;IAOI,8BAAA;ExEyhfV;EwEhifM;IAOI,8BAAA;ExE4hfV;EwEnifM;IAOI,+BAAA;ExE+hfV;EwEtifM;IAOI,8BAAA;ExEkifV;EwEzifM;IAOI,yBAAA;ExEqifV;EwE5ifM;IAOI,+BAAA;ExEwifV;EwE/ifM;IAOI,8BAAA;ExE2ifV;EwEljfM;IAOI,4BAAA;ExE8ifV;EwErjfM;IAOI,8BAAA;ExEijfV;EwExjfM;IAOI,4BAAA;ExEojfV;EwE3jfM;IAOI,8BAAA;ExEujfV;EwE9jfM;IAOI,4BAAA;ExE0jfV;EwEjkfM;IAOI,4BAAA;ExE6jfV;EwEpkfM;IAOI,6BAAA;ExEgkfV;EwEvkfM;IAOI,4BAAA;ExEmkfV;EwE1kfM;IAOI,2BAAA;ExEskfV;EwE7kfM;IAOI,0BAAA;ExEykfV;EwEhlfM;IAOI,wBAAA;ExE4kfV;EwEnlfM;IAOI,0BAAA;ExE+kfV;EwEtlfM;IAOI,wBAAA;ExEklfV;EwEzlfM;IAOI,0BAAA;ExEqlfV;EwE5lfM;IAOI,wBAAA;ExEwlfV;EwE/lfM;IAOI,wBAAA;ExE2lfV;EwElmfM;IAOI,yBAAA;ExE8lfV;EwErmfM;IAOI,iCAAA;IAAA,gCAAA;ExEkmfV;EwEzmfM;IAOI,gCAAA;IAAA,+BAAA;ExEsmfV;EwE7mfM;IAOI,8BAAA;IAAA,6BAAA;ExE0mfV;EwEjnfM;IAOI,gCAAA;IAAA,+BAAA;ExE8mfV;EwErnfM;IAOI,8BAAA;IAAA,6BAAA;ExEknfV;EwEznfM;IAOI,gCAAA;IAAA,+BAAA;ExEsnfV;EwE7nfM;IAOI,8BAAA;IAAA,6BAAA;ExE0nfV;EwEjofM;IAOI,8BAAA;IAAA,6BAAA;ExE8nfV;EwErofM;IAOI,+BAAA;IAAA,8BAAA;ExEkofV;EwEzofM;IAOI,+BAAA;IAAA,kCAAA;ExEsofV;EwE7ofM;IAOI,8BAAA;IAAA,iCAAA;ExE0ofV;EwEjpfM;IAOI,4BAAA;IAAA,+BAAA;ExE8ofV;EwErpfM;IAOI,8BAAA;IAAA,iCAAA;ExEkpfV;EwEzpfM;IAOI,4BAAA;IAAA,+BAAA;ExEspfV;EwE7pfM;IAOI,8BAAA;IAAA,iCAAA;ExE0pfV;EwEjqfM;IAOI,4BAAA;IAAA,+BAAA;ExE8pfV;EwErqfM;IAOI,4BAAA;IAAA,+BAAA;ExEkqfV;EwEzqfM;IAOI,6BAAA;IAAA,gCAAA;ExEsqfV;EwE7qfM;IAOI,+BAAA;ExEyqfV;EwEhrfM;IAOI,8BAAA;ExE4qfV;EwEnrfM;IAOI,4BAAA;ExE+qfV;EwEtrfM;IAOI,8BAAA;ExEkrfV;EwEzrfM;IAOI,4BAAA;ExEqrfV;EwE5rfM;IAOI,8BAAA;ExEwrfV;EwE/rfM;IAOI,4BAAA;ExE2rfV;EwElsfM;IAOI,4BAAA;ExE8rfV;EwErsfM;IAOI,6BAAA;ExEisfV;EwExsfM;IAOI,iCAAA;ExEosfV;EwE3sfM;IAOI,gCAAA;ExEusfV;EwE9sfM;IAOI,8BAAA;ExE0sfV;EwEjtfM;IAOI,gCAAA;ExE6sfV;EwEptfM;IAOI,8BAAA;ExEgtfV;EwEvtfM;IAOI,gCAAA;ExEmtfV;EwE1tfM;IAOI,8BAAA;ExEstfV;EwE7tfM;IAOI,8BAAA;ExEytfV;EwEhufM;IAOI,+BAAA;ExE4tfV;EwEnufM;IAOI,kCAAA;ExE+tfV;EwEtufM;IAOI,iCAAA;ExEkufV;EwEzufM;IAOI,+BAAA;ExEqufV;EwE5ufM;IAOI,iCAAA;ExEwufV;EwE/ufM;IAOI,+BAAA;ExE2ufV;EwElvfM;IAOI,iCAAA;ExE8ufV;EwErvfM;IAOI,+BAAA;ExEivfV;EwExvfM;IAOI,+BAAA;ExEovfV;EwE3vfM;IAOI,gCAAA;ExEuvfV;EwE9vfM;IAOI,gCAAA;ExE0vfV;EwEjwfM;IAOI,+BAAA;ExE6vfV;EwEpwfM;IAOI,6BAAA;ExEgwfV;EwEvwfM;IAOI,+BAAA;ExEmwfV;EwE1wfM;IAOI,6BAAA;ExEswfV;EwE7wfM;IAOI,+BAAA;ExEywfV;EwEhxfM;IAOI,6BAAA;ExE4wfV;EwEnxfM;IAOI,6BAAA;ExE+wfV;EwEtxfM;IAOI,8BAAA;ExEkxfV;EwEzxfM;IAOI,qBAAA;ExEqxfV;EwE5xfM;IAOI,2BAAA;ExEwxfV;EwE/xfM;IAOI,0BAAA;ExE2xfV;EwElyfM;IAOI,wBAAA;ExE8xfV;EwEryfM;IAOI,0BAAA;ExEiyfV;EwExyfM;IAOI,wBAAA;ExEoyfV;EwE3yfM;IAOI,0BAAA;ExEuyfV;EwE9yfM;IAOI,wBAAA;ExE0yfV;EwEjzfM;IAOI,wBAAA;ExE6yfV;EwEpzfM;IAOI,yBAAA;ExEgzfV;EwEvzfM;IAOI,2BAAA;IAAA,0BAAA;ExEozfV;EwE3zfM;IAOI,iCAAA;IAAA,gCAAA;ExEwzfV;EwE/zfM;IAOI,gCAAA;IAAA,+BAAA;ExE4zfV;EwEn0fM;IAOI,8BAAA;IAAA,6BAAA;ExEg0fV;EwEv0fM;IAOI,gCAAA;IAAA,+BAAA;ExEo0fV;EwE30fM;IAOI,8BAAA;IAAA,6BAAA;ExEw0fV;EwE/0fM;IAOI,gCAAA;IAAA,+BAAA;ExE40fV;EwEn1fM;IAOI,8BAAA;IAAA,6BAAA;ExEg1fV;EwEv1fM;IAOI,8BAAA;IAAA,6BAAA;ExEo1fV;EwE31fM;IAOI,+BAAA;IAAA,8BAAA;ExEw1fV;EwE/1fM;IAOI,yBAAA;IAAA,4BAAA;ExE41fV;EwEn2fM;IAOI,+BAAA;IAAA,kCAAA;ExEg2fV;EwEv2fM;IAOI,8BAAA;IAAA,iCAAA;ExEo2fV;EwE32fM;IAOI,4BAAA;IAAA,+BAAA;ExEw2fV;EwE/2fM;IAOI,8BAAA;IAAA,iCAAA;ExE42fV;EwEn3fM;IAOI,4BAAA;IAAA,+BAAA;ExEg3fV;EwEv3fM;IAOI,8BAAA;IAAA,iCAAA;ExEo3fV;EwE33fM;IAOI,4BAAA;IAAA,+BAAA;ExEw3fV;EwE/3fM;IAOI,4BAAA;IAAA,+BAAA;ExE43fV;EwEn4fM;IAOI,6BAAA;IAAA,gCAAA;ExEg4fV;EwEv4fM;IAOI,yBAAA;ExEm4fV;EwE14fM;IAOI,+BAAA;ExEs4fV;EwE74fM;IAOI,8BAAA;ExEy4fV;EwEh5fM;IAOI,4BAAA;ExE44fV;EwEn5fM;IAOI,8BAAA;ExE+4fV;EwEt5fM;IAOI,4BAAA;ExEk5fV;EwEz5fM;IAOI,8BAAA;ExEq5fV;EwE55fM;IAOI,4BAAA;ExEw5fV;EwE/5fM;IAOI,4BAAA;ExE25fV;EwEl6fM;IAOI,6BAAA;ExE85fV;EwEr6fM;IAOI,2BAAA;ExEi6fV;EwEx6fM;IAOI,iCAAA;ExEo6fV;EwE36fM;IAOI,gCAAA;ExEu6fV;EwE96fM;IAOI,8BAAA;ExE06fV;EwEj7fM;IAOI,gCAAA;ExE66fV;EwEp7fM;IAOI,8BAAA;ExEg7fV;EwEv7fM;IAOI,gCAAA;ExEm7fV;EwE17fM;IAOI,8BAAA;ExEs7fV;EwE77fM;IAOI,8BAAA;ExEy7fV;EwEh8fM;IAOI,+BAAA;ExE47fV;EwEn8fM;IAOI,4BAAA;ExE+7fV;EwEt8fM;IAOI,kCAAA;ExEk8fV;EwEz8fM;IAOI,iCAAA;ExEq8fV;EwE58fM;IAOI,+BAAA;ExEw8fV;EwE/8fM;IAOI,iCAAA;ExE28fV;EwEl9fM;IAOI,+BAAA;ExE88fV;EwEr9fM;IAOI,iCAAA;ExEi9fV;EwEx9fM;IAOI,+BAAA;ExEo9fV;EwE39fM;IAOI,+BAAA;ExEu9fV;EwE99fM;IAOI,gCAAA;ExE09fV;EwEj+fM;IAOI,0BAAA;ExE69fV;EwEp+fM;IAOI,gCAAA;ExEg+fV;EwEv+fM;IAOI,+BAAA;ExEm+fV;EwE1+fM;IAOI,6BAAA;ExEs+fV;EwE7+fM;IAOI,+BAAA;ExEy+fV;EwEh/fM;IAOI,6BAAA;ExE4+fV;EwEn/fM;IAOI,+BAAA;ExE++fV;EwEt/fM;IAOI,6BAAA;ExEk/fV;EwEz/fM;IAOI,6BAAA;ExEq/fV;EwE5/fM;IAOI,8BAAA;ExEw/fV;EwE//fM;IAOI,iBAAA;ExE2/fV;EwElggBM;IAOI,uBAAA;ExE8/fV;EwErggBM;IAOI,sBAAA;ExEiggBV;EwExggBM;IAOI,oBAAA;ExEoggBV;EwE3ggBM;IAOI,sBAAA;ExEuggBV;EwE9ggBM;IAOI,oBAAA;ExE0ggBV;EwEjhgBM;IAOI,sBAAA;ExE6ggBV;EwEphgBM;IAOI,oBAAA;ExEghgBV;EwEvhgBM;IAOI,oBAAA;ExEmhgBV;EwE1hgBM;IAOI,qBAAA;ExEshgBV;EwE7hgBM;IAOI,qBAAA;ExEyhgBV;EwEhigBM;IAOI,2BAAA;ExE4hgBV;EwEnigBM;IAOI,0BAAA;ExE+hgBV;EwEtigBM;IAOI,wBAAA;ExEkigBV;EwEzigBM;IAOI,0BAAA;ExEqigBV;EwE5igBM;IAOI,wBAAA;ExEwigBV;EwE/igBM;IAOI,0BAAA;ExE2igBV;EwEljgBM;IAOI,wBAAA;ExE8igBV;EwErjgBM;IAOI,wBAAA;ExEijgBV;EwExjgBM;IAOI,yBAAA;ExEojgBV;EwE3jgBM;IAOI,wBAAA;ExEujgBV;EwE9jgBM;IAOI,8BAAA;ExE0jgBV;EwEjkgBM;IAOI,6BAAA;ExE6jgBV;EwEpkgBM;IAOI,2BAAA;ExEgkgBV;EwEvkgBM;IAOI,6BAAA;ExEmkgBV;EwE1kgBM;IAOI,2BAAA;ExEskgBV;EwE7kgBM;IAOI,6BAAA;ExEykgBV;EwEhlgBM;IAOI,2BAAA;ExE4kgBV;EwEnlgBM;IAOI,2BAAA;ExE+kgBV;EwEtlgBM;IAOI,4BAAA;ExEklgBV;EwEzlgBM;IAOI,8CAAA;ExEqlgBV;EwE5lgBM;IAOI,6CAAA;ExEwlgBV;EwE/lgBM;IAOI,gDAAA;ExE2lgBV;EwElmgBM;IAOI,8CAAA;ExE8lgBV;EwErmgBM;IAOI,gDAAA;ExEimgBV;EwExmgBM;IAOI,6BAAA;ExEomgBV;EwE3mgBM;IAOI,2BAAA;ExEumgBV;EwE9mgBM;IAOI,4BAAA;ExE0mgBV;EwEjngBM;IAOI,6BAAA;ExE6mgBV;EwEpngBM;IAIQ,oBAAA;IAGJ,qEAAA;ExEingBV;EwExngBM;IAIQ,oBAAA;IAGJ,uEAAA;ExEqngBV;EwE5ngBM;IAIQ,oBAAA;IAGJ,qEAAA;ExEyngBV;EwEhogBM;IAIQ,oBAAA;IAGJ,kEAAA;ExE6ngBV;EwEpogBM;IAIQ,oBAAA;IAGJ,qEAAA;ExEiogBV;EwExogBM;IAIQ,oBAAA;IAGJ,oEAAA;ExEqogBV;EwE5ogBM;IAIQ,oBAAA;IAGJ,mEAAA;ExEyogBV;EwEhpgBM;IAIQ,oBAAA;IAGJ,kEAAA;ExE6ogBV;EwEppgBM;IAIQ,oBAAA;IAGJ,mEAAA;ExEipgBV;EwExpgBM;IAIQ,oBAAA;IAGJ,mEAAA;ExEqpgBV;EwE5pgBM;IAIQ,oBAAA;IAGJ,wEAAA;ExEypgBV;EwEhqgBM;IAIQ,oBAAA;IAGJ,2CAAA;ExE6pgBV;EwEpqgBM;IAIQ,oBAAA;IAGJ,oCAAA;ExEiqgBV;EwExqgBM;IAIQ,oBAAA;IAGJ,0CAAA;ExEqqgBV;EwE5qgBM;IAIQ,oBAAA;IAGJ,2CAAA;ExEyqgBV;EwEhrgBM;IAIQ,oBAAA;IAGJ,0CAAA;ExE6qgBV;EwEprgBM;IAIQ,oBAAA;IAGJ,0CAAA;ExEirgBV;EwExrgBM;IAIQ,oBAAA;IAGJ,yBAAA;ExEqrgBV;AACF;AMhsgBI;EkEGI;IAOI,sBAAA;ExE0rgBV;EwEjsgBM;IAOI,uBAAA;ExE6rgBV;EwEpsgBM;IAOI,sBAAA;ExEgsgBV;EwEvsgBM;IAOI,8BAAA;ExEmsgBV;EwE1sgBM;IAOI,4BAAA;ExEssgBV;EwE7sgBM;IAOI,2BAAA;ExEysgBV;EwEhtgBM;IAOI,iCAAA;ExE4sgBV;EwEntgBM;IAOI,2BAAA;ExE+sgBV;EwEttgBM;IAOI,qBAAA;ExEktgBV;EwEztgBM;IAOI,wBAAA;ExEqtgBV;EwE5tgBM;IAOI,uBAAA;ExEwtgBV;EwE/tgBM;IAOI,wBAAA;ExE2tgBV;EwElugBM;IAOI,qBAAA;ExE8tgBV;EwErugBM;IAOI,uBAAA;ExEiugBV;EwExugBM;IAOI,uBAAA;ExEougBV;EwE3ugBM;IAOI,wBAAA;ExEuugBV;EwE9ugBM;IAOI,uBAAA;ExE0ugBV;EwEjvgBM;IAOI,uBAAA;ExE6ugBV;EwEpvgBM;IAOI,wBAAA;ExEgvgBV;EwEvvgBM;IAOI,uBAAA;ExEmvgBV;EwE1vgBM;IAOI,wBAAA;ExEsvgBV;EwE7vgBM;IAOI,uBAAA;ExEyvgBV;EwEhwgBM;IAOI,wBAAA;ExE4vgBV;EwEnwgBM;IAOI,uBAAA;ExE+vgBV;EwEtwgBM;IAOI,uBAAA;ExEkwgBV;EwEzwgBM;IAOI,wBAAA;ExEqwgBV;EwE5wgBM;IAOI,uBAAA;ExEwwgBV;EwE/wgBM;IAOI,wBAAA;ExE2wgBV;EwElxgBM;IAOI,0BAAA;ExE8wgBV;EwErxgBM;IAOI,gCAAA;ExEixgBV;EwExxgBM;IAOI,yBAAA;ExEoxgBV;EwE3xgBM;IAOI,wBAAA;ExEuxgBV;EwE9xgBM;IAOI,+BAAA;ExE0xgBV;EwEjygBM;IAOI,yBAAA;ExE6xgBV;EwEpygBM;IAOI,6BAAA;ExEgygBV;EwEvygBM;IAOI,8BAAA;ExEmygBV;EwE1ygBM;IAOI,wBAAA;ExEsygBV;EwE7ygBM;IAOI,+BAAA;ExEyygBV;EwEhzgBM;IAOI,wBAAA;ExE4ygBV;EwEnzgBM;IAOI,iBAAA;ExE+ygBV;EwEtzgBM;IAOI,mBAAA;ExEkzgBV;EwEzzgBM;IAOI,oBAAA;ExEqzgBV;EwE5zgBM;IAOI,kBAAA;ExEwzgBV;EwE/zgBM;IAOI,kBAAA;ExE2zgBV;EwEl0gBM;IAOI,kBAAA;ExE8zgBV;EwEr0gBM;IAOI,kBAAA;ExEi0gBV;EwEx0gBM;IAOI,kBAAA;ExEo0gBV;EwE30gBM;IAOI,mBAAA;ExEu0gBV;EwE90gBM;IAOI,mBAAA;ExE00gBV;EwEj1gBM;IAOI,mBAAA;ExE60gBV;EwEp1gBM;IAOI,mBAAA;ExEg1gBV;EwEv1gBM;IAOI,mBAAA;ExEm1gBV;EwE11gBM;IAOI,mBAAA;ExEs1gBV;EwE71gBM;IAOI,mBAAA;ExEy1gBV;EwEh2gBM;IAOI,mBAAA;ExE41gBV;EwEn2gBM;IAOI,mBAAA;ExE+1gBV;EwEt2gBM;IAOI,mBAAA;ExEk2gBV;EwEz2gBM;IAOI,mBAAA;ExEq2gBV;EwE52gBM;IAOI,mBAAA;ExEw2gBV;EwE/2gBM;IAOI,mBAAA;ExE22gBV;EwEl3gBM;IAOI,mBAAA;ExE82gBV;EwEr3gBM;IAOI,mBAAA;ExEi3gBV;EwEx3gBM;IAOI,mBAAA;ExEo3gBV;EwE33gBM;IAOI,mBAAA;ExEu3gBV;EwE93gBM;IAOI,oBAAA;ExE03gBV;EwEj4gBM;IAOI,oBAAA;ExE63gBV;EwEp4gBM;IAOI,sBAAA;ExEg4gBV;EwEv4gBM;IAOI,uBAAA;ExEm4gBV;EwE14gBM;IAOI,qBAAA;ExEs4gBV;EwE74gBM;IAOI,qBAAA;ExEy4gBV;EwEh5gBM;IAOI,qBAAA;ExE44gBV;EwEn5gBM;IAOI,qBAAA;ExE+4gBV;EwEt5gBM;IAOI,qBAAA;ExEk5gBV;EwEz5gBM;IAOI,sBAAA;ExEq5gBV;EwE55gBM;IAOI,sBAAA;ExEw5gBV;EwE/5gBM;IAOI,sBAAA;ExE25gBV;EwEl6gBM;IAOI,sBAAA;ExE85gBV;EwEr6gBM;IAOI,sBAAA;ExEi6gBV;EwEx6gBM;IAOI,sBAAA;ExEo6gBV;EwE36gBM;IAOI,sBAAA;ExEu6gBV;EwE96gBM;IAOI,sBAAA;ExE06gBV;EwEj7gBM;IAOI,sBAAA;ExE66gBV;EwEp7gBM;IAOI,sBAAA;ExEg7gBV;EwEv7gBM;IAOI,sBAAA;ExEm7gBV;EwE17gBM;IAOI,sBAAA;ExEs7gBV;EwE77gBM;IAOI,sBAAA;ExEy7gBV;EwEh8gBM;IAOI,sBAAA;ExE47gBV;EwEn8gBM;IAOI,sBAAA;ExE+7gBV;EwEt8gBM;IAOI,sBAAA;ExEk8gBV;EwEz8gBM;IAOI,sBAAA;ExEq8gBV;EwE58gBM;IAOI,uBAAA;ExEw8gBV;EwE/8gBM;IAOI,kBAAA;ExE28gBV;EwEl9gBM;IAOI,oBAAA;ExE88gBV;EwEr9gBM;IAOI,qBAAA;ExEi9gBV;EwEx9gBM;IAOI,mBAAA;ExEo9gBV;EwE39gBM;IAOI,mBAAA;ExEu9gBV;EwE99gBM;IAOI,mBAAA;ExE09gBV;EwEj+gBM;IAOI,mBAAA;ExE69gBV;EwEp+gBM;IAOI,mBAAA;ExEg+gBV;EwEv+gBM;IAOI,oBAAA;ExEm+gBV;EwE1+gBM;IAOI,oBAAA;ExEs+gBV;EwE7+gBM;IAOI,oBAAA;ExEy+gBV;EwEh/gBM;IAOI,oBAAA;ExE4+gBV;EwEn/gBM;IAOI,oBAAA;ExE++gBV;EwEt/gBM;IAOI,oBAAA;ExEk/gBV;EwEz/gBM;IAOI,oBAAA;ExEq/gBV;EwE5/gBM;IAOI,oBAAA;ExEw/gBV;EwE//gBM;IAOI,oBAAA;ExE2/gBV;EwElghBM;IAOI,oBAAA;ExE8/gBV;EwErghBM;IAOI,oBAAA;ExEighBV;EwExghBM;IAOI,oBAAA;ExEoghBV;EwE3ghBM;IAOI,oBAAA;ExEughBV;EwE9ghBM;IAOI,oBAAA;ExE0ghBV;EwEjhhBM;IAOI,oBAAA;ExE6ghBV;EwEphhBM;IAOI,oBAAA;ExEghhBV;EwEvhhBM;IAOI,oBAAA;ExEmhhBV;EwE1hhBM;IAOI,qBAAA;ExEshhBV;EwE7hhBM;IAOI,mBAAA;ExEyhhBV;EwEhihBM;IAOI,qBAAA;ExE4hhBV;EwEnihBM;IAOI,sBAAA;ExE+hhBV;EwEtihBM;IAOI,oBAAA;ExEkihBV;EwEzihBM;IAOI,oBAAA;ExEqihBV;EwE5ihBM;IAOI,oBAAA;ExEwihBV;EwE/ihBM;IAOI,oBAAA;ExE2ihBV;EwEljhBM;IAOI,oBAAA;ExE8ihBV;EwErjhBM;IAOI,qBAAA;ExEijhBV;EwExjhBM;IAOI,qBAAA;ExEojhBV;EwE3jhBM;IAOI,qBAAA;ExEujhBV;EwE9jhBM;IAOI,qBAAA;ExE0jhBV;EwEjkhBM;IAOI,qBAAA;ExE6jhBV;EwEpkhBM;IAOI,qBAAA;ExEgkhBV;EwEvkhBM;IAOI,qBAAA;ExEmkhBV;EwE1khBM;IAOI,qBAAA;ExEskhBV;EwE7khBM;IAOI,qBAAA;ExEykhBV;EwEhlhBM;IAOI,qBAAA;ExE4khBV;EwEnlhBM;IAOI,qBAAA;ExE+khBV;EwEtlhBM;IAOI,qBAAA;ExEklhBV;EwEzlhBM;IAOI,qBAAA;ExEqlhBV;EwE5lhBM;IAOI,qBAAA;ExEwlhBV;EwE/lhBM;IAOI,qBAAA;ExE2lhBV;EwElmhBM;IAOI,qBAAA;ExE8lhBV;EwErmhBM;IAOI,qBAAA;ExEimhBV;EwExmhBM;IAOI,sBAAA;ExEomhBV;EwE3mhBM;IAOI,qBAAA;ExEumhBV;EwE9mhBM;IAOI,qBAAA;ExE0mhBV;EwEjnhBM;IAOI,qBAAA;ExE6mhBV;EwEpnhBM;IAOI,sBAAA;ExEgnhBV;EwEvnhBM;IAOI,sBAAA;ExEmnhBV;EwE1nhBM;IAOI,oBAAA;ExEsnhBV;EwE7nhBM;IAOI,qBAAA;ExEynhBV;EwEhohBM;IAOI,qBAAA;ExE4nhBV;EwEnohBM;IAOI,qBAAA;ExE+nhBV;EwEtohBM;IAOI,qBAAA;ExEkohBV;EwEzohBM;IAOI,qBAAA;ExEqohBV;EwE5ohBM;IAOI,qBAAA;ExEwohBV;EwE/ohBM;IAOI,qBAAA;ExE2ohBV;EwElphBM;IAOI,qBAAA;ExE8ohBV;EwErphBM;IAOI,qBAAA;ExEiphBV;EwExphBM;IAOI,qBAAA;ExEophBV;EwE3phBM;IAOI,qBAAA;ExEuphBV;EwE9phBM;IAOI,qBAAA;ExE0phBV;EwEjqhBM;IAOI,qBAAA;ExE6phBV;EwEpqhBM;IAOI,qBAAA;ExEgqhBV;EwEvqhBM;IAOI,qBAAA;ExEmqhBV;EwE1qhBM;IAOI,sBAAA;ExEsqhBV;EwE7qhBM;IAOI,sBAAA;ExEyqhBV;EwEhrhBM;IAOI,sBAAA;ExE4qhBV;EwEnrhBM;IAOI,uBAAA;ExE+qhBV;EwEtrhBM;IAOI,uBAAA;ExEkrhBV;EwEzrhBM;IAOI,qBAAA;ExEqrhBV;EwE5rhBM;IAOI,sBAAA;ExEwrhBV;EwE/rhBM;IAOI,sBAAA;ExE2rhBV;EwElshBM;IAOI,sBAAA;ExE8rhBV;EwErshBM;IAOI,sBAAA;ExEishBV;EwExshBM;IAOI,sBAAA;ExEoshBV;EwE3shBM;IAOI,sBAAA;ExEushBV;EwE9shBM;IAOI,sBAAA;ExE0shBV;EwEjthBM;IAOI,sBAAA;ExE6shBV;EwEpthBM;IAOI,sBAAA;ExEgthBV;EwEvthBM;IAOI,sBAAA;ExEmthBV;EwE1thBM;IAOI,sBAAA;ExEsthBV;EwE7thBM;IAOI,sBAAA;ExEythBV;EwEhuhBM;IAOI,sBAAA;ExE4thBV;EwEnuhBM;IAOI,sBAAA;ExE+thBV;EwEtuhBM;IAOI,sBAAA;ExEkuhBV;EwEzuhBM;IAOI,yBAAA;ExEquhBV;EwE5uhBM;IAOI,8BAAA;ExEwuhBV;EwE/uhBM;IAOI,iCAAA;ExE2uhBV;EwElvhBM;IAOI,sCAAA;ExE8uhBV;EwErvhBM;IAOI,yCAAA;ExEivhBV;EwExvhBM;IAOI,uBAAA;ExEovhBV;EwE3vhBM;IAOI,uBAAA;ExEuvhBV;EwE9vhBM;IAOI,yBAAA;ExE0vhBV;EwEjwhBM;IAOI,yBAAA;ExE6vhBV;EwEpwhBM;IAOI,0BAAA;ExEgwhBV;EwEvwhBM;IAOI,4BAAA;ExEmwhBV;EwE1whBM;IAOI,kCAAA;ExEswhBV;EwE7whBM;IAOI,sCAAA;ExEywhBV;EwEhxhBM;IAOI,oCAAA;ExE4whBV;EwEnxhBM;IAOI,kCAAA;ExE+whBV;EwEtxhBM;IAOI,yCAAA;ExEkxhBV;EwEzxhBM;IAOI,wCAAA;ExEqxhBV;EwE5xhBM;IAOI,wCAAA;ExEwxhBV;EwE/xhBM;IAOI,kCAAA;ExE2xhBV;EwElyhBM;IAOI,gCAAA;ExE8xhBV;EwEryhBM;IAOI,8BAAA;ExEiyhBV;EwExyhBM;IAOI,gCAAA;ExEoyhBV;EwE3yhBM;IAOI,+BAAA;ExEuyhBV;EwE9yhBM;IAOI,oCAAA;ExE0yhBV;EwEjzhBM;IAOI,kCAAA;ExE6yhBV;EwEpzhBM;IAOI,gCAAA;ExEgzhBV;EwEvzhBM;IAOI,uCAAA;ExEmzhBV;EwE1zhBM;IAOI,sCAAA;ExEszhBV;EwE7zhBM;IAOI,iCAAA;ExEyzhBV;EwEh0hBM;IAOI,2BAAA;ExE4zhBV;EwEn0hBM;IAOI,iCAAA;ExE+zhBV;EwEt0hBM;IAOI,+BAAA;ExEk0hBV;EwEz0hBM;IAOI,6BAAA;ExEq0hBV;EwE50hBM;IAOI,+BAAA;ExEw0hBV;EwE/0hBM;IAOI,8BAAA;ExE20hBV;EwEl1hBM;IAOI,oBAAA;ExE80hBV;EwEr1hBM;IAOI,mBAAA;ExEi1hBV;EwEx1hBM;IAOI,mBAAA;ExEo1hBV;EwE31hBM;IAOI,mBAAA;ExEu1hBV;EwE91hBM;IAOI,mBAAA;ExE01hBV;EwEj2hBM;IAOI,mBAAA;ExE61hBV;EwEp2hBM;IAOI,mBAAA;ExEg2hBV;EwEv2hBM;IAOI,mBAAA;ExEm2hBV;EwE12hBM;IAOI,oBAAA;ExEs2hBV;EwE72hBM;IAOI,0BAAA;ExEy2hBV;EwEh3hBM;IAOI,yBAAA;ExE42hBV;EwEn3hBM;IAOI,uBAAA;ExE+2hBV;EwEt3hBM;IAOI,yBAAA;ExEk3hBV;EwEz3hBM;IAOI,uBAAA;ExEq3hBV;EwE53hBM;IAOI,yBAAA;ExEw3hBV;EwE/3hBM;IAOI,uBAAA;ExE23hBV;EwEl4hBM;IAOI,uBAAA;ExE83hBV;EwEr4hBM;IAOI,wBAAA;ExEi4hBV;EwEx4hBM;IAOI,uBAAA;ExEo4hBV;EwE34hBM;IAOI,0BAAA;IAAA,yBAAA;ExEw4hBV;EwE/4hBM;IAOI,gCAAA;IAAA,+BAAA;ExE44hBV;EwEn5hBM;IAOI,+BAAA;IAAA,8BAAA;ExEg5hBV;EwEv5hBM;IAOI,6BAAA;IAAA,4BAAA;ExEo5hBV;EwE35hBM;IAOI,+BAAA;IAAA,8BAAA;ExEw5hBV;EwE/5hBM;IAOI,6BAAA;IAAA,4BAAA;ExE45hBV;EwEn6hBM;IAOI,+BAAA;IAAA,8BAAA;ExEg6hBV;EwEv6hBM;IAOI,6BAAA;IAAA,4BAAA;ExEo6hBV;EwE36hBM;IAOI,6BAAA;IAAA,4BAAA;ExEw6hBV;EwE/6hBM;IAOI,8BAAA;IAAA,6BAAA;ExE46hBV;EwEn7hBM;IAOI,6BAAA;IAAA,4BAAA;ExEg7hBV;EwEv7hBM;IAOI,wBAAA;IAAA,2BAAA;ExEo7hBV;EwE37hBM;IAOI,8BAAA;IAAA,iCAAA;ExEw7hBV;EwE/7hBM;IAOI,6BAAA;IAAA,gCAAA;ExE47hBV;EwEn8hBM;IAOI,2BAAA;IAAA,8BAAA;ExEg8hBV;EwEv8hBM;IAOI,6BAAA;IAAA,gCAAA;ExEo8hBV;EwE38hBM;IAOI,2BAAA;IAAA,8BAAA;ExEw8hBV;EwE/8hBM;IAOI,6BAAA;IAAA,gCAAA;ExE48hBV;EwEn9hBM;IAOI,2BAAA;IAAA,8BAAA;ExEg9hBV;EwEv9hBM;IAOI,2BAAA;IAAA,8BAAA;ExEo9hBV;EwE39hBM;IAOI,4BAAA;IAAA,+BAAA;ExEw9hBV;EwE/9hBM;IAOI,2BAAA;IAAA,8BAAA;ExE49hBV;EwEn+hBM;IAOI,wBAAA;ExE+9hBV;EwEt+hBM;IAOI,8BAAA;ExEk+hBV;EwEz+hBM;IAOI,6BAAA;ExEq+hBV;EwE5+hBM;IAOI,2BAAA;ExEw+hBV;EwE/+hBM;IAOI,6BAAA;ExE2+hBV;EwEl/hBM;IAOI,2BAAA;ExE8+hBV;EwEr/hBM;IAOI,6BAAA;ExEi/hBV;EwEx/hBM;IAOI,2BAAA;ExEo/hBV;EwE3/hBM;IAOI,2BAAA;ExEu/hBV;EwE9/hBM;IAOI,4BAAA;ExE0/hBV;EwEjgiBM;IAOI,2BAAA;ExE6/hBV;EwEpgiBM;IAOI,0BAAA;ExEggiBV;EwEvgiBM;IAOI,gCAAA;ExEmgiBV;EwE1giBM;IAOI,+BAAA;ExEsgiBV;EwE7giBM;IAOI,6BAAA;ExEygiBV;EwEhhiBM;IAOI,+BAAA;ExE4giBV;EwEnhiBM;IAOI,6BAAA;ExE+giBV;EwEthiBM;IAOI,+BAAA;ExEkhiBV;EwEzhiBM;IAOI,6BAAA;ExEqhiBV;EwE5hiBM;IAOI,6BAAA;ExEwhiBV;EwE/hiBM;IAOI,8BAAA;ExE2hiBV;EwEliiBM;IAOI,6BAAA;ExE8hiBV;EwEriiBM;IAOI,2BAAA;ExEiiiBV;EwExiiBM;IAOI,iCAAA;ExEoiiBV;EwE3iiBM;IAOI,gCAAA;ExEuiiBV;EwE9iiBM;IAOI,8BAAA;ExE0iiBV;EwEjjiBM;IAOI,gCAAA;ExE6iiBV;EwEpjiBM;IAOI,8BAAA;ExEgjiBV;EwEvjiBM;IAOI,gCAAA;ExEmjiBV;EwE1jiBM;IAOI,8BAAA;ExEsjiBV;EwE7jiBM;IAOI,8BAAA;ExEyjiBV;EwEhkiBM;IAOI,+BAAA;ExE4jiBV;EwEnkiBM;IAOI,8BAAA;ExE+jiBV;EwEtkiBM;IAOI,yBAAA;ExEkkiBV;EwEzkiBM;IAOI,+BAAA;ExEqkiBV;EwE5kiBM;IAOI,8BAAA;ExEwkiBV;EwE/kiBM;IAOI,4BAAA;ExE2kiBV;EwElliBM;IAOI,8BAAA;ExE8kiBV;EwErliBM;IAOI,4BAAA;ExEiliBV;EwExliBM;IAOI,8BAAA;ExEoliBV;EwE3liBM;IAOI,4BAAA;ExEuliBV;EwE9liBM;IAOI,4BAAA;ExE0liBV;EwEjmiBM;IAOI,6BAAA;ExE6liBV;EwEpmiBM;IAOI,4BAAA;ExEgmiBV;EwEvmiBM;IAOI,2BAAA;ExEmmiBV;EwE1miBM;IAOI,0BAAA;ExEsmiBV;EwE7miBM;IAOI,wBAAA;ExEymiBV;EwEhniBM;IAOI,0BAAA;ExE4miBV;EwEnniBM;IAOI,wBAAA;ExE+miBV;EwEtniBM;IAOI,0BAAA;ExEkniBV;EwEzniBM;IAOI,wBAAA;ExEqniBV;EwE5niBM;IAOI,wBAAA;ExEwniBV;EwE/niBM;IAOI,yBAAA;ExE2niBV;EwEloiBM;IAOI,iCAAA;IAAA,gCAAA;ExE+niBV;EwEtoiBM;IAOI,gCAAA;IAAA,+BAAA;ExEmoiBV;EwE1oiBM;IAOI,8BAAA;IAAA,6BAAA;ExEuoiBV;EwE9oiBM;IAOI,gCAAA;IAAA,+BAAA;ExE2oiBV;EwElpiBM;IAOI,8BAAA;IAAA,6BAAA;ExE+oiBV;EwEtpiBM;IAOI,gCAAA;IAAA,+BAAA;ExEmpiBV;EwE1piBM;IAOI,8BAAA;IAAA,6BAAA;ExEupiBV;EwE9piBM;IAOI,8BAAA;IAAA,6BAAA;ExE2piBV;EwElqiBM;IAOI,+BAAA;IAAA,8BAAA;ExE+piBV;EwEtqiBM;IAOI,+BAAA;IAAA,kCAAA;ExEmqiBV;EwE1qiBM;IAOI,8BAAA;IAAA,iCAAA;ExEuqiBV;EwE9qiBM;IAOI,4BAAA;IAAA,+BAAA;ExE2qiBV;EwElriBM;IAOI,8BAAA;IAAA,iCAAA;ExE+qiBV;EwEtriBM;IAOI,4BAAA;IAAA,+BAAA;ExEmriBV;EwE1riBM;IAOI,8BAAA;IAAA,iCAAA;ExEuriBV;EwE9riBM;IAOI,4BAAA;IAAA,+BAAA;ExE2riBV;EwElsiBM;IAOI,4BAAA;IAAA,+BAAA;ExE+riBV;EwEtsiBM;IAOI,6BAAA;IAAA,gCAAA;ExEmsiBV;EwE1siBM;IAOI,+BAAA;ExEssiBV;EwE7siBM;IAOI,8BAAA;ExEysiBV;EwEhtiBM;IAOI,4BAAA;ExE4siBV;EwEntiBM;IAOI,8BAAA;ExE+siBV;EwEttiBM;IAOI,4BAAA;ExEktiBV;EwEztiBM;IAOI,8BAAA;ExEqtiBV;EwE5tiBM;IAOI,4BAAA;ExEwtiBV;EwE/tiBM;IAOI,4BAAA;ExE2tiBV;EwEluiBM;IAOI,6BAAA;ExE8tiBV;EwEruiBM;IAOI,iCAAA;ExEiuiBV;EwExuiBM;IAOI,gCAAA;ExEouiBV;EwE3uiBM;IAOI,8BAAA;ExEuuiBV;EwE9uiBM;IAOI,gCAAA;ExE0uiBV;EwEjviBM;IAOI,8BAAA;ExE6uiBV;EwEpviBM;IAOI,gCAAA;ExEgviBV;EwEvviBM;IAOI,8BAAA;ExEmviBV;EwE1viBM;IAOI,8BAAA;ExEsviBV;EwE7viBM;IAOI,+BAAA;ExEyviBV;EwEhwiBM;IAOI,kCAAA;ExE4viBV;EwEnwiBM;IAOI,iCAAA;ExE+viBV;EwEtwiBM;IAOI,+BAAA;ExEkwiBV;EwEzwiBM;IAOI,iCAAA;ExEqwiBV;EwE5wiBM;IAOI,+BAAA;ExEwwiBV;EwE/wiBM;IAOI,iCAAA;ExE2wiBV;EwElxiBM;IAOI,+BAAA;ExE8wiBV;EwErxiBM;IAOI,+BAAA;ExEixiBV;EwExxiBM;IAOI,gCAAA;ExEoxiBV;EwE3xiBM;IAOI,gCAAA;ExEuxiBV;EwE9xiBM;IAOI,+BAAA;ExE0xiBV;EwEjyiBM;IAOI,6BAAA;ExE6xiBV;EwEpyiBM;IAOI,+BAAA;ExEgyiBV;EwEvyiBM;IAOI,6BAAA;ExEmyiBV;EwE1yiBM;IAOI,+BAAA;ExEsyiBV;EwE7yiBM;IAOI,6BAAA;ExEyyiBV;EwEhziBM;IAOI,6BAAA;ExE4yiBV;EwEnziBM;IAOI,8BAAA;ExE+yiBV;EwEtziBM;IAOI,qBAAA;ExEkziBV;EwEzziBM;IAOI,2BAAA;ExEqziBV;EwE5ziBM;IAOI,0BAAA;ExEwziBV;EwE/ziBM;IAOI,wBAAA;ExE2ziBV;EwEl0iBM;IAOI,0BAAA;ExE8ziBV;EwEr0iBM;IAOI,wBAAA;ExEi0iBV;EwEx0iBM;IAOI,0BAAA;ExEo0iBV;EwE30iBM;IAOI,wBAAA;ExEu0iBV;EwE90iBM;IAOI,wBAAA;ExE00iBV;EwEj1iBM;IAOI,yBAAA;ExE60iBV;EwEp1iBM;IAOI,2BAAA;IAAA,0BAAA;ExEi1iBV;EwEx1iBM;IAOI,iCAAA;IAAA,gCAAA;ExEq1iBV;EwE51iBM;IAOI,gCAAA;IAAA,+BAAA;ExEy1iBV;EwEh2iBM;IAOI,8BAAA;IAAA,6BAAA;ExE61iBV;EwEp2iBM;IAOI,gCAAA;IAAA,+BAAA;ExEi2iBV;EwEx2iBM;IAOI,8BAAA;IAAA,6BAAA;ExEq2iBV;EwE52iBM;IAOI,gCAAA;IAAA,+BAAA;ExEy2iBV;EwEh3iBM;IAOI,8BAAA;IAAA,6BAAA;ExE62iBV;EwEp3iBM;IAOI,8BAAA;IAAA,6BAAA;ExEi3iBV;EwEx3iBM;IAOI,+BAAA;IAAA,8BAAA;ExEq3iBV;EwE53iBM;IAOI,yBAAA;IAAA,4BAAA;ExEy3iBV;EwEh4iBM;IAOI,+BAAA;IAAA,kCAAA;ExE63iBV;EwEp4iBM;IAOI,8BAAA;IAAA,iCAAA;ExEi4iBV;EwEx4iBM;IAOI,4BAAA;IAAA,+BAAA;ExEq4iBV;EwE54iBM;IAOI,8BAAA;IAAA,iCAAA;ExEy4iBV;EwEh5iBM;IAOI,4BAAA;IAAA,+BAAA;ExE64iBV;EwEp5iBM;IAOI,8BAAA;IAAA,iCAAA;ExEi5iBV;EwEx5iBM;IAOI,4BAAA;IAAA,+BAAA;ExEq5iBV;EwE55iBM;IAOI,4BAAA;IAAA,+BAAA;ExEy5iBV;EwEh6iBM;IAOI,6BAAA;IAAA,gCAAA;ExE65iBV;EwEp6iBM;IAOI,yBAAA;ExEg6iBV;EwEv6iBM;IAOI,+BAAA;ExEm6iBV;EwE16iBM;IAOI,8BAAA;ExEs6iBV;EwE76iBM;IAOI,4BAAA;ExEy6iBV;EwEh7iBM;IAOI,8BAAA;ExE46iBV;EwEn7iBM;IAOI,4BAAA;ExE+6iBV;EwEt7iBM;IAOI,8BAAA;ExEk7iBV;EwEz7iBM;IAOI,4BAAA;ExEq7iBV;EwE57iBM;IAOI,4BAAA;ExEw7iBV;EwE/7iBM;IAOI,6BAAA;ExE27iBV;EwEl8iBM;IAOI,2BAAA;ExE87iBV;EwEr8iBM;IAOI,iCAAA;ExEi8iBV;EwEx8iBM;IAOI,gCAAA;ExEo8iBV;EwE38iBM;IAOI,8BAAA;ExEu8iBV;EwE98iBM;IAOI,gCAAA;ExE08iBV;EwEj9iBM;IAOI,8BAAA;ExE68iBV;EwEp9iBM;IAOI,gCAAA;ExEg9iBV;EwEv9iBM;IAOI,8BAAA;ExEm9iBV;EwE19iBM;IAOI,8BAAA;ExEs9iBV;EwE79iBM;IAOI,+BAAA;ExEy9iBV;EwEh+iBM;IAOI,4BAAA;ExE49iBV;EwEn+iBM;IAOI,kCAAA;ExE+9iBV;EwEt+iBM;IAOI,iCAAA;ExEk+iBV;EwEz+iBM;IAOI,+BAAA;ExEq+iBV;EwE5+iBM;IAOI,iCAAA;ExEw+iBV;EwE/+iBM;IAOI,+BAAA;ExE2+iBV;EwEl/iBM;IAOI,iCAAA;ExE8+iBV;EwEr/iBM;IAOI,+BAAA;ExEi/iBV;EwEx/iBM;IAOI,+BAAA;ExEo/iBV;EwE3/iBM;IAOI,gCAAA;ExEu/iBV;EwE9/iBM;IAOI,0BAAA;ExE0/iBV;EwEjgjBM;IAOI,gCAAA;ExE6/iBV;EwEpgjBM;IAOI,+BAAA;ExEggjBV;EwEvgjBM;IAOI,6BAAA;ExEmgjBV;EwE1gjBM;IAOI,+BAAA;ExEsgjBV;EwE7gjBM;IAOI,6BAAA;ExEygjBV;EwEhhjBM;IAOI,+BAAA;ExE4gjBV;EwEnhjBM;IAOI,6BAAA;ExE+gjBV;EwEthjBM;IAOI,6BAAA;ExEkhjBV;EwEzhjBM;IAOI,8BAAA;ExEqhjBV;EwE5hjBM;IAOI,iBAAA;ExEwhjBV;EwE/hjBM;IAOI,uBAAA;ExE2hjBV;EwElijBM;IAOI,sBAAA;ExE8hjBV;EwErijBM;IAOI,oBAAA;ExEiijBV;EwExijBM;IAOI,sBAAA;ExEoijBV;EwE3ijBM;IAOI,oBAAA;ExEuijBV;EwE9ijBM;IAOI,sBAAA;ExE0ijBV;EwEjjjBM;IAOI,oBAAA;ExE6ijBV;EwEpjjBM;IAOI,oBAAA;ExEgjjBV;EwEvjjBM;IAOI,qBAAA;ExEmjjBV;EwE1jjBM;IAOI,qBAAA;ExEsjjBV;EwE7jjBM;IAOI,2BAAA;ExEyjjBV;EwEhkjBM;IAOI,0BAAA;ExE4jjBV;EwEnkjBM;IAOI,wBAAA;ExE+jjBV;EwEtkjBM;IAOI,0BAAA;ExEkkjBV;EwEzkjBM;IAOI,wBAAA;ExEqkjBV;EwE5kjBM;IAOI,0BAAA;ExEwkjBV;EwE/kjBM;IAOI,wBAAA;ExE2kjBV;EwElljBM;IAOI,wBAAA;ExE8kjBV;EwErljBM;IAOI,yBAAA;ExEiljBV;EwExljBM;IAOI,wBAAA;ExEoljBV;EwE3ljBM;IAOI,8BAAA;ExEuljBV;EwE9ljBM;IAOI,6BAAA;ExE0ljBV;EwEjmjBM;IAOI,2BAAA;ExE6ljBV;EwEpmjBM;IAOI,6BAAA;ExEgmjBV;EwEvmjBM;IAOI,2BAAA;ExEmmjBV;EwE1mjBM;IAOI,6BAAA;ExEsmjBV;EwE7mjBM;IAOI,2BAAA;ExEymjBV;EwEhnjBM;IAOI,2BAAA;ExE4mjBV;EwEnnjBM;IAOI,4BAAA;ExE+mjBV;EwEtnjBM;IAOI,8CAAA;ExEknjBV;EwEznjBM;IAOI,6CAAA;ExEqnjBV;EwE5njBM;IAOI,gDAAA;ExEwnjBV;EwE/njBM;IAOI,8CAAA;ExE2njBV;EwElojBM;IAOI,gDAAA;ExE8njBV;EwErojBM;IAOI,6BAAA;ExEiojBV;EwExojBM;IAOI,2BAAA;ExEoojBV;EwE3ojBM;IAOI,4BAAA;ExEuojBV;EwE9ojBM;IAOI,6BAAA;ExE0ojBV;EwEjpjBM;IAIQ,oBAAA;IAGJ,qEAAA;ExE8ojBV;EwErpjBM;IAIQ,oBAAA;IAGJ,uEAAA;ExEkpjBV;EwEzpjBM;IAIQ,oBAAA;IAGJ,qEAAA;ExEspjBV;EwE7pjBM;IAIQ,oBAAA;IAGJ,kEAAA;ExE0pjBV;EwEjqjBM;IAIQ,oBAAA;IAGJ,qEAAA;ExE8pjBV;EwErqjBM;IAIQ,oBAAA;IAGJ,oEAAA;ExEkqjBV;EwEzqjBM;IAIQ,oBAAA;IAGJ,mEAAA;ExEsqjBV;EwE7qjBM;IAIQ,oBAAA;IAGJ,kEAAA;ExE0qjBV;EwEjrjBM;IAIQ,oBAAA;IAGJ,mEAAA;ExE8qjBV;EwErrjBM;IAIQ,oBAAA;IAGJ,mEAAA;ExEkrjBV;EwEzrjBM;IAIQ,oBAAA;IAGJ,wEAAA;ExEsrjBV;EwE7rjBM;IAIQ,oBAAA;IAGJ,2CAAA;ExE0rjBV;EwEjsjBM;IAIQ,oBAAA;IAGJ,oCAAA;ExE8rjBV;EwErsjBM;IAIQ,oBAAA;IAGJ,0CAAA;ExEksjBV;EwEzsjBM;IAIQ,oBAAA;IAGJ,2CAAA;ExEssjBV;EwE7sjBM;IAIQ,oBAAA;IAGJ,0CAAA;ExE0sjBV;EwEjtjBM;IAIQ,oBAAA;IAGJ,0CAAA;ExE8sjBV;EwErtjBM;IAIQ,oBAAA;IAGJ,yBAAA;ExEktjBV;AACF;AM7tjBI;EkEGI;IAOI,sBAAA;ExEutjBV;EwE9tjBM;IAOI,uBAAA;ExE0tjBV;EwEjujBM;IAOI,sBAAA;ExE6tjBV;EwEpujBM;IAOI,8BAAA;ExEgujBV;EwEvujBM;IAOI,4BAAA;ExEmujBV;EwE1ujBM;IAOI,2BAAA;ExEsujBV;EwE7ujBM;IAOI,iCAAA;ExEyujBV;EwEhvjBM;IAOI,2BAAA;ExE4ujBV;EwEnvjBM;IAOI,qBAAA;ExE+ujBV;EwEtvjBM;IAOI,wBAAA;ExEkvjBV;EwEzvjBM;IAOI,uBAAA;ExEqvjBV;EwE5vjBM;IAOI,wBAAA;ExEwvjBV;EwE/vjBM;IAOI,qBAAA;ExE2vjBV;EwElwjBM;IAOI,uBAAA;ExE8vjBV;EwErwjBM;IAOI,uBAAA;ExEiwjBV;EwExwjBM;IAOI,wBAAA;ExEowjBV;EwE3wjBM;IAOI,uBAAA;ExEuwjBV;EwE9wjBM;IAOI,uBAAA;ExE0wjBV;EwEjxjBM;IAOI,wBAAA;ExE6wjBV;EwEpxjBM;IAOI,uBAAA;ExEgxjBV;EwEvxjBM;IAOI,wBAAA;ExEmxjBV;EwE1xjBM;IAOI,uBAAA;ExEsxjBV;EwE7xjBM;IAOI,wBAAA;ExEyxjBV;EwEhyjBM;IAOI,uBAAA;ExE4xjBV;EwEnyjBM;IAOI,uBAAA;ExE+xjBV;EwEtyjBM;IAOI,wBAAA;ExEkyjBV;EwEzyjBM;IAOI,uBAAA;ExEqyjBV;EwE5yjBM;IAOI,wBAAA;ExEwyjBV;EwE/yjBM;IAOI,0BAAA;ExE2yjBV;EwElzjBM;IAOI,gCAAA;ExE8yjBV;EwErzjBM;IAOI,yBAAA;ExEizjBV;EwExzjBM;IAOI,wBAAA;ExEozjBV;EwE3zjBM;IAOI,+BAAA;ExEuzjBV;EwE9zjBM;IAOI,yBAAA;ExE0zjBV;EwEj0jBM;IAOI,6BAAA;ExE6zjBV;EwEp0jBM;IAOI,8BAAA;ExEg0jBV;EwEv0jBM;IAOI,wBAAA;ExEm0jBV;EwE10jBM;IAOI,+BAAA;ExEs0jBV;EwE70jBM;IAOI,wBAAA;ExEy0jBV;EwEh1jBM;IAOI,iBAAA;ExE40jBV;EwEn1jBM;IAOI,mBAAA;ExE+0jBV;EwEt1jBM;IAOI,oBAAA;ExEk1jBV;EwEz1jBM;IAOI,kBAAA;ExEq1jBV;EwE51jBM;IAOI,kBAAA;ExEw1jBV;EwE/1jBM;IAOI,kBAAA;ExE21jBV;EwEl2jBM;IAOI,kBAAA;ExE81jBV;EwEr2jBM;IAOI,kBAAA;ExEi2jBV;EwEx2jBM;IAOI,mBAAA;ExEo2jBV;EwE32jBM;IAOI,mBAAA;ExEu2jBV;EwE92jBM;IAOI,mBAAA;ExE02jBV;EwEj3jBM;IAOI,mBAAA;ExE62jBV;EwEp3jBM;IAOI,mBAAA;ExEg3jBV;EwEv3jBM;IAOI,mBAAA;ExEm3jBV;EwE13jBM;IAOI,mBAAA;ExEs3jBV;EwE73jBM;IAOI,mBAAA;ExEy3jBV;EwEh4jBM;IAOI,mBAAA;ExE43jBV;EwEn4jBM;IAOI,mBAAA;ExE+3jBV;EwEt4jBM;IAOI,mBAAA;ExEk4jBV;EwEz4jBM;IAOI,mBAAA;ExEq4jBV;EwE54jBM;IAOI,mBAAA;ExEw4jBV;EwE/4jBM;IAOI,mBAAA;ExE24jBV;EwEl5jBM;IAOI,mBAAA;ExE84jBV;EwEr5jBM;IAOI,mBAAA;ExEi5jBV;EwEx5jBM;IAOI,mBAAA;ExEo5jBV;EwE35jBM;IAOI,oBAAA;ExEu5jBV;EwE95jBM;IAOI,oBAAA;ExE05jBV;EwEj6jBM;IAOI,sBAAA;ExE65jBV;EwEp6jBM;IAOI,uBAAA;ExEg6jBV;EwEv6jBM;IAOI,qBAAA;ExEm6jBV;EwE16jBM;IAOI,qBAAA;ExEs6jBV;EwE76jBM;IAOI,qBAAA;ExEy6jBV;EwEh7jBM;IAOI,qBAAA;ExE46jBV;EwEn7jBM;IAOI,qBAAA;ExE+6jBV;EwEt7jBM;IAOI,sBAAA;ExEk7jBV;EwEz7jBM;IAOI,sBAAA;ExEq7jBV;EwE57jBM;IAOI,sBAAA;ExEw7jBV;EwE/7jBM;IAOI,sBAAA;ExE27jBV;EwEl8jBM;IAOI,sBAAA;ExE87jBV;EwEr8jBM;IAOI,sBAAA;ExEi8jBV;EwEx8jBM;IAOI,sBAAA;ExEo8jBV;EwE38jBM;IAOI,sBAAA;ExEu8jBV;EwE98jBM;IAOI,sBAAA;ExE08jBV;EwEj9jBM;IAOI,sBAAA;ExE68jBV;EwEp9jBM;IAOI,sBAAA;ExEg9jBV;EwEv9jBM;IAOI,sBAAA;ExEm9jBV;EwE19jBM;IAOI,sBAAA;ExEs9jBV;EwE79jBM;IAOI,sBAAA;ExEy9jBV;EwEh+jBM;IAOI,sBAAA;ExE49jBV;EwEn+jBM;IAOI,sBAAA;ExE+9jBV;EwEt+jBM;IAOI,sBAAA;ExEk+jBV;EwEz+jBM;IAOI,uBAAA;ExEq+jBV;EwE5+jBM;IAOI,kBAAA;ExEw+jBV;EwE/+jBM;IAOI,oBAAA;ExE2+jBV;EwEl/jBM;IAOI,qBAAA;ExE8+jBV;EwEr/jBM;IAOI,mBAAA;ExEi/jBV;EwEx/jBM;IAOI,mBAAA;ExEo/jBV;EwE3/jBM;IAOI,mBAAA;ExEu/jBV;EwE9/jBM;IAOI,mBAAA;ExE0/jBV;EwEjgkBM;IAOI,mBAAA;ExE6/jBV;EwEpgkBM;IAOI,oBAAA;ExEggkBV;EwEvgkBM;IAOI,oBAAA;ExEmgkBV;EwE1gkBM;IAOI,oBAAA;ExEsgkBV;EwE7gkBM;IAOI,oBAAA;ExEygkBV;EwEhhkBM;IAOI,oBAAA;ExE4gkBV;EwEnhkBM;IAOI,oBAAA;ExE+gkBV;EwEthkBM;IAOI,oBAAA;ExEkhkBV;EwEzhkBM;IAOI,oBAAA;ExEqhkBV;EwE5hkBM;IAOI,oBAAA;ExEwhkBV;EwE/hkBM;IAOI,oBAAA;ExE2hkBV;EwElikBM;IAOI,oBAAA;ExE8hkBV;EwErikBM;IAOI,oBAAA;ExEiikBV;EwExikBM;IAOI,oBAAA;ExEoikBV;EwE3ikBM;IAOI,oBAAA;ExEuikBV;EwE9ikBM;IAOI,oBAAA;ExE0ikBV;EwEjjkBM;IAOI,oBAAA;ExE6ikBV;EwEpjkBM;IAOI,oBAAA;ExEgjkBV;EwEvjkBM;IAOI,qBAAA;ExEmjkBV;EwE1jkBM;IAOI,mBAAA;ExEsjkBV;EwE7jkBM;IAOI,qBAAA;ExEyjkBV;EwEhkkBM;IAOI,sBAAA;ExE4jkBV;EwEnkkBM;IAOI,oBAAA;ExE+jkBV;EwEtkkBM;IAOI,oBAAA;ExEkkkBV;EwEzkkBM;IAOI,oBAAA;ExEqkkBV;EwE5kkBM;IAOI,oBAAA;ExEwkkBV;EwE/kkBM;IAOI,oBAAA;ExE2kkBV;EwEllkBM;IAOI,qBAAA;ExE8kkBV;EwErlkBM;IAOI,qBAAA;ExEilkBV;EwExlkBM;IAOI,qBAAA;ExEolkBV;EwE3lkBM;IAOI,qBAAA;ExEulkBV;EwE9lkBM;IAOI,qBAAA;ExE0lkBV;EwEjmkBM;IAOI,qBAAA;ExE6lkBV;EwEpmkBM;IAOI,qBAAA;ExEgmkBV;EwEvmkBM;IAOI,qBAAA;ExEmmkBV;EwE1mkBM;IAOI,qBAAA;ExEsmkBV;EwE7mkBM;IAOI,qBAAA;ExEymkBV;EwEhnkBM;IAOI,qBAAA;ExE4mkBV;EwEnnkBM;IAOI,qBAAA;ExE+mkBV;EwEtnkBM;IAOI,qBAAA;ExEknkBV;EwEznkBM;IAOI,qBAAA;ExEqnkBV;EwE5nkBM;IAOI,qBAAA;ExEwnkBV;EwE/nkBM;IAOI,qBAAA;ExE2nkBV;EwElokBM;IAOI,qBAAA;ExE8nkBV;EwErokBM;IAOI,sBAAA;ExEiokBV;EwExokBM;IAOI,qBAAA;ExEookBV;EwE3okBM;IAOI,qBAAA;ExEuokBV;EwE9okBM;IAOI,qBAAA;ExE0okBV;EwEjpkBM;IAOI,sBAAA;ExE6okBV;EwEppkBM;IAOI,sBAAA;ExEgpkBV;EwEvpkBM;IAOI,oBAAA;ExEmpkBV;EwE1pkBM;IAOI,qBAAA;ExEspkBV;EwE7pkBM;IAOI,qBAAA;ExEypkBV;EwEhqkBM;IAOI,qBAAA;ExE4pkBV;EwEnqkBM;IAOI,qBAAA;ExE+pkBV;EwEtqkBM;IAOI,qBAAA;ExEkqkBV;EwEzqkBM;IAOI,qBAAA;ExEqqkBV;EwE5qkBM;IAOI,qBAAA;ExEwqkBV;EwE/qkBM;IAOI,qBAAA;ExE2qkBV;EwElrkBM;IAOI,qBAAA;ExE8qkBV;EwErrkBM;IAOI,qBAAA;ExEirkBV;EwExrkBM;IAOI,qBAAA;ExEorkBV;EwE3rkBM;IAOI,qBAAA;ExEurkBV;EwE9rkBM;IAOI,qBAAA;ExE0rkBV;EwEjskBM;IAOI,qBAAA;ExE6rkBV;EwEpskBM;IAOI,qBAAA;ExEgskBV;EwEvskBM;IAOI,sBAAA;ExEmskBV;EwE1skBM;IAOI,sBAAA;ExEsskBV;EwE7skBM;IAOI,sBAAA;ExEyskBV;EwEhtkBM;IAOI,uBAAA;ExE4skBV;EwEntkBM;IAOI,uBAAA;ExE+skBV;EwEttkBM;IAOI,qBAAA;ExEktkBV;EwEztkBM;IAOI,sBAAA;ExEqtkBV;EwE5tkBM;IAOI,sBAAA;ExEwtkBV;EwE/tkBM;IAOI,sBAAA;ExE2tkBV;EwElukBM;IAOI,sBAAA;ExE8tkBV;EwErukBM;IAOI,sBAAA;ExEiukBV;EwExukBM;IAOI,sBAAA;ExEoukBV;EwE3ukBM;IAOI,sBAAA;ExEuukBV;EwE9ukBM;IAOI,sBAAA;ExE0ukBV;EwEjvkBM;IAOI,sBAAA;ExE6ukBV;EwEpvkBM;IAOI,sBAAA;ExEgvkBV;EwEvvkBM;IAOI,sBAAA;ExEmvkBV;EwE1vkBM;IAOI,sBAAA;ExEsvkBV;EwE7vkBM;IAOI,sBAAA;ExEyvkBV;EwEhwkBM;IAOI,sBAAA;ExE4vkBV;EwEnwkBM;IAOI,sBAAA;ExE+vkBV;EwEtwkBM;IAOI,yBAAA;ExEkwkBV;EwEzwkBM;IAOI,8BAAA;ExEqwkBV;EwE5wkBM;IAOI,iCAAA;ExEwwkBV;EwE/wkBM;IAOI,sCAAA;ExE2wkBV;EwElxkBM;IAOI,yCAAA;ExE8wkBV;EwErxkBM;IAOI,uBAAA;ExEixkBV;EwExxkBM;IAOI,uBAAA;ExEoxkBV;EwE3xkBM;IAOI,yBAAA;ExEuxkBV;EwE9xkBM;IAOI,yBAAA;ExE0xkBV;EwEjykBM;IAOI,0BAAA;ExE6xkBV;EwEpykBM;IAOI,4BAAA;ExEgykBV;EwEvykBM;IAOI,kCAAA;ExEmykBV;EwE1ykBM;IAOI,sCAAA;ExEsykBV;EwE7ykBM;IAOI,oCAAA;ExEyykBV;EwEhzkBM;IAOI,kCAAA;ExE4ykBV;EwEnzkBM;IAOI,yCAAA;ExE+ykBV;EwEtzkBM;IAOI,wCAAA;ExEkzkBV;EwEzzkBM;IAOI,wCAAA;ExEqzkBV;EwE5zkBM;IAOI,kCAAA;ExEwzkBV;EwE/zkBM;IAOI,gCAAA;ExE2zkBV;EwEl0kBM;IAOI,8BAAA;ExE8zkBV;EwEr0kBM;IAOI,gCAAA;ExEi0kBV;EwEx0kBM;IAOI,+BAAA;ExEo0kBV;EwE30kBM;IAOI,oCAAA;ExEu0kBV;EwE90kBM;IAOI,kCAAA;ExE00kBV;EwEj1kBM;IAOI,gCAAA;ExE60kBV;EwEp1kBM;IAOI,uCAAA;ExEg1kBV;EwEv1kBM;IAOI,sCAAA;ExEm1kBV;EwE11kBM;IAOI,iCAAA;ExEs1kBV;EwE71kBM;IAOI,2BAAA;ExEy1kBV;EwEh2kBM;IAOI,iCAAA;ExE41kBV;EwEn2kBM;IAOI,+BAAA;ExE+1kBV;EwEt2kBM;IAOI,6BAAA;ExEk2kBV;EwEz2kBM;IAOI,+BAAA;ExEq2kBV;EwE52kBM;IAOI,8BAAA;ExEw2kBV;EwE/2kBM;IAOI,oBAAA;ExE22kBV;EwEl3kBM;IAOI,mBAAA;ExE82kBV;EwEr3kBM;IAOI,mBAAA;ExEi3kBV;EwEx3kBM;IAOI,mBAAA;ExEo3kBV;EwE33kBM;IAOI,mBAAA;ExEu3kBV;EwE93kBM;IAOI,mBAAA;ExE03kBV;EwEj4kBM;IAOI,mBAAA;ExE63kBV;EwEp4kBM;IAOI,mBAAA;ExEg4kBV;EwEv4kBM;IAOI,oBAAA;ExEm4kBV;EwE14kBM;IAOI,0BAAA;ExEs4kBV;EwE74kBM;IAOI,yBAAA;ExEy4kBV;EwEh5kBM;IAOI,uBAAA;ExE44kBV;EwEn5kBM;IAOI,yBAAA;ExE+4kBV;EwEt5kBM;IAOI,uBAAA;ExEk5kBV;EwEz5kBM;IAOI,yBAAA;ExEq5kBV;EwE55kBM;IAOI,uBAAA;ExEw5kBV;EwE/5kBM;IAOI,uBAAA;ExE25kBV;EwEl6kBM;IAOI,wBAAA;ExE85kBV;EwEr6kBM;IAOI,uBAAA;ExEi6kBV;EwEx6kBM;IAOI,0BAAA;IAAA,yBAAA;ExEq6kBV;EwE56kBM;IAOI,gCAAA;IAAA,+BAAA;ExEy6kBV;EwEh7kBM;IAOI,+BAAA;IAAA,8BAAA;ExE66kBV;EwEp7kBM;IAOI,6BAAA;IAAA,4BAAA;ExEi7kBV;EwEx7kBM;IAOI,+BAAA;IAAA,8BAAA;ExEq7kBV;EwE57kBM;IAOI,6BAAA;IAAA,4BAAA;ExEy7kBV;EwEh8kBM;IAOI,+BAAA;IAAA,8BAAA;ExE67kBV;EwEp8kBM;IAOI,6BAAA;IAAA,4BAAA;ExEi8kBV;EwEx8kBM;IAOI,6BAAA;IAAA,4BAAA;ExEq8kBV;EwE58kBM;IAOI,8BAAA;IAAA,6BAAA;ExEy8kBV;EwEh9kBM;IAOI,6BAAA;IAAA,4BAAA;ExE68kBV;EwEp9kBM;IAOI,wBAAA;IAAA,2BAAA;ExEi9kBV;EwEx9kBM;IAOI,8BAAA;IAAA,iCAAA;ExEq9kBV;EwE59kBM;IAOI,6BAAA;IAAA,gCAAA;ExEy9kBV;EwEh+kBM;IAOI,2BAAA;IAAA,8BAAA;ExE69kBV;EwEp+kBM;IAOI,6BAAA;IAAA,gCAAA;ExEi+kBV;EwEx+kBM;IAOI,2BAAA;IAAA,8BAAA;ExEq+kBV;EwE5+kBM;IAOI,6BAAA;IAAA,gCAAA;ExEy+kBV;EwEh/kBM;IAOI,2BAAA;IAAA,8BAAA;ExE6+kBV;EwEp/kBM;IAOI,2BAAA;IAAA,8BAAA;ExEi/kBV;EwEx/kBM;IAOI,4BAAA;IAAA,+BAAA;ExEq/kBV;EwE5/kBM;IAOI,2BAAA;IAAA,8BAAA;ExEy/kBV;EwEhglBM;IAOI,wBAAA;ExE4/kBV;EwEnglBM;IAOI,8BAAA;ExE+/kBV;EwEtglBM;IAOI,6BAAA;ExEkglBV;EwEzglBM;IAOI,2BAAA;ExEqglBV;EwE5glBM;IAOI,6BAAA;ExEwglBV;EwE/glBM;IAOI,2BAAA;ExE2glBV;EwElhlBM;IAOI,6BAAA;ExE8glBV;EwErhlBM;IAOI,2BAAA;ExEihlBV;EwExhlBM;IAOI,2BAAA;ExEohlBV;EwE3hlBM;IAOI,4BAAA;ExEuhlBV;EwE9hlBM;IAOI,2BAAA;ExE0hlBV;EwEjilBM;IAOI,0BAAA;ExE6hlBV;EwEpilBM;IAOI,gCAAA;ExEgilBV;EwEvilBM;IAOI,+BAAA;ExEmilBV;EwE1ilBM;IAOI,6BAAA;ExEsilBV;EwE7ilBM;IAOI,+BAAA;ExEyilBV;EwEhjlBM;IAOI,6BAAA;ExE4ilBV;EwEnjlBM;IAOI,+BAAA;ExE+ilBV;EwEtjlBM;IAOI,6BAAA;ExEkjlBV;EwEzjlBM;IAOI,6BAAA;ExEqjlBV;EwE5jlBM;IAOI,8BAAA;ExEwjlBV;EwE/jlBM;IAOI,6BAAA;ExE2jlBV;EwElklBM;IAOI,2BAAA;ExE8jlBV;EwErklBM;IAOI,iCAAA;ExEiklBV;EwExklBM;IAOI,gCAAA;ExEoklBV;EwE3klBM;IAOI,8BAAA;ExEuklBV;EwE9klBM;IAOI,gCAAA;ExE0klBV;EwEjllBM;IAOI,8BAAA;ExE6klBV;EwEpllBM;IAOI,gCAAA;ExEgllBV;EwEvllBM;IAOI,8BAAA;ExEmllBV;EwE1llBM;IAOI,8BAAA;ExEsllBV;EwE7llBM;IAOI,+BAAA;ExEyllBV;EwEhmlBM;IAOI,8BAAA;ExE4llBV;EwEnmlBM;IAOI,yBAAA;ExE+llBV;EwEtmlBM;IAOI,+BAAA;ExEkmlBV;EwEzmlBM;IAOI,8BAAA;ExEqmlBV;EwE5mlBM;IAOI,4BAAA;ExEwmlBV;EwE/mlBM;IAOI,8BAAA;ExE2mlBV;EwElnlBM;IAOI,4BAAA;ExE8mlBV;EwErnlBM;IAOI,8BAAA;ExEinlBV;EwExnlBM;IAOI,4BAAA;ExEonlBV;EwE3nlBM;IAOI,4BAAA;ExEunlBV;EwE9nlBM;IAOI,6BAAA;ExE0nlBV;EwEjolBM;IAOI,4BAAA;ExE6nlBV;EwEpolBM;IAOI,2BAAA;ExEgolBV;EwEvolBM;IAOI,0BAAA;ExEmolBV;EwE1olBM;IAOI,wBAAA;ExEsolBV;EwE7olBM;IAOI,0BAAA;ExEyolBV;EwEhplBM;IAOI,wBAAA;ExE4olBV;EwEnplBM;IAOI,0BAAA;ExE+olBV;EwEtplBM;IAOI,wBAAA;ExEkplBV;EwEzplBM;IAOI,wBAAA;ExEqplBV;EwE5plBM;IAOI,yBAAA;ExEwplBV;EwE/plBM;IAOI,iCAAA;IAAA,gCAAA;ExE4plBV;EwEnqlBM;IAOI,gCAAA;IAAA,+BAAA;ExEgqlBV;EwEvqlBM;IAOI,8BAAA;IAAA,6BAAA;ExEoqlBV;EwE3qlBM;IAOI,gCAAA;IAAA,+BAAA;ExEwqlBV;EwE/qlBM;IAOI,8BAAA;IAAA,6BAAA;ExE4qlBV;EwEnrlBM;IAOI,gCAAA;IAAA,+BAAA;ExEgrlBV;EwEvrlBM;IAOI,8BAAA;IAAA,6BAAA;ExEorlBV;EwE3rlBM;IAOI,8BAAA;IAAA,6BAAA;ExEwrlBV;EwE/rlBM;IAOI,+BAAA;IAAA,8BAAA;ExE4rlBV;EwEnslBM;IAOI,+BAAA;IAAA,kCAAA;ExEgslBV;EwEvslBM;IAOI,8BAAA;IAAA,iCAAA;ExEoslBV;EwE3slBM;IAOI,4BAAA;IAAA,+BAAA;ExEwslBV;EwE/slBM;IAOI,8BAAA;IAAA,iCAAA;ExE4slBV;EwEntlBM;IAOI,4BAAA;IAAA,+BAAA;ExEgtlBV;EwEvtlBM;IAOI,8BAAA;IAAA,iCAAA;ExEotlBV;EwE3tlBM;IAOI,4BAAA;IAAA,+BAAA;ExEwtlBV;EwE/tlBM;IAOI,4BAAA;IAAA,+BAAA;ExE4tlBV;EwEnulBM;IAOI,6BAAA;IAAA,gCAAA;ExEgulBV;EwEvulBM;IAOI,+BAAA;ExEmulBV;EwE1ulBM;IAOI,8BAAA;ExEsulBV;EwE7ulBM;IAOI,4BAAA;ExEyulBV;EwEhvlBM;IAOI,8BAAA;ExE4ulBV;EwEnvlBM;IAOI,4BAAA;ExE+ulBV;EwEtvlBM;IAOI,8BAAA;ExEkvlBV;EwEzvlBM;IAOI,4BAAA;ExEqvlBV;EwE5vlBM;IAOI,4BAAA;ExEwvlBV;EwE/vlBM;IAOI,6BAAA;ExE2vlBV;EwElwlBM;IAOI,iCAAA;ExE8vlBV;EwErwlBM;IAOI,gCAAA;ExEiwlBV;EwExwlBM;IAOI,8BAAA;ExEowlBV;EwE3wlBM;IAOI,gCAAA;ExEuwlBV;EwE9wlBM;IAOI,8BAAA;ExE0wlBV;EwEjxlBM;IAOI,gCAAA;ExE6wlBV;EwEpxlBM;IAOI,8BAAA;ExEgxlBV;EwEvxlBM;IAOI,8BAAA;ExEmxlBV;EwE1xlBM;IAOI,+BAAA;ExEsxlBV;EwE7xlBM;IAOI,kCAAA;ExEyxlBV;EwEhylBM;IAOI,iCAAA;ExE4xlBV;EwEnylBM;IAOI,+BAAA;ExE+xlBV;EwEtylBM;IAOI,iCAAA;ExEkylBV;EwEzylBM;IAOI,+BAAA;ExEqylBV;EwE5ylBM;IAOI,iCAAA;ExEwylBV;EwE/ylBM;IAOI,+BAAA;ExE2ylBV;EwElzlBM;IAOI,+BAAA;ExE8ylBV;EwErzlBM;IAOI,gCAAA;ExEizlBV;EwExzlBM;IAOI,gCAAA;ExEozlBV;EwE3zlBM;IAOI,+BAAA;ExEuzlBV;EwE9zlBM;IAOI,6BAAA;ExE0zlBV;EwEj0lBM;IAOI,+BAAA;ExE6zlBV;EwEp0lBM;IAOI,6BAAA;ExEg0lBV;EwEv0lBM;IAOI,+BAAA;ExEm0lBV;EwE10lBM;IAOI,6BAAA;ExEs0lBV;EwE70lBM;IAOI,6BAAA;ExEy0lBV;EwEh1lBM;IAOI,8BAAA;ExE40lBV;EwEn1lBM;IAOI,qBAAA;ExE+0lBV;EwEt1lBM;IAOI,2BAAA;ExEk1lBV;EwEz1lBM;IAOI,0BAAA;ExEq1lBV;EwE51lBM;IAOI,wBAAA;ExEw1lBV;EwE/1lBM;IAOI,0BAAA;ExE21lBV;EwEl2lBM;IAOI,wBAAA;ExE81lBV;EwEr2lBM;IAOI,0BAAA;ExEi2lBV;EwEx2lBM;IAOI,wBAAA;ExEo2lBV;EwE32lBM;IAOI,wBAAA;ExEu2lBV;EwE92lBM;IAOI,yBAAA;ExE02lBV;EwEj3lBM;IAOI,2BAAA;IAAA,0BAAA;ExE82lBV;EwEr3lBM;IAOI,iCAAA;IAAA,gCAAA;ExEk3lBV;EwEz3lBM;IAOI,gCAAA;IAAA,+BAAA;ExEs3lBV;EwE73lBM;IAOI,8BAAA;IAAA,6BAAA;ExE03lBV;EwEj4lBM;IAOI,gCAAA;IAAA,+BAAA;ExE83lBV;EwEr4lBM;IAOI,8BAAA;IAAA,6BAAA;ExEk4lBV;EwEz4lBM;IAOI,gCAAA;IAAA,+BAAA;ExEs4lBV;EwE74lBM;IAOI,8BAAA;IAAA,6BAAA;ExE04lBV;EwEj5lBM;IAOI,8BAAA;IAAA,6BAAA;ExE84lBV;EwEr5lBM;IAOI,+BAAA;IAAA,8BAAA;ExEk5lBV;EwEz5lBM;IAOI,yBAAA;IAAA,4BAAA;ExEs5lBV;EwE75lBM;IAOI,+BAAA;IAAA,kCAAA;ExE05lBV;EwEj6lBM;IAOI,8BAAA;IAAA,iCAAA;ExE85lBV;EwEr6lBM;IAOI,4BAAA;IAAA,+BAAA;ExEk6lBV;EwEz6lBM;IAOI,8BAAA;IAAA,iCAAA;ExEs6lBV;EwE76lBM;IAOI,4BAAA;IAAA,+BAAA;ExE06lBV;EwEj7lBM;IAOI,8BAAA;IAAA,iCAAA;ExE86lBV;EwEr7lBM;IAOI,4BAAA;IAAA,+BAAA;ExEk7lBV;EwEz7lBM;IAOI,4BAAA;IAAA,+BAAA;ExEs7lBV;EwE77lBM;IAOI,6BAAA;IAAA,gCAAA;ExE07lBV;EwEj8lBM;IAOI,yBAAA;ExE67lBV;EwEp8lBM;IAOI,+BAAA;ExEg8lBV;EwEv8lBM;IAOI,8BAAA;ExEm8lBV;EwE18lBM;IAOI,4BAAA;ExEs8lBV;EwE78lBM;IAOI,8BAAA;ExEy8lBV;EwEh9lBM;IAOI,4BAAA;ExE48lBV;EwEn9lBM;IAOI,8BAAA;ExE+8lBV;EwEt9lBM;IAOI,4BAAA;ExEk9lBV;EwEz9lBM;IAOI,4BAAA;ExEq9lBV;EwE59lBM;IAOI,6BAAA;ExEw9lBV;EwE/9lBM;IAOI,2BAAA;ExE29lBV;EwEl+lBM;IAOI,iCAAA;ExE89lBV;EwEr+lBM;IAOI,gCAAA;ExEi+lBV;EwEx+lBM;IAOI,8BAAA;ExEo+lBV;EwE3+lBM;IAOI,gCAAA;ExEu+lBV;EwE9+lBM;IAOI,8BAAA;ExE0+lBV;EwEj/lBM;IAOI,gCAAA;ExE6+lBV;EwEp/lBM;IAOI,8BAAA;ExEg/lBV;EwEv/lBM;IAOI,8BAAA;ExEm/lBV;EwE1/lBM;IAOI,+BAAA;ExEs/lBV;EwE7/lBM;IAOI,4BAAA;ExEy/lBV;EwEhgmBM;IAOI,kCAAA;ExE4/lBV;EwEngmBM;IAOI,iCAAA;ExE+/lBV;EwEtgmBM;IAOI,+BAAA;ExEkgmBV;EwEzgmBM;IAOI,iCAAA;ExEqgmBV;EwE5gmBM;IAOI,+BAAA;ExEwgmBV;EwE/gmBM;IAOI,iCAAA;ExE2gmBV;EwElhmBM;IAOI,+BAAA;ExE8gmBV;EwErhmBM;IAOI,+BAAA;ExEihmBV;EwExhmBM;IAOI,gCAAA;ExEohmBV;EwE3hmBM;IAOI,0BAAA;ExEuhmBV;EwE9hmBM;IAOI,gCAAA;ExE0hmBV;EwEjimBM;IAOI,+BAAA;ExE6hmBV;EwEpimBM;IAOI,6BAAA;ExEgimBV;EwEvimBM;IAOI,+BAAA;ExEmimBV;EwE1imBM;IAOI,6BAAA;ExEsimBV;EwE7imBM;IAOI,+BAAA;ExEyimBV;EwEhjmBM;IAOI,6BAAA;ExE4imBV;EwEnjmBM;IAOI,6BAAA;ExE+imBV;EwEtjmBM;IAOI,8BAAA;ExEkjmBV;EwEzjmBM;IAOI,iBAAA;ExEqjmBV;EwE5jmBM;IAOI,uBAAA;ExEwjmBV;EwE/jmBM;IAOI,sBAAA;ExE2jmBV;EwElkmBM;IAOI,oBAAA;ExE8jmBV;EwErkmBM;IAOI,sBAAA;ExEikmBV;EwExkmBM;IAOI,oBAAA;ExEokmBV;EwE3kmBM;IAOI,sBAAA;ExEukmBV;EwE9kmBM;IAOI,oBAAA;ExE0kmBV;EwEjlmBM;IAOI,oBAAA;ExE6kmBV;EwEplmBM;IAOI,qBAAA;ExEglmBV;EwEvlmBM;IAOI,qBAAA;ExEmlmBV;EwE1lmBM;IAOI,2BAAA;ExEslmBV;EwE7lmBM;IAOI,0BAAA;ExEylmBV;EwEhmmBM;IAOI,wBAAA;ExE4lmBV;EwEnmmBM;IAOI,0BAAA;ExE+lmBV;EwEtmmBM;IAOI,wBAAA;ExEkmmBV;EwEzmmBM;IAOI,0BAAA;ExEqmmBV;EwE5mmBM;IAOI,wBAAA;ExEwmmBV;EwE/mmBM;IAOI,wBAAA;ExE2mmBV;EwElnmBM;IAOI,yBAAA;ExE8mmBV;EwErnmBM;IAOI,wBAAA;ExEinmBV;EwExnmBM;IAOI,8BAAA;ExEonmBV;EwE3nmBM;IAOI,6BAAA;ExEunmBV;EwE9nmBM;IAOI,2BAAA;ExE0nmBV;EwEjomBM;IAOI,6BAAA;ExE6nmBV;EwEpomBM;IAOI,2BAAA;ExEgomBV;EwEvomBM;IAOI,6BAAA;ExEmomBV;EwE1omBM;IAOI,2BAAA;ExEsomBV;EwE7omBM;IAOI,2BAAA;ExEyomBV;EwEhpmBM;IAOI,4BAAA;ExE4omBV;EwEnpmBM;IAOI,8CAAA;ExE+omBV;EwEtpmBM;IAOI,6CAAA;ExEkpmBV;EwEzpmBM;IAOI,gDAAA;ExEqpmBV;EwE5pmBM;IAOI,8CAAA;ExEwpmBV;EwE/pmBM;IAOI,gDAAA;ExE2pmBV;EwElqmBM;IAOI,6BAAA;ExE8pmBV;EwErqmBM;IAOI,2BAAA;ExEiqmBV;EwExqmBM;IAOI,4BAAA;ExEoqmBV;EwE3qmBM;IAOI,6BAAA;ExEuqmBV;EwE9qmBM;IAIQ,oBAAA;IAGJ,qEAAA;ExE2qmBV;EwElrmBM;IAIQ,oBAAA;IAGJ,uEAAA;ExE+qmBV;EwEtrmBM;IAIQ,oBAAA;IAGJ,qEAAA;ExEmrmBV;EwE1rmBM;IAIQ,oBAAA;IAGJ,kEAAA;ExEurmBV;EwE9rmBM;IAIQ,oBAAA;IAGJ,qEAAA;ExE2rmBV;EwElsmBM;IAIQ,oBAAA;IAGJ,oEAAA;ExE+rmBV;EwEtsmBM;IAIQ,oBAAA;IAGJ,mEAAA;ExEmsmBV;EwE1smBM;IAIQ,oBAAA;IAGJ,kEAAA;ExEusmBV;EwE9smBM;IAIQ,oBAAA;IAGJ,mEAAA;ExE2smBV;EwEltmBM;IAIQ,oBAAA;IAGJ,mEAAA;ExE+smBV;EwEttmBM;IAIQ,oBAAA;IAGJ,wEAAA;ExEmtmBV;EwE1tmBM;IAIQ,oBAAA;IAGJ,2CAAA;ExEutmBV;EwE9tmBM;IAIQ,oBAAA;IAGJ,oCAAA;ExE2tmBV;EwElumBM;IAIQ,oBAAA;IAGJ,0CAAA;ExE+tmBV;EwEtumBM;IAIQ,oBAAA;IAGJ,2CAAA;ExEmumBV;EwE1umBM;IAIQ,oBAAA;IAGJ,0CAAA;ExEuumBV;EwE9umBM;IAIQ,oBAAA;IAGJ,0CAAA;ExE2umBV;EwElvmBM;IAIQ,oBAAA;IAGJ,yBAAA;ExE+umBV;AACF;AM1vmBI;EkEGI;IAOI,sBAAA;ExEovmBV;EwE3vmBM;IAOI,uBAAA;ExEuvmBV;EwE9vmBM;IAOI,sBAAA;ExE0vmBV;EwEjwmBM;IAOI,8BAAA;ExE6vmBV;EwEpwmBM;IAOI,4BAAA;ExEgwmBV;EwEvwmBM;IAOI,2BAAA;ExEmwmBV;EwE1wmBM;IAOI,iCAAA;ExEswmBV;EwE7wmBM;IAOI,2BAAA;ExEywmBV;EwEhxmBM;IAOI,qBAAA;ExE4wmBV;EwEnxmBM;IAOI,wBAAA;ExE+wmBV;EwEtxmBM;IAOI,uBAAA;ExEkxmBV;EwEzxmBM;IAOI,wBAAA;ExEqxmBV;EwE5xmBM;IAOI,qBAAA;ExEwxmBV;EwE/xmBM;IAOI,uBAAA;ExE2xmBV;EwElymBM;IAOI,uBAAA;ExE8xmBV;EwErymBM;IAOI,wBAAA;ExEiymBV;EwExymBM;IAOI,uBAAA;ExEoymBV;EwE3ymBM;IAOI,uBAAA;ExEuymBV;EwE9ymBM;IAOI,wBAAA;ExE0ymBV;EwEjzmBM;IAOI,uBAAA;ExE6ymBV;EwEpzmBM;IAOI,wBAAA;ExEgzmBV;EwEvzmBM;IAOI,uBAAA;ExEmzmBV;EwE1zmBM;IAOI,wBAAA;ExEszmBV;EwE7zmBM;IAOI,uBAAA;ExEyzmBV;EwEh0mBM;IAOI,uBAAA;ExE4zmBV;EwEn0mBM;IAOI,wBAAA;ExE+zmBV;EwEt0mBM;IAOI,uBAAA;ExEk0mBV;EwEz0mBM;IAOI,wBAAA;ExEq0mBV;EwE50mBM;IAOI,0BAAA;ExEw0mBV;EwE/0mBM;IAOI,gCAAA;ExE20mBV;EwEl1mBM;IAOI,yBAAA;ExE80mBV;EwEr1mBM;IAOI,wBAAA;ExEi1mBV;EwEx1mBM;IAOI,+BAAA;ExEo1mBV;EwE31mBM;IAOI,yBAAA;ExEu1mBV;EwE91mBM;IAOI,6BAAA;ExE01mBV;EwEj2mBM;IAOI,8BAAA;ExE61mBV;EwEp2mBM;IAOI,wBAAA;ExEg2mBV;EwEv2mBM;IAOI,+BAAA;ExEm2mBV;EwE12mBM;IAOI,wBAAA;ExEs2mBV;EwE72mBM;IAOI,iBAAA;ExEy2mBV;EwEh3mBM;IAOI,mBAAA;ExE42mBV;EwEn3mBM;IAOI,oBAAA;ExE+2mBV;EwEt3mBM;IAOI,kBAAA;ExEk3mBV;EwEz3mBM;IAOI,kBAAA;ExEq3mBV;EwE53mBM;IAOI,kBAAA;ExEw3mBV;EwE/3mBM;IAOI,kBAAA;ExE23mBV;EwEl4mBM;IAOI,kBAAA;ExE83mBV;EwEr4mBM;IAOI,mBAAA;ExEi4mBV;EwEx4mBM;IAOI,mBAAA;ExEo4mBV;EwE34mBM;IAOI,mBAAA;ExEu4mBV;EwE94mBM;IAOI,mBAAA;ExE04mBV;EwEj5mBM;IAOI,mBAAA;ExE64mBV;EwEp5mBM;IAOI,mBAAA;ExEg5mBV;EwEv5mBM;IAOI,mBAAA;ExEm5mBV;EwE15mBM;IAOI,mBAAA;ExEs5mBV;EwE75mBM;IAOI,mBAAA;ExEy5mBV;EwEh6mBM;IAOI,mBAAA;ExE45mBV;EwEn6mBM;IAOI,mBAAA;ExE+5mBV;EwEt6mBM;IAOI,mBAAA;ExEk6mBV;EwEz6mBM;IAOI,mBAAA;ExEq6mBV;EwE56mBM;IAOI,mBAAA;ExEw6mBV;EwE/6mBM;IAOI,mBAAA;ExE26mBV;EwEl7mBM;IAOI,mBAAA;ExE86mBV;EwEr7mBM;IAOI,mBAAA;ExEi7mBV;EwEx7mBM;IAOI,oBAAA;ExEo7mBV;EwE37mBM;IAOI,oBAAA;ExEu7mBV;EwE97mBM;IAOI,sBAAA;ExE07mBV;EwEj8mBM;IAOI,uBAAA;ExE67mBV;EwEp8mBM;IAOI,qBAAA;ExEg8mBV;EwEv8mBM;IAOI,qBAAA;ExEm8mBV;EwE18mBM;IAOI,qBAAA;ExEs8mBV;EwE78mBM;IAOI,qBAAA;ExEy8mBV;EwEh9mBM;IAOI,qBAAA;ExE48mBV;EwEn9mBM;IAOI,sBAAA;ExE+8mBV;EwEt9mBM;IAOI,sBAAA;ExEk9mBV;EwEz9mBM;IAOI,sBAAA;ExEq9mBV;EwE59mBM;IAOI,sBAAA;ExEw9mBV;EwE/9mBM;IAOI,sBAAA;ExE29mBV;EwEl+mBM;IAOI,sBAAA;ExE89mBV;EwEr+mBM;IAOI,sBAAA;ExEi+mBV;EwEx+mBM;IAOI,sBAAA;ExEo+mBV;EwE3+mBM;IAOI,sBAAA;ExEu+mBV;EwE9+mBM;IAOI,sBAAA;ExE0+mBV;EwEj/mBM;IAOI,sBAAA;ExE6+mBV;EwEp/mBM;IAOI,sBAAA;ExEg/mBV;EwEv/mBM;IAOI,sBAAA;ExEm/mBV;EwE1/mBM;IAOI,sBAAA;ExEs/mBV;EwE7/mBM;IAOI,sBAAA;ExEy/mBV;EwEhgnBM;IAOI,sBAAA;ExE4/mBV;EwEngnBM;IAOI,sBAAA;ExE+/mBV;EwEtgnBM;IAOI,uBAAA;ExEkgnBV;EwEzgnBM;IAOI,kBAAA;ExEqgnBV;EwE5gnBM;IAOI,oBAAA;ExEwgnBV;EwE/gnBM;IAOI,qBAAA;ExE2gnBV;EwElhnBM;IAOI,mBAAA;ExE8gnBV;EwErhnBM;IAOI,mBAAA;ExEihnBV;EwExhnBM;IAOI,mBAAA;ExEohnBV;EwE3hnBM;IAOI,mBAAA;ExEuhnBV;EwE9hnBM;IAOI,mBAAA;ExE0hnBV;EwEjinBM;IAOI,oBAAA;ExE6hnBV;EwEpinBM;IAOI,oBAAA;ExEginBV;EwEvinBM;IAOI,oBAAA;ExEminBV;EwE1inBM;IAOI,oBAAA;ExEsinBV;EwE7inBM;IAOI,oBAAA;ExEyinBV;EwEhjnBM;IAOI,oBAAA;ExE4inBV;EwEnjnBM;IAOI,oBAAA;ExE+inBV;EwEtjnBM;IAOI,oBAAA;ExEkjnBV;EwEzjnBM;IAOI,oBAAA;ExEqjnBV;EwE5jnBM;IAOI,oBAAA;ExEwjnBV;EwE/jnBM;IAOI,oBAAA;ExE2jnBV;EwElknBM;IAOI,oBAAA;ExE8jnBV;EwErknBM;IAOI,oBAAA;ExEiknBV;EwExknBM;IAOI,oBAAA;ExEoknBV;EwE3knBM;IAOI,oBAAA;ExEuknBV;EwE9knBM;IAOI,oBAAA;ExE0knBV;EwEjlnBM;IAOI,oBAAA;ExE6knBV;EwEplnBM;IAOI,qBAAA;ExEglnBV;EwEvlnBM;IAOI,mBAAA;ExEmlnBV;EwE1lnBM;IAOI,qBAAA;ExEslnBV;EwE7lnBM;IAOI,sBAAA;ExEylnBV;EwEhmnBM;IAOI,oBAAA;ExE4lnBV;EwEnmnBM;IAOI,oBAAA;ExE+lnBV;EwEtmnBM;IAOI,oBAAA;ExEkmnBV;EwEzmnBM;IAOI,oBAAA;ExEqmnBV;EwE5mnBM;IAOI,oBAAA;ExEwmnBV;EwE/mnBM;IAOI,qBAAA;ExE2mnBV;EwElnnBM;IAOI,qBAAA;ExE8mnBV;EwErnnBM;IAOI,qBAAA;ExEinnBV;EwExnnBM;IAOI,qBAAA;ExEonnBV;EwE3nnBM;IAOI,qBAAA;ExEunnBV;EwE9nnBM;IAOI,qBAAA;ExE0nnBV;EwEjonBM;IAOI,qBAAA;ExE6nnBV;EwEponBM;IAOI,qBAAA;ExEgonBV;EwEvonBM;IAOI,qBAAA;ExEmonBV;EwE1onBM;IAOI,qBAAA;ExEsonBV;EwE7onBM;IAOI,qBAAA;ExEyonBV;EwEhpnBM;IAOI,qBAAA;ExE4onBV;EwEnpnBM;IAOI,qBAAA;ExE+onBV;EwEtpnBM;IAOI,qBAAA;ExEkpnBV;EwEzpnBM;IAOI,qBAAA;ExEqpnBV;EwE5pnBM;IAOI,qBAAA;ExEwpnBV;EwE/pnBM;IAOI,qBAAA;ExE2pnBV;EwElqnBM;IAOI,sBAAA;ExE8pnBV;EwErqnBM;IAOI,qBAAA;ExEiqnBV;EwExqnBM;IAOI,qBAAA;ExEoqnBV;EwE3qnBM;IAOI,qBAAA;ExEuqnBV;EwE9qnBM;IAOI,sBAAA;ExE0qnBV;EwEjrnBM;IAOI,sBAAA;ExE6qnBV;EwEprnBM;IAOI,oBAAA;ExEgrnBV;EwEvrnBM;IAOI,qBAAA;ExEmrnBV;EwE1rnBM;IAOI,qBAAA;ExEsrnBV;EwE7rnBM;IAOI,qBAAA;ExEyrnBV;EwEhsnBM;IAOI,qBAAA;ExE4rnBV;EwEnsnBM;IAOI,qBAAA;ExE+rnBV;EwEtsnBM;IAOI,qBAAA;ExEksnBV;EwEzsnBM;IAOI,qBAAA;ExEqsnBV;EwE5snBM;IAOI,qBAAA;ExEwsnBV;EwE/snBM;IAOI,qBAAA;ExE2snBV;EwEltnBM;IAOI,qBAAA;ExE8snBV;EwErtnBM;IAOI,qBAAA;ExEitnBV;EwExtnBM;IAOI,qBAAA;ExEotnBV;EwE3tnBM;IAOI,qBAAA;ExEutnBV;EwE9tnBM;IAOI,qBAAA;ExE0tnBV;EwEjunBM;IAOI,qBAAA;ExE6tnBV;EwEpunBM;IAOI,sBAAA;ExEgunBV;EwEvunBM;IAOI,sBAAA;ExEmunBV;EwE1unBM;IAOI,sBAAA;ExEsunBV;EwE7unBM;IAOI,uBAAA;ExEyunBV;EwEhvnBM;IAOI,uBAAA;ExE4unBV;EwEnvnBM;IAOI,qBAAA;ExE+unBV;EwEtvnBM;IAOI,sBAAA;ExEkvnBV;EwEzvnBM;IAOI,sBAAA;ExEqvnBV;EwE5vnBM;IAOI,sBAAA;ExEwvnBV;EwE/vnBM;IAOI,sBAAA;ExE2vnBV;EwElwnBM;IAOI,sBAAA;ExE8vnBV;EwErwnBM;IAOI,sBAAA;ExEiwnBV;EwExwnBM;IAOI,sBAAA;ExEownBV;EwE3wnBM;IAOI,sBAAA;ExEuwnBV;EwE9wnBM;IAOI,sBAAA;ExE0wnBV;EwEjxnBM;IAOI,sBAAA;ExE6wnBV;EwEpxnBM;IAOI,sBAAA;ExEgxnBV;EwEvxnBM;IAOI,sBAAA;ExEmxnBV;EwE1xnBM;IAOI,sBAAA;ExEsxnBV;EwE7xnBM;IAOI,sBAAA;ExEyxnBV;EwEhynBM;IAOI,sBAAA;ExE4xnBV;EwEnynBM;IAOI,yBAAA;ExE+xnBV;EwEtynBM;IAOI,8BAAA;ExEkynBV;EwEzynBM;IAOI,iCAAA;ExEqynBV;EwE5ynBM;IAOI,sCAAA;ExEwynBV;EwE/ynBM;IAOI,yCAAA;ExE2ynBV;EwElznBM;IAOI,uBAAA;ExE8ynBV;EwErznBM;IAOI,uBAAA;ExEiznBV;EwExznBM;IAOI,yBAAA;ExEoznBV;EwE3znBM;IAOI,yBAAA;ExEuznBV;EwE9znBM;IAOI,0BAAA;ExE0znBV;EwEj0nBM;IAOI,4BAAA;ExE6znBV;EwEp0nBM;IAOI,kCAAA;ExEg0nBV;EwEv0nBM;IAOI,sCAAA;ExEm0nBV;EwE10nBM;IAOI,oCAAA;ExEs0nBV;EwE70nBM;IAOI,kCAAA;ExEy0nBV;EwEh1nBM;IAOI,yCAAA;ExE40nBV;EwEn1nBM;IAOI,wCAAA;ExE+0nBV;EwEt1nBM;IAOI,wCAAA;ExEk1nBV;EwEz1nBM;IAOI,kCAAA;ExEq1nBV;EwE51nBM;IAOI,gCAAA;ExEw1nBV;EwE/1nBM;IAOI,8BAAA;ExE21nBV;EwEl2nBM;IAOI,gCAAA;ExE81nBV;EwEr2nBM;IAOI,+BAAA;ExEi2nBV;EwEx2nBM;IAOI,oCAAA;ExEo2nBV;EwE32nBM;IAOI,kCAAA;ExEu2nBV;EwE92nBM;IAOI,gCAAA;ExE02nBV;EwEj3nBM;IAOI,uCAAA;ExE62nBV;EwEp3nBM;IAOI,sCAAA;ExEg3nBV;EwEv3nBM;IAOI,iCAAA;ExEm3nBV;EwE13nBM;IAOI,2BAAA;ExEs3nBV;EwE73nBM;IAOI,iCAAA;ExEy3nBV;EwEh4nBM;IAOI,+BAAA;ExE43nBV;EwEn4nBM;IAOI,6BAAA;ExE+3nBV;EwEt4nBM;IAOI,+BAAA;ExEk4nBV;EwEz4nBM;IAOI,8BAAA;ExEq4nBV;EwE54nBM;IAOI,oBAAA;ExEw4nBV;EwE/4nBM;IAOI,mBAAA;ExE24nBV;EwEl5nBM;IAOI,mBAAA;ExE84nBV;EwEr5nBM;IAOI,mBAAA;ExEi5nBV;EwEx5nBM;IAOI,mBAAA;ExEo5nBV;EwE35nBM;IAOI,mBAAA;ExEu5nBV;EwE95nBM;IAOI,mBAAA;ExE05nBV;EwEj6nBM;IAOI,mBAAA;ExE65nBV;EwEp6nBM;IAOI,oBAAA;ExEg6nBV;EwEv6nBM;IAOI,0BAAA;ExEm6nBV;EwE16nBM;IAOI,yBAAA;ExEs6nBV;EwE76nBM;IAOI,uBAAA;ExEy6nBV;EwEh7nBM;IAOI,yBAAA;ExE46nBV;EwEn7nBM;IAOI,uBAAA;ExE+6nBV;EwEt7nBM;IAOI,yBAAA;ExEk7nBV;EwEz7nBM;IAOI,uBAAA;ExEq7nBV;EwE57nBM;IAOI,uBAAA;ExEw7nBV;EwE/7nBM;IAOI,wBAAA;ExE27nBV;EwEl8nBM;IAOI,uBAAA;ExE87nBV;EwEr8nBM;IAOI,0BAAA;IAAA,yBAAA;ExEk8nBV;EwEz8nBM;IAOI,gCAAA;IAAA,+BAAA;ExEs8nBV;EwE78nBM;IAOI,+BAAA;IAAA,8BAAA;ExE08nBV;EwEj9nBM;IAOI,6BAAA;IAAA,4BAAA;ExE88nBV;EwEr9nBM;IAOI,+BAAA;IAAA,8BAAA;ExEk9nBV;EwEz9nBM;IAOI,6BAAA;IAAA,4BAAA;ExEs9nBV;EwE79nBM;IAOI,+BAAA;IAAA,8BAAA;ExE09nBV;EwEj+nBM;IAOI,6BAAA;IAAA,4BAAA;ExE89nBV;EwEr+nBM;IAOI,6BAAA;IAAA,4BAAA;ExEk+nBV;EwEz+nBM;IAOI,8BAAA;IAAA,6BAAA;ExEs+nBV;EwE7+nBM;IAOI,6BAAA;IAAA,4BAAA;ExE0+nBV;EwEj/nBM;IAOI,wBAAA;IAAA,2BAAA;ExE8+nBV;EwEr/nBM;IAOI,8BAAA;IAAA,iCAAA;ExEk/nBV;EwEz/nBM;IAOI,6BAAA;IAAA,gCAAA;ExEs/nBV;EwE7/nBM;IAOI,2BAAA;IAAA,8BAAA;ExE0/nBV;EwEjgoBM;IAOI,6BAAA;IAAA,gCAAA;ExE8/nBV;EwErgoBM;IAOI,2BAAA;IAAA,8BAAA;ExEkgoBV;EwEzgoBM;IAOI,6BAAA;IAAA,gCAAA;ExEsgoBV;EwE7goBM;IAOI,2BAAA;IAAA,8BAAA;ExE0goBV;EwEjhoBM;IAOI,2BAAA;IAAA,8BAAA;ExE8goBV;EwErhoBM;IAOI,4BAAA;IAAA,+BAAA;ExEkhoBV;EwEzhoBM;IAOI,2BAAA;IAAA,8BAAA;ExEshoBV;EwE7hoBM;IAOI,wBAAA;ExEyhoBV;EwEhioBM;IAOI,8BAAA;ExE4hoBV;EwEnioBM;IAOI,6BAAA;ExE+hoBV;EwEtioBM;IAOI,2BAAA;ExEkioBV;EwEzioBM;IAOI,6BAAA;ExEqioBV;EwE5ioBM;IAOI,2BAAA;ExEwioBV;EwE/ioBM;IAOI,6BAAA;ExE2ioBV;EwEljoBM;IAOI,2BAAA;ExE8ioBV;EwErjoBM;IAOI,2BAAA;ExEijoBV;EwExjoBM;IAOI,4BAAA;ExEojoBV;EwE3joBM;IAOI,2BAAA;ExEujoBV;EwE9joBM;IAOI,0BAAA;ExE0joBV;EwEjkoBM;IAOI,gCAAA;ExE6joBV;EwEpkoBM;IAOI,+BAAA;ExEgkoBV;EwEvkoBM;IAOI,6BAAA;ExEmkoBV;EwE1koBM;IAOI,+BAAA;ExEskoBV;EwE7koBM;IAOI,6BAAA;ExEykoBV;EwEhloBM;IAOI,+BAAA;ExE4koBV;EwEnloBM;IAOI,6BAAA;ExE+koBV;EwEtloBM;IAOI,6BAAA;ExEkloBV;EwEzloBM;IAOI,8BAAA;ExEqloBV;EwE5loBM;IAOI,6BAAA;ExEwloBV;EwE/loBM;IAOI,2BAAA;ExE2loBV;EwElmoBM;IAOI,iCAAA;ExE8loBV;EwErmoBM;IAOI,gCAAA;ExEimoBV;EwExmoBM;IAOI,8BAAA;ExEomoBV;EwE3moBM;IAOI,gCAAA;ExEumoBV;EwE9moBM;IAOI,8BAAA;ExE0moBV;EwEjnoBM;IAOI,gCAAA;ExE6moBV;EwEpnoBM;IAOI,8BAAA;ExEgnoBV;EwEvnoBM;IAOI,8BAAA;ExEmnoBV;EwE1noBM;IAOI,+BAAA;ExEsnoBV;EwE7noBM;IAOI,8BAAA;ExEynoBV;EwEhooBM;IAOI,yBAAA;ExE4noBV;EwEnooBM;IAOI,+BAAA;ExE+noBV;EwEtooBM;IAOI,8BAAA;ExEkooBV;EwEzooBM;IAOI,4BAAA;ExEqooBV;EwE5ooBM;IAOI,8BAAA;ExEwooBV;EwE/ooBM;IAOI,4BAAA;ExE2ooBV;EwElpoBM;IAOI,8BAAA;ExE8ooBV;EwErpoBM;IAOI,4BAAA;ExEipoBV;EwExpoBM;IAOI,4BAAA;ExEopoBV;EwE3poBM;IAOI,6BAAA;ExEupoBV;EwE9poBM;IAOI,4BAAA;ExE0poBV;EwEjqoBM;IAOI,2BAAA;ExE6poBV;EwEpqoBM;IAOI,0BAAA;ExEgqoBV;EwEvqoBM;IAOI,wBAAA;ExEmqoBV;EwE1qoBM;IAOI,0BAAA;ExEsqoBV;EwE7qoBM;IAOI,wBAAA;ExEyqoBV;EwEhroBM;IAOI,0BAAA;ExE4qoBV;EwEnroBM;IAOI,wBAAA;ExE+qoBV;EwEtroBM;IAOI,wBAAA;ExEkroBV;EwEzroBM;IAOI,yBAAA;ExEqroBV;EwE5roBM;IAOI,iCAAA;IAAA,gCAAA;ExEyroBV;EwEhsoBM;IAOI,gCAAA;IAAA,+BAAA;ExE6roBV;EwEpsoBM;IAOI,8BAAA;IAAA,6BAAA;ExEisoBV;EwExsoBM;IAOI,gCAAA;IAAA,+BAAA;ExEqsoBV;EwE5soBM;IAOI,8BAAA;IAAA,6BAAA;ExEysoBV;EwEhtoBM;IAOI,gCAAA;IAAA,+BAAA;ExE6soBV;EwEptoBM;IAOI,8BAAA;IAAA,6BAAA;ExEitoBV;EwExtoBM;IAOI,8BAAA;IAAA,6BAAA;ExEqtoBV;EwE5toBM;IAOI,+BAAA;IAAA,8BAAA;ExEytoBV;EwEhuoBM;IAOI,+BAAA;IAAA,kCAAA;ExE6toBV;EwEpuoBM;IAOI,8BAAA;IAAA,iCAAA;ExEiuoBV;EwExuoBM;IAOI,4BAAA;IAAA,+BAAA;ExEquoBV;EwE5uoBM;IAOI,8BAAA;IAAA,iCAAA;ExEyuoBV;EwEhvoBM;IAOI,4BAAA;IAAA,+BAAA;ExE6uoBV;EwEpvoBM;IAOI,8BAAA;IAAA,iCAAA;ExEivoBV;EwExvoBM;IAOI,4BAAA;IAAA,+BAAA;ExEqvoBV;EwE5voBM;IAOI,4BAAA;IAAA,+BAAA;ExEyvoBV;EwEhwoBM;IAOI,6BAAA;IAAA,gCAAA;ExE6voBV;EwEpwoBM;IAOI,+BAAA;ExEgwoBV;EwEvwoBM;IAOI,8BAAA;ExEmwoBV;EwE1woBM;IAOI,4BAAA;ExEswoBV;EwE7woBM;IAOI,8BAAA;ExEywoBV;EwEhxoBM;IAOI,4BAAA;ExE4woBV;EwEnxoBM;IAOI,8BAAA;ExE+woBV;EwEtxoBM;IAOI,4BAAA;ExEkxoBV;EwEzxoBM;IAOI,4BAAA;ExEqxoBV;EwE5xoBM;IAOI,6BAAA;ExEwxoBV;EwE/xoBM;IAOI,iCAAA;ExE2xoBV;EwElyoBM;IAOI,gCAAA;ExE8xoBV;EwEryoBM;IAOI,8BAAA;ExEiyoBV;EwExyoBM;IAOI,gCAAA;ExEoyoBV;EwE3yoBM;IAOI,8BAAA;ExEuyoBV;EwE9yoBM;IAOI,gCAAA;ExE0yoBV;EwEjzoBM;IAOI,8BAAA;ExE6yoBV;EwEpzoBM;IAOI,8BAAA;ExEgzoBV;EwEvzoBM;IAOI,+BAAA;ExEmzoBV;EwE1zoBM;IAOI,kCAAA;ExEszoBV;EwE7zoBM;IAOI,iCAAA;ExEyzoBV;EwEh0oBM;IAOI,+BAAA;ExE4zoBV;EwEn0oBM;IAOI,iCAAA;ExE+zoBV;EwEt0oBM;IAOI,+BAAA;ExEk0oBV;EwEz0oBM;IAOI,iCAAA;ExEq0oBV;EwE50oBM;IAOI,+BAAA;ExEw0oBV;EwE/0oBM;IAOI,+BAAA;ExE20oBV;EwEl1oBM;IAOI,gCAAA;ExE80oBV;EwEr1oBM;IAOI,gCAAA;ExEi1oBV;EwEx1oBM;IAOI,+BAAA;ExEo1oBV;EwE31oBM;IAOI,6BAAA;ExEu1oBV;EwE91oBM;IAOI,+BAAA;ExE01oBV;EwEj2oBM;IAOI,6BAAA;ExE61oBV;EwEp2oBM;IAOI,+BAAA;ExEg2oBV;EwEv2oBM;IAOI,6BAAA;ExEm2oBV;EwE12oBM;IAOI,6BAAA;ExEs2oBV;EwE72oBM;IAOI,8BAAA;ExEy2oBV;EwEh3oBM;IAOI,qBAAA;ExE42oBV;EwEn3oBM;IAOI,2BAAA;ExE+2oBV;EwEt3oBM;IAOI,0BAAA;ExEk3oBV;EwEz3oBM;IAOI,wBAAA;ExEq3oBV;EwE53oBM;IAOI,0BAAA;ExEw3oBV;EwE/3oBM;IAOI,wBAAA;ExE23oBV;EwEl4oBM;IAOI,0BAAA;ExE83oBV;EwEr4oBM;IAOI,wBAAA;ExEi4oBV;EwEx4oBM;IAOI,wBAAA;ExEo4oBV;EwE34oBM;IAOI,yBAAA;ExEu4oBV;EwE94oBM;IAOI,2BAAA;IAAA,0BAAA;ExE24oBV;EwEl5oBM;IAOI,iCAAA;IAAA,gCAAA;ExE+4oBV;EwEt5oBM;IAOI,gCAAA;IAAA,+BAAA;ExEm5oBV;EwE15oBM;IAOI,8BAAA;IAAA,6BAAA;ExEu5oBV;EwE95oBM;IAOI,gCAAA;IAAA,+BAAA;ExE25oBV;EwEl6oBM;IAOI,8BAAA;IAAA,6BAAA;ExE+5oBV;EwEt6oBM;IAOI,gCAAA;IAAA,+BAAA;ExEm6oBV;EwE16oBM;IAOI,8BAAA;IAAA,6BAAA;ExEu6oBV;EwE96oBM;IAOI,8BAAA;IAAA,6BAAA;ExE26oBV;EwEl7oBM;IAOI,+BAAA;IAAA,8BAAA;ExE+6oBV;EwEt7oBM;IAOI,yBAAA;IAAA,4BAAA;ExEm7oBV;EwE17oBM;IAOI,+BAAA;IAAA,kCAAA;ExEu7oBV;EwE97oBM;IAOI,8BAAA;IAAA,iCAAA;ExE27oBV;EwEl8oBM;IAOI,4BAAA;IAAA,+BAAA;ExE+7oBV;EwEt8oBM;IAOI,8BAAA;IAAA,iCAAA;ExEm8oBV;EwE18oBM;IAOI,4BAAA;IAAA,+BAAA;ExEu8oBV;EwE98oBM;IAOI,8BAAA;IAAA,iCAAA;ExE28oBV;EwEl9oBM;IAOI,4BAAA;IAAA,+BAAA;ExE+8oBV;EwEt9oBM;IAOI,4BAAA;IAAA,+BAAA;ExEm9oBV;EwE19oBM;IAOI,6BAAA;IAAA,gCAAA;ExEu9oBV;EwE99oBM;IAOI,yBAAA;ExE09oBV;EwEj+oBM;IAOI,+BAAA;ExE69oBV;EwEp+oBM;IAOI,8BAAA;ExEg+oBV;EwEv+oBM;IAOI,4BAAA;ExEm+oBV;EwE1+oBM;IAOI,8BAAA;ExEs+oBV;EwE7+oBM;IAOI,4BAAA;ExEy+oBV;EwEh/oBM;IAOI,8BAAA;ExE4+oBV;EwEn/oBM;IAOI,4BAAA;ExE++oBV;EwEt/oBM;IAOI,4BAAA;ExEk/oBV;EwEz/oBM;IAOI,6BAAA;ExEq/oBV;EwE5/oBM;IAOI,2BAAA;ExEw/oBV;EwE//oBM;IAOI,iCAAA;ExE2/oBV;EwElgpBM;IAOI,gCAAA;ExE8/oBV;EwErgpBM;IAOI,8BAAA;ExEigpBV;EwExgpBM;IAOI,gCAAA;ExEogpBV;EwE3gpBM;IAOI,8BAAA;ExEugpBV;EwE9gpBM;IAOI,gCAAA;ExE0gpBV;EwEjhpBM;IAOI,8BAAA;ExE6gpBV;EwEphpBM;IAOI,8BAAA;ExEghpBV;EwEvhpBM;IAOI,+BAAA;ExEmhpBV;EwE1hpBM;IAOI,4BAAA;ExEshpBV;EwE7hpBM;IAOI,kCAAA;ExEyhpBV;EwEhipBM;IAOI,iCAAA;ExE4hpBV;EwEnipBM;IAOI,+BAAA;ExE+hpBV;EwEtipBM;IAOI,iCAAA;ExEkipBV;EwEzipBM;IAOI,+BAAA;ExEqipBV;EwE5ipBM;IAOI,iCAAA;ExEwipBV;EwE/ipBM;IAOI,+BAAA;ExE2ipBV;EwEljpBM;IAOI,+BAAA;ExE8ipBV;EwErjpBM;IAOI,gCAAA;ExEijpBV;EwExjpBM;IAOI,0BAAA;ExEojpBV;EwE3jpBM;IAOI,gCAAA;ExEujpBV;EwE9jpBM;IAOI,+BAAA;ExE0jpBV;EwEjkpBM;IAOI,6BAAA;ExE6jpBV;EwEpkpBM;IAOI,+BAAA;ExEgkpBV;EwEvkpBM;IAOI,6BAAA;ExEmkpBV;EwE1kpBM;IAOI,+BAAA;ExEskpBV;EwE7kpBM;IAOI,6BAAA;ExEykpBV;EwEhlpBM;IAOI,6BAAA;ExE4kpBV;EwEnlpBM;IAOI,8BAAA;ExE+kpBV;EwEtlpBM;IAOI,iBAAA;ExEklpBV;EwEzlpBM;IAOI,uBAAA;ExEqlpBV;EwE5lpBM;IAOI,sBAAA;ExEwlpBV;EwE/lpBM;IAOI,oBAAA;ExE2lpBV;EwElmpBM;IAOI,sBAAA;ExE8lpBV;EwErmpBM;IAOI,oBAAA;ExEimpBV;EwExmpBM;IAOI,sBAAA;ExEompBV;EwE3mpBM;IAOI,oBAAA;ExEumpBV;EwE9mpBM;IAOI,oBAAA;ExE0mpBV;EwEjnpBM;IAOI,qBAAA;ExE6mpBV;EwEpnpBM;IAOI,qBAAA;ExEgnpBV;EwEvnpBM;IAOI,2BAAA;ExEmnpBV;EwE1npBM;IAOI,0BAAA;ExEsnpBV;EwE7npBM;IAOI,wBAAA;ExEynpBV;EwEhopBM;IAOI,0BAAA;ExE4npBV;EwEnopBM;IAOI,wBAAA;ExE+npBV;EwEtopBM;IAOI,0BAAA;ExEkopBV;EwEzopBM;IAOI,wBAAA;ExEqopBV;EwE5opBM;IAOI,wBAAA;ExEwopBV;EwE/opBM;IAOI,yBAAA;ExE2opBV;EwElppBM;IAOI,wBAAA;ExE8opBV;EwErppBM;IAOI,8BAAA;ExEippBV;EwExppBM;IAOI,6BAAA;ExEoppBV;EwE3ppBM;IAOI,2BAAA;ExEuppBV;EwE9ppBM;IAOI,6BAAA;ExE0ppBV;EwEjqpBM;IAOI,2BAAA;ExE6ppBV;EwEpqpBM;IAOI,6BAAA;ExEgqpBV;EwEvqpBM;IAOI,2BAAA;ExEmqpBV;EwE1qpBM;IAOI,2BAAA;ExEsqpBV;EwE7qpBM;IAOI,4BAAA;ExEyqpBV;EwEhrpBM;IAOI,8CAAA;ExE4qpBV;EwEnrpBM;IAOI,6CAAA;ExE+qpBV;EwEtrpBM;IAOI,gDAAA;ExEkrpBV;EwEzrpBM;IAOI,8CAAA;ExEqrpBV;EwE5rpBM;IAOI,gDAAA;ExEwrpBV;EwE/rpBM;IAOI,6BAAA;ExE2rpBV;EwElspBM;IAOI,2BAAA;ExE8rpBV;EwErspBM;IAOI,4BAAA;ExEispBV;EwExspBM;IAOI,6BAAA;ExEospBV;EwE3spBM;IAIQ,oBAAA;IAGJ,qEAAA;ExEwspBV;EwE/spBM;IAIQ,oBAAA;IAGJ,uEAAA;ExE4spBV;EwEntpBM;IAIQ,oBAAA;IAGJ,qEAAA;ExEgtpBV;EwEvtpBM;IAIQ,oBAAA;IAGJ,kEAAA;ExEotpBV;EwE3tpBM;IAIQ,oBAAA;IAGJ,qEAAA;ExEwtpBV;EwE/tpBM;IAIQ,oBAAA;IAGJ,oEAAA;ExE4tpBV;EwEnupBM;IAIQ,oBAAA;IAGJ,mEAAA;ExEgupBV;EwEvupBM;IAIQ,oBAAA;IAGJ,kEAAA;ExEoupBV;EwE3upBM;IAIQ,oBAAA;IAGJ,mEAAA;ExEwupBV;EwE/upBM;IAIQ,oBAAA;IAGJ,mEAAA;ExE4upBV;EwEnvpBM;IAIQ,oBAAA;IAGJ,wEAAA;ExEgvpBV;EwEvvpBM;IAIQ,oBAAA;IAGJ,2CAAA;ExEovpBV;EwE3vpBM;IAIQ,oBAAA;IAGJ,oCAAA;ExEwvpBV;EwE/vpBM;IAIQ,oBAAA;IAGJ,0CAAA;ExE4vpBV;EwEnwpBM;IAIQ,oBAAA;IAGJ,2CAAA;ExEgwpBV;EwEvwpBM;IAIQ,oBAAA;IAGJ,0CAAA;ExEowpBV;EwE3wpBM;IAIQ,oBAAA;IAGJ,0CAAA;ExEwwpBV;EwE/wpBM;IAIQ,oBAAA;IAGJ,yBAAA;ExE4wpBV;AACF;AMvxpBI;EkEGI;IAOI,sBAAA;ExEixpBV;EwExxpBM;IAOI,uBAAA;ExEoxpBV;EwE3xpBM;IAOI,sBAAA;ExEuxpBV;EwE9xpBM;IAOI,8BAAA;ExE0xpBV;EwEjypBM;IAOI,4BAAA;ExE6xpBV;EwEpypBM;IAOI,2BAAA;ExEgypBV;EwEvypBM;IAOI,iCAAA;ExEmypBV;EwE1ypBM;IAOI,2BAAA;ExEsypBV;EwE7ypBM;IAOI,qBAAA;ExEyypBV;EwEhzpBM;IAOI,wBAAA;ExE4ypBV;EwEnzpBM;IAOI,uBAAA;ExE+ypBV;EwEtzpBM;IAOI,wBAAA;ExEkzpBV;EwEzzpBM;IAOI,qBAAA;ExEqzpBV;EwE5zpBM;IAOI,uBAAA;ExEwzpBV;EwE/zpBM;IAOI,uBAAA;ExE2zpBV;EwEl0pBM;IAOI,wBAAA;ExE8zpBV;EwEr0pBM;IAOI,uBAAA;ExEi0pBV;EwEx0pBM;IAOI,uBAAA;ExEo0pBV;EwE30pBM;IAOI,wBAAA;ExEu0pBV;EwE90pBM;IAOI,uBAAA;ExE00pBV;EwEj1pBM;IAOI,wBAAA;ExE60pBV;EwEp1pBM;IAOI,uBAAA;ExEg1pBV;EwEv1pBM;IAOI,wBAAA;ExEm1pBV;EwE11pBM;IAOI,uBAAA;ExEs1pBV;EwE71pBM;IAOI,uBAAA;ExEy1pBV;EwEh2pBM;IAOI,wBAAA;ExE41pBV;EwEn2pBM;IAOI,uBAAA;ExE+1pBV;EwEt2pBM;IAOI,wBAAA;ExEk2pBV;EwEz2pBM;IAOI,0BAAA;ExEq2pBV;EwE52pBM;IAOI,gCAAA;ExEw2pBV;EwE/2pBM;IAOI,yBAAA;ExE22pBV;EwEl3pBM;IAOI,wBAAA;ExE82pBV;EwEr3pBM;IAOI,+BAAA;ExEi3pBV;EwEx3pBM;IAOI,yBAAA;ExEo3pBV;EwE33pBM;IAOI,6BAAA;ExEu3pBV;EwE93pBM;IAOI,8BAAA;ExE03pBV;EwEj4pBM;IAOI,wBAAA;ExE63pBV;EwEp4pBM;IAOI,+BAAA;ExEg4pBV;EwEv4pBM;IAOI,wBAAA;ExEm4pBV;EwE14pBM;IAOI,iBAAA;ExEs4pBV;EwE74pBM;IAOI,mBAAA;ExEy4pBV;EwEh5pBM;IAOI,oBAAA;ExE44pBV;EwEn5pBM;IAOI,kBAAA;ExE+4pBV;EwEt5pBM;IAOI,kBAAA;ExEk5pBV;EwEz5pBM;IAOI,kBAAA;ExEq5pBV;EwE55pBM;IAOI,kBAAA;ExEw5pBV;EwE/5pBM;IAOI,kBAAA;ExE25pBV;EwEl6pBM;IAOI,mBAAA;ExE85pBV;EwEr6pBM;IAOI,mBAAA;ExEi6pBV;EwEx6pBM;IAOI,mBAAA;ExEo6pBV;EwE36pBM;IAOI,mBAAA;ExEu6pBV;EwE96pBM;IAOI,mBAAA;ExE06pBV;EwEj7pBM;IAOI,mBAAA;ExE66pBV;EwEp7pBM;IAOI,mBAAA;ExEg7pBV;EwEv7pBM;IAOI,mBAAA;ExEm7pBV;EwE17pBM;IAOI,mBAAA;ExEs7pBV;EwE77pBM;IAOI,mBAAA;ExEy7pBV;EwEh8pBM;IAOI,mBAAA;ExE47pBV;EwEn8pBM;IAOI,mBAAA;ExE+7pBV;EwEt8pBM;IAOI,mBAAA;ExEk8pBV;EwEz8pBM;IAOI,mBAAA;ExEq8pBV;EwE58pBM;IAOI,mBAAA;ExEw8pBV;EwE/8pBM;IAOI,mBAAA;ExE28pBV;EwEl9pBM;IAOI,mBAAA;ExE88pBV;EwEr9pBM;IAOI,oBAAA;ExEi9pBV;EwEx9pBM;IAOI,oBAAA;ExEo9pBV;EwE39pBM;IAOI,sBAAA;ExEu9pBV;EwE99pBM;IAOI,uBAAA;ExE09pBV;EwEj+pBM;IAOI,qBAAA;ExE69pBV;EwEp+pBM;IAOI,qBAAA;ExEg+pBV;EwEv+pBM;IAOI,qBAAA;ExEm+pBV;EwE1+pBM;IAOI,qBAAA;ExEs+pBV;EwE7+pBM;IAOI,qBAAA;ExEy+pBV;EwEh/pBM;IAOI,sBAAA;ExE4+pBV;EwEn/pBM;IAOI,sBAAA;ExE++pBV;EwEt/pBM;IAOI,sBAAA;ExEk/pBV;EwEz/pBM;IAOI,sBAAA;ExEq/pBV;EwE5/pBM;IAOI,sBAAA;ExEw/pBV;EwE//pBM;IAOI,sBAAA;ExE2/pBV;EwElgqBM;IAOI,sBAAA;ExE8/pBV;EwErgqBM;IAOI,sBAAA;ExEigqBV;EwExgqBM;IAOI,sBAAA;ExEogqBV;EwE3gqBM;IAOI,sBAAA;ExEugqBV;EwE9gqBM;IAOI,sBAAA;ExE0gqBV;EwEjhqBM;IAOI,sBAAA;ExE6gqBV;EwEphqBM;IAOI,sBAAA;ExEghqBV;EwEvhqBM;IAOI,sBAAA;ExEmhqBV;EwE1hqBM;IAOI,sBAAA;ExEshqBV;EwE7hqBM;IAOI,sBAAA;ExEyhqBV;EwEhiqBM;IAOI,sBAAA;ExE4hqBV;EwEniqBM;IAOI,uBAAA;ExE+hqBV;EwEtiqBM;IAOI,kBAAA;ExEkiqBV;EwEziqBM;IAOI,oBAAA;ExEqiqBV;EwE5iqBM;IAOI,qBAAA;ExEwiqBV;EwE/iqBM;IAOI,mBAAA;ExE2iqBV;EwEljqBM;IAOI,mBAAA;ExE8iqBV;EwErjqBM;IAOI,mBAAA;ExEijqBV;EwExjqBM;IAOI,mBAAA;ExEojqBV;EwE3jqBM;IAOI,mBAAA;ExEujqBV;EwE9jqBM;IAOI,oBAAA;ExE0jqBV;EwEjkqBM;IAOI,oBAAA;ExE6jqBV;EwEpkqBM;IAOI,oBAAA;ExEgkqBV;EwEvkqBM;IAOI,oBAAA;ExEmkqBV;EwE1kqBM;IAOI,oBAAA;ExEskqBV;EwE7kqBM;IAOI,oBAAA;ExEykqBV;EwEhlqBM;IAOI,oBAAA;ExE4kqBV;EwEnlqBM;IAOI,oBAAA;ExE+kqBV;EwEtlqBM;IAOI,oBAAA;ExEklqBV;EwEzlqBM;IAOI,oBAAA;ExEqlqBV;EwE5lqBM;IAOI,oBAAA;ExEwlqBV;EwE/lqBM;IAOI,oBAAA;ExE2lqBV;EwElmqBM;IAOI,oBAAA;ExE8lqBV;EwErmqBM;IAOI,oBAAA;ExEimqBV;EwExmqBM;IAOI,oBAAA;ExEomqBV;EwE3mqBM;IAOI,oBAAA;ExEumqBV;EwE9mqBM;IAOI,oBAAA;ExE0mqBV;EwEjnqBM;IAOI,qBAAA;ExE6mqBV;EwEpnqBM;IAOI,mBAAA;ExEgnqBV;EwEvnqBM;IAOI,qBAAA;ExEmnqBV;EwE1nqBM;IAOI,sBAAA;ExEsnqBV;EwE7nqBM;IAOI,oBAAA;ExEynqBV;EwEhoqBM;IAOI,oBAAA;ExE4nqBV;EwEnoqBM;IAOI,oBAAA;ExE+nqBV;EwEtoqBM;IAOI,oBAAA;ExEkoqBV;EwEzoqBM;IAOI,oBAAA;ExEqoqBV;EwE5oqBM;IAOI,qBAAA;ExEwoqBV;EwE/oqBM;IAOI,qBAAA;ExE2oqBV;EwElpqBM;IAOI,qBAAA;ExE8oqBV;EwErpqBM;IAOI,qBAAA;ExEipqBV;EwExpqBM;IAOI,qBAAA;ExEopqBV;EwE3pqBM;IAOI,qBAAA;ExEupqBV;EwE9pqBM;IAOI,qBAAA;ExE0pqBV;EwEjqqBM;IAOI,qBAAA;ExE6pqBV;EwEpqqBM;IAOI,qBAAA;ExEgqqBV;EwEvqqBM;IAOI,qBAAA;ExEmqqBV;EwE1qqBM;IAOI,qBAAA;ExEsqqBV;EwE7qqBM;IAOI,qBAAA;ExEyqqBV;EwEhrqBM;IAOI,qBAAA;ExE4qqBV;EwEnrqBM;IAOI,qBAAA;ExE+qqBV;EwEtrqBM;IAOI,qBAAA;ExEkrqBV;EwEzrqBM;IAOI,qBAAA;ExEqrqBV;EwE5rqBM;IAOI,qBAAA;ExEwrqBV;EwE/rqBM;IAOI,sBAAA;ExE2rqBV;EwElsqBM;IAOI,qBAAA;ExE8rqBV;EwErsqBM;IAOI,qBAAA;ExEisqBV;EwExsqBM;IAOI,qBAAA;ExEosqBV;EwE3sqBM;IAOI,sBAAA;ExEusqBV;EwE9sqBM;IAOI,sBAAA;ExE0sqBV;EwEjtqBM;IAOI,oBAAA;ExE6sqBV;EwEptqBM;IAOI,qBAAA;ExEgtqBV;EwEvtqBM;IAOI,qBAAA;ExEmtqBV;EwE1tqBM;IAOI,qBAAA;ExEstqBV;EwE7tqBM;IAOI,qBAAA;ExEytqBV;EwEhuqBM;IAOI,qBAAA;ExE4tqBV;EwEnuqBM;IAOI,qBAAA;ExE+tqBV;EwEtuqBM;IAOI,qBAAA;ExEkuqBV;EwEzuqBM;IAOI,qBAAA;ExEquqBV;EwE5uqBM;IAOI,qBAAA;ExEwuqBV;EwE/uqBM;IAOI,qBAAA;ExE2uqBV;EwElvqBM;IAOI,qBAAA;ExE8uqBV;EwErvqBM;IAOI,qBAAA;ExEivqBV;EwExvqBM;IAOI,qBAAA;ExEovqBV;EwE3vqBM;IAOI,qBAAA;ExEuvqBV;EwE9vqBM;IAOI,qBAAA;ExE0vqBV;EwEjwqBM;IAOI,sBAAA;ExE6vqBV;EwEpwqBM;IAOI,sBAAA;ExEgwqBV;EwEvwqBM;IAOI,sBAAA;ExEmwqBV;EwE1wqBM;IAOI,uBAAA;ExEswqBV;EwE7wqBM;IAOI,uBAAA;ExEywqBV;EwEhxqBM;IAOI,qBAAA;ExE4wqBV;EwEnxqBM;IAOI,sBAAA;ExE+wqBV;EwEtxqBM;IAOI,sBAAA;ExEkxqBV;EwEzxqBM;IAOI,sBAAA;ExEqxqBV;EwE5xqBM;IAOI,sBAAA;ExEwxqBV;EwE/xqBM;IAOI,sBAAA;ExE2xqBV;EwElyqBM;IAOI,sBAAA;ExE8xqBV;EwEryqBM;IAOI,sBAAA;ExEiyqBV;EwExyqBM;IAOI,sBAAA;ExEoyqBV;EwE3yqBM;IAOI,sBAAA;ExEuyqBV;EwE9yqBM;IAOI,sBAAA;ExE0yqBV;EwEjzqBM;IAOI,sBAAA;ExE6yqBV;EwEpzqBM;IAOI,sBAAA;ExEgzqBV;EwEvzqBM;IAOI,sBAAA;ExEmzqBV;EwE1zqBM;IAOI,sBAAA;ExEszqBV;EwE7zqBM;IAOI,sBAAA;ExEyzqBV;EwEh0qBM;IAOI,yBAAA;ExE4zqBV;EwEn0qBM;IAOI,8BAAA;ExE+zqBV;EwEt0qBM;IAOI,iCAAA;ExEk0qBV;EwEz0qBM;IAOI,sCAAA;ExEq0qBV;EwE50qBM;IAOI,yCAAA;ExEw0qBV;EwE/0qBM;IAOI,uBAAA;ExE20qBV;EwEl1qBM;IAOI,uBAAA;ExE80qBV;EwEr1qBM;IAOI,yBAAA;ExEi1qBV;EwEx1qBM;IAOI,yBAAA;ExEo1qBV;EwE31qBM;IAOI,0BAAA;ExEu1qBV;EwE91qBM;IAOI,4BAAA;ExE01qBV;EwEj2qBM;IAOI,kCAAA;ExE61qBV;EwEp2qBM;IAOI,sCAAA;ExEg2qBV;EwEv2qBM;IAOI,oCAAA;ExEm2qBV;EwE12qBM;IAOI,kCAAA;ExEs2qBV;EwE72qBM;IAOI,yCAAA;ExEy2qBV;EwEh3qBM;IAOI,wCAAA;ExE42qBV;EwEn3qBM;IAOI,wCAAA;ExE+2qBV;EwEt3qBM;IAOI,kCAAA;ExEk3qBV;EwEz3qBM;IAOI,gCAAA;ExEq3qBV;EwE53qBM;IAOI,8BAAA;ExEw3qBV;EwE/3qBM;IAOI,gCAAA;ExE23qBV;EwEl4qBM;IAOI,+BAAA;ExE83qBV;EwEr4qBM;IAOI,oCAAA;ExEi4qBV;EwEx4qBM;IAOI,kCAAA;ExEo4qBV;EwE34qBM;IAOI,gCAAA;ExEu4qBV;EwE94qBM;IAOI,uCAAA;ExE04qBV;EwEj5qBM;IAOI,sCAAA;ExE64qBV;EwEp5qBM;IAOI,iCAAA;ExEg5qBV;EwEv5qBM;IAOI,2BAAA;ExEm5qBV;EwE15qBM;IAOI,iCAAA;ExEs5qBV;EwE75qBM;IAOI,+BAAA;ExEy5qBV;EwEh6qBM;IAOI,6BAAA;ExE45qBV;EwEn6qBM;IAOI,+BAAA;ExE+5qBV;EwEt6qBM;IAOI,8BAAA;ExEk6qBV;EwEz6qBM;IAOI,oBAAA;ExEq6qBV;EwE56qBM;IAOI,mBAAA;ExEw6qBV;EwE/6qBM;IAOI,mBAAA;ExE26qBV;EwEl7qBM;IAOI,mBAAA;ExE86qBV;EwEr7qBM;IAOI,mBAAA;ExEi7qBV;EwEx7qBM;IAOI,mBAAA;ExEo7qBV;EwE37qBM;IAOI,mBAAA;ExEu7qBV;EwE97qBM;IAOI,mBAAA;ExE07qBV;EwEj8qBM;IAOI,oBAAA;ExE67qBV;EwEp8qBM;IAOI,0BAAA;ExEg8qBV;EwEv8qBM;IAOI,yBAAA;ExEm8qBV;EwE18qBM;IAOI,uBAAA;ExEs8qBV;EwE78qBM;IAOI,yBAAA;ExEy8qBV;EwEh9qBM;IAOI,uBAAA;ExE48qBV;EwEn9qBM;IAOI,yBAAA;ExE+8qBV;EwEt9qBM;IAOI,uBAAA;ExEk9qBV;EwEz9qBM;IAOI,uBAAA;ExEq9qBV;EwE59qBM;IAOI,wBAAA;ExEw9qBV;EwE/9qBM;IAOI,uBAAA;ExE29qBV;EwEl+qBM;IAOI,0BAAA;IAAA,yBAAA;ExE+9qBV;EwEt+qBM;IAOI,gCAAA;IAAA,+BAAA;ExEm+qBV;EwE1+qBM;IAOI,+BAAA;IAAA,8BAAA;ExEu+qBV;EwE9+qBM;IAOI,6BAAA;IAAA,4BAAA;ExE2+qBV;EwEl/qBM;IAOI,+BAAA;IAAA,8BAAA;ExE++qBV;EwEt/qBM;IAOI,6BAAA;IAAA,4BAAA;ExEm/qBV;EwE1/qBM;IAOI,+BAAA;IAAA,8BAAA;ExEu/qBV;EwE9/qBM;IAOI,6BAAA;IAAA,4BAAA;ExE2/qBV;EwElgrBM;IAOI,6BAAA;IAAA,4BAAA;ExE+/qBV;EwEtgrBM;IAOI,8BAAA;IAAA,6BAAA;ExEmgrBV;EwE1grBM;IAOI,6BAAA;IAAA,4BAAA;ExEugrBV;EwE9grBM;IAOI,wBAAA;IAAA,2BAAA;ExE2grBV;EwElhrBM;IAOI,8BAAA;IAAA,iCAAA;ExE+grBV;EwEthrBM;IAOI,6BAAA;IAAA,gCAAA;ExEmhrBV;EwE1hrBM;IAOI,2BAAA;IAAA,8BAAA;ExEuhrBV;EwE9hrBM;IAOI,6BAAA;IAAA,gCAAA;ExE2hrBV;EwElirBM;IAOI,2BAAA;IAAA,8BAAA;ExE+hrBV;EwEtirBM;IAOI,6BAAA;IAAA,gCAAA;ExEmirBV;EwE1irBM;IAOI,2BAAA;IAAA,8BAAA;ExEuirBV;EwE9irBM;IAOI,2BAAA;IAAA,8BAAA;ExE2irBV;EwEljrBM;IAOI,4BAAA;IAAA,+BAAA;ExE+irBV;EwEtjrBM;IAOI,2BAAA;IAAA,8BAAA;ExEmjrBV;EwE1jrBM;IAOI,wBAAA;ExEsjrBV;EwE7jrBM;IAOI,8BAAA;ExEyjrBV;EwEhkrBM;IAOI,6BAAA;ExE4jrBV;EwEnkrBM;IAOI,2BAAA;ExE+jrBV;EwEtkrBM;IAOI,6BAAA;ExEkkrBV;EwEzkrBM;IAOI,2BAAA;ExEqkrBV;EwE5krBM;IAOI,6BAAA;ExEwkrBV;EwE/krBM;IAOI,2BAAA;ExE2krBV;EwEllrBM;IAOI,2BAAA;ExE8krBV;EwErlrBM;IAOI,4BAAA;ExEilrBV;EwExlrBM;IAOI,2BAAA;ExEolrBV;EwE3lrBM;IAOI,0BAAA;ExEulrBV;EwE9lrBM;IAOI,gCAAA;ExE0lrBV;EwEjmrBM;IAOI,+BAAA;ExE6lrBV;EwEpmrBM;IAOI,6BAAA;ExEgmrBV;EwEvmrBM;IAOI,+BAAA;ExEmmrBV;EwE1mrBM;IAOI,6BAAA;ExEsmrBV;EwE7mrBM;IAOI,+BAAA;ExEymrBV;EwEhnrBM;IAOI,6BAAA;ExE4mrBV;EwEnnrBM;IAOI,6BAAA;ExE+mrBV;EwEtnrBM;IAOI,8BAAA;ExEknrBV;EwEznrBM;IAOI,6BAAA;ExEqnrBV;EwE5nrBM;IAOI,2BAAA;ExEwnrBV;EwE/nrBM;IAOI,iCAAA;ExE2nrBV;EwElorBM;IAOI,gCAAA;ExE8nrBV;EwErorBM;IAOI,8BAAA;ExEiorBV;EwExorBM;IAOI,gCAAA;ExEoorBV;EwE3orBM;IAOI,8BAAA;ExEuorBV;EwE9orBM;IAOI,gCAAA;ExE0orBV;EwEjprBM;IAOI,8BAAA;ExE6orBV;EwEpprBM;IAOI,8BAAA;ExEgprBV;EwEvprBM;IAOI,+BAAA;ExEmprBV;EwE1prBM;IAOI,8BAAA;ExEsprBV;EwE7prBM;IAOI,yBAAA;ExEyprBV;EwEhqrBM;IAOI,+BAAA;ExE4prBV;EwEnqrBM;IAOI,8BAAA;ExE+prBV;EwEtqrBM;IAOI,4BAAA;ExEkqrBV;EwEzqrBM;IAOI,8BAAA;ExEqqrBV;EwE5qrBM;IAOI,4BAAA;ExEwqrBV;EwE/qrBM;IAOI,8BAAA;ExE2qrBV;EwElrrBM;IAOI,4BAAA;ExE8qrBV;EwErrrBM;IAOI,4BAAA;ExEirrBV;EwExrrBM;IAOI,6BAAA;ExEorrBV;EwE3rrBM;IAOI,4BAAA;ExEurrBV;EwE9rrBM;IAOI,2BAAA;ExE0rrBV;EwEjsrBM;IAOI,0BAAA;ExE6rrBV;EwEpsrBM;IAOI,wBAAA;ExEgsrBV;EwEvsrBM;IAOI,0BAAA;ExEmsrBV;EwE1srBM;IAOI,wBAAA;ExEssrBV;EwE7srBM;IAOI,0BAAA;ExEysrBV;EwEhtrBM;IAOI,wBAAA;ExE4srBV;EwEntrBM;IAOI,wBAAA;ExE+srBV;EwEttrBM;IAOI,yBAAA;ExEktrBV;EwEztrBM;IAOI,iCAAA;IAAA,gCAAA;ExEstrBV;EwE7trBM;IAOI,gCAAA;IAAA,+BAAA;ExE0trBV;EwEjurBM;IAOI,8BAAA;IAAA,6BAAA;ExE8trBV;EwErurBM;IAOI,gCAAA;IAAA,+BAAA;ExEkurBV;EwEzurBM;IAOI,8BAAA;IAAA,6BAAA;ExEsurBV;EwE7urBM;IAOI,gCAAA;IAAA,+BAAA;ExE0urBV;EwEjvrBM;IAOI,8BAAA;IAAA,6BAAA;ExE8urBV;EwErvrBM;IAOI,8BAAA;IAAA,6BAAA;ExEkvrBV;EwEzvrBM;IAOI,+BAAA;IAAA,8BAAA;ExEsvrBV;EwE7vrBM;IAOI,+BAAA;IAAA,kCAAA;ExE0vrBV;EwEjwrBM;IAOI,8BAAA;IAAA,iCAAA;ExE8vrBV;EwErwrBM;IAOI,4BAAA;IAAA,+BAAA;ExEkwrBV;EwEzwrBM;IAOI,8BAAA;IAAA,iCAAA;ExEswrBV;EwE7wrBM;IAOI,4BAAA;IAAA,+BAAA;ExE0wrBV;EwEjxrBM;IAOI,8BAAA;IAAA,iCAAA;ExE8wrBV;EwErxrBM;IAOI,4BAAA;IAAA,+BAAA;ExEkxrBV;EwEzxrBM;IAOI,4BAAA;IAAA,+BAAA;ExEsxrBV;EwE7xrBM;IAOI,6BAAA;IAAA,gCAAA;ExE0xrBV;EwEjyrBM;IAOI,+BAAA;ExE6xrBV;EwEpyrBM;IAOI,8BAAA;ExEgyrBV;EwEvyrBM;IAOI,4BAAA;ExEmyrBV;EwE1yrBM;IAOI,8BAAA;ExEsyrBV;EwE7yrBM;IAOI,4BAAA;ExEyyrBV;EwEhzrBM;IAOI,8BAAA;ExE4yrBV;EwEnzrBM;IAOI,4BAAA;ExE+yrBV;EwEtzrBM;IAOI,4BAAA;ExEkzrBV;EwEzzrBM;IAOI,6BAAA;ExEqzrBV;EwE5zrBM;IAOI,iCAAA;ExEwzrBV;EwE/zrBM;IAOI,gCAAA;ExE2zrBV;EwEl0rBM;IAOI,8BAAA;ExE8zrBV;EwEr0rBM;IAOI,gCAAA;ExEi0rBV;EwEx0rBM;IAOI,8BAAA;ExEo0rBV;EwE30rBM;IAOI,gCAAA;ExEu0rBV;EwE90rBM;IAOI,8BAAA;ExE00rBV;EwEj1rBM;IAOI,8BAAA;ExE60rBV;EwEp1rBM;IAOI,+BAAA;ExEg1rBV;EwEv1rBM;IAOI,kCAAA;ExEm1rBV;EwE11rBM;IAOI,iCAAA;ExEs1rBV;EwE71rBM;IAOI,+BAAA;ExEy1rBV;EwEh2rBM;IAOI,iCAAA;ExE41rBV;EwEn2rBM;IAOI,+BAAA;ExE+1rBV;EwEt2rBM;IAOI,iCAAA;ExEk2rBV;EwEz2rBM;IAOI,+BAAA;ExEq2rBV;EwE52rBM;IAOI,+BAAA;ExEw2rBV;EwE/2rBM;IAOI,gCAAA;ExE22rBV;EwEl3rBM;IAOI,gCAAA;ExE82rBV;EwEr3rBM;IAOI,+BAAA;ExEi3rBV;EwEx3rBM;IAOI,6BAAA;ExEo3rBV;EwE33rBM;IAOI,+BAAA;ExEu3rBV;EwE93rBM;IAOI,6BAAA;ExE03rBV;EwEj4rBM;IAOI,+BAAA;ExE63rBV;EwEp4rBM;IAOI,6BAAA;ExEg4rBV;EwEv4rBM;IAOI,6BAAA;ExEm4rBV;EwE14rBM;IAOI,8BAAA;ExEs4rBV;EwE74rBM;IAOI,qBAAA;ExEy4rBV;EwEh5rBM;IAOI,2BAAA;ExE44rBV;EwEn5rBM;IAOI,0BAAA;ExE+4rBV;EwEt5rBM;IAOI,wBAAA;ExEk5rBV;EwEz5rBM;IAOI,0BAAA;ExEq5rBV;EwE55rBM;IAOI,wBAAA;ExEw5rBV;EwE/5rBM;IAOI,0BAAA;ExE25rBV;EwEl6rBM;IAOI,wBAAA;ExE85rBV;EwEr6rBM;IAOI,wBAAA;ExEi6rBV;EwEx6rBM;IAOI,yBAAA;ExEo6rBV;EwE36rBM;IAOI,2BAAA;IAAA,0BAAA;ExEw6rBV;EwE/6rBM;IAOI,iCAAA;IAAA,gCAAA;ExE46rBV;EwEn7rBM;IAOI,gCAAA;IAAA,+BAAA;ExEg7rBV;EwEv7rBM;IAOI,8BAAA;IAAA,6BAAA;ExEo7rBV;EwE37rBM;IAOI,gCAAA;IAAA,+BAAA;ExEw7rBV;EwE/7rBM;IAOI,8BAAA;IAAA,6BAAA;ExE47rBV;EwEn8rBM;IAOI,gCAAA;IAAA,+BAAA;ExEg8rBV;EwEv8rBM;IAOI,8BAAA;IAAA,6BAAA;ExEo8rBV;EwE38rBM;IAOI,8BAAA;IAAA,6BAAA;ExEw8rBV;EwE/8rBM;IAOI,+BAAA;IAAA,8BAAA;ExE48rBV;EwEn9rBM;IAOI,yBAAA;IAAA,4BAAA;ExEg9rBV;EwEv9rBM;IAOI,+BAAA;IAAA,kCAAA;ExEo9rBV;EwE39rBM;IAOI,8BAAA;IAAA,iCAAA;ExEw9rBV;EwE/9rBM;IAOI,4BAAA;IAAA,+BAAA;ExE49rBV;EwEn+rBM;IAOI,8BAAA;IAAA,iCAAA;ExEg+rBV;EwEv+rBM;IAOI,4BAAA;IAAA,+BAAA;ExEo+rBV;EwE3+rBM;IAOI,8BAAA;IAAA,iCAAA;ExEw+rBV;EwE/+rBM;IAOI,4BAAA;IAAA,+BAAA;ExE4+rBV;EwEn/rBM;IAOI,4BAAA;IAAA,+BAAA;ExEg/rBV;EwEv/rBM;IAOI,6BAAA;IAAA,gCAAA;ExEo/rBV;EwE3/rBM;IAOI,yBAAA;ExEu/rBV;EwE9/rBM;IAOI,+BAAA;ExE0/rBV;EwEjgsBM;IAOI,8BAAA;ExE6/rBV;EwEpgsBM;IAOI,4BAAA;ExEggsBV;EwEvgsBM;IAOI,8BAAA;ExEmgsBV;EwE1gsBM;IAOI,4BAAA;ExEsgsBV;EwE7gsBM;IAOI,8BAAA;ExEygsBV;EwEhhsBM;IAOI,4BAAA;ExE4gsBV;EwEnhsBM;IAOI,4BAAA;ExE+gsBV;EwEthsBM;IAOI,6BAAA;ExEkhsBV;EwEzhsBM;IAOI,2BAAA;ExEqhsBV;EwE5hsBM;IAOI,iCAAA;ExEwhsBV;EwE/hsBM;IAOI,gCAAA;ExE2hsBV;EwElisBM;IAOI,8BAAA;ExE8hsBV;EwErisBM;IAOI,gCAAA;ExEiisBV;EwExisBM;IAOI,8BAAA;ExEoisBV;EwE3isBM;IAOI,gCAAA;ExEuisBV;EwE9isBM;IAOI,8BAAA;ExE0isBV;EwEjjsBM;IAOI,8BAAA;ExE6isBV;EwEpjsBM;IAOI,+BAAA;ExEgjsBV;EwEvjsBM;IAOI,4BAAA;ExEmjsBV;EwE1jsBM;IAOI,kCAAA;ExEsjsBV;EwE7jsBM;IAOI,iCAAA;ExEyjsBV;EwEhksBM;IAOI,+BAAA;ExE4jsBV;EwEnksBM;IAOI,iCAAA;ExE+jsBV;EwEtksBM;IAOI,+BAAA;ExEkksBV;EwEzksBM;IAOI,iCAAA;ExEqksBV;EwE5ksBM;IAOI,+BAAA;ExEwksBV;EwE/ksBM;IAOI,+BAAA;ExE2ksBV;EwEllsBM;IAOI,gCAAA;ExE8ksBV;EwErlsBM;IAOI,0BAAA;ExEilsBV;EwExlsBM;IAOI,gCAAA;ExEolsBV;EwE3lsBM;IAOI,+BAAA;ExEulsBV;EwE9lsBM;IAOI,6BAAA;ExE0lsBV;EwEjmsBM;IAOI,+BAAA;ExE6lsBV;EwEpmsBM;IAOI,6BAAA;ExEgmsBV;EwEvmsBM;IAOI,+BAAA;ExEmmsBV;EwE1msBM;IAOI,6BAAA;ExEsmsBV;EwE7msBM;IAOI,6BAAA;ExEymsBV;EwEhnsBM;IAOI,8BAAA;ExE4msBV;EwEnnsBM;IAOI,iBAAA;ExE+msBV;EwEtnsBM;IAOI,uBAAA;ExEknsBV;EwEznsBM;IAOI,sBAAA;ExEqnsBV;EwE5nsBM;IAOI,oBAAA;ExEwnsBV;EwE/nsBM;IAOI,sBAAA;ExE2nsBV;EwElosBM;IAOI,oBAAA;ExE8nsBV;EwErosBM;IAOI,sBAAA;ExEiosBV;EwExosBM;IAOI,oBAAA;ExEoosBV;EwE3osBM;IAOI,oBAAA;ExEuosBV;EwE9osBM;IAOI,qBAAA;ExE0osBV;EwEjpsBM;IAOI,qBAAA;ExE6osBV;EwEppsBM;IAOI,2BAAA;ExEgpsBV;EwEvpsBM;IAOI,0BAAA;ExEmpsBV;EwE1psBM;IAOI,wBAAA;ExEspsBV;EwE7psBM;IAOI,0BAAA;ExEypsBV;EwEhqsBM;IAOI,wBAAA;ExE4psBV;EwEnqsBM;IAOI,0BAAA;ExE+psBV;EwEtqsBM;IAOI,wBAAA;ExEkqsBV;EwEzqsBM;IAOI,wBAAA;ExEqqsBV;EwE5qsBM;IAOI,yBAAA;ExEwqsBV;EwE/qsBM;IAOI,wBAAA;ExE2qsBV;EwElrsBM;IAOI,8BAAA;ExE8qsBV;EwErrsBM;IAOI,6BAAA;ExEirsBV;EwExrsBM;IAOI,2BAAA;ExEorsBV;EwE3rsBM;IAOI,6BAAA;ExEursBV;EwE9rsBM;IAOI,2BAAA;ExE0rsBV;EwEjssBM;IAOI,6BAAA;ExE6rsBV;EwEpssBM;IAOI,2BAAA;ExEgssBV;EwEvssBM;IAOI,2BAAA;ExEmssBV;EwE1ssBM;IAOI,4BAAA;ExEsssBV;EwE7ssBM;IAOI,8CAAA;ExEyssBV;EwEhtsBM;IAOI,6CAAA;ExE4ssBV;EwEntsBM;IAOI,gDAAA;ExE+ssBV;EwEttsBM;IAOI,8CAAA;ExEktsBV;EwEztsBM;IAOI,gDAAA;ExEqtsBV;EwE5tsBM;IAOI,6BAAA;ExEwtsBV;EwE/tsBM;IAOI,2BAAA;ExE2tsBV;EwElusBM;IAOI,4BAAA;ExE8tsBV;EwErusBM;IAOI,6BAAA;ExEiusBV;EwExusBM;IAIQ,oBAAA;IAGJ,qEAAA;ExEqusBV;EwE5usBM;IAIQ,oBAAA;IAGJ,uEAAA;ExEyusBV;EwEhvsBM;IAIQ,oBAAA;IAGJ,qEAAA;ExE6usBV;EwEpvsBM;IAIQ,oBAAA;IAGJ,kEAAA;ExEivsBV;EwExvsBM;IAIQ,oBAAA;IAGJ,qEAAA;ExEqvsBV;EwE5vsBM;IAIQ,oBAAA;IAGJ,oEAAA;ExEyvsBV;EwEhwsBM;IAIQ,oBAAA;IAGJ,mEAAA;ExE6vsBV;EwEpwsBM;IAIQ,oBAAA;IAGJ,kEAAA;ExEiwsBV;EwExwsBM;IAIQ,oBAAA;IAGJ,mEAAA;ExEqwsBV;EwE5wsBM;IAIQ,oBAAA;IAGJ,mEAAA;ExEywsBV;EwEhxsBM;IAIQ,oBAAA;IAGJ,wEAAA;ExE6wsBV;EwEpxsBM;IAIQ,oBAAA;IAGJ,2CAAA;ExEixsBV;EwExxsBM;IAIQ,oBAAA;IAGJ,oCAAA;ExEqxsBV;EwE5xsBM;IAIQ,oBAAA;IAGJ,0CAAA;ExEyxsBV;EwEhysBM;IAIQ,oBAAA;IAGJ,2CAAA;ExE6xsBV;EwEpysBM;IAIQ,oBAAA;IAGJ,0CAAA;ExEiysBV;EwExysBM;IAIQ,oBAAA;IAGJ,0CAAA;ExEqysBV;EwE5ysBM;IAIQ,oBAAA;IAGJ,yBAAA;ExEyysBV;AACF;AMpzsBI;EkEGI;IAOI,sBAAA;ExE8ysBV;EwErzsBM;IAOI,uBAAA;ExEizsBV;EwExzsBM;IAOI,sBAAA;ExEozsBV;EwE3zsBM;IAOI,8BAAA;ExEuzsBV;EwE9zsBM;IAOI,4BAAA;ExE0zsBV;EwEj0sBM;IAOI,2BAAA;ExE6zsBV;EwEp0sBM;IAOI,iCAAA;ExEg0sBV;EwEv0sBM;IAOI,2BAAA;ExEm0sBV;EwE10sBM;IAOI,qBAAA;ExEs0sBV;EwE70sBM;IAOI,wBAAA;ExEy0sBV;EwEh1sBM;IAOI,uBAAA;ExE40sBV;EwEn1sBM;IAOI,wBAAA;ExE+0sBV;EwEt1sBM;IAOI,qBAAA;ExEk1sBV;EwEz1sBM;IAOI,uBAAA;ExEq1sBV;EwE51sBM;IAOI,uBAAA;ExEw1sBV;EwE/1sBM;IAOI,wBAAA;ExE21sBV;EwEl2sBM;IAOI,uBAAA;ExE81sBV;EwEr2sBM;IAOI,uBAAA;ExEi2sBV;EwEx2sBM;IAOI,wBAAA;ExEo2sBV;EwE32sBM;IAOI,uBAAA;ExEu2sBV;EwE92sBM;IAOI,wBAAA;ExE02sBV;EwEj3sBM;IAOI,uBAAA;ExE62sBV;EwEp3sBM;IAOI,wBAAA;ExEg3sBV;EwEv3sBM;IAOI,uBAAA;ExEm3sBV;EwE13sBM;IAOI,uBAAA;ExEs3sBV;EwE73sBM;IAOI,wBAAA;ExEy3sBV;EwEh4sBM;IAOI,uBAAA;ExE43sBV;EwEn4sBM;IAOI,wBAAA;ExE+3sBV;EwEt4sBM;IAOI,0BAAA;ExEk4sBV;EwEz4sBM;IAOI,gCAAA;ExEq4sBV;EwE54sBM;IAOI,yBAAA;ExEw4sBV;EwE/4sBM;IAOI,wBAAA;ExE24sBV;EwEl5sBM;IAOI,+BAAA;ExE84sBV;EwEr5sBM;IAOI,yBAAA;ExEi5sBV;EwEx5sBM;IAOI,6BAAA;ExEo5sBV;EwE35sBM;IAOI,8BAAA;ExEu5sBV;EwE95sBM;IAOI,wBAAA;ExE05sBV;EwEj6sBM;IAOI,+BAAA;ExE65sBV;EwEp6sBM;IAOI,wBAAA;ExEg6sBV;EwEv6sBM;IAOI,iBAAA;ExEm6sBV;EwE16sBM;IAOI,mBAAA;ExEs6sBV;EwE76sBM;IAOI,oBAAA;ExEy6sBV;EwEh7sBM;IAOI,kBAAA;ExE46sBV;EwEn7sBM;IAOI,kBAAA;ExE+6sBV;EwEt7sBM;IAOI,kBAAA;ExEk7sBV;EwEz7sBM;IAOI,kBAAA;ExEq7sBV;EwE57sBM;IAOI,kBAAA;ExEw7sBV;EwE/7sBM;IAOI,mBAAA;ExE27sBV;EwEl8sBM;IAOI,mBAAA;ExE87sBV;EwEr8sBM;IAOI,mBAAA;ExEi8sBV;EwEx8sBM;IAOI,mBAAA;ExEo8sBV;EwE38sBM;IAOI,mBAAA;ExEu8sBV;EwE98sBM;IAOI,mBAAA;ExE08sBV;EwEj9sBM;IAOI,mBAAA;ExE68sBV;EwEp9sBM;IAOI,mBAAA;ExEg9sBV;EwEv9sBM;IAOI,mBAAA;ExEm9sBV;EwE19sBM;IAOI,mBAAA;ExEs9sBV;EwE79sBM;IAOI,mBAAA;ExEy9sBV;EwEh+sBM;IAOI,mBAAA;ExE49sBV;EwEn+sBM;IAOI,mBAAA;ExE+9sBV;EwEt+sBM;IAOI,mBAAA;ExEk+sBV;EwEz+sBM;IAOI,mBAAA;ExEq+sBV;EwE5+sBM;IAOI,mBAAA;ExEw+sBV;EwE/+sBM;IAOI,mBAAA;ExE2+sBV;EwEl/sBM;IAOI,oBAAA;ExE8+sBV;EwEr/sBM;IAOI,oBAAA;ExEi/sBV;EwEx/sBM;IAOI,sBAAA;ExEo/sBV;EwE3/sBM;IAOI,uBAAA;ExEu/sBV;EwE9/sBM;IAOI,qBAAA;ExE0/sBV;EwEjgtBM;IAOI,qBAAA;ExE6/sBV;EwEpgtBM;IAOI,qBAAA;ExEggtBV;EwEvgtBM;IAOI,qBAAA;ExEmgtBV;EwE1gtBM;IAOI,qBAAA;ExEsgtBV;EwE7gtBM;IAOI,sBAAA;ExEygtBV;EwEhhtBM;IAOI,sBAAA;ExE4gtBV;EwEnhtBM;IAOI,sBAAA;ExE+gtBV;EwEthtBM;IAOI,sBAAA;ExEkhtBV;EwEzhtBM;IAOI,sBAAA;ExEqhtBV;EwE5htBM;IAOI,sBAAA;ExEwhtBV;EwE/htBM;IAOI,sBAAA;ExE2htBV;EwElitBM;IAOI,sBAAA;ExE8htBV;EwEritBM;IAOI,sBAAA;ExEiitBV;EwExitBM;IAOI,sBAAA;ExEoitBV;EwE3itBM;IAOI,sBAAA;ExEuitBV;EwE9itBM;IAOI,sBAAA;ExE0itBV;EwEjjtBM;IAOI,sBAAA;ExE6itBV;EwEpjtBM;IAOI,sBAAA;ExEgjtBV;EwEvjtBM;IAOI,sBAAA;ExEmjtBV;EwE1jtBM;IAOI,sBAAA;ExEsjtBV;EwE7jtBM;IAOI,sBAAA;ExEyjtBV;EwEhktBM;IAOI,uBAAA;ExE4jtBV;EwEnktBM;IAOI,kBAAA;ExE+jtBV;EwEtktBM;IAOI,oBAAA;ExEkktBV;EwEzktBM;IAOI,qBAAA;ExEqktBV;EwE5ktBM;IAOI,mBAAA;ExEwktBV;EwE/ktBM;IAOI,mBAAA;ExE2ktBV;EwElltBM;IAOI,mBAAA;ExE8ktBV;EwErltBM;IAOI,mBAAA;ExEiltBV;EwExltBM;IAOI,mBAAA;ExEoltBV;EwE3ltBM;IAOI,oBAAA;ExEultBV;EwE9ltBM;IAOI,oBAAA;ExE0ltBV;EwEjmtBM;IAOI,oBAAA;ExE6ltBV;EwEpmtBM;IAOI,oBAAA;ExEgmtBV;EwEvmtBM;IAOI,oBAAA;ExEmmtBV;EwE1mtBM;IAOI,oBAAA;ExEsmtBV;EwE7mtBM;IAOI,oBAAA;ExEymtBV;EwEhntBM;IAOI,oBAAA;ExE4mtBV;EwEnntBM;IAOI,oBAAA;ExE+mtBV;EwEtntBM;IAOI,oBAAA;ExEkntBV;EwEzntBM;IAOI,oBAAA;ExEqntBV;EwE5ntBM;IAOI,oBAAA;ExEwntBV;EwE/ntBM;IAOI,oBAAA;ExE2ntBV;EwElotBM;IAOI,oBAAA;ExE8ntBV;EwErotBM;IAOI,oBAAA;ExEiotBV;EwExotBM;IAOI,oBAAA;ExEootBV;EwE3otBM;IAOI,oBAAA;ExEuotBV;EwE9otBM;IAOI,qBAAA;ExE0otBV;EwEjptBM;IAOI,mBAAA;ExE6otBV;EwEpptBM;IAOI,qBAAA;ExEgptBV;EwEvptBM;IAOI,sBAAA;ExEmptBV;EwE1ptBM;IAOI,oBAAA;ExEsptBV;EwE7ptBM;IAOI,oBAAA;ExEyptBV;EwEhqtBM;IAOI,oBAAA;ExE4ptBV;EwEnqtBM;IAOI,oBAAA;ExE+ptBV;EwEtqtBM;IAOI,oBAAA;ExEkqtBV;EwEzqtBM;IAOI,qBAAA;ExEqqtBV;EwE5qtBM;IAOI,qBAAA;ExEwqtBV;EwE/qtBM;IAOI,qBAAA;ExE2qtBV;EwElrtBM;IAOI,qBAAA;ExE8qtBV;EwErrtBM;IAOI,qBAAA;ExEirtBV;EwExrtBM;IAOI,qBAAA;ExEortBV;EwE3rtBM;IAOI,qBAAA;ExEurtBV;EwE9rtBM;IAOI,qBAAA;ExE0rtBV;EwEjstBM;IAOI,qBAAA;ExE6rtBV;EwEpstBM;IAOI,qBAAA;ExEgstBV;EwEvstBM;IAOI,qBAAA;ExEmstBV;EwE1stBM;IAOI,qBAAA;ExEsstBV;EwE7stBM;IAOI,qBAAA;ExEystBV;EwEhttBM;IAOI,qBAAA;ExE4stBV;EwEnttBM;IAOI,qBAAA;ExE+stBV;EwEtttBM;IAOI,qBAAA;ExEkttBV;EwEzttBM;IAOI,qBAAA;ExEqttBV;EwE5ttBM;IAOI,sBAAA;ExEwttBV;EwE/ttBM;IAOI,qBAAA;ExE2ttBV;EwElutBM;IAOI,qBAAA;ExE8ttBV;EwErutBM;IAOI,qBAAA;ExEiutBV;EwExutBM;IAOI,sBAAA;ExEoutBV;EwE3utBM;IAOI,sBAAA;ExEuutBV;EwE9utBM;IAOI,oBAAA;ExE0utBV;EwEjvtBM;IAOI,qBAAA;ExE6utBV;EwEpvtBM;IAOI,qBAAA;ExEgvtBV;EwEvvtBM;IAOI,qBAAA;ExEmvtBV;EwE1vtBM;IAOI,qBAAA;ExEsvtBV;EwE7vtBM;IAOI,qBAAA;ExEyvtBV;EwEhwtBM;IAOI,qBAAA;ExE4vtBV;EwEnwtBM;IAOI,qBAAA;ExE+vtBV;EwEtwtBM;IAOI,qBAAA;ExEkwtBV;EwEzwtBM;IAOI,qBAAA;ExEqwtBV;EwE5wtBM;IAOI,qBAAA;ExEwwtBV;EwE/wtBM;IAOI,qBAAA;ExE2wtBV;EwElxtBM;IAOI,qBAAA;ExE8wtBV;EwErxtBM;IAOI,qBAAA;ExEixtBV;EwExxtBM;IAOI,qBAAA;ExEoxtBV;EwE3xtBM;IAOI,qBAAA;ExEuxtBV;EwE9xtBM;IAOI,sBAAA;ExE0xtBV;EwEjytBM;IAOI,sBAAA;ExE6xtBV;EwEpytBM;IAOI,sBAAA;ExEgytBV;EwEvytBM;IAOI,uBAAA;ExEmytBV;EwE1ytBM;IAOI,uBAAA;ExEsytBV;EwE7ytBM;IAOI,qBAAA;ExEyytBV;EwEhztBM;IAOI,sBAAA;ExE4ytBV;EwEnztBM;IAOI,sBAAA;ExE+ytBV;EwEtztBM;IAOI,sBAAA;ExEkztBV;EwEzztBM;IAOI,sBAAA;ExEqztBV;EwE5ztBM;IAOI,sBAAA;ExEwztBV;EwE/ztBM;IAOI,sBAAA;ExE2ztBV;EwEl0tBM;IAOI,sBAAA;ExE8ztBV;EwEr0tBM;IAOI,sBAAA;ExEi0tBV;EwEx0tBM;IAOI,sBAAA;ExEo0tBV;EwE30tBM;IAOI,sBAAA;ExEu0tBV;EwE90tBM;IAOI,sBAAA;ExE00tBV;EwEj1tBM;IAOI,sBAAA;ExE60tBV;EwEp1tBM;IAOI,sBAAA;ExEg1tBV;EwEv1tBM;IAOI,sBAAA;ExEm1tBV;EwE11tBM;IAOI,sBAAA;ExEs1tBV;EwE71tBM;IAOI,yBAAA;ExEy1tBV;EwEh2tBM;IAOI,8BAAA;ExE41tBV;EwEn2tBM;IAOI,iCAAA;ExE+1tBV;EwEt2tBM;IAOI,sCAAA;ExEk2tBV;EwEz2tBM;IAOI,yCAAA;ExEq2tBV;EwE52tBM;IAOI,uBAAA;ExEw2tBV;EwE/2tBM;IAOI,uBAAA;ExE22tBV;EwEl3tBM;IAOI,yBAAA;ExE82tBV;EwEr3tBM;IAOI,yBAAA;ExEi3tBV;EwEx3tBM;IAOI,0BAAA;ExEo3tBV;EwE33tBM;IAOI,4BAAA;ExEu3tBV;EwE93tBM;IAOI,kCAAA;ExE03tBV;EwEj4tBM;IAOI,sCAAA;ExE63tBV;EwEp4tBM;IAOI,oCAAA;ExEg4tBV;EwEv4tBM;IAOI,kCAAA;ExEm4tBV;EwE14tBM;IAOI,yCAAA;ExEs4tBV;EwE74tBM;IAOI,wCAAA;ExEy4tBV;EwEh5tBM;IAOI,wCAAA;ExE44tBV;EwEn5tBM;IAOI,kCAAA;ExE+4tBV;EwEt5tBM;IAOI,gCAAA;ExEk5tBV;EwEz5tBM;IAOI,8BAAA;ExEq5tBV;EwE55tBM;IAOI,gCAAA;ExEw5tBV;EwE/5tBM;IAOI,+BAAA;ExE25tBV;EwEl6tBM;IAOI,oCAAA;ExE85tBV;EwEr6tBM;IAOI,kCAAA;ExEi6tBV;EwEx6tBM;IAOI,gCAAA;ExEo6tBV;EwE36tBM;IAOI,uCAAA;ExEu6tBV;EwE96tBM;IAOI,sCAAA;ExE06tBV;EwEj7tBM;IAOI,iCAAA;ExE66tBV;EwEp7tBM;IAOI,2BAAA;ExEg7tBV;EwEv7tBM;IAOI,iCAAA;ExEm7tBV;EwE17tBM;IAOI,+BAAA;ExEs7tBV;EwE77tBM;IAOI,6BAAA;ExEy7tBV;EwEh8tBM;IAOI,+BAAA;ExE47tBV;EwEn8tBM;IAOI,8BAAA;ExE+7tBV;EwEt8tBM;IAOI,oBAAA;ExEk8tBV;EwEz8tBM;IAOI,mBAAA;ExEq8tBV;EwE58tBM;IAOI,mBAAA;ExEw8tBV;EwE/8tBM;IAOI,mBAAA;ExE28tBV;EwEl9tBM;IAOI,mBAAA;ExE88tBV;EwEr9tBM;IAOI,mBAAA;ExEi9tBV;EwEx9tBM;IAOI,mBAAA;ExEo9tBV;EwE39tBM;IAOI,mBAAA;ExEu9tBV;EwE99tBM;IAOI,oBAAA;ExE09tBV;EwEj+tBM;IAOI,0BAAA;ExE69tBV;EwEp+tBM;IAOI,yBAAA;ExEg+tBV;EwEv+tBM;IAOI,uBAAA;ExEm+tBV;EwE1+tBM;IAOI,yBAAA;ExEs+tBV;EwE7+tBM;IAOI,uBAAA;ExEy+tBV;EwEh/tBM;IAOI,yBAAA;ExE4+tBV;EwEn/tBM;IAOI,uBAAA;ExE++tBV;EwEt/tBM;IAOI,uBAAA;ExEk/tBV;EwEz/tBM;IAOI,wBAAA;ExEq/tBV;EwE5/tBM;IAOI,uBAAA;ExEw/tBV;EwE//tBM;IAOI,0BAAA;IAAA,yBAAA;ExE4/tBV;EwEnguBM;IAOI,gCAAA;IAAA,+BAAA;ExEgguBV;EwEvguBM;IAOI,+BAAA;IAAA,8BAAA;ExEoguBV;EwE3guBM;IAOI,6BAAA;IAAA,4BAAA;ExEwguBV;EwE/guBM;IAOI,+BAAA;IAAA,8BAAA;ExE4guBV;EwEnhuBM;IAOI,6BAAA;IAAA,4BAAA;ExEghuBV;EwEvhuBM;IAOI,+BAAA;IAAA,8BAAA;ExEohuBV;EwE3huBM;IAOI,6BAAA;IAAA,4BAAA;ExEwhuBV;EwE/huBM;IAOI,6BAAA;IAAA,4BAAA;ExE4huBV;EwEniuBM;IAOI,8BAAA;IAAA,6BAAA;ExEgiuBV;EwEviuBM;IAOI,6BAAA;IAAA,4BAAA;ExEoiuBV;EwE3iuBM;IAOI,wBAAA;IAAA,2BAAA;ExEwiuBV;EwE/iuBM;IAOI,8BAAA;IAAA,iCAAA;ExE4iuBV;EwEnjuBM;IAOI,6BAAA;IAAA,gCAAA;ExEgjuBV;EwEvjuBM;IAOI,2BAAA;IAAA,8BAAA;ExEojuBV;EwE3juBM;IAOI,6BAAA;IAAA,gCAAA;ExEwjuBV;EwE/juBM;IAOI,2BAAA;IAAA,8BAAA;ExE4juBV;EwEnkuBM;IAOI,6BAAA;IAAA,gCAAA;ExEgkuBV;EwEvkuBM;IAOI,2BAAA;IAAA,8BAAA;ExEokuBV;EwE3kuBM;IAOI,2BAAA;IAAA,8BAAA;ExEwkuBV;EwE/kuBM;IAOI,4BAAA;IAAA,+BAAA;ExE4kuBV;EwEnluBM;IAOI,2BAAA;IAAA,8BAAA;ExEgluBV;EwEvluBM;IAOI,wBAAA;ExEmluBV;EwE1luBM;IAOI,8BAAA;ExEsluBV;EwE7luBM;IAOI,6BAAA;ExEyluBV;EwEhmuBM;IAOI,2BAAA;ExE4luBV;EwEnmuBM;IAOI,6BAAA;ExE+luBV;EwEtmuBM;IAOI,2BAAA;ExEkmuBV;EwEzmuBM;IAOI,6BAAA;ExEqmuBV;EwE5muBM;IAOI,2BAAA;ExEwmuBV;EwE/muBM;IAOI,2BAAA;ExE2muBV;EwElnuBM;IAOI,4BAAA;ExE8muBV;EwErnuBM;IAOI,2BAAA;ExEinuBV;EwExnuBM;IAOI,0BAAA;ExEonuBV;EwE3nuBM;IAOI,gCAAA;ExEunuBV;EwE9nuBM;IAOI,+BAAA;ExE0nuBV;EwEjouBM;IAOI,6BAAA;ExE6nuBV;EwEpouBM;IAOI,+BAAA;ExEgouBV;EwEvouBM;IAOI,6BAAA;ExEmouBV;EwE1ouBM;IAOI,+BAAA;ExEsouBV;EwE7ouBM;IAOI,6BAAA;ExEyouBV;EwEhpuBM;IAOI,6BAAA;ExE4ouBV;EwEnpuBM;IAOI,8BAAA;ExE+ouBV;EwEtpuBM;IAOI,6BAAA;ExEkpuBV;EwEzpuBM;IAOI,2BAAA;ExEqpuBV;EwE5puBM;IAOI,iCAAA;ExEwpuBV;EwE/puBM;IAOI,gCAAA;ExE2puBV;EwElquBM;IAOI,8BAAA;ExE8puBV;EwErquBM;IAOI,gCAAA;ExEiquBV;EwExquBM;IAOI,8BAAA;ExEoquBV;EwE3quBM;IAOI,gCAAA;ExEuquBV;EwE9quBM;IAOI,8BAAA;ExE0quBV;EwEjruBM;IAOI,8BAAA;ExE6quBV;EwEpruBM;IAOI,+BAAA;ExEgruBV;EwEvruBM;IAOI,8BAAA;ExEmruBV;EwE1ruBM;IAOI,yBAAA;ExEsruBV;EwE7ruBM;IAOI,+BAAA;ExEyruBV;EwEhsuBM;IAOI,8BAAA;ExE4ruBV;EwEnsuBM;IAOI,4BAAA;ExE+ruBV;EwEtsuBM;IAOI,8BAAA;ExEksuBV;EwEzsuBM;IAOI,4BAAA;ExEqsuBV;EwE5suBM;IAOI,8BAAA;ExEwsuBV;EwE/suBM;IAOI,4BAAA;ExE2suBV;EwEltuBM;IAOI,4BAAA;ExE8suBV;EwErtuBM;IAOI,6BAAA;ExEituBV;EwExtuBM;IAOI,4BAAA;ExEotuBV;EwE3tuBM;IAOI,2BAAA;ExEutuBV;EwE9tuBM;IAOI,0BAAA;ExE0tuBV;EwEjuuBM;IAOI,wBAAA;ExE6tuBV;EwEpuuBM;IAOI,0BAAA;ExEguuBV;EwEvuuBM;IAOI,wBAAA;ExEmuuBV;EwE1uuBM;IAOI,0BAAA;ExEsuuBV;EwE7uuBM;IAOI,wBAAA;ExEyuuBV;EwEhvuBM;IAOI,wBAAA;ExE4uuBV;EwEnvuBM;IAOI,yBAAA;ExE+uuBV;EwEtvuBM;IAOI,iCAAA;IAAA,gCAAA;ExEmvuBV;EwE1vuBM;IAOI,gCAAA;IAAA,+BAAA;ExEuvuBV;EwE9vuBM;IAOI,8BAAA;IAAA,6BAAA;ExE2vuBV;EwElwuBM;IAOI,gCAAA;IAAA,+BAAA;ExE+vuBV;EwEtwuBM;IAOI,8BAAA;IAAA,6BAAA;ExEmwuBV;EwE1wuBM;IAOI,gCAAA;IAAA,+BAAA;ExEuwuBV;EwE9wuBM;IAOI,8BAAA;IAAA,6BAAA;ExE2wuBV;EwElxuBM;IAOI,8BAAA;IAAA,6BAAA;ExE+wuBV;EwEtxuBM;IAOI,+BAAA;IAAA,8BAAA;ExEmxuBV;EwE1xuBM;IAOI,+BAAA;IAAA,kCAAA;ExEuxuBV;EwE9xuBM;IAOI,8BAAA;IAAA,iCAAA;ExE2xuBV;EwElyuBM;IAOI,4BAAA;IAAA,+BAAA;ExE+xuBV;EwEtyuBM;IAOI,8BAAA;IAAA,iCAAA;ExEmyuBV;EwE1yuBM;IAOI,4BAAA;IAAA,+BAAA;ExEuyuBV;EwE9yuBM;IAOI,8BAAA;IAAA,iCAAA;ExE2yuBV;EwElzuBM;IAOI,4BAAA;IAAA,+BAAA;ExE+yuBV;EwEtzuBM;IAOI,4BAAA;IAAA,+BAAA;ExEmzuBV;EwE1zuBM;IAOI,6BAAA;IAAA,gCAAA;ExEuzuBV;EwE9zuBM;IAOI,+BAAA;ExE0zuBV;EwEj0uBM;IAOI,8BAAA;ExE6zuBV;EwEp0uBM;IAOI,4BAAA;ExEg0uBV;EwEv0uBM;IAOI,8BAAA;ExEm0uBV;EwE10uBM;IAOI,4BAAA;ExEs0uBV;EwE70uBM;IAOI,8BAAA;ExEy0uBV;EwEh1uBM;IAOI,4BAAA;ExE40uBV;EwEn1uBM;IAOI,4BAAA;ExE+0uBV;EwEt1uBM;IAOI,6BAAA;ExEk1uBV;EwEz1uBM;IAOI,iCAAA;ExEq1uBV;EwE51uBM;IAOI,gCAAA;ExEw1uBV;EwE/1uBM;IAOI,8BAAA;ExE21uBV;EwEl2uBM;IAOI,gCAAA;ExE81uBV;EwEr2uBM;IAOI,8BAAA;ExEi2uBV;EwEx2uBM;IAOI,gCAAA;ExEo2uBV;EwE32uBM;IAOI,8BAAA;ExEu2uBV;EwE92uBM;IAOI,8BAAA;ExE02uBV;EwEj3uBM;IAOI,+BAAA;ExE62uBV;EwEp3uBM;IAOI,kCAAA;ExEg3uBV;EwEv3uBM;IAOI,iCAAA;ExEm3uBV;EwE13uBM;IAOI,+BAAA;ExEs3uBV;EwE73uBM;IAOI,iCAAA;ExEy3uBV;EwEh4uBM;IAOI,+BAAA;ExE43uBV;EwEn4uBM;IAOI,iCAAA;ExE+3uBV;EwEt4uBM;IAOI,+BAAA;ExEk4uBV;EwEz4uBM;IAOI,+BAAA;ExEq4uBV;EwE54uBM;IAOI,gCAAA;ExEw4uBV;EwE/4uBM;IAOI,gCAAA;ExE24uBV;EwEl5uBM;IAOI,+BAAA;ExE84uBV;EwEr5uBM;IAOI,6BAAA;ExEi5uBV;EwEx5uBM;IAOI,+BAAA;ExEo5uBV;EwE35uBM;IAOI,6BAAA;ExEu5uBV;EwE95uBM;IAOI,+BAAA;ExE05uBV;EwEj6uBM;IAOI,6BAAA;ExE65uBV;EwEp6uBM;IAOI,6BAAA;ExEg6uBV;EwEv6uBM;IAOI,8BAAA;ExEm6uBV;EwE16uBM;IAOI,qBAAA;ExEs6uBV;EwE76uBM;IAOI,2BAAA;ExEy6uBV;EwEh7uBM;IAOI,0BAAA;ExE46uBV;EwEn7uBM;IAOI,wBAAA;ExE+6uBV;EwEt7uBM;IAOI,0BAAA;ExEk7uBV;EwEz7uBM;IAOI,wBAAA;ExEq7uBV;EwE57uBM;IAOI,0BAAA;ExEw7uBV;EwE/7uBM;IAOI,wBAAA;ExE27uBV;EwEl8uBM;IAOI,wBAAA;ExE87uBV;EwEr8uBM;IAOI,yBAAA;ExEi8uBV;EwEx8uBM;IAOI,2BAAA;IAAA,0BAAA;ExEq8uBV;EwE58uBM;IAOI,iCAAA;IAAA,gCAAA;ExEy8uBV;EwEh9uBM;IAOI,gCAAA;IAAA,+BAAA;ExE68uBV;EwEp9uBM;IAOI,8BAAA;IAAA,6BAAA;ExEi9uBV;EwEx9uBM;IAOI,gCAAA;IAAA,+BAAA;ExEq9uBV;EwE59uBM;IAOI,8BAAA;IAAA,6BAAA;ExEy9uBV;EwEh+uBM;IAOI,gCAAA;IAAA,+BAAA;ExE69uBV;EwEp+uBM;IAOI,8BAAA;IAAA,6BAAA;ExEi+uBV;EwEx+uBM;IAOI,8BAAA;IAAA,6BAAA;ExEq+uBV;EwE5+uBM;IAOI,+BAAA;IAAA,8BAAA;ExEy+uBV;EwEh/uBM;IAOI,yBAAA;IAAA,4BAAA;ExE6+uBV;EwEp/uBM;IAOI,+BAAA;IAAA,kCAAA;ExEi/uBV;EwEx/uBM;IAOI,8BAAA;IAAA,iCAAA;ExEq/uBV;EwE5/uBM;IAOI,4BAAA;IAAA,+BAAA;ExEy/uBV;EwEhgvBM;IAOI,8BAAA;IAAA,iCAAA;ExE6/uBV;EwEpgvBM;IAOI,4BAAA;IAAA,+BAAA;ExEigvBV;EwExgvBM;IAOI,8BAAA;IAAA,iCAAA;ExEqgvBV;EwE5gvBM;IAOI,4BAAA;IAAA,+BAAA;ExEygvBV;EwEhhvBM;IAOI,4BAAA;IAAA,+BAAA;ExE6gvBV;EwEphvBM;IAOI,6BAAA;IAAA,gCAAA;ExEihvBV;EwExhvBM;IAOI,yBAAA;ExEohvBV;EwE3hvBM;IAOI,+BAAA;ExEuhvBV;EwE9hvBM;IAOI,8BAAA;ExE0hvBV;EwEjivBM;IAOI,4BAAA;ExE6hvBV;EwEpivBM;IAOI,8BAAA;ExEgivBV;EwEvivBM;IAOI,4BAAA;ExEmivBV;EwE1ivBM;IAOI,8BAAA;ExEsivBV;EwE7ivBM;IAOI,4BAAA;ExEyivBV;EwEhjvBM;IAOI,4BAAA;ExE4ivBV;EwEnjvBM;IAOI,6BAAA;ExE+ivBV;EwEtjvBM;IAOI,2BAAA;ExEkjvBV;EwEzjvBM;IAOI,iCAAA;ExEqjvBV;EwE5jvBM;IAOI,gCAAA;ExEwjvBV;EwE/jvBM;IAOI,8BAAA;ExE2jvBV;EwElkvBM;IAOI,gCAAA;ExE8jvBV;EwErkvBM;IAOI,8BAAA;ExEikvBV;EwExkvBM;IAOI,gCAAA;ExEokvBV;EwE3kvBM;IAOI,8BAAA;ExEukvBV;EwE9kvBM;IAOI,8BAAA;ExE0kvBV;EwEjlvBM;IAOI,+BAAA;ExE6kvBV;EwEplvBM;IAOI,4BAAA;ExEglvBV;EwEvlvBM;IAOI,kCAAA;ExEmlvBV;EwE1lvBM;IAOI,iCAAA;ExEslvBV;EwE7lvBM;IAOI,+BAAA;ExEylvBV;EwEhmvBM;IAOI,iCAAA;ExE4lvBV;EwEnmvBM;IAOI,+BAAA;ExE+lvBV;EwEtmvBM;IAOI,iCAAA;ExEkmvBV;EwEzmvBM;IAOI,+BAAA;ExEqmvBV;EwE5mvBM;IAOI,+BAAA;ExEwmvBV;EwE/mvBM;IAOI,gCAAA;ExE2mvBV;EwElnvBM;IAOI,0BAAA;ExE8mvBV;EwErnvBM;IAOI,gCAAA;ExEinvBV;EwExnvBM;IAOI,+BAAA;ExEonvBV;EwE3nvBM;IAOI,6BAAA;ExEunvBV;EwE9nvBM;IAOI,+BAAA;ExE0nvBV;EwEjovBM;IAOI,6BAAA;ExE6nvBV;EwEpovBM;IAOI,+BAAA;ExEgovBV;EwEvovBM;IAOI,6BAAA;ExEmovBV;EwE1ovBM;IAOI,6BAAA;ExEsovBV;EwE7ovBM;IAOI,8BAAA;ExEyovBV;EwEhpvBM;IAOI,iBAAA;ExE4ovBV;EwEnpvBM;IAOI,uBAAA;ExE+ovBV;EwEtpvBM;IAOI,sBAAA;ExEkpvBV;EwEzpvBM;IAOI,oBAAA;ExEqpvBV;EwE5pvBM;IAOI,sBAAA;ExEwpvBV;EwE/pvBM;IAOI,oBAAA;ExE2pvBV;EwElqvBM;IAOI,sBAAA;ExE8pvBV;EwErqvBM;IAOI,oBAAA;ExEiqvBV;EwExqvBM;IAOI,oBAAA;ExEoqvBV;EwE3qvBM;IAOI,qBAAA;ExEuqvBV;EwE9qvBM;IAOI,qBAAA;ExE0qvBV;EwEjrvBM;IAOI,2BAAA;ExE6qvBV;EwEprvBM;IAOI,0BAAA;ExEgrvBV;EwEvrvBM;IAOI,wBAAA;ExEmrvBV;EwE1rvBM;IAOI,0BAAA;ExEsrvBV;EwE7rvBM;IAOI,wBAAA;ExEyrvBV;EwEhsvBM;IAOI,0BAAA;ExE4rvBV;EwEnsvBM;IAOI,wBAAA;ExE+rvBV;EwEtsvBM;IAOI,wBAAA;ExEksvBV;EwEzsvBM;IAOI,yBAAA;ExEqsvBV;EwE5svBM;IAOI,wBAAA;ExEwsvBV;EwE/svBM;IAOI,8BAAA;ExE2svBV;EwEltvBM;IAOI,6BAAA;ExE8svBV;EwErtvBM;IAOI,2BAAA;ExEitvBV;EwExtvBM;IAOI,6BAAA;ExEotvBV;EwE3tvBM;IAOI,2BAAA;ExEutvBV;EwE9tvBM;IAOI,6BAAA;ExE0tvBV;EwEjuvBM;IAOI,2BAAA;ExE6tvBV;EwEpuvBM;IAOI,2BAAA;ExEguvBV;EwEvuvBM;IAOI,4BAAA;ExEmuvBV;EwE1uvBM;IAOI,8CAAA;ExEsuvBV;EwE7uvBM;IAOI,6CAAA;ExEyuvBV;EwEhvvBM;IAOI,gDAAA;ExE4uvBV;EwEnvvBM;IAOI,8CAAA;ExE+uvBV;EwEtvvBM;IAOI,gDAAA;ExEkvvBV;EwEzvvBM;IAOI,6BAAA;ExEqvvBV;EwE5vvBM;IAOI,2BAAA;ExEwvvBV;EwE/vvBM;IAOI,4BAAA;ExE2vvBV;EwElwvBM;IAOI,6BAAA;ExE8vvBV;EwErwvBM;IAIQ,oBAAA;IAGJ,qEAAA;ExEkwvBV;EwEzwvBM;IAIQ,oBAAA;IAGJ,uEAAA;ExEswvBV;EwE7wvBM;IAIQ,oBAAA;IAGJ,qEAAA;ExE0wvBV;EwEjxvBM;IAIQ,oBAAA;IAGJ,kEAAA;ExE8wvBV;EwErxvBM;IAIQ,oBAAA;IAGJ,qEAAA;ExEkxvBV;EwEzxvBM;IAIQ,oBAAA;IAGJ,oEAAA;ExEsxvBV;EwE7xvBM;IAIQ,oBAAA;IAGJ,mEAAA;ExE0xvBV;EwEjyvBM;IAIQ,oBAAA;IAGJ,kEAAA;ExE8xvBV;EwEryvBM;IAIQ,oBAAA;IAGJ,mEAAA;ExEkyvBV;EwEzyvBM;IAIQ,oBAAA;IAGJ,mEAAA;ExEsyvBV;EwE7yvBM;IAIQ,oBAAA;IAGJ,wEAAA;ExE0yvBV;EwEjzvBM;IAIQ,oBAAA;IAGJ,2CAAA;ExE8yvBV;EwErzvBM;IAIQ,oBAAA;IAGJ,oCAAA;ExEkzvBV;EwEzzvBM;IAIQ,oBAAA;IAGJ,0CAAA;ExEszvBV;EwE7zvBM;IAIQ,oBAAA;IAGJ,2CAAA;ExE0zvBV;EwEj0vBM;IAIQ,oBAAA;IAGJ,0CAAA;ExE8zvBV;EwEr0vBM;IAIQ,oBAAA;IAGJ,0CAAA;ExEk0vBV;EwEz0vBM;IAIQ,oBAAA;IAGJ,yBAAA;ExEs0vBV;AACF;AyE73vBA;ED+CQ;IAOI,8BAAA;ExE20vBV;EwEl1vBM;IAOI,4BAAA;ExE80vBV;EwEr1vBM;IAOI,+BAAA;ExEi1vBV;EwEx1vBM;IAOI,8BAAA;ExEo1vBV;EwE31vBM;IAOI,+BAAA;ExEu1vBV;EwE91vBM;IAOI,8BAAA;ExE01vBV;EwEj2vBM;IAOI,4BAAA;ExE61vBV;EwEp2vBM;IAOI,+BAAA;ExEg2vBV;EwEv2vBM;IAOI,8BAAA;ExEm2vBV;EwE12vBM;IAOI,+BAAA;ExEs2vBV;EwE72vBM;IAOI,8BAAA;ExEy2vBV;EwEh3vBM;IAOI,4BAAA;ExE42vBV;EwEn3vBM;IAOI,+BAAA;ExE+2vBV;EwEt3vBM;IAOI,8BAAA;ExEk3vBV;EwEz3vBM;IAOI,+BAAA;ExEq3vBV;EwE53vBM;IAOI,8BAAA;ExEw3vBV;EwE/3vBM;IAOI,4BAAA;ExE23vBV;EwEl4vBM;IAOI,+BAAA;ExE83vBV;EwEr4vBM;IAOI,8BAAA;ExEi4vBV;EwEx4vBM;IAOI,+BAAA;ExEo4vBV;EwE34vBM;IAOI,8BAAA;ExEu4vBV;EwE94vBM;IAOI,4BAAA;ExE04vBV;EwEj5vBM;IAOI,+BAAA;ExE64vBV;EwEp5vBM;IAOI,8BAAA;ExEg5vBV;EwEv5vBM;IAOI,+BAAA;ExEm5vBV;EwE15vBM;IAOI,8BAAA;ExEs5vBV;EwE75vBM;IAOI,4BAAA;ExEy5vBV;EwEh6vBM;IAOI,+BAAA;ExE45vBV;EwEn6vBM;IAOI,8BAAA;ExE+5vBV;EwEt6vBM;IAOI,+BAAA;ExEk6vBV;EwEz6vBM;IAOI,8BAAA;ExEq6vBV;EwE56vBM;IAOI,4BAAA;ExEw6vBV;EwE/6vBM;IAOI,+BAAA;ExE26vBV;EwEl7vBM;IAOI,8BAAA;ExE86vBV;EwEr7vBM;IAOI,+BAAA;ExEi7vBV;EwEx7vBM;IAOI,8BAAA;ExEo7vBV;EwE37vBM;IAOI,4BAAA;ExEu7vBV;EwE97vBM;IAOI,+BAAA;ExE07vBV;EwEj8vBM;IAOI,8BAAA;ExE67vBV;EwEp8vBM;IAOI,+BAAA;ExEg8vBV;AACF;AyEp+vBA;ED4BQ;IAOI,0BAAA;ExEq8vBV;EwE58vBM;IAOI,gCAAA;ExEw8vBV;EwE/8vBM;IAOI,yBAAA;ExE28vBV;EwEl9vBM;IAOI,wBAAA;ExE88vBV;EwEr9vBM;IAOI,+BAAA;ExEi9vBV;EwEx9vBM;IAOI,yBAAA;ExEo9vBV;EwE39vBM;IAOI,6BAAA;ExEu9vBV;EwE99vBM;IAOI,8BAAA;ExE09vBV;EwEj+vBM;IAOI,wBAAA;ExE69vBV;EwEp+vBM;IAOI,+BAAA;ExEg+vBV;EwEv+vBM;IAOI,wBAAA;ExEm+vBV;AACF","sourcesContent":["$font-family-sans-serif: 'Poppins', sans-serif;\n\n// Colors\n$primary: #fe6b2a;\n$secondary: #35353a;\n$dark: #000;\n$body-bg: #0c0c0e;\n$body-color: #fff;\n$font-size-base: 1.15rem;\n$list-group-bg: #2a2a30;\n\n// Links\n$link-hover-color: $primary;\n$btn-color: #fff !important;\n\n// Navbar\n$navbar-dark-hover-color: $secondary;\n$navbar-padding-y: 1rem;\n$navbar-nav-link-padding-x: 0.5rem;\n$navbar-dark-color: #fff;\n$navbar-dark-hover-color: $primary;\n$nav-link-font-size: 1.05rem;\n\n// Headings\n$headings-font-weight: bold;\n\n// Horizontal Rule\n$hr-color: $primary;\n$hr-border-width: 3px;\n$hr-opacity: 1;\n\n// Buttons\n$button-font-size: 1.15rem;\n$button-radius: 50px;\n$button-padding-x: 30px;\n$button-padding-y: 10px;\n\n// Font Size\n$btn-font-size: $button-font-size;\n$btn-font-size-sm: $button-font-size;\n$btn-font-size-lg: $button-font-size;\n\n// Border Radius\n$btn-border-radius: $button-radius;\n$btn-border-radius-sm: $button-radius;\n$btn-border-radius-lg: $button-radius;\n$navbar-toggler-border-radius: 5px;\n\n// Buttons padding\n$btn-padding-x: $button-padding-x;\n$btn-padding-x-sm: $button-padding-x;\n$btn-padding-x-lg: $button-padding-x;\n$btn-padding-x-xl: $button-padding-x;\n\n$btn-padding-y: $button-padding-y;\n$btn-padding-y-sm: $button-padding-y;\n$btn-padding-y-lg: $button-padding-y;\n$btn-padding-y-xl: $button-padding-y;\n\n// Badges\n$badge-font-size: 0.9rem;\n$badge-padding-y: 0.4rem;\n$badge-padding-x: 0.6rem;\n\n// Inputs\n$input-radius: 0;\n$form-check-input-border-radius: 0;\n$input-btn-padding-y: 1rem;\n$input-btn-padding-x: 1rem;\n$input-border-radius: $input-radius;\n$input-border-radius-sm: $input-radius;\n$input-border-radius-lg: $input-radius;\n$input-border-color: #666;\n$input-placeholder-color: var(--bs-gray-700);\n\n// Cards\n$card-bg: $secondary;\n$box-shadow: 0 0.5rem 1rem rgba($dark, 0.8);\n$box-shadow-lg: 0 1rem 3rem rgba($dark, 0.8);\n\n// Video Modal\n$modal-backdrop-bg: #d0c8c8;\n$modal-backdrop-opacity: 0.8;\n\n$modal-dialog-margin: 1rem 0.5rem;\n\n// Spacers\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * 0.25,\n  2: $spacer * 0.5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n  6: $spacer * 4.5,\n  7: $spacer * 6,\n  8: $spacer * 8,\n  9: $spacer * 12,\n) !default;\n\n$headings-margin-bottom: $spacer * 1;\n$line-height-base: 1.7;\n\n// Gutters\n$grid-gutter-width: 1.5rem;\n$gutters: (\n  0: 0,\n  1: $spacer * 0.25,\n  2: $spacer * 0.5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n  6: $spacer * 4.5,\n  7: $spacer * 6,\n  8: $spacer * 8,\n  9: $spacer * 12,\n);\n// Negative Margin\n$enable-negative-margins: true;\n\n// Add values to predefined classes\n@import '/node_modules/bootstrap/scss/functions';\n@import '/node_modules/bootstrap/scss/variables';\n@import '/node_modules/bootstrap/scss/variables-dark';\n@import '/node_modules/bootstrap/scss/maps';\n@import '/node_modules/bootstrap/scss/mixins';\n@import '/node_modules/bootstrap/scss/utilities';\n@import '/node_modules/bootstrap/scss/modal';\n\n// Add breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  xxs: 438px,\n  sm: 576px,\n  mmd: 664px,\n  md: 768px,\n  mlg: 880px,\n  lg: 992px,\n  xl: 1199px,\n  xxl: 1400px,\n);\n\n$container-max-widths: (\n  xxs: 401px,\n  sm: 540px,\n  mmd: 622px,\n  md: 720px,\n  mlg: 840px,\n  lg: 960px,\n  xl: 1050px,\n  xxl: 1320px,\n);\n\n// Position Values\n$position-values: (\n  0: 0,\n  1: 1%,\n  2: 2%,\n  3: 3%,\n  4: 4%,\n  5: 5%,\n  10: 10%,\n  15: 15%,\n  20: 20%,\n  25: 25%,\n  30: 30%,\n  35: 35%,\n  40: 40%,\n  45: 45%,\n  50: 50%,\n  55: 55%,\n  60: 60%,\n  65: 65%,\n  70: 70%,\n  75: 75%,\n  80: 80%,\n  85: 85%,\n  90: 90%,\n  95: 95%,\n  100: 100%,\n  n50: -50%,\n);\n\n// ----------------------------\n$utilities: map-merge(\n  $utilities,\n  (\n    'top':\n      map-merge(\n        map-get($utilities, 'top'),\n        (\n          values:\n            map-merge(\n              map-get(map-get($utilities, 'top'), 'values'),\n              $position-values\n            ),\n        )\n      ),\n  )\n);\n\n$utilities: map-merge(\n  $utilities,\n  (\n    'top':\n      map-merge(\n        map-get($utilities, 'top'),\n        (\n          responsive: true,\n        )\n      ),\n  )\n);\n\n// -------------------------------\n$utilities: map-merge(\n  $utilities,\n  (\n    'bottom':\n      map-merge(\n        map-get($utilities, 'bottom'),\n        (\n          values:\n            map-merge(\n              map-get(map-get($utilities, 'bottom'), 'values'),\n              $position-values\n            ),\n        )\n      ),\n  )\n);\n$utilities: map-merge(\n  $utilities,\n  (\n    'bottom':\n      map-merge(\n        map-get($utilities, 'bottom'),\n        (\n          responsive: true,\n        )\n      ),\n  )\n);\n\n// -----------------------------\n$utilities: map-merge(\n  $utilities,\n  (\n    'start':\n      map-merge(\n        map-get($utilities, 'start'),\n        (\n          values:\n            map-merge(\n              map-get(map-get($utilities, 'start'), 'values'),\n              $position-values\n            ),\n        )\n      ),\n  )\n);\n\n$utilities: map-merge(\n  $utilities,\n  (\n    'start':\n      map-merge(\n        map-get($utilities, 'start'),\n        (\n          responsive: true,\n        )\n      ),\n  )\n);\n\n// --------------------------\n$utilities: map-merge(\n  $utilities,\n  (\n    'end':\n      map-merge(\n        map-get($utilities, 'end'),\n        (\n          values:\n            map-merge(\n              map-get(map-get($utilities, 'end'), 'values'),\n              $position-values\n            ),\n        )\n      ),\n  )\n);\n\n$utilities: map-merge(\n  $utilities,\n  (\n    'end':\n      map-merge(\n        map-get($utilities, 'end'),\n        (\n          responsive: true,\n        )\n      ),\n  )\n);\n\n// Rounded class-------\n$border-radius-3xl: 3rem !default;\n$border-radius-4xl: 4rem !default;\n$border-radius-5xl: 5rem !default;\n\n// -------------\n$utilities: map-merge(\n  $utilities,\n  (\n    'rounded':\n      map-merge(\n        map-get($utilities, 'rounded'),\n        (\n          values:\n            map-merge(\n              map-get(map-get($utilities, 'rounded'), 'values'),\n              (\n                6: $border-radius-3xl,\n                7: $border-radius-4xl,\n                8: $border-radius-5xl,\n              )\n            ),\n        )\n      ),\n  )\n);\n\n// ------------------------\n$values: (\n  5: 5%,\n  10: 10%,\n  15: 15%,\n  20: 20%,\n  30: 30%,\n  35: 35%,\n  40: 40%,\n  45: 45%,\n  55: 55%,\n  60: 60%,\n  65: 65%,\n  70: 70%,\n  80: 80%,\n  85: 85%,\n  90: 90%,\n  95: 95%,\n);\n\n// Width class --------------------------\n$utilities: map-merge(\n  $utilities,\n  (\n    'width':\n      map-merge(\n        map-get($utilities, 'width'),\n        (\n          values:\n            map-merge(map-get(map-get($utilities, 'width'), 'values'), $values),\n        )\n      ),\n  )\n);\n\n// Enable Responsive classes\n$utilities: map-merge(\n  $utilities,\n  (\n    'width':\n      map-merge(\n        map-get($utilities, 'width'),\n        (\n          responsive: true,\n        )\n      ),\n  )\n);\n\n// Height class ------------------------\n$utilities: map-merge(\n  $utilities,\n  (\n    'height':\n      map-merge(\n        map-get($utilities, 'height'),\n        (\n          values:\n            map-merge(map-get(map-get($utilities, 'height'), 'values'), $values),\n        )\n      ),\n  )\n);\n\n$utilities: map-merge(\n  $utilities,\n  (\n    'height':\n      map-merge(\n        map-get($utilities, 'height'),\n        (\n          responsive: true,\n        )\n      ),\n  )\n);\n\n// Opacity\n$utilities: map-merge(\n  $utilities,\n  (\n    'opacity':\n      map-merge(\n        map-get($utilities, 'opacity'),\n        (\n          values:\n            map-merge(\n              map-get(map-get($utilities, 'opacity'), 'values'),\n              (\n                5: 0.5,\n                10: 0.1,\n                15: 0.15,\n                20: 0.2,\n                30: 0.3,\n                35: 0.35,\n                40: 0.4,\n                45: 0.45,\n                60: 0.6,\n                65: 0.65,\n                70: 0.7,\n                80: 0.8,\n                85: 0.85,\n                90: 0.9,\n                95: 0.95,\n              )\n            ),\n        )\n      ),\n  )\n);\n\n$utilities: map-merge(\n  $utilities,\n  (\n    'opacity':\n      map-merge(\n        map-get($utilities, 'opacity'),\n        (\n          responsive: true,\n        )\n      ),\n  )\n);\n\n// -------------------------\n$utilities: map-merge(\n  $utilities,\n  (\n    'font-size':\n      map-merge(\n        map-get($utilities, 'font-size'),\n        (\n          responsive: true,\n        )\n      ),\n  )\n);\n\n// -------------------------\n$utilities: map-merge(\n  $utilities,\n  (\n    'color':\n      map-merge(\n        map-get($utilities, 'color'),\n        (\n          responsive: true,\n        )\n      ),\n  )\n);\n\n@import '/node_modules/bootstrap/scss/bootstrap.scss';\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.3 (https://getbootstrap.com/)\n   * Copyright 2011-2024 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-header .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n    // stylelint-enable selector-max-class\n\n    > .accordion-collapse {\n      @include border-radius(0);\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) calc(-.5 * var(--#{$prefix}offcanvas-padding-x)) calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
